import { r as e } from "./rolldown-runtime-B1bRi_D7.js";
import t from "classnames";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { PureComponent as a, createContext as o, createRef as s, forwardRef as c, memo as l, useCallback as u, useEffect as d, useImperativeHandle as f, useMemo as p, useRef as m, useState as h } from "react";
import g from "lodash/find";
import _ from "lodash/sortBy";
//#region src/components/icon/generated/iconmeta.json
var v = /* @__PURE__ */ e({
	default: () => b,
	names: () => y
}), y = {
	ai: [
		"ai",
		"grammar-spelling",
		"translate-auto",
		"translate-preferred",
		"translate"
	],
	"analytics & insights": [
		"activity",
		"bars-filter",
		"chart-area",
		"chart-bar-stacked",
		"chart-bar",
		"chart-donut",
		"chart-line",
		"chart-pie",
		"circle-dashed",
		"dashboard",
		"experiment",
		"filter-a-z",
		"filter-z-a",
		"hourglass-clock",
		"hourglass-end",
		"hourglass-full",
		"hourglass-half",
		"hourglass-start",
		"magnifying-glass-chart",
		"presentation",
		"trend-down",
		"trend-up"
	],
	arrows: /* @__PURE__ */ "angle-double-left.angle-double-right.angle-down.angle-left.angle-right.angle-square-down.angle-square-left.angle-square-right.angle-square-up.angle-up.arrow-down.arrow-expand.arrow-left.arrow-right.arrow-square-down.arrow-square-left.arrow-square-right.arrow-square-up.arrow-up.arrows-h.arrows-v.compress.exchange.expand.redo.reduce.sign-in.sign-out.sort-down.sort-up.sync.undo".split("."),
	audio: [
		"announcement-slash",
		"announcement",
		"headset",
		"pause",
		"play",
		"record",
		"stop",
		"volume-down",
		"volume-mute",
		"volume-off",
		"volume-up"
	],
	"calendar & time": [
		"calendar-plus",
		"calendar-times",
		"calendar",
		"clock-one",
		"clock-three",
		"clock",
		"history",
		"moon",
		"sun"
	],
	channel: [
		"callback",
		"chat-bot",
		"chat-widget",
		"chat",
		"dixa-messenger",
		"facebook-messenger",
		"generic-api",
		"instagram",
		"mail",
		"messaging-settings",
		"messenger",
		"mim-advisor",
		"mim-sidekick",
		"mim",
		"phone",
		"simultaneous",
		"sms",
		"trustpilot",
		"twitter",
		"voicemail",
		"whatsapp",
		"working"
	],
	conversation: [
		"at",
		"chat-plus",
		"chat-slash",
		"chat-x",
		"conversations",
		"forward-all",
		"forward",
		"phone-hang",
		"phone-incoming",
		"phone-outgoing",
		"phone-plus",
		"rec",
		"reply-all",
		"reply",
		"social",
		"subtitle",
		"tag",
		"tags",
		"transcript",
		"video",
		"widget-customize"
	],
	editor: /* @__PURE__ */ "align-center.align-justify.align-left.align-right.anchor.bold.callout.code-block.copy.cut.divider.download.enter.format.heading-1.heading-2.heading-3.heading.image-inline.image.italic.link-slash.link.list-ol-letters.list-ol-numbers.list-ol-roman.list-ol.list-ul-circle.list-ul-disc.list-ul-square.list-ul.paper-plane.paperclip.paste.print.quote.sticky-note.strikethrough.table-header-column.table-header-row.table.text.th.underline.upload".split("."),
	"file & folder": [
		"file-archive",
		"file-audio",
		"file-csv",
		"file-draft",
		"file-excel",
		"file-image",
		"file-lock",
		"file-pdf",
		"file-powerpoint",
		"file-text-search",
		"file-text",
		"file-video",
		"file-word",
		"file",
		"folder-open-slash",
		"folder-open",
		"folder-slash",
		"folder"
	],
	generic: /* @__PURE__ */ "american-football.bars.bell-slash.bell.bolt.bookmark.camera.check-circle-filled.check-circle.circle-filled.circle.close-circle-filled.close.dixa.docked.done.double-check-circle-filled.double-check-circle.exclamation-circle-filled.exclamation-triangle-filled.exclamation.external-link.flag.floating.gift.hamburger.heart.home.info-filled.info.keyboard.knowledge.map-pin.minus.plane.plus-circle-filled.plus.question-filled.question.search-minus.search-plus.search.shield-alert.square-plus.thumbtack-full.thumbtack-slash.thumbtack.wrench".split("."),
	integrations: /* @__PURE__ */ "ada.agillic.assembled.braze.busylight.digitalgenius.elevio.github.ingrid.jira.kindly.klaviyo.linear.loyaltylion.magento.miuros.podio.recharge.rivoloyalty.salesforce.shopify.solvemate.trustpilot-outlined.trustpilot-star.voyado.web-form.webhooks.yotpo".split("."),
	presence: [
		"away-toggle",
		"circle-empty",
		"circle-simultaneous",
		"circle-z",
		"media-chat",
		"media-email",
		"media-messaging",
		"media-voice",
		"phone-filled"
	],
	satisfaction: [
		"smile",
		"star-full",
		"star-half-full",
		"star",
		"thumbs-down",
		"thumbs-up"
	],
	"settings & workflows": /* @__PURE__ */ "archive.autocomplete.branch.building.channels.cloud-check.cloud-download.cloud-slash.cloud-syncing.cloud-upload.cloud.code.cog.combine.credit-card.dots-h.dots-v.drag-h.drag.dropdown-list.eye-closed.eye-slash.eye.filter.flow.hide-strategy.input.key.lightbulb.lock.merge.pen-slash.pen.plug.preferences.route.trash.url-trigger.world-slash.world".split("."),
	user: [
		"address-book",
		"ban",
		"id-card",
		"role-custom",
		"role-system",
		"team",
		"user-agent",
		"user-minus",
		"user-plus",
		"user-secret",
		"user-slash",
		"user-status",
		"user",
		"users"
	]
}, b = { names: y }, x = {
	purple: {
		100: "var(--dixa-color-purple-100)",
		200: "var(--dixa-color-purple-200)",
		300: "var(--dixa-color-purple-300)",
		400: "var(--dixa-color-purple-400)",
		500: "var(--dixa-color-purple-500)",
		600: "var(--dixa-color-purple-600)",
		700: "var(--dixa-color-purple-700)",
		800: "var(--dixa-color-purple-800)",
		900: "var(--dixa-color-purple-900)",
		values: {
			100: {
				light: "#f0f0ff",
				dark: "#242033"
			},
			200: {
				light: "#ddd8fd",
				dark: "#484166"
			},
			300: {
				light: "#c1b9f8",
				dark: "#6c6199"
			},
			400: {
				light: "#8f82ed",
				dark: "#9082cc"
			},
			500: {
				light: "#5644d8",
				dark: "#b4a2ff"
			},
			600: {
				light: "#392aa7",
				dark: "#c3b5ff"
			},
			700: {
				light: "#281c82",
				dark: "#d2c7ff"
			},
			800: {
				light: "#140561",
				dark: "#e1daff"
			},
			900: {
				light: "#0c0146",
				dark: "#f0ecff"
			}
		}
	},
	green: {
		100: "var(--dixa-color-green-100)",
		200: "var(--dixa-color-green-200)",
		300: "var(--dixa-color-green-300)",
		400: "var(--dixa-color-green-400)",
		500: "var(--dixa-color-green-500)",
		600: "var(--dixa-color-green-600)",
		700: "var(--dixa-color-green-700)",
		800: "var(--dixa-color-green-800)",
		900: "var(--dixa-color-green-900)",
		values: {
			100: {
				light: "#dffbe9",
				dark: "#03271f"
			},
			200: {
				light: "#c6f5d6",
				dark: "#064d3f"
			},
			300: {
				light: "#9febb9",
				dark: "#08745e"
			},
			400: {
				light: "#6ad495",
				dark: "#0b9a7e"
			},
			500: {
				light: "#33b967",
				dark: "#0ec19d"
			},
			600: {
				light: "#23924e",
				dark: "#3ecdb1"
			},
			700: {
				light: "#196c39",
				dark: "#6edac4"
			},
			800: {
				light: "#195239",
				dark: "#9fe6d8"
			},
			900: {
				light: "#164832",
				dark: "#cff3eb"
			}
		}
	},
	blue: {
		100: "var(--dixa-color-blue-100)",
		200: "var(--dixa-color-blue-200)",
		300: "var(--dixa-color-blue-300)",
		400: "var(--dixa-color-blue-400)",
		500: "var(--dixa-color-blue-500)",
		600: "var(--dixa-color-blue-600)",
		700: "var(--dixa-color-blue-700)",
		800: "var(--dixa-color-blue-800)",
		900: "var(--dixa-color-blue-900)",
		values: {
			100: {
				light: "#e7f5fe",
				dark: "#081a32"
			},
			200: {
				light: "#a8d9fc",
				dark: "#0f3565"
			},
			300: {
				light: "#69bbf6",
				dark: "#174f97"
			},
			400: {
				light: "#36a1ec",
				dark: "#1e6aca"
			},
			500: {
				light: "#0078cc",
				dark: "#2684fc"
			},
			600: {
				light: "#0067ad",
				dark: "#519dfd"
			},
			700: {
				light: "#005893",
				dark: "#7db5fd"
			},
			800: {
				light: "#00487a",
				dark: "#a8cefe"
			},
			900: {
				light: "#003d66",
				dark: "#d4e6fe"
			}
		}
	},
	orange: {
		100: "var(--dixa-color-orange-100)",
		200: "var(--dixa-color-orange-200)",
		300: "var(--dixa-color-orange-300)",
		400: "var(--dixa-color-orange-400)",
		500: "var(--dixa-color-orange-500)",
		600: "var(--dixa-color-orange-600)",
		700: "var(--dixa-color-orange-700)",
		800: "var(--dixa-color-orange-800)",
		900: "var(--dixa-color-orange-900)",
		values: {
			100: {
				light: "#ffeedd",
				dark: "#321f05"
			},
			200: {
				light: "#ffdcaf",
				dark: "#643d0b"
			},
			300: {
				light: "#ffbd6e",
				dark: "#955c10"
			},
			400: {
				light: "#ff9e37",
				dark: "#c77a16"
			},
			500: {
				light: "#fc800d",
				dark: "#f9991b"
			},
			600: {
				light: "#e56500",
				dark: "#faad49"
			},
			700: {
				light: "#ca4f00",
				dark: "#fbc276"
			},
			800: {
				light: "#a93900",
				dark: "#fdd6a4"
			},
			900: {
				light: "#872600",
				dark: "#feebd1"
			}
		}
	},
	red: {
		100: "var(--dixa-color-red-100)",
		200: "var(--dixa-color-red-200)",
		300: "var(--dixa-color-red-300)",
		400: "var(--dixa-color-red-400)",
		500: "var(--dixa-color-red-500)",
		600: "var(--dixa-color-red-600)",
		700: "var(--dixa-color-red-700)",
		800: "var(--dixa-color-red-800)",
		900: "var(--dixa-color-red-900)",
		values: {
			100: {
				light: "#fff2f2",
				dark: "#310c0c"
			},
			200: {
				light: "#f5cccb",
				dark: "#631918"
			},
			300: {
				light: "#eaa8a6",
				dark: "#942525"
			},
			400: {
				light: "#db6a68",
				dark: "#c63231"
			},
			500: {
				light: "#c83c3c",
				dark: "#f73e3d"
			},
			600: {
				light: "#c11d1d",
				dark: "#f96564"
			},
			700: {
				light: "#b30908",
				dark: "#fa8b8b"
			},
			800: {
				light: "#9e0302",
				dark: "#fcb2b1"
			},
			900: {
				light: "#870000",
				dark: "#fdd8d8"
			}
		}
	},
	neutral: {
		100: "var(--dixa-color-neutral-100)",
		200: "var(--dixa-color-neutral-200)",
		300: "var(--dixa-color-neutral-300)",
		400: "var(--dixa-color-neutral-400)",
		500: "var(--dixa-color-neutral-500)",
		600: "var(--dixa-color-neutral-600)",
		700: "var(--dixa-color-neutral-700)",
		800: "var(--dixa-color-neutral-800)",
		900: "var(--dixa-color-neutral-900)",
		values: {
			100: {
				light: "#f5f7fa",
				dark: "#23242c"
			},
			200: {
				light: "#e7ecf3",
				dark: "#2e3039"
			},
			300: {
				light: "#d7dfea",
				dark: "#464650"
			},
			400: {
				light: "#b5c1d4",
				dark: "#62626a"
			},
			500: {
				light: "#8193b0",
				dark: "#7e7e85"
			},
			600: {
				light: "#617598",
				dark: "#99999f"
			},
			700: {
				light: "#45587c",
				dark: "#b5b5b9"
			},
			800: {
				light: "#263758",
				dark: "#d1d1d3"
			},
			900: {
				light: "#132243",
				dark: "#ededee"
			},
			"000": {
				light: "#ffffff",
				dark: "#1a1b23"
			}
		},
		"000": "var(--dixa-color-neutral-000)"
	}
}, S = {
	"box-shadow": {
		100: "var(--dixa-effect-box-shadow-100)",
		200: "var(--dixa-effect-box-shadow-200)",
		300: "var(--dixa-effect-box-shadow-300)",
		400: "var(--dixa-effect-box-shadow-400)",
		values: {
			100: {
				light: "0px 2px 4px #6176981a, 0px 1px 2px #6176980a",
				dark: "0px 2px 4px #0a0a0e4d, 0px 1px 2px #0a0a0e36"
			},
			200: {
				light: "0px 4px 8px #6176981a, 0px 2px 4px #6176980a",
				dark: "0px 4px 8px #0a0a0e4d, 0px 2px 4px #0a0a0e36"
			},
			300: {
				light: "0px 8px 16px #6176981a, 0px 4px 8px #6176980a",
				dark: "0px 8px 16px #0a0a0e4d, 0px 4px 8px #0a0a0e36"
			},
			400: {
				light: "0px 12px 24px #6176981a, 0px 8px 16px #6176980a",
				dark: "0px 12px 24px #0a0a0e4d, 0px 8px 16px #0a0a0e36"
			}
		}
	},
	opacity: {
		200: "var(--dixa-effect-opacity-200)",
		500: "var(--dixa-effect-opacity-500)",
		values: {
			200: .2,
			500: .5
		}
	}
}, C = {
	spacer: {
		100: "var(--dixa-size-spacer-100)",
		200: "var(--dixa-size-spacer-200)",
		250: "var(--dixa-size-spacer-250)",
		300: "var(--dixa-size-spacer-300)",
		400: "var(--dixa-size-spacer-400)",
		500: "var(--dixa-size-spacer-500)",
		values: {
			100: "4px",
			200: "8px",
			250: "12px",
			300: "16px",
			400: "24px",
			500: "32px"
		}
	},
	"border-radius": {
		50: "var(--dixa-size-border-radius-50)",
		100: "var(--dixa-size-border-radius-100)",
		values: {
			50: "2px",
			100: "4px"
		}
	},
	border: {
		100: "var(--dixa-size-border-100)",
		200: "var(--dixa-size-border-200)",
		values: {
			100: "1px",
			200: "2px"
		}
	}
}, w = {
	color: {
		values: {
			primary: {
				light: "#132244",
				dark: "#e4e6ec"
			},
			secondary: {
				light: "#46597c",
				dark: "#aeafbb"
			},
			tertiary: {
				light: "#8294b0",
				dark: "#7f818e"
			},
			success: {
				light: "#23924e",
				dark: "#3ecdb1"
			},
			error: {
				light: "#c11d1d",
				dark: "#f96564"
			},
			warning: {
				light: "#e56500",
				dark: "#faad49"
			},
			link: {
				light: "#0078cc",
				dark: "#519dfd"
			}
		},
		primary: "var(--dixa-typography-color-primary)",
		secondary: "var(--dixa-typography-color-secondary)",
		tertiary: "var(--dixa-typography-color-tertiary)",
		success: "var(--dixa-typography-color-success)",
		error: "var(--dixa-typography-color-error)",
		warning: "var(--dixa-typography-color-warning)",
		link: "var(--dixa-typography-color-link)"
	},
	family: {
		values: {
			default: "IBM Plex Sans, Helvetica, Arial, sans-serif",
			code: "IBM Plex Mono, Menlo, Monaco, Consolas, Courier New, monospace"
		},
		default: "var(--dixa-typography-family-default)",
		code: "var(--dixa-typography-family-code)"
	},
	"letter-spacing": {
		100: "var(--dixa-typography-letter-spacing-100)",
		200: "var(--dixa-typography-letter-spacing-200)",
		300: "var(--dixa-typography-letter-spacing-300)",
		400: "var(--dixa-typography-letter-spacing-400)",
		500: "var(--dixa-typography-letter-spacing-500)",
		600: "var(--dixa-typography-letter-spacing-600)",
		700: "var(--dixa-typography-letter-spacing-700)",
		800: "var(--dixa-typography-letter-spacing-800)",
		900: "var(--dixa-typography-letter-spacing-900)",
		values: {
			100: "0px",
			200: "0px",
			300: "0px",
			400: "0px",
			500: "0px",
			600: "0px",
			700: "0px",
			800: "0px",
			900: "0px"
		}
	},
	"line-height": {
		100: "var(--dixa-typography-line-height-100)",
		200: "var(--dixa-typography-line-height-200)",
		300: "var(--dixa-typography-line-height-300)",
		400: "var(--dixa-typography-line-height-400)",
		values: {
			100: "12px",
			200: "16px",
			300: "20px",
			400: "24px"
		}
	},
	size: {
		100: "var(--dixa-typography-size-100)",
		200: "var(--dixa-typography-size-200)",
		300: "var(--dixa-typography-size-300)",
		400: "var(--dixa-typography-size-400)",
		500: "var(--dixa-typography-size-500)",
		600: "var(--dixa-typography-size-600)",
		values: {
			100: "10px",
			200: "12px",
			300: "14px",
			400: "16px",
			500: "18px",
			600: "24px"
		}
	},
	weight: {
		values: {
			semibold: 600,
			normal: 400
		},
		semibold: "var(--dixa-typography-weight-semibold)",
		normal: "var(--dixa-typography-weight-normal)"
	}
}, T = (e, t) => {
	let n = e.split(".").reverse(), r = t;
	for (; n.length;) {
		let e = n.pop();
		if (!e) return null;
		if (r[e] === void 0) return e === "0" ? e : (console.warn(`Token does not exist. (${e})`), null);
		r = r[e];
	}
	return r && typeof r != "object" ? r : null;
}, E = (e, t) => e.split(" ").map((e) => T(e, t)).filter((e) => e !== null).join(" "), ee = [
	"currentColor",
	"transparent",
	"inherit",
	"initial"
], D = {
	primary: "var(--dixa-typography-color-primary)",
	secondary: "var(--dixa-typography-color-secondary)",
	tertiary: "var(--dixa-typography-color-tertiary)",
	white: "var(--dixa-color-neutral-000)",
	success: "var(--dixa-typography-color-success)",
	error: "var(--dixa-typography-color-error)",
	warning: "var(--dixa-typography-color-warning)",
	link: "var(--dixa-typography-color-link)"
}, O = (e) => {
	if (e === void 0 || e.startsWith("#") || e.startsWith("rgb") || e.startsWith("var") || ee.includes(e)) return e;
	if (e in D) return D[e];
	let t = E(e, x);
	if (t) return t;
}, k = (e) => {
	let t = Object.keys(S["box-shadow"]);
	return t.includes(e) ? E(e, S["box-shadow"]) : t.map((e) => `box-shadow.${e}`).includes(e) ? E(e, S) : e;
}, A = (e) => e.indexOf("px") > -1 || e.indexOf("%") > -1 || e.indexOf("vh") > -1 || e.indexOf("vw") > -1 || e.startsWith("var"), j = (e = "200") => A(e) ? e : E(e, C.spacer) || "", te = (e = "100") => A(e) ? e : E(e, C["border-radius"]) || "", ne = (e = "100") => A(e) ? e : E(e, C.border) || "", re = (e = "100") => A(e) ? e : E(e, w.size) || "", ie = { root: "h-icon--icon__root" }, ae = { svg: "<svg xmlns=\"http://www.w3.org/2000/svg\">\n<symbol id=\"icon-ai\" viewBox=\"0 0 20 20\"><path d=\"M13.234 3.663A.362.362 0 0 0 13 4c0 .15.094.284.234.338L15 5l.662 1.766a.362.362 0 0 0 .675 0L17 5l1.766-.662A.362.362 0 0 0 19 4a.362.362 0 0 0-.234-.337L17 3l-.663-1.766a.362.362 0 0 0-.675 0L15 3l-1.766.663Zm-5.78.628a.498.498 0 0 0-.907 0l-1.66 3.593-3.593 1.66a.498.498 0 0 0-.003.91l3.593 1.659 1.66 3.593a.498.498 0 0 0 .906 0l1.66-3.593 3.593-1.66a.498.498 0 0 0 0-.906L9.11 7.887 7.45 4.295l.003-.003ZM14 15l-1.766.662A.362.362 0 0 0 12 16c0 .15.094.284.234.337L14 17l.662 1.766a.362.362 0 0 0 .675 0L16 17l1.766-.663A.362.362 0 0 0 18 16a.362.362 0 0 0-.234-.338L16 15l-.662-1.766A.362.362 0 0 0 15 13a.362.362 0 0 0-.338.234L14 15Z\"/></symbol>\n<symbol id=\"icon-grammar-spelling\" viewBox=\"0 0 20 20\"><path d=\"M4.588 3A2.577 2.577 0 0 0 2 5.566v4.9c0 .516.42.933.941.933.52 0 .941-.417.941-.933V8.599h1.883v1.867c0 .516.42.933.94.933.522 0 .942-.417.942-.933v-4.9A2.577 2.577 0 0 0 5.06 3h-.47Zm1.177 3.733H3.882V5.566c0-.387.315-.7.706-.7h.47c.392 0 .707.313.707.7v1.167ZM10 3a.936.936 0 0 0-.941.933v6.533c0 .516.42.933.941.933h2.118c1.43 0 2.588-1.149 2.588-2.566 0-.689-.274-1.313-.718-1.773.303-.42.483-.937.483-1.494A2.577 2.577 0 0 0 11.882 3H10Zm1.882 3.266h-.94v-1.4h.94c.392 0 .706.313.706.7 0 .388-.314.7-.706.7Zm-.94 3.267v-1.4h1.176c.39 0 .706.312.706.7 0 .388-.315.7-.706.7H10.94Zm6.852 2.45a.93.93 0 0 0-.147-1.313.946.946 0 0 0-1.323.146l-3.11 3.852-1.137-1.128a.948.948 0 0 0-1.333 0 .929.929 0 0 0 0 1.32l1.883 1.867a.948.948 0 0 0 1.4-.078l3.767-4.667Z\"/></symbol>\n<symbol id=\"icon-translate-auto\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M4 2a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v-.666A2.667 2.667 0 0 1 10.667 8h.666V4a2 2 0 0 0-2-2H4Zm2 1.333c.244 0 .444.2.444.445v.442h1.778a.446.446 0 0 1 0 .89H8.09l-.117.322a5.34 5.34 0 0 1-1.21 1.918c.088.064.18.122.274.178l.525.314a.443.443 0 1 1-.455.762L6.58 8.29a6.328 6.328 0 0 1-.512-.345 5.42 5.42 0 0 1-.722.436l-.48.24a.447.447 0 0 1-.598-.2.448.448 0 0 1 .2-.598l.481-.24c.15-.072.292-.155.43-.244l-.58-.581a.447.447 0 0 1 0-.628.446.446 0 0 1 .628 0l.65.65a4.443 4.443 0 0 0 1.06-1.651l.006-.017H3.778a.446.446 0 0 1-.445-.444c0-.245.2-.445.445-.445h1.778v-.445c0-.245.2-.445.444-.445Z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M8.667 10.667a2 2 0 0 1 2-2H16a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2H6.667l1.518-1.772a2 2 0 0 0 .482-1.301v-4.26Zm2 .433c0-.24.194-.433.433-.433h4.467a.433.433 0 0 1 0 .866H11.1a.433.433 0 0 1-.433-.433Zm.433 1.567a.433.433 0 0 0 0 .866h1.8a.433.433 0 0 0 0-.866h-1.8Zm-.433 2.433c0-.24.194-.433.433-.433h3.133a.433.433 0 1 1 0 .866H11.1a.433.433 0 0 1-.433-.433Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-translate-preferred\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M4 2a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v-.666A2.667 2.667 0 0 1 10.667 8h.666V4a2 2 0 0 0-2-2H4Zm2 1.333c.244 0 .444.2.444.445v.442h1.778a.446.446 0 0 1 0 .89H8.09l-.117.322a5.34 5.34 0 0 1-1.21 1.918c.088.064.18.122.274.178l.525.314a.443.443 0 1 1-.455.762L6.58 8.29a6.328 6.328 0 0 1-.512-.345 5.42 5.42 0 0 1-.722.436l-.48.24a.447.447 0 0 1-.598-.2.448.448 0 0 1 .2-.598l.481-.24c.15-.072.292-.155.43-.244l-.58-.581a.447.447 0 0 1 0-.628.446.446 0 0 1 .628 0l.65.65a4.443 4.443 0 0 0 1.06-1.651l.006-.017H3.778a.446.446 0 0 1-.445-.444c0-.245.2-.445.445-.445h1.778v-.445c0-.245.2-.445.444-.445Z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M8.667 10.667a2 2 0 0 1 2-2H16a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2h-5.333a2 2 0 0 1-2-2v-5.333Zm4.666 3a1.52 1.52 0 0 1-1.321-.75 1.472 1.472 0 0 1 0-1.5c.274-.457.774-.75 1.321-.75a1.54 1.54 0 0 1 1.31.75 1.472 1.472 0 0 1 0 1.5c-.274.468-.774.75-1.31.75Zm-.547.562h1.083c1.179 0 2.131.938 2.131 2.098 0 .187-.167.34-.357.34h-4.631a.343.343 0 0 1-.345-.34c0-1.16.94-2.098 2.119-2.098Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-translate\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M4 2a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v-.666A2.667 2.667 0 0 1 10.667 8h.666V4a2 2 0 0 0-2-2H4Zm2 1.333c.244 0 .444.2.444.445v.442h1.778a.446.446 0 0 1 0 .89H8.09l-.117.322a5.34 5.34 0 0 1-1.21 1.918c.088.064.18.122.274.178l.525.314a.443.443 0 1 1-.455.762L6.58 8.29a6.328 6.328 0 0 1-.512-.345 5.42 5.42 0 0 1-.722.436l-.48.24a.447.447 0 0 1-.598-.2.448.448 0 0 1 .2-.598l.481-.24c.15-.072.292-.155.43-.244l-.58-.581a.447.447 0 0 1 0-.628.446.446 0 0 1 .628 0l.65.65a4.443 4.443 0 0 0 1.06-1.651l.006-.017H3.778a.446.446 0 0 1-.445-.444c0-.245.2-.445.445-.445h1.778v-.445c0-.245.2-.445.444-.445Z\" clip-rule=\"evenodd\"/><path d=\"m13.335 12.308.805 1.913h-1.607l.802-1.913Z\"/><path fill-rule=\"evenodd\" d=\"M8.667 10.667a2 2 0 0 1 2-2H16a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2h-5.333a2 2 0 0 1-2-2v-5.333Zm5.102.28a.472.472 0 0 0-.434-.28.472.472 0 0 0-.435.28l-1.866 4.443a.437.437 0 0 0 .26.578c.239.091.51-.02.606-.247l.257-.608h2.353l.257.608a.475.475 0 0 0 .606.247.437.437 0 0 0 .26-.578l-1.867-4.443h.003Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-activity\" viewBox=\"0 0 20 20\"><path d=\"M9.972 2a1 1 0 0 1 .994.738l2.312 8.474.828-1.659C14.275 9.216 14.622 9 15 9h3a.999.999 0 1 1 0 2h-2.381l-1.725 3.447a.998.998 0 0 1-.994.547.999.999 0 0 1-.866-.732l-1.918-7.034-2.138 9.981a1 1 0 0 1-1.937.066L4.247 11H2a.999.999 0 1 1 0-2h3c.447 0 .838.297.963.725l.9 3.15L9.021 2.791c.097-.45.49-.778.95-.791Z\"/></symbol>\n<symbol id=\"icon-bars-filter\" viewBox=\"0 0 20 20\"><path d=\"M2 5c0-.553.447-1 1-1h14a.999.999 0 1 1 0 2H3c-.553 0-1-.447-1-1Zm3 5c0-.553.447-1 1-1h8a.999.999 0 1 1 0 2H6c-.553 0-1-.447-1-1Zm7 5c0 .553-.447 1-1 1H9a.999.999 0 1 1 0-2h2c.553 0 1 .447 1 1Z\"/></symbol>\n<symbol id=\"icon-chart-area\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15.953 3.471A1.13 1.13 0 0 1 18 4.126v11.748c0 .621-.506 1.126-1.13 1.126H3.13a1.129 1.129 0 0 1-1.124-1.011L2 15.873v-4.147c0-.222.067-.438.188-.62l4.123-6.22.013-.019.042-.057.02-.024a1.131 1.131 0 0 1 1.666-.072l4.47 4.495 3.379-5.66.052-.079Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-chart-bar-stacked\" viewBox=\"0 0 20 20\"><path d=\"M6 15.5A1.5 1.5 0 0 1 4.5 17h-1A1.5 1.5 0 0 1 2 15.5h4ZM12 15.5a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 8 15.5v-6h4v6ZM18 15.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-4h4v4ZM4.5 9A1.5 1.5 0 0 1 6 10.5V14H2v-3.5A1.5 1.5 0 0 1 3.5 9h1ZM16.5 5A1.5 1.5 0 0 1 18 6.5V10h-4V6.5A1.5 1.5 0 0 1 15.5 5h1ZM10.5 3A1.5 1.5 0 0 1 12 4.5V8H8V4.5A1.5 1.5 0 0 1 9.5 3h1Z\"/></symbol>\n<symbol id=\"icon-chart-bar\" viewBox=\"0 0 20 20\"><path d=\"M8 4.5A1.5 1.5 0 0 1 9.5 3h1A1.5 1.5 0 0 1 12 4.5v11a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 8 15.5v-11Zm-6 6A1.5 1.5 0 0 1 3.5 9h1A1.5 1.5 0 0 1 6 10.5v5A1.5 1.5 0 0 1 4.5 17h-1A1.5 1.5 0 0 1 2 15.5v-5ZM15.5 5h1A1.5 1.5 0 0 1 18 6.5v9a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 15.5 5Z\"/></symbol>\n<symbol id=\"icon-chart-donut\" viewBox=\"0 0 20 20\"><path d=\"M6.561 2.776a1 1 0 0 1 .86 1.806 6.003 6.003 0 0 0-1.662 9.663 6.007 6.007 0 0 0 5.265 1.667 6.003 6.003 0 0 0 4.397-3.34 1 1 0 0 1 1.807.857A8.001 8.001 0 1 1 6.561 2.776ZM10.998 2.063a7.998 7.998 0 0 1 5.187 2.862 8.001 8.001 0 0 1 1.752 4.078.844.844 0 0 1-.056.428l-.012.028a.875.875 0 0 1-.046.088l-.017.025a.903.903 0 0 1-.034.05l-.028.035a.977.977 0 0 1-.023.027l-.035.038-.033.03a.937.937 0 0 1-.074.06l-.03.022-.057.034-.024.014a.972.972 0 0 1-.164.07l-.008.003A.994.994 0 0 1 17 10h-1.54a.993.993 0 0 1-.244-.032l-.034-.009a1.021 1.021 0 0 1-.123-.044l-.037-.018a1.073 1.073 0 0 1-.23-.149l-.025-.02a1.234 1.234 0 0 1-.093-.092l-.01-.01-.018-.022c-.025-.03-.05-.06-.072-.092l-.017-.025a1.395 1.395 0 0 1-.15-.282l-.059-.196a4.463 4.463 0 0 0-.977-1.928l-.067-.076-.151-.158a4.458 4.458 0 0 0-2.162-1.195c-.016-.004-.03-.011-.046-.015-.484-.128-.89-.507-.94-.994A.991.991 0 0 1 10 4.54V3c0-.552.45-1.006.998-.937Z\"/></symbol>\n<symbol id=\"icon-chart-line\" viewBox=\"0 0 20 20\"><path d=\"M15.891 3.567c.31-.539 1-.727 1.54-.419l.097.062c.466.332.613.967.323 1.474l-4.907 8.561a.983.983 0 0 1-1.553.199l-3.264-3.321-4.045 6.354a1.132 1.132 0 0 1-1.559.348 1.125 1.125 0 0 1-.347-1.555l4.91-7.709a.983.983 0 0 1 1.53-.16l3.206 3.263 4.07-7.097Z\"/></symbol>\n<symbol id=\"icon-chart-pie\" viewBox=\"0 0 20 20\"><path d=\"M11.535 9.469h5.52c.555 0 1.01-.452.938-1a7.536 7.536 0 0 0-6.461-6.461c-.55-.073-1.001.382-1.001.937v5.52c0 .556.448 1.004 1.004 1.004Zm-2.51-5.435c0-.58-.492-1.045-1.06-.926A7.532 7.532 0 0 0 2 10.473 7.53 7.53 0 0 0 9.527 18a7.526 7.526 0 0 0 7.365-5.965c.119-.568-.345-1.06-.926-1.06H9.778a.75.75 0 0 1-.752-.753V4.034Z\"/></symbol>\n<symbol id=\"icon-circle-dashed\" viewBox=\"0 0 20 20\"><path d=\"M10.18 15.997c.552-.016 1.08.328 1.187.87.107.54-.246 1.073-.797 1.113a7.976 7.976 0 0 1-1.141 0c-.55-.04-.903-.572-.796-1.114.107-.541.635-.885 1.186-.869a6.371 6.371 0 0 0 .362 0ZM4.179 13.888c.459-.307 1.074-.177 1.453.225.082.088.167.172.255.254.402.379.532.995.224 1.454-.307.459-.933.586-1.35.224a8.056 8.056 0 0 1-.807-.807c-.361-.417-.234-1.043.225-1.35ZM14.368 14.113c.379-.402.995-.531 1.453-.224.459.307.586.932.224 1.35-.25.287-.52.556-.807.806-.417.361-1.042.235-1.35-.224-.306-.458-.177-1.074.225-1.453.088-.082.173-.167.255-.255ZM10 6a4 4 0 1 1 0 8 4 4 0 0 1 0-8ZM2.02 9.43c.04-.551.572-.905 1.114-.797.541.107.885.635.869 1.186a6.155 6.155 0 0 0 0 .362c.016.552-.329 1.08-.87 1.186-.542.107-1.074-.246-1.112-.797a8.095 8.095 0 0 1 0-1.14ZM16.866 8.633c.542-.107 1.074.245 1.114.796a8.004 8.004 0 0 1 0 1.141c-.04.55-.572.904-1.114.797-.541-.107-.885-.635-.869-1.186a6.375 6.375 0 0 0 0-.362c-.016-.551.328-1.079.87-1.186ZM4.76 3.954c.418-.362 1.044-.234 1.351.225.308.459.178 1.075-.224 1.454a6.055 6.055 0 0 0-.254.254c-.379.402-.995.532-1.454.224-.46-.307-.587-.933-.225-1.35.25-.288.52-.558.807-.807ZM13.888 4.179c.307-.46.933-.586 1.35-.225.288.25.558.52.807.807.362.417.235 1.043-.224 1.35-.458.308-1.075.178-1.454-.224a6.072 6.072 0 0 0-.254-.255c-.402-.379-.532-.994-.225-1.453ZM10 2c.192 0 .382.007.57.02.55.04.904.571.797 1.113-.107.541-.635.886-1.186.87a6.159 6.159 0 0 0-.362 0c-.551.016-1.079-.328-1.186-.87-.108-.541.246-1.074.797-1.112C9.618 2.007 9.808 2 10 2Z\"/></symbol>\n<symbol id=\"icon-dashboard\" viewBox=\"0 0 20 20\"><path d=\"M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm10 3c0-.84-.516-1.56-1.25-1.853V5.75A.748.748 0 0 0 10 5a.748.748 0 0 0-.75.75v5.397A1.999 1.999 0 0 0 10 15c1.103 0 2-.897 2-2ZM6.5 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5-4.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z\"/></symbol>\n<symbol id=\"icon-experiment\" viewBox=\"0 0 20 20\"><path d=\"M12.706 2.294a1.002 1.002 0 0 0-1.415 1.415l.293.291-8.706 8.706A2.999 2.999 0 0 0 2 14.828V15a3 3 0 0 0 3 3h.172c.797 0 1.56-.316 2.122-.878L16 8.416l.294.293a1.002 1.002 0 0 0 1.415-1.415l-5-5h-.003ZM8.416 10 13 5.416 14.584 7l-3 3H8.413h.003Z\"/></symbol>\n<symbol id=\"icon-filter-a-z\" viewBox=\"0 0 20 20\"><path d=\"m9.206 14.206-2.5 2.5c-.39.39-1.025.39-1.415 0l-2.5-2.5a1.002 1.002 0 0 1 1.415-1.415l.794.793V4a.999.999 0 1 1 2 0v9.584l.794-.793a1.002 1.002 0 0 1 1.415 1.415h-.003Zm5.688-10.653c1.584 3.166 2.415 4.834 2.5 5a1 1 0 1 1-1.788.894L15.381 9H12.62l-.225.447a.999.999 0 1 1-1.788-.894c.085-.166.916-1.834 2.5-5C13.275 3.216 13.622 3 14 3s.725.212.894.553ZM14 6.237 13.369 7.5h1.262L14 6.237ZM11 12c0-.553.447-1 1-1h4a1.004 1.004 0 0 1 .71 1.71L14.415 15H16a.999.999 0 1 1 0 2h-4a1.004 1.004 0 0 1-.71-1.71l2.294-2.293H12c-.553 0-1-.447-1-1V12Z\"/></symbol>\n<symbol id=\"icon-filter-z-a\" viewBox=\"0 0 20 20\"><path d=\"m9.206 14.206-2.5 2.5c-.39.39-1.025.39-1.415 0l-2.5-2.5a1.002 1.002 0 0 1 1.415-1.415l.794.793V4a.999.999 0 1 1 2 0v9.584l.794-.793a1.002 1.002 0 0 1 1.415 1.415h-.003ZM11 4c0-.553.447-1 1-1h4a1.004 1.004 0 0 1 .71 1.71L14.415 7H16a.999.999 0 1 1 0 2h-4a1.004 1.004 0 0 1-.71-1.71L13.589 5H12c-.553 0-1-.447-1-1Zm3.894 6.553 2.5 5a1 1 0 1 1-1.788.894L15.381 16H12.62l-.225.447a1 1 0 1 1-1.788-.894l2.5-5c.169-.337.516-.553.894-.553s.725.213.894.553ZM14 13.237l-.631 1.263h1.262L14 13.238Z\"/></symbol>\n<symbol id=\"icon-hourglass-clock\" viewBox=\"0 0 20 20\"><path d=\"M2 3c0-.553.447-1 1-1h10a.999.999 0 1 1 0 2v.344a5 5 0 0 1-1.466 3.534L9.412 10l.56.56a5.985 5.985 0 0 0-1.066 1.762L8 11.416l-2.122 2.121A2.999 2.999 0 0 0 5 15.66v.344h3.688c.187.728.509 1.406.937 2L3 18a.999.999 0 1 1 0-2v-.344a5 5 0 0 1 1.466-3.534L6.588 10 4.466 7.878A5 5 0 0 1 3 4.344V4c-.553 0-1-.447-1-1Zm3 1v.344c0 .797.316 1.56.878 2.122L8 8.588l2.122-2.122A2.999 2.999 0 0 0 11 4.344V4H5Zm5 10.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5-2.5c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5H16c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1v-1.5c0-.275-.225-.5-.5-.5Z\"/></symbol>\n<symbol id=\"icon-hourglass-end\" viewBox=\"0 0 20 20\"><path d=\"M5 2a.999.999 0 1 0 0 2v.344a5 5 0 0 0 1.466 3.534L8.588 10l-2.122 2.122A5 5 0 0 0 5 15.656V16a.999.999 0 1 0 0 2h10a.999.999 0 1 0 0-2v-.344a5 5 0 0 0-1.466-3.534L11.412 10l2.122-2.122A5 5 0 0 0 15 4.344V4a.999.999 0 1 0 0-2H5Zm2 2.344V4h6v.344c0 .797-.316 1.56-.878 2.122L10 8.588 7.878 6.466A3.004 3.004 0 0 1 7 4.344Z\"/></symbol>\n<symbol id=\"icon-hourglass-full\" viewBox=\"0 0 20 20\"><path d=\"M4 3c0-.553.447-1 1-1h10a.999.999 0 1 1 0 2v.344a5 5 0 0 1-1.466 3.534L11.412 10l2.122 2.122A5 5 0 0 1 15 15.656V16a.999.999 0 1 1 0 2H5a.999.999 0 1 1 0-2v-.344a5 5 0 0 1 1.466-3.534L8.588 10 6.466 7.878A5 5 0 0 1 5 4.344V4c-.553 0-1-.447-1-1Zm3 1v.344c0 .797.316 1.56.878 2.122L10 8.588l2.122-2.122A2.999 2.999 0 0 0 13 4.344V4H7Zm0 12h6v-.344c0-.797-.316-1.56-.878-2.122L10 11.412l-2.122 2.122A2.999 2.999 0 0 0 7 15.656V16Z\"/></symbol>\n<symbol id=\"icon-hourglass-half\" viewBox=\"0 0 20 20\"><path d=\"M5 2a.999.999 0 1 0 0 2v.344a5 5 0 0 0 1.466 3.534L8.588 10l-2.122 2.122A5 5 0 0 0 5 15.656V16a.999.999 0 1 0 0 2h10a.999.999 0 1 0 0-2v-.344a5 5 0 0 0-1.466-3.534L11.412 10l2.122-2.122A5 5 0 0 0 15 4.344V4a.999.999 0 1 0 0-2H5Zm2 2.344V4h6v.344c0 .593-.175 1.168-.5 1.656h-5A3.008 3.008 0 0 1 7 4.344ZM7.5 14c.11-.166.237-.322.378-.466L10 11.412l2.122 2.122c.144.144.269.3.381.466H7.5Z\"/></symbol>\n<symbol id=\"icon-hourglass-start\" viewBox=\"0 0 20 20\"><path d=\"M5 2a.999.999 0 1 0 0 2v.344a5 5 0 0 0 1.466 3.534L8.588 10l-2.122 2.122A5 5 0 0 0 5 15.656V16a.999.999 0 1 0 0 2h10a.999.999 0 1 0 0-2v-.344a5 5 0 0 0-1.466-3.534L11.412 10l2.122-2.122A5 5 0 0 0 15 4.344V4a.999.999 0 1 0 0-2H5Zm8 13.656V16H7v-.344c0-.797.316-1.56.878-2.122L10 11.412l2.122 2.122c.562.563.878 1.325.878 2.122Z\"/></symbol>\n<symbol id=\"icon-magnifying-glass-chart\" viewBox=\"0 0 20 20\"><path d=\"M15 8.5c0 1.434-.466 2.76-1.25 3.834l3.956 3.96a1.002 1.002 0 0 1-1.415 1.415l-3.957-3.959A6.499 6.499 0 0 1 2 8.5C2 4.91 4.91 2 8.5 2S15 4.91 15 8.5Zm-9.75.25v2c0 .416.334.75.75.75s.75-.334.75-.75v-2A.748.748 0 0 0 6 8a.748.748 0 0 0-.75.75Zm2.5-3v5c0 .416.334.75.75.75s.75-.334.75-.75v-5A.748.748 0 0 0 8.5 5a.748.748 0 0 0-.75.75Zm2.5 2v3c0 .416.334.75.75.75s.75-.334.75-.75v-3A.748.748 0 0 0 11 7a.748.748 0 0 0-.75.75Z\"/></symbol>\n<symbol id=\"icon-presentation\" viewBox=\"0 0 20 20\"><path d=\"M4 5v8h12V5H4ZM2 5c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2h-4.5l.5 1.5h2.25c.416 0 .75.334.75.75s-.334.75-.75.75h-8.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75H8l.5-1.5H4c-1.103 0-2-.897-2-2V5Zm9.75 1.5h2.5c.416 0 .75.334.75.75v2.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-.69l-2.219 2.218a.75.75 0 0 1-.531.219.75.75 0 0 1-.531-.219L8.25 9.31l-1.969 1.97a.75.75 0 0 1-1.06-1.06l2.5-2.5a.747.747 0 0 1 1.06 0l1.969 1.968 1.69-1.69h-.69a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75V6.5Z\"/></symbol>\n<symbol id=\"icon-trend-down\" viewBox=\"0 0 20 20\"><path d=\"M13.002 13a.999.999 0 1 0 0 2h5c.553 0 1-.448 1-1V9a.999.999 0 1 0-2 0v2.584L11.71 6.29a1.002 1.002 0 0 0-1.416 0l-3.29 3.294-4.294-4.291a1.002 1.002 0 0 0-1.416 1.416l5 5c.39.39 1.025.39 1.416 0l3.293-3.294 4.585 4.584h-2.585Z\"/></symbol>\n<symbol id=\"icon-trend-up\" viewBox=\"0 0 20 20\"><path d=\"M13 7a.999.999 0 1 1 0-2h5c.553 0 1 .447 1 1v5a.999.999 0 1 1-2 0V8.416l-5.294 5.293c-.39.391-1.025.391-1.415 0L7 10.416l-4.294 4.29a1.002 1.002 0 0 1-1.415-1.415l5-5c.39-.391 1.025-.391 1.415 0L11 11.584 15.584 7H13Z\"/></symbol>\n<symbol id=\"icon-angle-double-left\" viewBox=\"0 0 20 20\"><path d=\"M3.293 9.296c-.39.39-.39 1.025 0 1.416l5 5a1.002 1.002 0 0 0 1.416-1.416l-4.294-4.294 4.29-4.293A1.002 1.002 0 0 0 8.29 4.293l-5 5 .003.003Zm11-5-5 5c-.39.39-.39 1.025 0 1.416l5 5a1.002 1.002 0 0 0 1.416-1.416l-4.294-4.294 4.29-4.293a1.002 1.002 0 0 0-1.415-1.416l.003.003Z\"/></symbol>\n<symbol id=\"icon-angle-double-right\" viewBox=\"0 0 20 20\"><path d=\"M16.722 10.706c.39-.39.39-1.025 0-1.415l-5-5a1.002 1.002 0 0 0-1.416 1.415L14.6 10l-4.29 4.294a1.001 1.001 0 0 0 1.415 1.415l5-5-.003-.003Zm-11 5 5-5c.39-.39.39-1.025 0-1.415l-5-5a1.002 1.002 0 0 0-1.416 1.415L8.6 10l-4.29 4.294a1.001 1.001 0 0 0 1.415 1.415l-.003-.003Z\"/></symbol>\n<symbol id=\"icon-angle-down\" viewBox=\"0 0 20 20\"><path d=\"M9.294 13.706c.39.39 1.025.39 1.415 0l5-5a1.002 1.002 0 0 0-1.415-1.415L10 11.584l-4.294-4.29a1.002 1.002 0 0 0-1.415 1.415l5 5 .003-.003Z\"/></symbol>\n<symbol id=\"icon-angle-left\" viewBox=\"0 0 20 20\"><path d=\"M6.294 9.294c-.39.39-.39 1.025 0 1.415l5 5a1.002 1.002 0 0 0 1.415-1.415L8.416 10l4.29-4.294a1.002 1.002 0 0 0-1.415-1.415l-5 5 .003.003Z\"/></symbol>\n<symbol id=\"icon-angle-right\" viewBox=\"0 0 20 20\"><path d=\"M13.722 9.294c.39.39.39 1.025 0 1.415l-5 5a1.002 1.002 0 0 1-1.416-1.415L11.6 10 7.31 5.706a1.002 1.002 0 0 1 1.415-1.415l5 5-.003.003Z\"/></symbol>\n<symbol id=\"icon-angle-square-down\" viewBox=\"0 0 20 20\"><path d=\"M15 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10Zm-5.531-4.219-3.25-3.25a.75.75 0 0 1 1.06-1.06l2.718 2.72 2.719-2.72a.75.75 0 0 1 1.06 1.06l-3.245 3.25a.747.747 0 0 1-1.06 0H9.47Z\"/></symbol>\n<symbol id=\"icon-angle-square-left\" viewBox=\"0 0 20 20\"><path d=\"M3 15c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v10Zm4.219-5.531 3.25-3.25a.75.75 0 0 1 1.06 1.06l-2.72 2.718 2.72 2.719a.75.75 0 0 1-1.06 1.06l-3.25-3.245a.747.747 0 0 1 0-1.06V9.47Z\"/></symbol>\n<symbol id=\"icon-angle-square-right\" viewBox=\"0 0 20 20\"><path d=\"M17 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5Zm-4.219 5.531-3.25 3.25a.75.75 0 0 1-1.06-1.06l2.72-2.718-2.72-2.719a.75.75 0 0 1 1.06-1.06l3.25 3.245a.747.747 0 0 1 0 1.06v.002Z\"/></symbol>\n<symbol id=\"icon-angle-square-up\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm5.531 4.219 3.25 3.25a.75.75 0 0 1-1.06 1.06l-2.718-2.72-2.719 2.72a.75.75 0 0 1-1.06-1.06l3.245-3.25a.747.747 0 0 1 1.06 0h.002Z\"/></symbol>\n<symbol id=\"icon-angle-up\" viewBox=\"0 0 20 20\"><path d=\"M9.294 6.294c.39-.39 1.025-.39 1.415 0l5 5a1.002 1.002 0 0 1-1.415 1.415L10 8.416l-4.294 4.29a1.002 1.002 0 0 1-1.415-1.415l5-5 .003.003Z\"/></symbol>\n<symbol id=\"icon-arrow-down\" viewBox=\"0 0 20 20\"><path d=\"M9.294 17.706c.39.39 1.025.39 1.415 0l5-5a1.002 1.002 0 0 0-1.415-1.415L11 14.584V3a.999.999 0 1 0-2 0v11.584l-3.294-3.293a1.002 1.002 0 0 0-1.415 1.415l5 5h.003Z\"/></symbol>\n<symbol id=\"icon-arrow-expand\" viewBox=\"0 0 20 20\"><path d=\"M13 2a.999.999 0 1 0 0 2h1.584l-3.293 3.294a1.002 1.002 0 0 0 1.415 1.415L16 5.416V7a.999.999 0 1 0 2 0V3c0-.553-.447-1-1-1h-4Zm-4.294 9.294a1.002 1.002 0 0 0-1.415 0L4 14.584V13a.999.999 0 1 0-2 0v4c0 .553.447 1 1 1h4a.999.999 0 1 0 0-2H5.416l3.293-3.294c.391-.39.391-1.025 0-1.415l-.003.003Z\"/></symbol>\n<symbol id=\"icon-arrow-left\" viewBox=\"0 0 20 20\"><path d=\"M2.294 9.294c-.39.39-.39 1.025 0 1.415l5 5a1.002 1.002 0 0 0 1.415-1.415L5.416 11H17a.999.999 0 1 0 0-2H5.416l3.293-3.294a1.002 1.002 0 0 0-1.415-1.415l-5 5v.003Z\"/></symbol>\n<symbol id=\"icon-arrow-right\" viewBox=\"0 0 20 20\"><path d=\"M17.706 10.706c.39-.39.39-1.025 0-1.415l-5-5a1.002 1.002 0 0 0-1.415 1.415L14.584 9H3a.999.999 0 1 0 0 2h11.584l-3.293 3.294a1.002 1.002 0 0 0 1.415 1.415l5-5v-.003Z\"/></symbol>\n<symbol id=\"icon-arrow-square-down\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm4.469 10.781-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.218 1.22V6.75c0-.416.334-.75.75-.75.415 0 .75.334.75.75v4.69l1.219-1.218a.75.75 0 0 1 1.06 1.06l-2.501 2.5a.747.747 0 0 1-1.06 0h.004Z\"/></symbol>\n<symbol id=\"icon-arrow-square-left\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm1.219 6.469 2.5-2.5a.75.75 0 0 1 1.06 1.06l-1.22 1.218h4.691c.416 0 .75.334.75.75 0 .415-.334.75-.75.75H8.56l1.218 1.219a.75.75 0 0 1-1.06 1.06l-2.5-2.501a.747.747 0 0 1 0-1.06v.004Z\"/></symbol>\n<symbol id=\"icon-arrow-square-right\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm6.281 10.031a.75.75 0 0 1-1.06-1.06l1.22-1.218H6.75a.748.748 0 0 1-.75-.75c0-.415.334-.75.75-.75h4.69l-1.218-1.219a.75.75 0 0 1 1.06-1.06l2.5 2.501a.747.747 0 0 1 0 1.06l-2.5 2.5v-.004Z\"/></symbol>\n<symbol id=\"icon-arrow-square-up\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm5.531 3.219 2.5 2.5a.75.75 0 0 1-1.06 1.06l-1.218-1.22v4.691c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V8.56L8.034 9.777a.75.75 0 0 1-1.06-1.06l2.501-2.5a.747.747 0 0 1 1.06 0h-.004Z\"/></symbol>\n<symbol id=\"icon-arrow-up\" viewBox=\"0 0 20 20\"><path d=\"M10.706 2.544a1.001 1.001 0 0 0-1.415 0l-5 5a1.002 1.002 0 0 0 1.415 1.415L9 5.666V17.25a.999.999 0 1 0 2 0V5.666l3.294 3.293a1.002 1.002 0 0 0 1.415-1.415l-5-5h-.003Z\"/></symbol>\n<symbol id=\"icon-arrows-h\" viewBox=\"0 0 20 20\"><path d=\"m15.706 13.706 3-3c.39-.39.39-1.025 0-1.415l-3-3a1.002 1.002 0 0 0-1.415 1.415L15.584 9H4.413l1.293-1.294a1.002 1.002 0 0 0-1.415-1.415l-3 3a.998.998 0 0 0 0 1.412l3 3a1.001 1.001 0 0 0 1.415-1.415l-1.293-1.294h11.171l-1.293 1.293a1.002 1.002 0 0 0 1.415 1.416v.003Z\"/></symbol>\n<symbol id=\"icon-arrows-v\" viewBox=\"0 0 20 20\"><path d=\"M10.706 1.294a1.001 1.001 0 0 0-1.415 0l-3 3a1.002 1.002 0 0 0 1.415 1.415L9 4.416v11.168l-1.294-1.29a1.001 1.001 0 0 0-1.415 1.415l3 3a.998.998 0 0 0 1.412 0l3-3a1.002 1.002 0 0 0-1.415-1.415l-1.294 1.293V4.417l1.293 1.293a1.002 1.002 0 0 0 1.416-1.415l-3-3h.003Z\"/></symbol>\n<symbol id=\"icon-compress\" viewBox=\"0 0 20 20\"><path d=\"M17.706 3.706a1.001 1.001 0 0 0-1.415-1.415L12.5 6.084V4.5a.999.999 0 1 0-2 0v4c0 .553.447 1 1 1h4a.999.999 0 1 0 0-2h-1.584l3.793-3.794h-.003ZM4.5 10.5a.999.999 0 1 0 0 2h1.584l-3.793 3.794a1.001 1.001 0 0 0 1.415 1.415L7.5 13.916V15.5a.999.999 0 1 0 2 0v-4c0-.553-.447-1-1-1h-4Z\"/></symbol>\n<symbol id=\"icon-exchange\" viewBox=\"0 0 20 20\"><path d=\"m17.706 6.706-3 3a1.001 1.001 0 0 1-1.415-1.415L14.584 7H3a.999.999 0 1 1 0-2h11.584l-1.293-1.294a1.002 1.002 0 0 1 1.415-1.415l3 3c.39.39.39 1.025 0 1.415Zm-12.415 11-3-3a1.002 1.002 0 0 1 0-1.415l3-3a1.002 1.002 0 0 1 1.415 1.415L5.416 13H17a.999.999 0 1 1 0 2H5.416l1.293 1.294a1.002 1.002 0 0 1-1.415 1.415l-.003-.003Z\"/></symbol>\n<symbol id=\"icon-expand\" viewBox=\"0 0 20 20\"><path d=\"M13 2a.999.999 0 1 0 0 2h1.584l-3.293 3.294a1.002 1.002 0 0 0 1.415 1.415L16 5.416V7a.999.999 0 1 0 2 0V3c0-.553-.447-1-1-1h-4Zm-4.294 9.294a1.002 1.002 0 0 0-1.415 0L4 14.584V13a.999.999 0 1 0-2 0v4c0 .553.447 1 1 1h4a.999.999 0 1 0 0-2H5.416l3.293-3.294c.391-.39.391-1.025 0-1.415l-.003.003Z\"/></symbol>\n<symbol id=\"icon-redo\" viewBox=\"0 0 20 20\"><path d=\"M15.647 4.334 16 4.67V3a.999.999 0 1 1 2 0v4c0 .553-.447 1-1 1h-4a.999.999 0 1 1 0-2h1.497l-.238-.225-.018-.019a5.998 5.998 0 0 0-8.485 0 5.998 5.998 0 0 0 0 8.485 5.998 5.998 0 0 0 9.169-.816 1.002 1.002 0 0 1 1.64 1.147 7.997 7.997 0 0 1-12.222 1.084A8 8 0 0 1 15.648 4.334Z\"/></symbol>\n<symbol id=\"icon-reduce\" viewBox=\"0 0 20 20\"><path d=\"M16 15a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h12Z\"/></symbol>\n<symbol id=\"icon-sign-in\" viewBox=\"0 0 20 20\"><path d=\"M13 5h2c.553 0 1 .447 1 1v8c0 .553-.447 1-1 1h-2a.999.999 0 1 0 0 2h2a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a.999.999 0 1 0 0 2Zm-.294 5.706c.39-.39.39-1.025 0-1.415l-4-4a1.002 1.002 0 0 0-1.415 1.415L9.584 9H3a.999.999 0 1 0 0 2h6.584l-2.293 2.294a1.002 1.002 0 0 0 1.415 1.415l4-4v-.003Z\"/></symbol>\n<symbol id=\"icon-sign-out\" viewBox=\"0 0 20 20\"><path d=\"M7 5a.999.999 0 1 0 0-2H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2a.999.999 0 1 0 0-2H5c-.553 0-1-.447-1-1V6c0-.553.447-1 1-1h2Zm10.706 5.706c.39-.39.39-1.025 0-1.415l-4-4a1.002 1.002 0 0 0-1.415 1.415L14.584 9H8a.999.999 0 1 0 0 2h6.584l-2.293 2.294a1.002 1.002 0 0 0 1.415 1.415l4-4v-.003Z\"/></symbol>\n<symbol id=\"icon-sort-down\" viewBox=\"0 0 20 20\"><path d=\"M9.294 18.706c.39.39 1.025.39 1.415 0l4-4a1.002 1.002 0 0 0-1.415-1.415L11 15.584V2a.999.999 0 1 0-2 0v13.584l-2.294-2.293a1.002 1.002 0 0 0-1.415 1.415l4 4h.003Z\"/></symbol>\n<symbol id=\"icon-sort-up\" viewBox=\"0 0 20 20\"><path d=\"M10.706 1.294a1.001 1.001 0 0 0-1.415 0l-4 4a1.002 1.002 0 0 0 1.415 1.415L9 4.416V18a.999.999 0 1 0 2 0V4.416l2.294 2.293a1.002 1.002 0 0 0 1.415-1.415l-4-4h-.003Z\"/></symbol>\n<symbol id=\"icon-sync\" viewBox=\"0 0 20 20\"><path d=\"M4.06 9.14a6.002 6.002 0 0 1 10.184-3.384l.018.019L14.5 6h-1.497a.999.999 0 1 0 0 2h4c.553 0 1-.447 1-1V3a.999.999 0 1 0-2 0v1.669l-.353-.335A8 8 0 0 0 2.081 8.86a.998.998 0 1 0 1.978.285V9.14Zm13.859 2a1 1 0 0 0-.847-1.13 1.003 1.003 0 0 0-1.131.846 6.002 6.002 0 0 1-10.185 3.385l-.018-.02-.238-.224h1.497a.999.999 0 1 0 0-2L3 12a.995.995 0 0 0-.71.297.997.997 0 0 0-.29.712l.031 3.97a.997.997 0 0 0 1.01.99.999.999 0 0 0 .99-1.01L4.02 15.35l.334.316A8 8 0 0 0 17.92 11.14Z\"/></symbol>\n<symbol id=\"icon-undo\" viewBox=\"0 0 20 20\"><path d=\"M10 4a5.988 5.988 0 0 0-4.472 2H7a.999.999 0 1 1 0 2H3c-.553 0-1-.447-1-1V3a.999.999 0 1 1 2 0v1.71A8 8 0 0 1 18 10a8 8 0 0 1-14.566 4.572 1.002 1.002 0 0 1 1.641-1.147A6.002 6.002 0 0 0 16 9.997 5.999 5.999 0 0 0 10 4Z\"/></symbol>\n<symbol id=\"icon-announcement-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-4.507-4.511A5.971 5.971 0 0 0 16 9V7.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75V9c0 1.228-.49 2.34-1.29 3.153l-1.06-1.06A3 3 0 0 0 13 9V5a3 3 0 0 0-6 0v.944L2.281 1.225v-.003Zm9.322 13.562-1.294-1.293A4.501 4.501 0 0 1 5.503 9v-.32L4.141 7.32a.738.738 0 0 0-.138.431V9a6 6 0 0 0 5.25 5.953V16.5h-1.5a.748.748 0 0 0-.75.75c0 .416.335.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5v-1.547c.29-.037.575-.094.853-.169h-.003Z\"/></symbol>\n<symbol id=\"icon-announcement\" viewBox=\"0 0 20 20\"><path d=\"M10 2a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3ZM5.5 7.75A.748.748 0 0 0 4.75 7a.748.748 0 0 0-.75.75V9a6 6 0 0 0 5.25 5.953V16.5h-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5v-1.547A6 6 0 0 0 16 9V7.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75V9a4.501 4.501 0 0 1-9 0V7.75Z\"/></symbol>\n<symbol id=\"icon-headset\" viewBox=\"0 0 20 20\"><path d=\"M10 4a5.003 5.003 0 0 0-4.928 4.147C5.362 8.053 5.675 8 6 8h.5A1.5 1.5 0 0 1 8 9.5v3A1.5 1.5 0 0 1 6.5 14H6a3 3 0 0 1-3-3V9a7 7 0 0 1 14 0v5.253a3.752 3.752 0 0 1-3.753 3.75L10.5 18h-1a1.5 1.5 0 0 1 0-3h1a1.5 1.5 0 0 1 1.5 1.5h1.25a2.249 2.249 0 0 0 2.25-2.25v-.653c-.44.256-.953.4-1.5.4h-.5a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h.5c.325 0 .634.05.928.147A5.004 5.004 0 0 0 10 3.997V4Z\"/></symbol>\n<symbol id=\"icon-pause\" viewBox=\"0 0 20 20\"><path d=\"M5.5 3A1.5 1.5 0 0 0 4 4.5v11A1.5 1.5 0 0 0 5.5 17h2A1.5 1.5 0 0 0 9 15.5v-11A1.5 1.5 0 0 0 7.5 3h-2Zm7 0A1.5 1.5 0 0 0 11 4.5v11a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 14.5 3h-2Z\"/></symbol>\n<symbol id=\"icon-play\" viewBox=\"0 0 20 20\"><path d=\"M5.85 3.153A1.25 1.25 0 0 0 4 4.25v11.5a1.249 1.249 0 0 0 1.85 1.097l10.5-5.75a1.252 1.252 0 0 0 0-2.194l-10.5-5.75Z\"/></symbol>\n<symbol id=\"icon-record\" viewBox=\"0 0 20 20\"><path d=\"M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z\"/></symbol>\n<symbol id=\"icon-stop\" viewBox=\"0 0 20 20\"><path d=\"M5 3h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2Z\"/></symbol>\n<symbol id=\"icon-volume-down\" viewBox=\"0 0 20 20\"><path d=\"M4.5 13H6l4.19 3.725a1.088 1.088 0 0 0 1.81-.813V4.088a1.088 1.088 0 0 0-1.81-.813L6 7H4.5A1.5 1.5 0 0 0 3 8.5v3A1.5 1.5 0 0 0 4.5 13Zm10.394-5.328a.75.75 0 1 0-.947 1.166c.337.275.553.693.553 1.162s-.216.887-.553 1.166a.753.753 0 0 0-.11 1.056.753.753 0 0 0 1.057.11A3.015 3.015 0 0 0 16 10c0-.94-.434-1.778-1.11-2.328h.004Z\"/></symbol>\n<symbol id=\"icon-volume-mute\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-7.782-7.78V4.09a1.088 1.088 0 0 0-1.81-.813L6.62 5.563 2.28 1.222ZM3.82 7H3.5A1.5 1.5 0 0 0 2 8.5v3A1.5 1.5 0 0 0 3.5 13H5l4.19 3.725a1.088 1.088 0 0 0 1.81-.813v-1.73L3.819 7Zm10.91-1.55a.75.75 0 0 0 .109 1.056A4.49 4.49 0 0 1 16.5 10a4.478 4.478 0 0 1-.931 2.74l1.068 1.07A5.983 5.983 0 0 0 18 10a5.995 5.995 0 0 0-2.216-4.656.75.75 0 0 0-1.056.11V5.45Zm-1.338 5.112 1.103 1.104a2.997 2.997 0 0 0-.603-3.994.75.75 0 1 0-.947 1.166c.34.275.553.693.553 1.165 0 .2-.038.388-.11.563l.004-.004Z\"/></symbol>\n<symbol id=\"icon-volume-off\" viewBox=\"0 0 20 20\"><path d=\"M2.5 13H4l4.19 3.725a1.088 1.088 0 0 0 1.81-.813V4.088a1.088 1.088 0 0 0-1.81-.813L4 7H2.5A1.5 1.5 0 0 0 1 8.5v3A1.5 1.5 0 0 0 2.5 13Zm9.969-5.531a.747.747 0 0 0 0 1.06l1.469 1.468-1.47 1.469a.75.75 0 0 0 1.06 1.06l1.469-1.47 1.469 1.469a.75.75 0 0 0 1.06-1.06l-1.47-1.468 1.469-1.469a.75.75 0 0 0-1.06-1.06l-1.468 1.47-1.469-1.47a.747.747 0 0 0-1.06 0Z\"/></symbol>\n<symbol id=\"icon-volume-up\" viewBox=\"0 0 20 20\"><path d=\"M16.675 3.016a.75.75 0 1 0-.947 1.165A7.47 7.47 0 0 1 18.5 10a7.481 7.481 0 0 1-2.772 5.822.753.753 0 0 0-.11 1.056.753.753 0 0 0 1.057.11A8.994 8.994 0 0 0 20 10a8.978 8.978 0 0 0-3.325-6.984Zm-1.89 2.328a.75.75 0 1 0-.947 1.165A4.483 4.483 0 0 1 15.5 10c0 1.41-.647 2.666-1.662 3.494a.753.753 0 0 0-.11 1.056.753.753 0 0 0 1.056.11A5.996 5.996 0 0 0 17 10.002a5.995 5.995 0 0 0-2.216-4.656v-.003Zm-1.891 2.328a.75.75 0 1 0-.947 1.166c.337.275.553.693.553 1.162s-.216.887-.553 1.166a.753.753 0 0 0-.11 1.056.753.753 0 0 0 1.057.11 3.004 3.004 0 0 0 0-4.66ZM2.5 13H4l4.19 3.725a1.088 1.088 0 0 0 1.81-.813V4.088a1.088 1.088 0 0 0-1.81-.813L4 7H2.5A1.5 1.5 0 0 0 1 8.5v3A1.5 1.5 0 0 0 2.5 13Z\"/></symbol>\n<symbol id=\"icon-calendar-plus\" viewBox=\"0 0 20 20\"><path d=\"M7 2.5c.553 0 1 .447 1 1v1h4v-1a.999.999 0 1 1 2 0v1h1c1.103 0 2 .897 2 2v9c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-9c0-1.103.897-2 2-2h1v-1c0-.553.447-1 1-1Zm3 6a.748.748 0 0 0-.75.75v1.5h-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h1.5v1.5c0 .416.334.75.75.75s.75-.334.75-.75v-1.5h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5v-1.5A.748.748 0 0 0 10 8.5Z\"/></symbol>\n<symbol id=\"icon-calendar-times\" viewBox=\"0 0 20 20\"><path d=\"M7 2.5c.553 0 1 .447 1 1v1h4v-1a.999.999 0 1 1 2 0v1h1c1.103 0 2 .897 2 2v9c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-9c0-1.103.897-2 2-2h1v-1c0-.553.447-1 1-1Zm5.122 6.878a.747.747 0 0 0-1.06 0l-1.059 1.06-1.06-1.06a.75.75 0 0 0-1.06 1.06l1.06 1.059-1.059 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06 1.059 1.059a.75.75 0 0 0 1.06-1.06l-1.06-1.06 1.059-1.059a.747.747 0 0 0 0-1.059Z\"/></symbol>\n<symbol id=\"icon-calendar\" viewBox=\"0 0 20 20\"><path d=\"M7 2.5c.553 0 1 .447 1 1v1h4v-1a.999.999 0 1 1 2 0v1h1c1.103 0 2 .897 2 2v9c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-9c0-1.103.897-2 2-2h1v-1c0-.553.447-1 1-1ZM5 10v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5Zm4 0v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5Zm4.5-.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1ZM5 14v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5Zm4.5-.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1Zm3.5.5v1c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5Z\"/></symbol>\n<symbol id=\"icon-clock-one\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm.75-12.25v1.772l.625-.938a.754.754 0 0 1 1.04-.209.753.753 0 0 1 .21 1.04l-2 3A.748.748 0 0 1 9.253 10V5.751c0-.416.335-.75.75-.75.416 0 .75.334.75.75h-.003Z\"/></symbol>\n<symbol id=\"icon-clock-three\" viewBox=\"0 0 20 20\"><path d=\"M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm-.75 3.75V10c0 .416.334.75.75.75h3.25c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-2.5v-3.5A.748.748 0 0 0 10 5a.748.748 0 0 0-.75.75Z\"/></symbol>\n<symbol id=\"icon-clock\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm.75-12.25V10c0 .416-.334.75-.75.75H6.75A.748.748 0 0 1 6 10c0-.416.334-.75.75-.75h2.5v-3.5c0-.416.334-.75.75-.75s.75.334.75.75Z\"/></symbol>\n<symbol id=\"icon-history\" viewBox=\"0 0 20 20\"><path d=\"M10 4c3.313 0 6 2.688 6 6a6.002 6.002 0 0 1-10.925 3.428 1.002 1.002 0 0 0-1.64 1.147A7.994 7.994 0 0 0 10 18a8 8 0 0 0 8-8A8 8 0 0 0 3.5 5.334V4.5a.999.999 0 1 0-2 0V8c0 .553.447 1 1 1h3.503a.999.999 0 1 0 0-2H4.806A5.99 5.99 0 0 1 10 4Zm.75 2.75A.748.748 0 0 0 10 6a.748.748 0 0 0-.75.75V10c0 .2.078.39.219.531l2.25 2.25a.75.75 0 0 0 1.06-1.06l-2.032-2.03V6.75h.003Z\"/></symbol>\n<symbol id=\"icon-moon\" viewBox=\"0 0 20 20\"><path d=\"M10 2a8 8 0 0 0-8 8 8 8 0 0 0 13.54 5.769.752.752 0 0 0 .166-.847.752.752 0 0 0-.743-.44A5.75 5.75 0 0 1 11.94 3.6a.75.75 0 0 0-.17-1.404A8.103 8.103 0 0 0 10 2Z\"/></symbol>\n<symbol id=\"icon-sun\" viewBox=\"0 0 20 20\"><path d=\"M6.569 1.684a.75.75 0 0 1 .703.07l2.744 1.818 2.743-1.819a.76.76 0 0 1 .704-.069c.23.094.393.3.443.544l.653 3.225 3.225.653c.244.05.45.219.544.447a.76.76 0 0 1-.069.703L16.441 10l1.818 2.744a.76.76 0 0 1 .07.703.74.74 0 0 1-.545.447l-3.228.65-.65 3.228a.753.753 0 0 1-.447.544.76.76 0 0 1-.703-.07l-2.744-1.818-2.743 1.819a.76.76 0 0 1-.703.069.74.74 0 0 1-.447-.544l-.65-3.228-3.228-.653a.753.753 0 0 1-.544-.447.76.76 0 0 1 .069-.703L3.584 10 1.766 7.256a.76.76 0 0 1-.07-.703.74.74 0 0 1 .545-.447l3.228-.65.653-3.228a.753.753 0 0 1 .447-.544ZM7.487 10a2.512 2.512 0 1 1 5.025 0 2.512 2.512 0 0 1-5.025 0Zm6.525 0a4.012 4.012 0 1 0-8.024 0 4.012 4.012 0 0 0 8.024 0Z\"/></symbol>\n<symbol id=\"icon-callback\" viewBox=\"0 0 20 20\"><path d=\"M6.429 3a.64.64 0 0 0-.63.653v2.769a.64.64 0 0 0 .63.653.64.64 0 0 0 .63-.653V5.228l2.495 2.584a.612.612 0 0 0 .89 0l2.521-2.611a.667.667 0 0 0 0-.923.615.615 0 0 0-.89 0L10 6.428 7.95 4.302h1.152a.64.64 0 0 0 .63-.653.638.638 0 0 0-.63-.65H6.43Zm9.64 13.916a1.045 1.045 0 0 0 1.329-.473l.076-.136c.872-1.583.735-3.846-.98-5.002a11.595 11.595 0 0 0-12.988 0c-1.717 1.156-1.851 3.422-.98 5.002l.077.136c.265.482.835.683 1.329.473l2.56-1.09c.436-.185.701-.645.654-1.13l-.16-1.65a8.694 8.694 0 0 1 6.019.106l-.148 1.542c-.047.484.218.944.654 1.129l2.56 1.09-.002.003Z\"/></symbol>\n<symbol id=\"icon-chat-bot\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2c.553 0 1 .447 1 1v2h3a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3V3c0-.553.447-1 1-1Zm2.536 11.219a.979.979 0 0 0-1.309.067 1.814 1.814 0 0 1-1.971.393 1.811 1.811 0 0 1-.587-.392.978.978 0 0 0-1.383 0l-.066.073a.978.978 0 0 0 .066 1.309 3.769 3.769 0 0 0 4.103.817c.4-.165.767-.4 1.087-.69l.134-.127a.978.978 0 0 0 0-1.382l-.074-.068ZM7 8.5a1.501 1.501 0 1 0 0 3.002A1.501 1.501 0 0 0 7 8.5Zm6 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z\" clip-rule=\"evenodd\"/><path d=\"M1 9c.553 0 1 .447 1 1v3a.999.999 0 1 1-2 0v-3c0-.553.447-1 1-1ZM19 9c.553 0 1 .447 1 1v3a.999.999 0 1 1-2 0v-3c0-.553.447-1 1-1Z\"/></symbol>\n<symbol id=\"icon-chat-widget\" viewBox=\"0 0 20 20\"><path d=\"M16 3c1.103 0 2 .897 2 2v3.5h-2V5H4v10h4.5v2H4l-.203-.01a2 2 0 0 1-1.784-1.784L2 15V5c0-1.034.788-1.888 1.797-1.99L4 3h12Zm.5 7a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5h5Z\"/></symbol>\n<symbol id=\"icon-chat\" viewBox=\"0 0 20 20\"><path d=\"M2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3Zm4.75 1.5h6.5c.416 0 .75.334.75.75s-.334.75-.75.75h-6.5A.748.748 0 0 1 6 8.25c0-.416.334-.75.75-.75Zm0 3h3.5c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-dixa-messenger\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7.856 2.861c3.075-1.772 7.007-.723 8.782 2.347a6.417 6.417 0 0 1-2.355 8.77L9.662 16.64l-.944.542-1.378.796a.152.152 0 0 1-.229-.132v-3.156c0-.186-.05-.37-.143-.532l-4.39-7.586a.582.582 0 0 1 .216-.796l5.063-2.916Zm-.231 4.176c-.552 0-1 .451-1 1.008 0 .556.448 1.006 1 1.006s1-.45 1-1.006c0-.557-.448-1.008-1-1.008Zm3 0c-.553 0-1 .451-1 1.008 0 .556.448 1.006 1 1.006s1-.45 1-1.006c0-.557-.448-1.008-1-1.008Zm3 0c-.552 0-1 .451-1 1.008 0 .556.448 1.006 1 1.006s1-.45 1-1.006c0-.557-.448-1.008-1-1.008Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-facebook-messenger\" viewBox=\"0 0 20 20\"><path d=\"M10 2c4.516 0 8 3.32 8 7.77 0 5.64-5.387 8.8-10.323 7.446-.29-.064-.322 0-2 .742-.225.064-.451.064-.612-.065-.194-.096-.29-.29-.29-.516-.065-1.483 0-1.611-.259-1.87C2.936 14.122 2 12.09 2 9.77 2 5.32 5.484 2 10 2Zm4.806 5.996c.226-.354-.193-.774-.548-.516l-2.516 1.902c-.194.13-.42.13-.58 0L9.29 7.996c-.29-.193-.613-.29-.935-.225-.355.064-.645.257-.807.548l-2.354 3.707c-.226.354.193.774.548.516l2.516-1.902c.194-.13.42-.13.58 0l1.872 1.386c.29.193.613.29.967.226.323-.065.613-.258.775-.549l2.354-3.707Z\"/></symbol>\n<symbol id=\"icon-generic-api\" viewBox=\"0 0 20 20\"><path d=\"M2 12V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-3.75a.756.756 0 0 0-.45.15l-3.6 2.7a.748.748 0 0 1-1.2-.6V15H5a3 3 0 0 1-3-3Zm8.969-6.031a.747.747 0 0 0 0 1.06l1.469 1.468-1.47 1.469a.75.75 0 0 0 1.06 1.06l2-2.001a.747.747 0 0 0 0-1.06l-2-2a.747.747 0 0 0-1.06 0v.004ZM9.03 7.03a.75.75 0 0 0-1.06-1.06l-2 2a.747.747 0 0 0 0 1.06l2 2a.75.75 0 0 0 1.06-1.06L7.562 8.504l1.47-1.469v-.003Z\"/></symbol>\n<symbol id=\"icon-instagram\" viewBox=\"0 0 20 20\"><path d=\"M10 12.899c1.585 0 2.86-1.276 2.86-2.899A2.853 2.853 0 0 0 10 7.14c-1.623 0-2.899 1.275-2.899 2.86A2.895 2.895 0 0 0 10 12.899Z\"/><path fill-rule=\"evenodd\" d=\"M2 10c0-2.485 0-3.728.406-4.708a5.333 5.333 0 0 1 2.886-2.886C6.272 2 7.515 2 10 2c2.485 0 3.727 0 4.708.406a5.333 5.333 0 0 1 2.886 2.886C18 6.272 18 7.515 18 10c0 2.485 0 3.727-.406 4.708a5.333 5.333 0 0 1-2.886 2.886C13.728 18 12.485 18 10 18c-2.485 0-3.728 0-4.708-.406a5.333 5.333 0 0 1-2.886-2.886C2 13.728 2 12.485 2 10Zm8-4.444c2.435 0 4.444 2.01 4.444 4.444A4.445 4.445 0 0 1 10 14.444 4.42 4.42 0 0 1 5.556 10 4.445 4.445 0 0 1 10 5.556Zm5.395.03c0-.51-.409-.92-.92-.92-.51 0-.92.41-.92.92 0 .511.41.92.92.92.511 0 .92-.409.92-.92Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-mail\" viewBox=\"0 0 20 20\"><path d=\"M3.5 4a1.5 1.5 0 0 0-.9 2.7l6.5 4.875a1.5 1.5 0 0 0 1.8 0L17.4 6.7a1.5 1.5 0 0 0-.9-2.7h-13ZM2 8.125V14c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8.125l-6.2 4.65a3 3 0 0 1-3.6 0L2 8.125Z\"/></symbol>\n<symbol id=\"icon-messaging-settings\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15 3a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-3.75a.757.757 0 0 0-.45.15l-3.6 2.7a.748.748 0 0 1-1.2-.6V16H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10Zm-3.58 3.387c-.184-.346-.635-.485-1.005-.313-.37.173-.415.393-.415.86V8.8H7.75a.763.763 0 0 0-.638.332.66.66 0 0 0-.033.681l1.5 2.8c.185.346.636.485 1.006.313.37-.173.415-.393.415-.944V10.2h2.25c.26 0 .501-.126.638-.332a.66.66 0 0 0 .033-.681l-1.5-2.8Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-messenger\" viewBox=\"0 0 20 20\"><path d=\"M2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3Zm4 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z\"/></symbol>\n<symbol id=\"icon-mim-advisor\" viewBox=\"0 0 20 20\"><path d=\"M7.855 2.861a6.435 6.435 0 0 1 8.783 2.347 6.387 6.387 0 0 1 .862 3.204 6.417 6.417 0 0 1-3.216 5.565L9.661 16.64l-.943.543-1.38.794a.152.152 0 0 1-.228-.13V14.69c0-.186-.05-.37-.143-.532L2.578 6.573a.583.583 0 0 1 .215-.797l5.062-2.915ZM13.5 6c-.74 0-1.384.403-1.73 1h-1.54A1.998 1.998 0 0 0 6.5 8a2 2 0 0 0 4 0h1a2 2 0 1 0 2-2Zm-5 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm5 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\"/></symbol>\n<symbol id=\"icon-mim-sidekick\" viewBox=\"0 0 20 20\"><path d=\"M7.856 2.861c3.076-1.772 7.007-.723 8.782 2.347a6.416 6.416 0 0 1-2.355 8.769L9.662 16.64l-.943.542-1.378.796a.153.153 0 0 1-.23-.132V14.69c0-.186-.05-.37-.143-.532L2.579 6.573a.583.583 0 0 1 .214-.797l5.063-2.915Zm5.063 6.747c-.085 0-.169.05-.186.135l-.354.946-.963.371c-.068.017-.118.102-.118.17 0 .084.05.169.118.186l.963.354.354.963c.017.068.101.118.186.118.067 0 .152-.05.169-.118l.372-.963.945-.354c.085-.017.136-.102.136-.187 0-.067-.052-.152-.136-.169l-.945-.37-.372-.947c-.017-.084-.102-.135-.17-.135ZM9.1 5.284a.254.254 0 0 0-.236.169l-.896 1.926-1.925.878a.28.28 0 0 0-.152.254c0 .1.05.202.152.252l1.925.878.896 1.926a.254.254 0 0 0 .236.17.296.296 0 0 0 .254-.17l.878-1.926 1.926-.894a.255.255 0 0 0 .169-.236.297.297 0 0 0-.17-.254l-1.925-.878-.878-1.926a.296.296 0 0 0-.254-.17Zm3.818-1.081c-.085 0-.169.05-.186.135l-.354.946-.963.371c-.068.017-.118.101-.118.169 0 .084.05.169.118.186l.963.355.354.963c.017.067.101.118.186.118.067 0 .152-.05.169-.118l.372-.963.945-.355c.085-.017.136-.102.136-.186 0-.068-.052-.152-.136-.169l-.945-.371-.372-.946c-.017-.085-.102-.135-.17-.135Z\"/></symbol>\n<symbol id=\"icon-mim\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7.856 2.862a6.434 6.434 0 0 1 8.782 2.346 6.385 6.385 0 0 1 .862 3.204 6.417 6.417 0 0 1-3.216 5.565L9.661 16.64l-.944.542-1.378.796a.152.152 0 0 1-.229-.132v-3.156c0-.187-.05-.37-.143-.533L2.578 6.573a.582.582 0 0 1 .214-.796l5.064-2.915Zm.65 5.245c.345 0 .623.28.623.627h.003a1.891 1.891 0 0 0 .547 1.329 1.865 1.865 0 0 0 1.319.55 1.854 1.854 0 0 0 1.319-.55 1.879 1.879 0 0 0 .546-1.329h.003c0-.346.279-.627.623-.627.343 0 .622.28.622.627a3.156 3.156 0 0 1-.912 2.218 3.112 3.112 0 0 1-2.201.919 3.094 3.094 0 0 1-2.202-.919 3.137 3.137 0 0 1-.912-2.218c0-.346.279-.627.623-.627Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone\" viewBox=\"0 0 20 20\"><path d=\"M7.006 2.781a1.27 1.27 0 0 0-1.503-.737l-.172.047c-2.019.55-3.744 2.506-3.24 4.887A14.214 14.214 0 0 0 13.02 17.91c2.385.507 4.338-1.221 4.888-3.24l.047-.172a1.265 1.265 0 0 0-.734-1.503l-3.04-1.266a1.268 1.268 0 0 0-1.47.369l-1.206 1.475a10.702 10.702 0 0 1-4.981-5.156L7.906 7.29a1.27 1.27 0 0 0 .369-1.47l-1.269-3.04Z\"/></symbol>\n<symbol id=\"icon-simultaneous\" viewBox=\"0 0 20 20\"><path d=\"M7 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9Z\"/><path d=\"M11 2a2 2 0 0 1 2 2v1.5H9A3.5 3.5 0 0 0 5.5 9v4H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7Z\"/></symbol>\n<symbol id=\"icon-sms\" viewBox=\"0 0 20 20\"><path d=\"M2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3Zm4.4 1.4H7c.275 0 .5.225.5.5s-.225.5-.5.5h-.6a.3.3 0 0 0 0 .6 1.299 1.299 0 1 1 0 2.6h-.8a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h.8a.3.3 0 0 0 0-.6 1.299 1.299 0 1 1 0-2.6Zm5.9 1.3c0-.719.581-1.3 1.3-1.3h.6c.275 0 .5.225.5.5s-.225.5-.5.5h-.6a.3.3 0 0 0 0 .6 1.299 1.299 0 1 1 0 2.6h-.8a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h.8a.3.3 0 0 0 0-.6c-.719 0-1.3-.581-1.3-1.3ZM9.228 7.644 10 8.928l.772-1.284a.5.5 0 0 1 .928.256v3.2c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.706l-.272.453a.502.502 0 0 1-.428.244.502.502 0 0 1-.428-.244L9.3 9.706V11.1c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V7.9a.499.499 0 0 1 .928-.256Z\"/></symbol>\n<symbol id=\"icon-trustpilot\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M18 8.115 5.06 18l1.888-6.115L2 8.11l6.116.006L10.003 2l1.887 6.115H18Z\" clip-rule=\"evenodd\"/><path d=\"m13.488 13.274-3.485.95L14.95 18l-1.463-4.726Z\"/></symbol>\n<symbol id=\"icon-twitter\" viewBox=\"0 0 20 20\"><path d=\"M14.599 3h2.43l-5.346 5.957L18 17h-4.928l-3.888-4.88L4.777 17H2.312l5.727-6.327L2 3h5.067l3.471 4.476L14.598 3Zm-.868 12.586h1.354L6.338 4.346H4.881l8.85 11.24Z\"/></symbol>\n<symbol id=\"icon-voicemail\" viewBox=\"0 0 20 20\"><path d=\"M6.25 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM13.75 8.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z\"/><path fill-rule=\"evenodd\" d=\"M16 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12Zm-2.25 3.25a2.75 2.75 0 0 0-2.447 4H8.697a2.75 2.75 0 1 0-2.447 1.5l.006-.001 7.517.001v-.002a2.748 2.748 0 0 0-.023-5.498Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-whatsapp\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M18 9.964c0-2.143-.929-4.107-2.429-5.607A7.802 7.802 0 0 0 9.964 2C5.607 2 2.036 5.571 2.036 9.929c0 1.428.393 2.785 1.071 3.964L2 18l4.179-1.071c1.178.607 2.464.964 3.785.964 4.393 0 8.036-3.572 8.036-7.929Zm-4.21 1.781c.107.055.185.095.21.17.071.072.071.465-.107.929-.179.464-.964.893-1.322.928-.642.107-1.142.072-2.392-.5-1.75-.75-2.954-2.375-3.299-2.841a1.826 1.826 0 0 0-.094-.123C6.679 10.165 6 9.237 6 8.237c0-.87.407-1.334.618-1.573l.06-.07a.67.67 0 0 1 .536-.25h.39c.132-.003.267-.006.432.357.087.24.282.695.428 1.036.092.216.165.387.179.428.036.107.071.214 0 .357-.161.338-.336.517-.461.643-.152.155-.228.233-.11.429.785 1.321 1.535 1.786 2.714 2.357.178.107.285.071.428-.036.035-.046.099-.125.173-.217.157-.194.362-.447.434-.569.143-.214.286-.178.465-.107.178.072 1.143.536 1.357.643.053.032.102.057.147.08Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-working\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 4a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-at\" viewBox=\"0 0 20 20\"><path d=\"M10 4c-3.313 0-6 2.688-6 6 0 3.313 2.688 6 6 6a.999.999 0 1 1 0 2 8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8v1a3 3 0 0 1-5.287 1.94 4 4 0 1 1-.378-6.187A.999.999 0 0 1 14 7.5V11a.999.999 0 1 0 1.999 0v-1c0-3.313-2.688-6-6-6Zm2 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z\"/></symbol>\n<symbol id=\"icon-chat-plus\" viewBox=\"0 0 20 20\"><path d=\"M2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3Zm8 .5c.416 0 .75.334.75.75v1.5h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v1.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-1.5h-1.5A.748.748 0 0 1 7 9.5c0-.416.334-.75.75-.75h1.5v-1.5c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-chat-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-2.182-2.18A2.995 2.995 0 0 0 18 13.004v-7a3 3 0 0 0-3-3L5 3c-.288 0-.566.04-.828.116l-1.89-1.894Zm-.19 4.05C2.03 5.503 2 5.75 2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15h1.569L2.09 5.272Z\"/></symbol>\n<symbol id=\"icon-chat-x\" viewBox=\"0 0 20 20\"><path d=\"M2 6v7a3 3 0 0 0 3 3h1v2.25a.748.748 0 0 0 1.2.6l3.6-2.7a.756.756 0 0 1 .45-.15H15a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3Zm10.122 1.378a.747.747 0 0 1 0 1.06l-1.06 1.059 1.06 1.06a.75.75 0 0 1-1.06 1.06l-1.059-1.06-1.06 1.059a.75.75 0 0 1-1.06-1.06l1.06-1.06-1.059-1.059a.75.75 0 0 1 1.06-1.06l1.06 1.06 1.059-1.059a.747.747 0 0 1 1.059 0Z\"/></symbol>\n<symbol id=\"icon-conversations\" viewBox=\"0 0 20 20\"><path d=\"M10.667 2c1.105 0 2 .894 2 2v5.333c0 1.106-.895 2-2 2h-2.89L5.462 13.44a.442.442 0 0 1-.3.117h-.05a.446.446 0 0 1-.444-.445v-1.778H4c-1.106 0-2-.894-2-2V4c0-1.106.894-2 2-2h6.667ZM7.333 13.778v-.24l.961-.871h2.373A3.332 3.332 0 0 0 14 9.333V6.444h2c1.106 0 2 .895 2 2v5.334c0 1.105-.894 2-2 2h-.667v1.778c0 .244-.2.444-.444.444h-.05a.447.447 0 0 1-.3-.117l-2.317-2.105H9.333c-1.105 0-2-.895-2-2Z\"/></symbol>\n<symbol id=\"icon-forward-all\" viewBox=\"0 0 20 20\"><path d=\"M8.619 3.073A1 1 0 0 0 8 3.998v2.5H6.5a5.5 5.5 0 0 0-5.5 5.5 6.128 6.128 0 0 0 3.131 5.441c.078.044.166.06.253.06.341 0 .616-.279.616-.616 0-.235-.134-.45-.306-.61C4.4 15.998 4 15.448 4 14.502a3 3 0 0 1 3-3h1v2.5a1.004 1.004 0 0 0 1.71.709l5-5c.39-.39.39-1.025 0-1.416l-5-5a.996.996 0 0 0-1.091-.215v-.007Zm3.96.147a.747.747 0 0 0 0 1.06l4.715 4.718-4.719 4.716a.75.75 0 0 0 1.06 1.06l5.053-5.05c.2-.188.312-.45.312-.726a.993.993 0 0 0-.313-.725l-5.05-5.053a.747.747 0 0 0-1.059 0Z\"/></symbol>\n<symbol id=\"icon-forward\" viewBox=\"0 0 20 20\"><path d=\"M11.619 3.071a1 1 0 0 0-.619.925v2.5H7.5a5.5 5.5 0 0 0-5.5 5.5 6.128 6.128 0 0 0 3.131 5.44c.078.045.166.06.253.06.341 0 .616-.278.616-.615 0-.235-.134-.45-.306-.61C5.4 15.996 5 15.446 5 14.5a3 3 0 0 1 3-3h3V14a1.004 1.004 0 0 0 1.71.71l5-5c.39-.39.39-1.025 0-1.416l-5-5a.996.996 0 0 0-1.091-.216v-.006Z\"/></symbol>\n<symbol id=\"icon-phone-hang\" viewBox=\"0 0 20 20\"><path d=\"M17.4 12.493c-.266.438-.835.622-1.33.43l-2.56-.993c-.435-.168-.7-.587-.653-1.028l.15-1.405a9.476 9.476 0 0 0-6.02-.097l.16 1.504c.048.441-.217.86-.653 1.029l-2.563.99c-.494.194-1.064.008-1.329-.43l-.076-.124c-.872-1.442-.735-3.504.98-4.557 3.936-2.416 9.051-2.416 12.988 0 1.717 1.053 1.851 3.117.98 4.557l-.077.124h.003Z\"/></symbol>\n<symbol id=\"icon-phone-incoming\" viewBox=\"0 0 20 20\"><path d=\"M5.503 2.044a1.265 1.265 0 0 1 1.503.734l1.266 3.04a1.268 1.268 0 0 1-.369 1.47L6.525 8.416a10.703 10.703 0 0 0 4.978 5.153l1.21-1.475a1.27 1.27 0 0 1 1.468-.369l3.038 1.269c.587.244.903.887.734 1.503l-.047.172c-.55 2.022-2.503 3.747-4.887 3.244A14.214 14.214 0 0 1 2.087 6.98c-.503-2.384 1.222-4.337 3.241-4.89l.172-.047h.003ZM17.781 3.28 14.563 6.5h1.69c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75v-3.5c0-.416.335-.75.75-.75.416 0 .75.334.75.75v1.69l3.219-3.218a.75.75 0 0 1 1.06 1.06Z\"/></symbol>\n<symbol id=\"icon-phone-outgoing\" viewBox=\"0 0 20 20\"><path d=\"M5.503 2.044a1.265 1.265 0 0 1 1.503.734l1.266 3.04a1.268 1.268 0 0 1-.369 1.47L6.525 8.416a10.703 10.703 0 0 0 4.978 5.153l1.21-1.475a1.27 1.27 0 0 1 1.468-.369l3.038 1.269c.587.244.903.887.734 1.503l-.047.172c-.55 2.022-2.503 3.747-4.887 3.244A14.214 14.214 0 0 1 2.087 6.98c-.503-2.384 1.222-4.337 3.241-4.89l.172-.047h.003Zm6.716 4.675L15.438 3.5h-1.691A.75.75 0 1 1 13.75 2h3.5c.416 0 .75.334.75.75v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V4.56l-3.219 3.218a.75.75 0 0 1-1.06-1.06h-.002Z\"/></symbol>\n<symbol id=\"icon-phone-plus\" viewBox=\"0 0 20 20\"><path d=\"M5.503 2.044a1.265 1.265 0 0 1 1.503.734l1.266 3.04a1.268 1.268 0 0 1-.369 1.47L6.525 8.416a10.703 10.703 0 0 0 4.978 5.153l1.21-1.475a1.27 1.27 0 0 1 1.468-.369l3.038 1.269c.587.244.903.887.734 1.503l-.047.172c-.55 2.022-2.503 3.747-4.887 3.244A14.214 14.214 0 0 1 2.087 6.98c-.503-2.384 1.222-4.337 3.241-4.89l.172-.047h.003ZM15 2c.416 0 .75.334.75.75v1.5h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v1.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-1.5h-1.5A.748.748 0 0 1 12 5c0-.416.334-.75.75-.75h1.5v-1.5c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-rec\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M3.6 6C2.7 6 2 6.68 2 7.5v6c0 .844.7 1.5 1.6 1.5h12.8c.875 0 1.6-.656 1.6-1.5v-6c0-.82-.725-1.5-1.6-1.5H3.6Zm3.926 3.801c0 .524-.277.985-.692 1.265l.583.782a.562.562 0 0 1-.154.798l-.008.006a.65.65 0 0 1-.852-.144l-.002-.004-.853-1.152h-.4v.817c0 .327-.287.576-.614.576-.342 0-.614-.255-.614-.576V9.104c0-.465.399-.854.911-.854h1.04c.91 0 1.655.699 1.655 1.551Zm-1.228 0c0 .225-.19.4-.426.4h-.724v-.8h.724c.233 0 .426.181.426.4Zm9.601-.077a.632.632 0 0 1-.868-.002 1.148 1.148 0 0 0-1.584.002 1.062 1.062 0 0 0 0 1.556c.46.423 1.123.424 1.584.002a.632.632 0 0 1 .868-.002c.24.225.228.581.009.804l-.005.005-.005.004a2.428 2.428 0 0 1-3.316 0l-.002-.002a2.159 2.159 0 0 1 0-3.178l.002-.002a2.428 2.428 0 0 1 3.316 0l.005.004.005.005a.555.555 0 0 1-.009.804ZM8.831 8.25h2.08c.334 0 .615.264.615.576 0 .327-.288.576-.614.576H9.148v.52h1.17c.332 0 .614.263.614.576 0 .326-.288.575-.615.575H9.148v.52h1.764c.333 0 .614.264.614.576 0 .327-.288.576-.614.576h-2.08c-.51 0-.912-.377-.912-.854V9.104c0-.465.399-.854.911-.854Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-reply-all\" viewBox=\"0 0 20 20\"><path d=\"M11.381 2.575A1 1 0 0 1 12 3.5V6h1.5a5.5 5.5 0 0 1 5.5 5.5 6.128 6.128 0 0 1-3.131 5.44.511.511 0 0 1-.253.06.617.617 0 0 1-.616-.616c0-.234.134-.45.306-.609.294-.275.694-.825.694-1.772a3 3 0 0 0-3-3h-1v2.5a1.004 1.004 0 0 1-1.71.71l-5-5a1.002 1.002 0 0 1 0-1.416l5-5a.996.996 0 0 1 1.091-.216v-.006Zm-3.956.147a.747.747 0 0 1 0 1.06L2.706 8.5l4.719 4.716a.75.75 0 0 1-1.06 1.06L1.313 9.224A.993.993 0 0 1 1 8.5c0-.275.113-.538.313-.725l5.05-5.053a.747.747 0 0 1 1.059 0h.003Z\"/></symbol>\n<symbol id=\"icon-reply\" viewBox=\"0 0 20 20\"><path d=\"M8.381 2.575A1 1 0 0 1 9 3.5V6h3.5a5.5 5.5 0 0 1 5.5 5.5 6.128 6.128 0 0 1-3.131 5.44.512.512 0 0 1-.253.06.617.617 0 0 1-.616-.616c0-.234.134-.45.306-.609.294-.275.694-.825.694-1.772a3 3 0 0 0-3-3H9v2.5a1.004 1.004 0 0 1-1.71.71l-5-5a1.002 1.002 0 0 1 0-1.416l5-5a.996.996 0 0 1 1.091-.216v-.006Z\"/></symbol>\n<symbol id=\"icon-social\" viewBox=\"0 0 20 20\"><path d=\"M14 8a3 3 0 1 0-2.96-2.5L6.989 7.753a3 3 0 1 0 0 4.494L11.04 14.5a3 3 0 1 0 .972-1.747L7.958 10.5c.029-.162.041-.328.041-.5a3.27 3.27 0 0 0-.04-.5l4.052-2.253A2.985 2.985 0 0 0 14 8Z\"/></symbol>\n<symbol id=\"icon-subtitle\" viewBox=\"0 0 20 20\"><path d=\"M4 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2H4Zm.75 5.5h5.5c.416 0 .75.334.75.75s-.334.75-.75.75h-5.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Zm8.5 0h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Zm-8.5 3h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Zm5 0h5.5c.416 0 .75.334.75.75s-.334.75-.75.75h-5.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-tag\" viewBox=\"0 0 20 20\"><path d=\"M3.016 5v4.672a2 2 0 0 0 .584 1.415l6 6a2 2 0 0 0 2.828 0l4.672-4.671a2 2 0 0 0 0-2.829l-6-6A1.983 1.983 0 0 0 9.688 3H5.016c-1.103 0-2 .897-2 2Zm3.5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\"/></symbol>\n<symbol id=\"icon-tags\" viewBox=\"0 0 20 20\"><path d=\"m13.537 3.222 4.632 4.697a2.25 2.25 0 0 1 0 3.162l-4.888 4.947a.75.75 0 0 1-1.065-1.053l4.887-4.95a.75.75 0 0 0 0-1.053L12.47 4.278a.75.75 0 0 1 1.065-1.053l.003-.003ZM2.003 9.172V5c0-1.103.897-2 2-2h4.172a2 2 0 0 1 1.416.584l4.5 4.5a2 2 0 0 1 0 2.829l-4.172 4.171a2 2 0 0 1-2.828 0l-4.5-4.5a2 2 0 0 1-.585-1.415l-.003.003Zm4.5-2.672a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z\"/></symbol>\n<symbol id=\"icon-transcript\" viewBox=\"0 0 20 20\"><path d=\"M10 3.06 4.013 7.493l4.94 3.662c.166.122.35.216.547.272V16.5c0 .172.016.337.04.5H4c-1.103 0-2-.897-2-2V7.503c0-.634.3-1.231.81-1.606l6.143-4.553a1.772 1.772 0 0 1 2.094 0l6.144 4.553c.225.165.409.375.543.612A2.94 2.94 0 0 0 17.5 6.5h-2.856L10 3.06Zm1 6.44A1.5 1.5 0 0 1 12.5 8h5A1.5 1.5 0 0 1 19 9.5v7a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-7Zm2.5.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h3c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-3Zm0 3a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h1.75c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75H13.5Z\"/></symbol>\n<symbol id=\"icon-video\" viewBox=\"0 0 20 20\"><path d=\"M4 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2H4Zm11.5 8.5 2.297 1.838A.74.74 0 0 0 19 13.76V6.24a.74.74 0 0 0-1.203-.578L15.5 7.5v5Z\"/></symbol>\n<symbol id=\"icon-widget-customize\" viewBox=\"0 0 20 20\"><path d=\"M16.7 1.5a1.498 1.498 0 0 1 2.122 0l.684.684c.59.591.585 1.55-.012 2.132L18.25 5.53l-2.79-2.79L16.7 1.5Zm-1.947 1.95 2.785 2.784L13 10.675a1.999 1.999 0 0 1-.766.469L10 11.89a.754.754 0 0 1-.769-.182.744.744 0 0 1-.181-.768l.744-2.228c.097-.294.262-.563.481-.782l4.478-4.481ZM2.013 7.5a2.5 2.5 0 0 1 2.5-2.5h3.5a.999.999 0 1 1 0 2h-3.5c-.275 0-.5.225-.5.5v7c0 .275.225.5.5.5h11c.274 0 .5-.225.5-.5V11a.999.999 0 1 1 2 0v3.5a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-7Zm5 2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\"/></symbol>\n<symbol id=\"icon-align-center\" viewBox=\"0 0 20 20\"><path d=\"M14 4c0-.553-.447-1-1-1H7a.999.999 0 1 0 0 2h6c.553 0 1-.447 1-1Zm3 4c0-.553-.447-1-1-1H4a.999.999 0 1 0 0 2h12c.553 0 1-.447 1-1ZM3 16c0 .553.447 1 1 1h12a.999.999 0 1 0 0-2H4c-.553 0-1 .447-1 1Zm11-4c0-.553-.447-1-1-1H7a.999.999 0 1 0 0 2h6c.553 0 1-.447 1-1Z\"/></symbol>\n<symbol id=\"icon-align-justify\" viewBox=\"0 0 20 20\"><path d=\"M17 4c0-.553-.447-1-1-1H4a.999.999 0 1 0 0 2h12c.553 0 1-.447 1-1Zm0 8c0-.553-.447-1-1-1H4a.999.999 0 1 0 0 2h12c.553 0 1-.447 1-1ZM3 8c0 .553.447 1 1 1h12a.999.999 0 1 0 0-2H4c-.553 0-1 .447-1 1Zm14 8c0-.553-.447-1-1-1H4a.999.999 0 1 0 0 2h12c.553 0 1-.447 1-1Z\"/></symbol>\n<symbol id=\"icon-align-left\" viewBox=\"0 0 20 20\"><path d=\"M12 4c0 .553-.447 1-1 1H4a.999.999 0 1 1 0-2h7c.553 0 1 .447 1 1Zm0 8c0 .553-.447 1-1 1H4a.999.999 0 1 1 0-2h7c.553 0 1 .447 1 1ZM3 8c0-.553.447-1 1-1h12a.999.999 0 1 1 0 2H4c-.553 0-1-.447-1-1Zm14 8c0 .553-.447 1-1 1H4a.999.999 0 1 1 0-2h12c.553 0 1 .447 1 1Z\"/></symbol>\n<symbol id=\"icon-align-right\" viewBox=\"0 0 20 20\"><path d=\"M17 4c0 .553-.447 1-1 1H9a.999.999 0 1 1 0-2h7c.553 0 1 .447 1 1Zm0 8c0 .553-.447 1-1 1H9a.999.999 0 1 1 0-2h7c.553 0 1 .447 1 1ZM3 8c0-.553.447-1 1-1h12a.999.999 0 1 1 0 2H4c-.553 0-1-.447-1-1Zm14 8c0 .553-.447 1-1 1H4a.999.999 0 1 1 0-2h12c.553 0 1 .447 1 1Z\"/></symbol>\n<symbol id=\"icon-anchor\" viewBox=\"0 0 20 20\"><path d=\"M10 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM7 5a3 3 0 1 1 4 2.828v8.06a4.498 4.498 0 0 0 3.497-4.266l-.503.44a.752.752 0 0 1-.988-1.13l2-1.75a.75.75 0 0 1 .988 0l2 1.75a.751.751 0 0 1-.988 1.13l-.506-.44A6.5 6.5 0 0 1 10 18a6.5 6.5 0 0 1-6.5-6.378l-.506.444a.752.752 0 0 1-.988-1.132l2-1.75a.75.75 0 0 1 .988 0l2 1.75a.751.751 0 0 1-.988 1.132l-.503-.441A4.505 4.505 0 0 0 9 15.891V7.83a3 3 0 0 1-2-2.828V5Z\"/></symbol>\n<symbol id=\"icon-bold\" viewBox=\"0 0 20 20\"><path d=\"M5 3a.999.999 0 1 0 0 2h1v10H5a.999.999 0 1 0 0 2h7a4 4 0 0 0 2.063-7.428A4 4 0 0 0 11 3H5Zm8 4c0 1.103-.897 2-2 2H8V5h3c1.103 0 2 .897 2 2Zm-5 8v-4h4c1.103 0 2 .897 2 2s-.897 2-2 2H8Z\"/></symbol>\n<symbol id=\"icon-callout\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm3.75 9.5h.75v-2h-.75A.748.748 0 0 1 8 9.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v2.75h.25c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75ZM10 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\"/></symbol>\n<symbol id=\"icon-code-block\" viewBox=\"0 0 20 20\"><path d=\"M3 5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5Zm8.219 1.969a.747.747 0 0 0 0 1.06l1.969 1.968-1.97 1.969a.75.75 0 0 0 1.06 1.06l2.5-2.501a.747.747 0 0 0 0-1.06l-2.5-2.5a.747.747 0 0 0-1.06 0v.004ZM8.78 8.03a.75.75 0 0 0-1.06-1.06L5.22 9.47a.747.747 0 0 0 0 1.06l2.5 2.5a.75.75 0 0 0 1.06-1.06L6.808 10l1.97-1.969h.002Z\"/></symbol>\n<symbol id=\"icon-copy\" viewBox=\"0 0 20 20\"><path d=\"M9 2c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V5.731c0-.543-.222-1.065-.616-1.444l-1.803-1.73A2.004 2.004 0 0 0 13.197 2H9ZM5 6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-.5h-2v.5H5V8h.5V6H5Z\"/></symbol>\n<symbol id=\"icon-cut\" viewBox=\"0 0 20 20\"><path d=\"m8 10-1.234 1.234A3.476 3.476 0 0 0 5.5 11 3.498 3.498 0 0 0 2 14.5C2 16.434 3.566 18 5.5 18S9 16.434 9 14.5c0-.447-.084-.872-.234-1.266L17.6 4.4a.564.564 0 0 0 0-.8 2.261 2.261 0 0 0-3.2 0L10 8 8.766 6.766C8.919 6.372 9 5.946 9 5.5 9 3.566 7.434 2 5.5 2A3.498 3.498 0 0 0 2 5.5C2 7.434 3.566 9 5.5 9c.447 0 .872-.084 1.266-.234L8 10Zm3.06 3.06 3.34 3.34a2.261 2.261 0 0 0 3.2 0 .564.564 0 0 0 0-.8l-4.54-4.54-2 2ZM4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM5.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z\"/></symbol>\n<symbol id=\"icon-divider\" viewBox=\"0 0 20 20\"><path d=\"M4.75 3h11.375v3.77c0 .519-.41.922-.875.922H4.75c-.492 0-.875-.403-.875-.923V3h.875Zm0 9.308h10.5c.465 0 .875.432.875.923V17H3.875v-3.77c0-.49.383-.922.875-.922Zm-1.094-3h12.688c.355 0 .656.317.656.692 0 .404-.3.692-.656.692H3.656C3.273 10.692 3 10.404 3 10c0-.375.273-.692.656-.692Z\"/></symbol>\n<symbol id=\"icon-download\" viewBox=\"0 0 20 20\"><path d=\"m14.706 8.706-4 4c-.39.39-1.025.39-1.415 0l-4-4a1.002 1.002 0 0 1 1.415-1.415L9 9.584V3a.999.999 0 1 1 2 0v6.584l2.294-2.293a1.002 1.002 0 0 1 1.415 1.415h-.003ZM5 13v2c0 .553.447 1 1 1h8c.553 0 1-.447 1-1v-2a.999.999 0 1 1 2 0v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2a.999.999 0 1 1 2 0Z\"/></symbol>\n<symbol id=\"icon-enter\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M14 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h8Zm-.938 3.5a.624.624 0 0 0-.612.636v1.272a.625.625 0 0 1-.613.637H8.774V7.772a.64.64 0 0 0-.378-.588.597.597 0 0 0-.668.137l-2.45 2.545.001.002a.655.655 0 0 0 0 .9l2.45 2.545a.594.594 0 0 0 .668.138c.23-.1.377-.332.377-.589V11.59h3.063c1.692 0 3.063-1.424 3.063-3.182V7.136a.625.625 0 0 0-.613-.636h-1.225Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-format\" viewBox=\"0 0 20 20\"><path d=\"M6 5v1a.999.999 0 1 1-2 0V4.25C4 3.56 4.56 3 5.25 3h9.5c.69 0 1.25.56 1.25 1.25V6a.999.999 0 1 1-2 0V5h-3v10h1.5a.999.999 0 1 1 0 2h-5a.999.999 0 1 1 0-2H9V5H6Z\"/></symbol>\n<symbol id=\"icon-heading-1\" viewBox=\"0 0 20 20\"><path d=\"M16 5a.993.993 0 0 0-.475-.85.998.998 0 0 0-.972-.044l-2 1a1 1 0 1 0 .894 1.788L14 6.619V14h-1a.999.999 0 1 0 0 2h4a.999.999 0 1 0 0-2h-1V5ZM4 5a.999.999 0 1 0-2 0v10a.999.999 0 1 0 2 0v-4h4v4a.999.999 0 1 0 2 0V5a.999.999 0 1 0-2 0v4H4V5Z\"/></symbol>\n<symbol id=\"icon-heading-2\" viewBox=\"0 0 20 20\"><path d=\"M4 5a.999.999 0 1 0-2 0v10a.999.999 0 1 0 2 0v-4h3v4a.999.999 0 1 0 2 0V5a.999.999 0 1 0-2 0v4H4V5Zm8.5-1a.999.999 0 1 0 0 2h2.534a1.215 1.215 0 0 1 .603 2.272l-2.384 1.362A4.464 4.464 0 0 0 11 13.516V15c0 .553.447 1 1 1h5a.999.999 0 1 0 0-2h-4v-.484a2.47 2.47 0 0 1 1.247-2.147l2.384-1.363A3.216 3.216 0 0 0 15.034 4H12.5Z\"/></symbol>\n<symbol id=\"icon-heading-3\" viewBox=\"0 0 20 20\"><path d=\"M4 5a.999.999 0 1 0-2 0v10a.999.999 0 1 0 2 0v-4h3v4a.999.999 0 1 0 2 0V5a.999.999 0 1 0-2 0v4H4V5Zm8 5c0 .553.447 1 1 1h1.75a1.5 1.5 0 0 1 0 3H12a.999.999 0 1 0 0 2h2.75a3.498 3.498 0 0 0 2.45-6 3.498 3.498 0 0 0-2.45-6H12a.999.999 0 1 0 0 2h2.75a1.5 1.5 0 0 1 0 3H13c-.553 0-1 .447-1 1Z\"/></symbol>\n<symbol id=\"icon-heading\" viewBox=\"0 0 20 20\"><path d=\"M3 4c0-.553.447-1 1-1h3a.999.999 0 1 1 0 2h-.5v3.5h7V5H13a.999.999 0 1 1 0-2h3a.999.999 0 1 1 0 2h-.5v10h.5a.999.999 0 1 1 0 2h-3a.999.999 0 1 1 0-2h.5v-4.5h-7V15H7a.999.999 0 1 1 0 2H4a.999.999 0 1 1 0-2h.5V5H4c-.553 0-1-.447-1-1Z\"/></symbol>\n<symbol id=\"icon-image-inline\" viewBox=\"0 0 20 20\"><path d=\"M16 15a.999.999 0 1 1 0 2H4a.999.999 0 1 1 0-2h12ZM16 11a.999.999 0 1 1 0 2H4a.999.999 0 1 1 0-2h12Z\"/><path fill-rule=\"evenodd\" d=\"M8.143 3c.472 0 .857.385.857.857v4.286A.858.858 0 0 1 8.143 9H3.857A.858.858 0 0 1 3 8.143V3.857C3 3.385 3.385 3 3.857 3h4.286Zm-1.5 2.573a.323.323 0 0 0-.275.154l-.822 1.346-.354-.507a.322.322 0 0 0-.527 0l-.75 1.072a.322.322 0 0 0 .264.505H7.82a.32.32 0 0 0 .275-.489L6.917 5.726a.323.323 0 0 0-.274-.155v.002Zm-1.93-1.502a.643.643 0 1 0 .002 1.286.643.643 0 0 0-.001-1.286Z\" clip-rule=\"evenodd\"/><path d=\"M16 7a.999.999 0 1 1 0 2h-4a.999.999 0 1 1 0-2h4ZM16 3a.999.999 0 1 1 0 2h-4a.999.999 0 1 1 0-2h4Z\"/></symbol>\n<symbol id=\"icon-image\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm2 2.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 9c.262 0 .503.137.64.36l2.75 4.5a.747.747 0 0 1-.64 1.14h-8.5a.753.753 0 0 1-.666-.403.752.752 0 0 1 .05-.775l1.75-2.5a.75.75 0 0 1 .616-.319.75.75 0 0 1 .616.319l.825 1.181 1.918-3.14a.754.754 0 0 1 .641-.36V9Z\"/></symbol>\n<symbol id=\"icon-italic\" viewBox=\"0 0 20 20\"><path d=\"M8 4c0-.553.447-1 1-1h6a.999.999 0 1 1 0 2h-1.834L9 15h2a.999.999 0 1 1 0 2H5a.999.999 0 1 1 0-2h1.834L11 5H9c-.553 0-1-.447-1-1Z\"/></symbol>\n<symbol id=\"icon-link-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-3.813-3.812c.13-.106.259-.221.378-.34l2.222-2.222a4.89 4.89 0 0 0-6.625-7.184c.634.315 1.209.734 1.703 1.234a2.89 2.89 0 0 1 3.506 4.538l-2.222 2.221a2.815 2.815 0 0 1-.394.329l-1.484-1.485c.516-.028.928-.45.944-.972V9.91c0-2.697-2.185-4.903-4.89-4.903-.6 0-1.185.11-1.735.319L2.28 1.222ZM8.06 7h.054c.471 0 .921.116 1.315.319.056.037.113.072.172.097.838.509 1.4 1.434 1.4 2.487v.038L8.06 7Zm3.76 8L7 10.181a4.888 4.888 0 0 0 4.816 4.816l.003.003ZM5.366 8.547 3.95 7.13 2.431 8.65a4.89 4.89 0 0 0 3.46 8.347 4.9 4.9 0 0 0 3.165-1.163A6.422 6.422 0 0 1 7.35 14.6a2.89 2.89 0 0 1-3.503-4.54l1.519-1.52v.007Z\"/></symbol>\n<symbol id=\"icon-link\" viewBox=\"0 0 20 20\"><path d=\"M14.11 5c-.52 0-1.022.14-1.463.397a6.407 6.407 0 0 0-1.703-1.235 4.89 4.89 0 0 1 6.625 7.184l-2.222 2.223A4.89 4.89 0 0 1 7 10.109c0-.046 0-.093.003-.14a1 1 0 1 1 2 .056v.081a2.89 2.89 0 0 0 4.934 2.044l2.222-2.222a2.89 2.89 0 0 0-2.044-4.934L14.11 5ZM9.6 7.416a.933.933 0 0 1-.172-.097 2.888 2.888 0 0 0-3.36.528l-2.221 2.222a2.89 2.89 0 0 0 3.503 4.54c.494.5 1.069.92 1.706 1.235A4.89 4.89 0 0 1 2.431 8.66l2.222-2.223a4.89 4.89 0 0 1 3.456-1.43C10.816 5.006 13 7.212 13 9.908v.122a1 1 0 1 1-2-.05V9.91a2.912 2.912 0 0 0-1.4-2.487v-.006Z\"/></symbol>\n<symbol id=\"icon-list-ol-letters\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M5.81 5.355v1.15c0 .198.016.368.047.51.032.14.064.273.095.397.032.124.048.26.048.408 0 .227-.059.403-.176.53-.117.128-.289.192-.514.192a.623.623 0 0 1-.48-.223c-.13-.152-.238-.463-.323-.933-.115.434-.272.746-.471.933-.2.187-.462.281-.785.281-.362 0-.661-.145-.899-.435C2.117 7.875 2 7.47 2 6.945v-.042c0-.548.127-.969.38-1.262.257-.297.568-.447.933-.45.222-.004.418.05.59.164.17.11.328.312.47.61v-.6c0-.548-.223-.822-.67-.822-.15 0-.273.013-.371.037a8.24 8.24 0 0 0-.276.075 1.084 1.084 0 0 1-.3.037.517.517 0 0 1-.409-.18.675.675 0 0 1-.152-.451c0-.23.063-.418.19-.563.127-.148.305-.261.533-.339.14-.046.293-.083.461-.111.172-.032.344-.048.519-.048.637 0 1.114.182 1.431.546.32.36.48.964.48 1.809ZM3.85 7.412c.13 0 .243-.055.338-.164.095-.11.143-.262.143-.456V6.69a.595.595 0 0 0-.129-.403.4.4 0 0 0-.314-.149.435.435 0 0 0-.361.17c-.089.11-.133.258-.133.446v.084c0 .18.04.322.123.425a.42.42 0 0 0 .333.148ZM2.713 9.3c-.475 0-.713.308-.713.925v5.934c0 .522.176.783.527.783.14 0 .255-.049.345-.147.09-.102.155-.266.196-.494l.135-.762c.133.564.318.95.555 1.156.236.203.498.305.787.305.234 0 .46-.079.681-.236.224-.162.409-.437.555-.826.146-.389.219-.925.219-1.608v-.21c0-.676-.062-1.21-.186-1.598-.125-.389-.291-.666-.5-.83a1.062 1.062 0 0 0-.68-.248c-.242 0-.468.083-.676.247-.205.165-.388.475-.55.93l.023-2.396c0-.617-.24-.925-.718-.925Zm.718 5.277v-.71c0-.332.055-.578.163-.735.11-.158.247-.237.415-.237.165 0 .296.08.392.242.096.161.144.415.144.762v.647c0 .35-.048.606-.144.767-.096.157-.227.236-.392.236-.168 0-.306-.079-.415-.236-.108-.158-.163-.403-.163-.736Z\" clip-rule=\"evenodd\"/><path d=\"M9 4h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Z\"/></symbol>\n<symbol id=\"icon-list-ol-numbers\" viewBox=\"0 0 20 20\"><path d=\"M2 4.25a.75.75 0 0 1 .75-.75h1.5c.416 0 .75.334.75.75V7.5h.75c.416 0 .75.334.75.75S6.166 9 5.75 9h-3A.748.748 0 0 1 2 8.25c0-.416.334-.75.75-.75h.75V5h-.75A.748.748 0 0 1 2 4.25Zm.95 7.162c.356-.268.79-.412 1.238-.412h.153a1.908 1.908 0 0 1 1.122 3.453l-.75.547H5.75c.416 0 .75.334.75.75s-.334.75-.75.75H2.916a.915.915 0 0 1-.538-1.656l2.203-1.603a.41.41 0 0 0-.24-.741h-.153c-.122 0-.241.04-.338.113l-.65.487a.749.749 0 1 1-.9-1.2l.65-.488ZM9 4h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Z\"/></symbol>\n<symbol id=\"icon-list-ol-roman\" viewBox=\"0 0 20 20\"><path d=\"M2.712 12.683c.44 0 .661.262.661.789v2.738c0 .526-.22.79-.661.79-.44 0-.66-.264-.66-.79v-2.738c0-.526.22-.79.66-.79ZM4.712 12.683c.44 0 .661.262.661.789v2.738c0 .526-.22.79-.661.79-.44 0-.66-.264-.66-.79v-2.738c0-.526.22-.79.66-.79ZM17 14a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2h8ZM2.712 10.7c.208 0 .38.064.515.192a.67.67 0 0 1 .202.51.677.677 0 0 1-.202.516.72.72 0 0 1-.515.19.713.713 0 0 1-.51-.19.677.677 0 0 1-.202-.516.67.67 0 0 1 .202-.51.712.712 0 0 1 .51-.192ZM4.712 10.7c.208 0 .38.064.515.192a.67.67 0 0 1 .202.51.677.677 0 0 1-.202.516.72.72 0 0 1-.515.19.713.713 0 0 1-.51-.19.677.677 0 0 1-.202-.516.67.67 0 0 1 .202-.51.712.712 0 0 1 .51-.192ZM17 9a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2h8ZM3.712 4.982c.44 0 .661.263.661.79V8.51c0 .526-.22.789-.661.789-.44 0-.66-.263-.66-.79V5.772c0-.525.22-.788.66-.789ZM17 4a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2h8ZM3.712 3c.208 0 .38.064.515.191a.67.67 0 0 1 .202.511.677.677 0 0 1-.202.516.72.72 0 0 1-.515.191.713.713 0 0 1-.51-.191A.677.677 0 0 1 3 3.702a.67.67 0 0 1 .202-.51.712.712 0 0 1 .51-.192Z\"/></symbol>\n<symbol id=\"icon-list-ol\" viewBox=\"0 0 20 20\"><path d=\"M2 4.25a.75.75 0 0 1 .75-.75h1.5c.416 0 .75.334.75.75V7.5h.75c.416 0 .75.334.75.75S6.166 9 5.75 9h-3A.748.748 0 0 1 2 8.25c0-.416.334-.75.75-.75h.75V5h-.75A.748.748 0 0 1 2 4.25Zm.95 7.162c.356-.268.79-.412 1.238-.412h.153a1.908 1.908 0 0 1 1.122 3.453l-.75.547H5.75c.416 0 .75.334.75.75s-.334.75-.75.75H2.916a.915.915 0 0 1-.538-1.656l2.203-1.603a.41.41 0 0 0-.24-.741h-.153c-.122 0-.241.04-.338.113l-.65.487a.749.749 0 1 1-.9-1.2l.65-.488ZM9 4h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Zm0 5h8a.999.999 0 1 1 0 2H9a.999.999 0 1 1 0-2Z\"/></symbol>\n<symbol id=\"icon-list-ul-circle\" viewBox=\"0 0 20 20\"><path d=\"M3.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM8 4a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm-4.5 2.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z\"/></symbol>\n<symbol id=\"icon-list-ul-disc\" viewBox=\"0 0 20 20\"><path d=\"M9 4a.999.999 0 1 0 0 2h8a.999.999 0 1 0 0-2H9Zm0 5a.999.999 0 1 0 0 2h8a.999.999 0 1 0 0-2H9Zm0 5a.999.999 0 1 0 0 2h8a.999.999 0 1 0 0-2H9ZM4.75 5a.75.75 0 1 0-.75.75V7a2 2 0 1 1 0-4 2 2 0 0 1 0 4V5.75A.75.75 0 0 0 4.75 5ZM4.75 10a.75.75 0 1 0-.75.75V12a2 2 0 1 1 0-4 2 2 0 0 1 0 4v-1.25a.75.75 0 0 0 .75-.75ZM4.75 15a.75.75 0 1 0-.75.75V17a2 2 0 1 1 0-4 2 2 0 0 1 0 4v-1.25a.75.75 0 0 0 .75-.75Z\"/></symbol>\n<symbol id=\"icon-list-ul-square\" viewBox=\"0 0 20 20\"><path d=\"M3.25 3.5a.748.748 0 0 0-.75.75v1.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-1.5a.748.748 0 0 0-.75-.75h-1.5ZM8 4a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8ZM2.5 9.25v1.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-1.5a.748.748 0 0 0-.75-.75h-1.5a.748.748 0 0 0-.75.75Zm.75 4.25a.748.748 0 0 0-.75.75v1.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-1.5a.748.748 0 0 0-.75-.75h-1.5Z\"/></symbol>\n<symbol id=\"icon-list-ul\" viewBox=\"0 0 20 20\"><path d=\"M3.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM8 4a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm0 5a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2H8Zm-4.5 2.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z\"/></symbol>\n<symbol id=\"icon-paper-plane\" viewBox=\"0 0 20 20\"><path d=\"M16.096 3.04a.677.677 0 0 1 .864.863l-4.483 12.515a.877.877 0 0 1-1.64.035l-1.616-3.979a.799.799 0 0 1 .13-.821l2.38-2.83a.384.384 0 0 0-.54-.542l-2.832 2.375a.81.81 0 0 1-.82.13L3.546 9.163a.877.877 0 0 1 .035-1.64L16.096 3.04Z\"/></symbol>\n<symbol id=\"icon-paperclip\" viewBox=\"0 0 20 20\"><path d=\"M9.019 2.4a4.5 4.5 0 0 1 6.362 0 4.5 4.5 0 0 1 0 6.363l-5.125 5.124a2.75 2.75 0 0 1-3.89 0 2.75 2.75 0 0 1 0-3.89l4.775-4.769a1.002 1.002 0 0 1 1.415 1.416l-4.775 4.772a.75.75 0 0 0 1.06 1.06l5.125-5.126a2.501 2.501 0 0 0 0-3.534 2.5 2.5 0 0 0-3.535 0L5.306 8.94a4.25 4.25 0 0 0 6.01 6.009l4.068-4.066A1.002 1.002 0 0 1 16.8 12.3l-4.069 4.063a6.249 6.249 0 1 1-8.837-8.838L9.019 2.4Z\"/></symbol>\n<symbol id=\"icon-paste\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h3.5V9c0-1.934 1.566-3.5 3.5-3.5h2V4c0-1.103-.897-2-2-2H4Zm5.75 3.5h-4.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h4.5c.416 0 .75.334.75.75s-.334.75-.75.75ZM11 7c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-5.172a2 2 0 0 0-.584-1.415l-1.829-1.829A2 2 0 0 0 14.172 7H11Z\"/></symbol>\n<symbol id=\"icon-print\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h6.672a2 2 0 0 1 1.415.584l1.329 1.329A2 2 0 0 1 16 5.328V6.5H4V4Zm-2 6c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v3c0 .553-.447 1-1 1h-1v2c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2v-2H3c-.553 0-1-.447-1-1v-3Zm4 5v1h8v-3H6v2Zm10.25-4.5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z\"/></symbol>\n<symbol id=\"icon-quote\" viewBox=\"0 0 20 20\"><path d=\"M3 8.75A3.749 3.749 0 0 1 6.75 5H7a.999.999 0 1 1 0 2h-.25C5.784 7 5 7.784 5 8.75V9h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V8.75Zm8 0A3.749 3.749 0 0 1 14.75 5H15a.999.999 0 1 1 0 2h-.25C13.784 7 13 7.784 13 8.75V9h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2V8.75Z\"/></symbol>\n<symbol id=\"icon-sticky-note\" viewBox=\"0 0 20 20\"><path d=\"M5 17c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v6.672a2 2 0 0 1-.584 1.415l-3.332 3.329A2 2 0 0 1 11.67 17H5Zm10.172-5.5H12.25a.748.748 0 0 0-.75.75v2.922l3.672-3.672Z\"/></symbol>\n<symbol id=\"icon-strikethrough\" viewBox=\"0 0 20 20\"><path d=\"M5 6.922A3.922 3.922 0 0 1 8.922 3H13.5a.999.999 0 1 1 0 2H8.922a1.92 1.92 0 0 0-.238 3.828L10.063 9H17a.999.999 0 1 1 0 2H3a.999.999 0 1 1 0-2h2.597A3.916 3.916 0 0 1 5 6.922Zm7.912 5.578h2.047a3.922 3.922 0 0 1-3.878 4.5H6.5a.999.999 0 1 1 0-2h4.578a1.92 1.92 0 0 0 1.835-2.5Z\"/></symbol>\n<symbol id=\"icon-table-header-column\" viewBox=\"0 0 20 20\"><path d=\"M3 5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5Zm4 0v4h8V5H7Zm8 6H7v4h8v-4Z\"/></symbol>\n<symbol id=\"icon-table-header-row\" viewBox=\"0 0 20 20\"><path d=\"M3 5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V5Zm2 2v8h4V7H5Zm10 0h-4v8h4V7Z\"/></symbol>\n<symbol id=\"icon-table\" viewBox=\"0 0 20 20\"><path d=\"M11 7v3h4V7h-4ZM9 7H5v3h4V7Zm-6 5V5c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-3Zm12 0h-4v3h4v-3Zm-6 3v-3H5v3h4Z\"/></symbol>\n<symbol id=\"icon-text\" viewBox=\"0 0 20 20\"><path d=\"M3 6V5h2v10H4a.999.999 0 1 0 0 2h4a.999.999 0 1 0 0-2H7V5h2v1a.999.999 0 1 0 2 0V4.25C11 3.56 10.44 3 9.75 3h-7.5C1.56 3 1 3.56 1 4.25V6a.999.999 0 1 0 2 0Zm8 6v-1h2v4h-1a.999.999 0 1 0 0 2h4a.999.999 0 1 0 0-2h-1v-4h2v1a.999.999 0 1 0 2 0v-1.75C19 9.56 18.44 9 17.75 9h-7.5C9.56 9 9 9.56 9 10.25V12a.999.999 0 1 0 2 0Z\"/></symbol>\n<symbol id=\"icon-th\" viewBox=\"0 0 20 20\"><path d=\"M15 5v2h-2V5h2Zm0 4v2h-2V9h2Zm0 4v2h-2v-2h2Zm-4-2H9V9h2v2Zm-2 2h2v2H9v-2Zm-2-2H5V9h2v2Zm-2 2h2v2H5v-2Zm0-6V5h2v2H5Zm4 0V5h2v2H9ZM5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Z\"/></symbol>\n<symbol id=\"icon-underline\" viewBox=\"0 0 20 20\"><path d=\"M4 3c0-.553.447-1 1-1h2a.999.999 0 1 1 0 2v5a3 3 0 0 0 6 0V4a.999.999 0 1 1 0-2h2a.999.999 0 1 1 0 2v5c0 2.762-2.238 5-5 5-2.763 0-5-2.238-5-5V4c-.553 0-1-.447-1-1Zm0 14c0-.553.447-1 1-1h10a.999.999 0 1 1 0 2H5c-.553 0-1-.447-1-1Z\"/></symbol>\n<symbol id=\"icon-upload\" viewBox=\"0 0 20 20\"><path d=\"M10.706 2.294a1.002 1.002 0 0 0-1.415 0l-4 4a1.002 1.002 0 0 0 1.415 1.415L9 5.416V12a.999.999 0 1 0 2 0V5.416l2.294 2.293a1.002 1.002 0 0 0 1.415-1.415l-4-4h-.003ZM5 13a.999.999 0 1 0-2 0v2a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2a.999.999 0 1 0-2 0v2c0 .553-.447 1-1 1H6c-.553 0-1-.447-1-1v-2Z\"/></symbol>\n<symbol id=\"icon-file-archive\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828ZM6 4.25c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5a.748.748 0 0 0-.75.75Zm0 3c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5a.748.748 0 0 0-.75.75ZM8 9.5H7c-.553 0-1 .447-1 1V12a1.5 1.5 0 0 0 3 0v-1.5c0-.553-.447-1-1-1Zm-.5 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z\"/></symbol>\n<symbol id=\"icon-file-audio\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828Zm1.681 5.788a.623.623 0 0 0-.868.156.623.623 0 0 0 .156.869 2.875 2.875 0 0 1 0 4.719.623.623 0 1 0 .712 1.024A4.127 4.127 0 0 0 13.95 13c0-1.4-.7-2.64-1.769-3.384ZM6.5 11.75c-.275 0-.5.225-.5.5v1.5c0 .275.225.5.5.5h.75l.85 1.063a.496.496 0 0 0 .39.187h.01c.275 0 .5-.225.5-.5v-4c0-.275-.225-.5-.5-.5h-.01a.496.496 0 0 0-.39.188l-.85 1.062H6.5Zm4 2.256c0 .335.328.569.59.363.404-.322.66-.816.66-1.369s-.256-1.047-.66-1.369c-.262-.21-.59.028-.59.363v2.015-.003Z\"/></symbol>\n<symbol id=\"icon-file-csv\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h2.5v-3.5c0-1.103.897-2 2-2H14V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 8.672 2H4Zm8.172 5.5H9.25a.748.748 0 0 1-.75-.75V3.828L12.172 7.5ZM9.25 13.875c-.76 0-1.375.616-1.375 1.375v2.5c0 .76.616 1.375 1.375 1.375h.5c.76 0 1.375-.616 1.375-1.375v-.25a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625v.25a.125.125 0 0 1-.125.125h-.5a.125.125 0 0 1-.125-.125v-2.5c0-.069.056-.125.125-.125h.5c.069 0 .125.056.125.125v.25c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.25c0-.76-.616-1.375-1.375-1.375h-.5Zm4.25 0a1.626 1.626 0 0 0 0 3.25c.206 0 .375.169.375.375a.376.376 0 0 1-.375.375h-1a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h1a1.626 1.626 0 0 0 0-3.25.376.376 0 0 1-.375-.375c0-.206.169-.375.375-.375h.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-.75Zm3 0a.627.627 0 0 0-.625.625v.988c0 1.109.328 2.196.944 3.118l.16.24a.623.623 0 0 0 1.037 0l.159-.24c.616-.925.944-2.01.944-3.119V14.5a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625v.988c0 .612-.128 1.215-.375 1.771a4.368 4.368 0 0 1-.375-1.771V14.5a.627.627 0 0 0-.625-.625h.006Z\"/></symbol>\n<symbol id=\"icon-file-draft\" viewBox=\"0 0 20 20\"><path d=\"M3 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h4.569l.34-1.703c.135-.678.47-1.3.957-1.788l4.13-4.13V7.33a2 2 0 0 0-.584-1.415L9.085 2.584A1.999 1.999 0 0 0 7.672 2H3Zm8.172 5.5H8.25a.748.748 0 0 1-.75-.75V3.828L11.172 7.5Zm-1.79 9.09-.373 1.863a.457.457 0 0 0 .538.538l1.862-.372a2.007 2.007 0 0 0 1.022-.547l3.716-3.716-2.5-2.5-3.716 3.716a2.007 2.007 0 0 0-.547 1.022l-.003-.003Zm8.368-3.843a1.767 1.767 0 1 0-2.5-2.5l-.9.9 2.5 2.5.9-.9Z\"/></symbol>\n<symbol id=\"icon-file-excel\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5v-3.5c0-1.103.897-2 2-2H14V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 8.672 2H4Zm8.172 5.5H9.25a.748.748 0 0 1-.75-.75V3.828L12.172 7.5Zm-2.047 7a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625c0 .45.134.887.381 1.262l.494.738-.494.738a2.27 2.27 0 0 0-.381 1.262c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625c0-.203.06-.4.172-.569l.203-.303.203.303c.113.169.172.366.172.569 0 .344.281.625.625.625a.627.627 0 0 0 .625-.625c0-.45-.134-.887-.381-1.262l-.494-.738.494-.738a2.27 2.27 0 0 0 .381-1.262.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625c0 .203-.06.4-.172.569l-.203.303-.203-.303a1.023 1.023 0 0 1-.172-.569Zm3.375 4.625h1a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-.375V14.5a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625Zm2.375-3.625c0 .897.728 1.625 1.625 1.625.206 0 .375.169.375.375a.376.376 0 0 1-.375.375h-1a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h1a1.626 1.626 0 0 0 0-3.25.376.376 0 0 1-.375-.375c0-.206.169-.375.375-.375h.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-.75c-.897 0-1.625.728-1.625 1.625Z\"/></symbol>\n<symbol id=\"icon-file-image\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828ZM8 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1.106 6h6.212a.894.894 0 0 0 .647-1.51l-3.025-3.18a1.002 1.002 0 0 0-.725-.31h-.01c-.274 0-.534.113-.724.31l-3.022 3.18A.894.894 0 0 0 6.894 16Z\"/></symbol>\n<symbol id=\"icon-file-lock\" viewBox=\"0 0 20 20\"><path d=\"M3.5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h6.54a2.958 2.958 0 0 1-.04-.503v-3c0-.89.387-1.688 1-2.235V11.5a4.003 4.003 0 0 1 2.5-3.71v-.462a2 2 0 0 0-.584-1.416L9.584 2.584A1.993 1.993 0 0 0 8.172 2H3.5Zm8.172 5.5H8.75A.748.748 0 0 1 8 6.75V3.828L11.672 7.5ZM16 11.503V13h-2v-1.497a.999.999 0 1 1 2 0ZM11.5 14.5v3A1.5 1.5 0 0 0 13 19h4a1.5 1.5 0 0 0 1.5-1.5v-3c0-.653-.419-1.21-1-1.416v-1.58a2.5 2.5 0 1 0-5 0v1.58c-.581.207-1 .763-1 1.416Z\"/></symbol>\n<symbol id=\"icon-file-pdf\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h2.5v-3.5c0-1.103.897-2 2-2H14V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 8.672 2H4Zm8.172 5.5H9.25a.748.748 0 0 1-.75-.75V3.828L12.172 7.5ZM8.5 13.875a.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.875H9.5c1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875h-1Zm1 2.5h-.375v-1.25H9.5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625Zm3-2.5a.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625h1c.897 0 1.625-.728 1.625-1.625v-2c0-.897-.728-1.625-1.625-1.625h-1Zm.625 4v-2.75h.375c.206 0 .375.169.375.375v2a.376.376 0 0 1-.375.375h-.375Zm2.75-3.375v4c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-1.375H18a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-.875v-.75H18a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-1.5a.627.627 0 0 0-.625.625Z\"/></symbol>\n<symbol id=\"icon-file-powerpoint\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h2.5v-3.5c0-1.103.897-2 2-2H14V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 8.672 2H4Zm8.172 5.5H9.25a.748.748 0 0 1-.75-.75V3.828L12.172 7.5ZM8.5 13.875a.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.875H9.5c1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875h-1Zm1 2.5h-.375v-1.25H9.5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625Zm3-2.5a.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.875h.375c1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875h-1Zm1 2.5h-.375v-1.25h.375c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625Zm2.375-1.875c0 .344.281.625.625.625h.375V18.5c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-3.375h.375a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-2a.627.627 0 0 0-.625.625Z\"/></symbol>\n<symbol id=\"icon-file-text-search\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828Zm2 8.172a3 3 0 1 0-1.478 2.588l1.197 1.196a.75.75 0 0 0 1.06-1.06l-1.198-1.196c.266-.447.416-.969.416-1.528h.003Zm-3-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z\"/></symbol>\n<symbol id=\"icon-file-text\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828ZM7.75 10a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4.5Zm0 3a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4.5Z\"/></symbol>\n<symbol id=\"icon-file-video\" viewBox=\"0 0 20 20\"><path d=\"M4 4c0-1.103.897-2 2-2h4.672a2 2 0 0 1 1.415.584l3.329 3.332A2 2 0 0 1 16 7.33V16c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4Zm6.5-.172V6.75c0 .416.334.75.75.75h2.922L10.5 3.828Zm-4 7.672v3c0 .553.447 1 1 1h3c.553 0 1-.447 1-1v-.75l1.094 1.094a.53.53 0 0 0 .906-.375v-2.94a.53.53 0 0 0-.906-.376L11.5 12.247v-.75c0-.553-.447-1-1-1h-3c-.553 0-1 .447-1 1v.003Z\"/></symbol>\n<symbol id=\"icon-file-word\" viewBox=\"0 0 20 20\"><path d=\"M4 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h2.5v-3.5c0-1.103.897-2 2-2H14V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 8.672 2H4Zm8.172 5.5H9.25a.748.748 0 0 1-.75-.75V3.828L12.172 7.5ZM8.5 13.875a.627.627 0 0 0-.625.625v4c0 .344.281.625.625.625h1c.897 0 1.625-.728 1.625-1.625v-2c0-.897-.728-1.625-1.625-1.625h-1Zm.625 4v-2.75H9.5c.206 0 .375.169.375.375v2a.376.376 0 0 1-.375.375h-.375Zm4.125-4c-.76 0-1.375.616-1.375 1.375v2.5c0 .76.616 1.375 1.375 1.375h.5c.76 0 1.375-.616 1.375-1.375v-2.5c0-.76-.616-1.375-1.375-1.375h-.5Zm-.125 1.375c0-.069.056-.125.125-.125h.5c.069 0 .125.056.125.125v2.5a.125.125 0 0 1-.125.125h-.5a.125.125 0 0 1-.125-.125v-2.5Zm2.75 0v2.5c0 .76.616 1.375 1.375 1.375h.5c.76 0 1.375-.616 1.375-1.375v-.25a.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625v.25a.125.125 0 0 1-.125.125h-.5a.125.125 0 0 1-.125-.125v-2.5c0-.069.056-.125.125-.125h.5c.069 0 .125.056.125.125v.25c0 .344.281.625.625.625a.627.627 0 0 0 .625-.625v-.25c0-.76-.616-1.375-1.375-1.375h-.5c-.76 0-1.375.616-1.375 1.375Z\"/></symbol>\n<symbol id=\"icon-file\" viewBox=\"0 0 20 20\"><path d=\"M6 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V7.328a2 2 0 0 0-.584-1.416l-3.332-3.328A1.994 1.994 0 0 0 10.672 2H6Zm8.172 5.5H11.25a.748.748 0 0 1-.75-.75V3.828L14.172 7.5Z\"/></symbol>\n<symbol id=\"icon-folder-open-slash\" viewBox=\"0 0 20 20\"><path d=\"M17.432 9a1.499 1.499 0 0 1 1.422 1.975l-1.5 4.5a1.5 1.5 0 0 1-1.422 1.025H4.094a1.499 1.499 0 0 1-1.422-1.975l1.5-4.5A1.5 1.5 0 0 1 5.594 9h11.838Zm-4.31 1.628a.747.747 0 0 0-1.06 0l-1.06 1.06-1.059-1.06a.75.75 0 0 0-1.059 1.06l1.06 1.06-1.06 1.059a.749.749 0 0 0 1.059 1.059l1.06-1.06 1.06 1.06a.75.75 0 0 0 1.06-1.059l-1.06-1.06 1.06-1.06a.747.747 0 0 0 0-1.06ZM8.347 3.5c.43 0 .853.141 1.2.4l1.2.9a.99.99 0 0 0 .6.2h3.666c1.103 0 2 .897 2 2v.5H5.593c-1.29 0-2.436.825-2.846 2.05h.003l-.737 2.206V5.5c0-1.103.897-2 2-2h4.334Z\"/></symbol>\n<symbol id=\"icon-folder-open\" viewBox=\"0 0 20 20\"><path d=\"m2.75 9.55-.737 2.206V5.5c0-1.103.896-2 2-2h4.334c.431 0 .853.14 1.2.4l1.2.9a.99.99 0 0 0 .6.2h3.665c1.104 0 2 .897 2 2v.5H5.595c-1.29 0-2.438.825-2.847 2.05h.003Zm13.181 6.95H4.094a1.499 1.499 0 0 1-1.422-1.975l1.5-4.5A1.499 1.499 0 0 1 5.594 9H17.43a1.499 1.499 0 0 1 1.422 1.975l-1.5 4.5a1.499 1.499 0 0 1-1.422 1.025Z\"/></symbol>\n<symbol id=\"icon-folder-slash\" viewBox=\"0 0 20 20\"><path d=\"M16 16.5H4c-1.103 0-2-.897-2-2v-9c0-1.103.897-2 2-2h4.334c.432 0 .854.14 1.2.4l1.2.9a.99.99 0 0 0 .6.2H16c1.103 0 2 .897 2 2v7.5c0 1.103-.897 2-2 2Zm-3.878-7.872a.747.747 0 0 0-1.06 0l-1.059 1.06-1.06-1.06a.75.75 0 0 0-1.06 1.06l1.06 1.059-1.059 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06 1.059 1.059a.75.75 0 0 0 1.06-1.06l-1.06-1.06 1.059-1.059a.747.747 0 0 0 0-1.059Z\"/></symbol>\n<symbol id=\"icon-folder\" viewBox=\"0 0 20 20\"><path d=\"M4 16.5h12c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-4.666a.99.99 0 0 1-.6-.2l-1.2-.9c-.347-.26-.768-.4-1.2-.4H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2Z\"/></symbol>\n<symbol id=\"icon-american-football\" viewBox=\"0 0 20 20\"><path d=\"M10.16 2.706c-2.782.563-4.704 1.981-5.938 3.872-.728 1.113-1.19 2.353-1.46 3.61l7.11 7.106c2.781-.563 4.703-1.982 5.94-3.872.729-1.113 1.191-2.353 1.46-3.61l-7.113-7.106Zm7.374 5.253a16.41 16.41 0 0 0-.15-3.709 1.942 1.942 0 0 0-1.659-1.613c-1.344-.184-2.569-.234-3.681-.168l5.49 5.487v.003Zm-9.543 9.575-5.494-5.49a16.41 16.41 0 0 0 .15 3.71c.137.868.837 1.5 1.66 1.612 1.343.184 2.568.234 3.68.168h.004ZM10.484 6.47a.747.747 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-2-2a.747.747 0 0 1 0-1.06Zm-2 2a.747.747 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-2-2a.747.747 0 0 1 0-1.06Zm-2 2a.747.747 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-2-2a.747.747 0 0 1 0-1.06Z\"/></symbol>\n<symbol id=\"icon-bars\" viewBox=\"0 0 20 20\"><path d=\"M3 5c0-.553.447-1 1-1h12a.999.999 0 1 1 0 2H4c-.553 0-1-.447-1-1Zm0 5c0-.553.447-1 1-1h12a.999.999 0 1 1 0 2H4c-.553 0-1-.447-1-1Zm14 5c0 .553-.447 1-1 1H4a.999.999 0 1 1 0-2h12c.553 0 1 .447 1 1Z\"/></symbol>\n<symbol id=\"icon-bell-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-2.735-2.733a1.112 1.112 0 0 0 .71-1.794l-.307-.381A6.652 6.652 0 0 1 15 8.678V8a5.002 5.002 0 0 0-4-4.9V3a.999.999 0 1 0-2 0v.1a4.998 4.998 0 0 0-2.975 1.866L2.281 1.222ZM5 8.675a6.637 6.637 0 0 1-1.45 4.137l-.306.382a1.11 1.11 0 0 0 .866 1.803h7.353L4.997 8.53v.14L5 8.676ZM10 18c.931 0 1.716-.637 1.938-1.5H8.062A2.002 2.002 0 0 0 10 18Z\"/></symbol>\n<symbol id=\"icon-bell\" viewBox=\"0 0 20 20\"><path d=\"M10 2c-.553 0-1 .447-1 1v.1A5.002 5.002 0 0 0 5 8v.678a6.637 6.637 0 0 1-1.45 4.138l-.306.38A1.11 1.11 0 0 0 4.11 15h11.777a1.11 1.11 0 0 0 .866-1.802l-.306-.381A6.652 6.652 0 0 1 15 8.678V8a5.002 5.002 0 0 0-4-4.9V3c0-.553-.447-1-1-1ZM8.062 16.5a2.002 2.002 0 0 0 3.876 0H8.062Z\"/></symbol>\n<symbol id=\"icon-bolt\" viewBox=\"0 0 20 20\"><path d=\"M13.464 2.18c.35.253.48.712.321 1.112L11.48 9.059h4.256a.94.94 0 0 1 .603 1.665l-8.47 7.058a.941.941 0 0 1-1.477-1.074l2.306-5.767H4.441a.94.94 0 0 1-.602-1.664l8.47-7.059a.94.94 0 0 1 1.155-.038Z\"/></symbol>\n<symbol id=\"icon-bookmark\" viewBox=\"0 0 20 20\"><path d=\"M6 2c-1.103 0-2 .897-2 2v13a.997.997 0 0 0 1.513.856L10 15.166l4.484 2.69A1.003 1.003 0 0 0 16 17V4c0-1.103-.897-2-2-2H6Z\"/></symbol>\n<symbol id=\"icon-camera\" viewBox=\"0 0 20 20\"><path d=\"M6.66 4.025 6.333 5H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-2.334l-.325-.975A1.496 1.496 0 0 0 11.919 3H8.08c-.647 0-1.218.413-1.422 1.025ZM10 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z\"/></symbol>\n<symbol id=\"icon-check-circle-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm2.637-9.353-2.5 4a.756.756 0 0 1-.603.353.737.737 0 0 1-.63-.3l-1.5-2a.749.749 0 1 1 1.2-.9l.843 1.125 1.919-3.072a.75.75 0 0 1 1.034-.237c.353.222.46.68.237 1.034v-.003Z\"/></symbol>\n<symbol id=\"icon-check-circle\" viewBox=\"0 0 20 20\"><path d=\"M11.365 7.854a.75.75 0 1 1 1.273.796v-.004l-2.5 4a.757.757 0 0 1-.604.354.737.737 0 0 1-.63-.3l-1.5-2a.75.75 0 1 1 1.2-.9l.843 1.125 1.918-3.071Z\"/><path fill-rule=\"evenodd\" d=\"M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-circle-filled\" viewBox=\"0 0 20 20\"><path d=\"M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z\"/></symbol>\n<symbol id=\"icon-circle\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10.021 2c4.43 0 8.022 3.582 8.022 8s-3.591 8-8.021 8C5.591 18 2 14.418 2 10s3.591-8 8.021-8Zm0 4a4.006 4.006 0 0 0-4.01 4c0 2.21 1.795 4 4.01 4 2.216 0 4.011-1.79 4.011-4 0-2.209-1.796-4-4.01-4Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-close-circle-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18ZM7.219 7.219a.747.747 0 0 1 1.06 0l1.718 1.718 1.719-1.718a.75.75 0 0 1 1.06 1.06l-1.72 1.718 1.719 1.719a.75.75 0 0 1-1.06 1.06l-1.718-1.72-1.719 1.719a.75.75 0 0 1-1.06-1.06l1.72-1.718-1.72-1.719a.747.747 0 0 1 0-1.06Z\"/></symbol>\n<symbol id=\"icon-close\" viewBox=\"0 0 20 20\"><path d=\"M5.722 4.294a1.002 1.002 0 0 0-1.416 1.415L8.6 10l-4.29 4.294a1.001 1.001 0 0 0 1.415 1.415l4.29-4.293 4.294 4.29a1.002 1.002 0 0 0 1.416-1.415L11.431 10l4.29-4.294a1.002 1.002 0 0 0-1.415-1.415l-4.29 4.293-4.294-4.29Z\"/></symbol>\n<symbol id=\"icon-dixa\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7.856 2.862a6.434 6.434 0 0 1 8.782 2.346 6.385 6.385 0 0 1 .862 3.204 6.417 6.417 0 0 1-3.216 5.565L9.661 16.64l-.944.542-1.378.796a.152.152 0 0 1-.229-.132v-3.156c0-.187-.05-.37-.143-.533L2.578 6.573a.582.582 0 0 1 .214-.796l5.064-2.915Zm2.683 8.333 1.601-.923a2.137 2.137 0 0 0 .786-2.924 2.143 2.143 0 0 0-2.927-.781l-1.604.92a.291.291 0 0 0-.107.4l1.852 3.202c.08.14.259.187.399.106Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-docked\" viewBox=\"0 0 20 20\"><path d=\"M11.2 4.01V6H3.6v8h7.6v2H3.6l-.204-.01a2 2 0 0 1-1.784-1.784L1.6 14V6c0-1.034.787-1.887 1.796-1.99L3.6 4l7.6.01ZM16.9 4a1.5 1.5 0 0 1 1.5 1.5v8.99a1.5 1.5 0 0 1-1.5 1.5h-4.1V4h4.1Zm-2.214 8.058c-.38 0-.686.343-.686.77 0 .428.306.772.685.772h1.83c.38 0 .685-.345.685-.772 0-.427-.306-.77-.685-.77h-1.83Zm0-2.83c-.38 0-.686.345-.686.772 0 .427.306.771.685.771h1.83c.38 0 .685-.344.685-.771 0-.427-.305-.771-.685-.771h-1.83Zm0-2.828c-.38 0-.686.344-.686.772 0 .427.306.77.685.77h1.83c.38 0 .685-.343.685-.77s-.305-.771-.685-.772h-1.83Z\"/></symbol>\n<symbol id=\"icon-done\" viewBox=\"0 0 20 20\"><path d=\"M16.587 3.694a1 1 0 0 1 .222 1.397l-8 11a1.002 1.002 0 0 1-1.515.119l-4-4a1.002 1.002 0 0 1 1.415-1.416l3.172 3.172 7.313-10.053a1 1 0 0 1 1.397-.222l-.004.003Z\"/></symbol>\n<symbol id=\"icon-double-check-circle-filled\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2a8 8 0 1 1 .001 16.001A8 8 0 0 1 10 2Zm.548 5.612a.752.752 0 0 0-1.035.238l-1.918 3.072-.844-1.125a.75.75 0 1 0-1.2.9l1.5 2a.754.754 0 0 0 .63.3.742.742 0 0 0 .604-.353l2.5-4v.002a.754.754 0 0 0-.237-1.034Zm3.752.001a.75.75 0 0 0-1.034.238l-1.92 3.07-.537-.716-.852 1.363.847 1.13c.147.196.384.308.63.3a.741.741 0 0 0 .604-.353l2.5-4v.002a.754.754 0 0 0-.238-1.034Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-double-check-circle\" viewBox=\"0 0 20 20\"><path d=\"M9.513 7.85a.752.752 0 0 1 1.272.796v-.002l-2.5 4a.742.742 0 0 1-.603.353.754.754 0 0 1-.631-.3l-1.5-2a.75.75 0 1 1 1.2-.9l.844 1.125L9.513 7.85ZM13.266 7.85a.75.75 0 0 1 1.272.797v-.002l-2.5 4a.742.742 0 0 1-.603.352.754.754 0 0 1-.631-.3l-.847-1.129.852-1.363.538.717 1.919-3.071Z\"/><path fill-rule=\"evenodd\" d=\"M10 2a7.955 7.955 0 0 1 4.387 1.31l.06.04c.073.048.143.1.214.15.037.026.074.051.11.078l.152.118.16.126c.2.165.392.338.574.52.23.23.442.475.64.728.042.053.084.105.124.159.027.035.052.072.078.109.05.07.102.141.15.214l.04.06a7.953 7.953 0 0 1 1.3 4.796 7.953 7.953 0 0 1-1.285 3.954l-.05.08c-.05.074-.103.146-.155.22l-.078.108c-.04.054-.082.106-.123.159-.04.051-.08.104-.121.154a8.05 8.05 0 0 1-1.248 1.215c-.053.041-.105.083-.159.123l-.098.071a7.985 7.985 0 0 1-.225.157l-.06.04a7.954 7.954 0 0 1-4.796 1.3 7.955 7.955 0 0 1-3.979-1.3l-.06-.04a7.997 7.997 0 0 1-.224-.157l-.1-.071-.158-.123a8.043 8.043 0 0 1-1.248-1.215c-.041-.05-.08-.103-.12-.154-.042-.053-.084-.105-.124-.159-.027-.035-.052-.072-.078-.109-.052-.072-.105-.145-.154-.22-.018-.026-.033-.053-.05-.079a7.953 7.953 0 0 1-1.283-4.794A7.954 7.954 0 0 1 3.31 5.612l.039-.06c.048-.073.1-.143.15-.214.026-.037.051-.074.078-.11l.123-.158a8 8 0 0 1 1.215-1.248c.053-.043.107-.084.161-.126.05-.04.1-.08.152-.118.035-.027.072-.052.109-.078.07-.05.141-.102.214-.15l.06-.04A7.955 7.955 0 0 1 10 2Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-exclamation-circle-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-14.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM10 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-8a.985.985 0 0 1 .981 1.053l-.231 3.25a.748.748 0 0 1-1.494 0l-.231-3.25A.976.976 0 0 1 10 6Z\"/></symbol>\n<symbol id=\"icon-exclamation-triangle-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 2c.46 0 .881.253 1.1.656l6.75 12.5A1.25 1.25 0 0 1 16.75 17H3.25c-.44 0-.847-.231-1.075-.61a1.243 1.243 0 0 1-.025-1.234l6.75-12.5C9.119 2.253 9.54 2 10 2Zm0 5.25a.748.748 0 0 0-.75.75v3.5c0 .416.334.75.75.75s.75-.334.75-.75V8a.748.748 0 0 0-.75-.75Zm.834 6.75a.835.835 0 1 0-1.665 0 .834.834 0 1 0 1.665 0Z\"/></symbol>\n<symbol id=\"icon-exclamation\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm0-11.75c.416 0 .75.334.75.75v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V7c0-.416.334-.75.75-.75ZM9.166 13a.834.834 0 1 1 1.665 0 .835.835 0 1 1-1.665 0Z\"/></symbol>\n<symbol id=\"icon-external-link\" viewBox=\"0 0 20 20\"><path d=\"M11.075 2.619C11.231 2.244 11.597 2 12 2h5c.553 0 1 .447 1 1v5a1.004 1.004 0 0 1-1.71.71L14.5 6.915l-4.794 4.79a1.002 1.002 0 0 1-1.415-1.415L13.084 5.5l-1.79-1.794a.996.996 0 0 1-.216-1.09l-.003.003ZM2 7.5A2.5 2.5 0 0 1 4.5 5H7a.999.999 0 1 1 0 2H4.5c-.275 0-.5.225-.5.5v8c0 .275.225.5.5.5h8c.275 0 .5-.225.5-.5V13a.999.999 0 1 1 2 0v2.5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 2 15.5v-8Z\"/></symbol>\n<symbol id=\"icon-flag\" viewBox=\"0 0 20 20\"><path d=\"M5 3a.999.999 0 1 0-2 0v14a.999.999 0 1 0 2 0v-3.8l1.96-.587a5.36 5.36 0 0 1 3.943.34c1.335.669 2.89.75 4.288.225l1.159-.434a1 1 0 0 0 .65-.938v-7.74a.967.967 0 0 0-1.4-.866l-.369.184a4.984 4.984 0 0 1-4.462 0 4.98 4.98 0 0 0-3.663-.315L5 3.7V3Z\"/></symbol>\n<symbol id=\"icon-floating\" viewBox=\"0 0 20 20\"><path d=\"M16.4 3.99c1.103 0 2 .897 2 2v2h-2v-2L3.6 6v8h7.6v2H3.6l-.204-.01a2 2 0 0 1-1.784-1.784L1.6 14V6c0-1.034.787-1.887 1.796-1.99L3.6 4l12.8-.01Zm.5 5.6a1.5 1.5 0 0 1 1.5 1.5v3.4a1.5 1.5 0 0 1-1.5 1.5h-2.6a1.5 1.5 0 0 1-1.5-1.5v-3.4a1.5 1.5 0 0 1 1.5-1.5h2.6Zm-2.214 3.667c-.38 0-.686.344-.686.771 0 .428.306.772.685.772h1.83c.38 0 .685-.344.685-.772 0-.427-.306-.77-.685-.771h-1.83Zm0-2.457c-.38 0-.686.344-.686.771 0 .428.306.772.685.772h1.83c.38 0 .685-.344.685-.772 0-.427-.306-.771-.685-.771h-1.83Z\"/></symbol>\n<symbol id=\"icon-gift\" viewBox=\"0 0 20 20\"><path d=\"M12.047 4.65c.237-.403.669-.65 1.134-.65h.069a1.25 1.25 0 1 1 0 2.5h-2.29l1.087-1.85Zm-4.094 0L9.041 6.5H6.75a1.25 1.25 0 1 1 0-2.5h.069c.465 0 .9.247 1.134.65Zm2.8-.76L10 5.173 9.247 3.89A2.816 2.816 0 0 0 6.819 2.5H6.75a2.75 2.75 0 0 0-2.45 4H3c-.553 0-1 .447-1 1v1c0 .553.447 1 1 1h14c.553 0 1-.447 1-1v-1c0-.553-.447-1-1-1h-1.3a2.75 2.75 0 0 0-2.45-4h-.069a2.82 2.82 0 0 0-2.428 1.388v.003ZM17 11h-6.25v6.5H15c1.103 0 2-.897 2-2V11Zm-7.75 0H3v4.5c0 1.103.897 2 2 2h4.25V11Z\"/></symbol>\n<symbol id=\"icon-hamburger\" viewBox=\"0 0 20 20\"><path d=\"M3.688 9A.688.688 0 0 1 3 8.312c0-.537.081-1.074.337-1.546C4.031 5.49 5.91 3 10 3c4.09 0 5.969 2.487 6.663 3.766.256.471.337 1.009.337 1.546 0 .382-.31.688-.688.688H3.688Zm6.062 1.5L12 12l2.25-1.5h2.5a1.25 1.25 0 1 1 0 2.5H3.25a1.25 1.25 0 1 1 0-2.5h6.5Zm6.5 4c.416 0 .762.344.637.738A2.504 2.504 0 0 1 14.5 17h-9a2.494 2.494 0 0 1-2.388-1.762c-.125-.394.222-.738.638-.738h12.5ZM10.75 5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM6.5 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM14.25 6a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z\"/></symbol>\n<symbol id=\"icon-heart\" viewBox=\"0 0 20 20\"><path d=\"m9.531 4.722.469.647.469-.647A4.162 4.162 0 0 1 18 7.159v.082c0 3.506-4.372 7.578-6.653 9.318-.388.294-.863.441-1.347.441s-.963-.144-1.347-.44C6.372 14.818 2 10.746 2 7.24v-.08a4.16 4.16 0 0 1 7.531-2.438Z\"/></symbol>\n<symbol id=\"icon-home\" viewBox=\"0 0 20 20\"><path d=\"M10.681 2.269a.998.998 0 0 0-1.36 0l-7 6.5c-.3.281-.4.715-.25 1.097.15.38.516.634.929.634h.5V16c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-5.5h.5a1.001 1.001 0 0 0 .681-1.731l-7-6.5ZM9.5 12h1a1.5 1.5 0 0 1 1.5 1.5v3H8v-3A1.5 1.5 0 0 1 9.5 12Z\"/></symbol>\n<symbol id=\"icon-info-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18ZM9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-.25 2h1.5c.416 0 .75.334.75.75v2.75h.25c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h.75v-2h-.75A.748.748 0 0 1 8 9.75c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-info\" viewBox=\"0 0 20 20\"><path d=\"M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13ZM10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm-1.25-5.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75H11V9.75a.748.748 0 0 0-.75-.75h-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h.75v2h-.75ZM10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\"/></symbol>\n<symbol id=\"icon-keyboard\" viewBox=\"0 0 20 20\"><path d=\"M3 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2H3Zm.5 2h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM3 9.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1ZM6.5 6h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM6 9.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm.5 2.5h7c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-7a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM9 6.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1ZM9.5 9h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM12 6.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm.5 2.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM15 6.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm.5 2.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5Z\"/></symbol>\n<symbol id=\"icon-knowledge\" viewBox=\"0 0 20 20\"><path d=\"M15 18H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h9.5A1.5 1.5 0 0 1 17 3.5v9c0 .653-.419 1.21-1 1.416V16a.999.999 0 1 1 0 2h-1Zm-9-4a.999.999 0 1 0 0 2h8v-2H6Zm1-7.25c0 .416.334.75.75.75h5.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-5.5a.748.748 0 0 0-.75.75ZM7.75 9a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h5.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-5.5Z\"/></symbol>\n<symbol id=\"icon-map-pin\" viewBox=\"0 0 20 20\"><path d=\"M11 10.887A4.501 4.501 0 0 0 10 2a4.501 4.501 0 0 0-1 8.887V17a.999.999 0 1 0 2 0v-6.113ZM10.25 5c-.966 0-1.75.784-1.75 1.75 0 .416-.334.75-.75.75A.748.748 0 0 1 7 6.75a3.252 3.252 0 0 1 3.25-3.25c.416 0 .75.334.75.75s-.334.75-.75.75Z\"/></symbol>\n<symbol id=\"icon-minus\" viewBox=\"0 0 20 20\"><path d=\"M3 10c0-.553.447-1 1-1h12a.999.999 0 1 1 0 2H4c-.553 0-1-.447-1-1Z\"/></symbol>\n<symbol id=\"icon-plane\" viewBox=\"0 0 20 20\"><path d=\"M17.25 8.25a1.751 1.751 0 0 1 0 3.5h-3.978l-4.975 5.425c-.19.206-.456.325-.738.325H6.194a.502.502 0 0 1-.475-.66l1.697-5.09H4.3l-1.65 2.063a.496.496 0 0 1-.39.187h-.62a.5.5 0 0 1-.484-.622L2 10l-.844-3.378A.5.5 0 0 1 1.641 6h.618c.154 0 .297.069.391.188L4.3 8.25h3.116L5.719 3.16a.502.502 0 0 1 .475-.66h1.365c.282 0 .547.119.738.325l4.975 5.425h3.978Z\"/></symbol>\n<symbol id=\"icon-plus-circle-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8Zm-.75-5.25v-2h-2A.748.748 0 0 1 6.5 10c0-.416.334-.75.75-.75h2v-2c0-.416.334-.75.75-.75s.75.334.75.75v2h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2v2c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75Z\"/></symbol>\n<symbol id=\"icon-plus\" viewBox=\"0 0 20 20\"><path d=\"M11 4a.999.999 0 1 0-2 0v5H4a.999.999 0 1 0 0 2h5v5a.999.999 0 1 0 2 0v-5h5a.999.999 0 1 0 0-2h-5V4Z\"/></symbol>\n<symbol id=\"icon-question-filled\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm0-10.5c-.553 0-1 .447-1 1 0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75 2.5 2.5 0 1 1 5 0c0 1.475-1.125 2.1-1.75 2.328v.119c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-.253c0-.64.463-1.1.94-1.257.2-.065.413-.171.57-.321.134-.132.24-.313.24-.613 0-.553-.447-1-1-1V7.5Zm-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z\"/></symbol>\n<symbol id=\"icon-question\" viewBox=\"0 0 20 20\"><path d=\"M16.5 10a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0ZM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-2.5c-.553 0-1 .447-1 1 0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75 2.5 2.5 0 1 1 5 0c0 1.475-1.125 2.1-1.75 2.328v.119c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-.253c0-.64.463-1.1.94-1.257.2-.065.413-.171.57-.321.134-.132.24-.313.24-.613 0-.553-.447-1-1-1V7.5Zm-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z\"/></symbol>\n<symbol id=\"icon-search-minus\" viewBox=\"0 0 20 20\"><path d=\"M15 8.5c0 1.434-.466 2.76-1.25 3.834l3.956 3.96a1.002 1.002 0 0 1-1.415 1.415l-3.957-3.959A6.499 6.499 0 0 1 2 8.5C2 4.91 4.91 2 8.5 2S15 4.91 15 8.5Zm-8.75-.75a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4.5Z\"/></symbol>\n<symbol id=\"icon-search-plus\" viewBox=\"0 0 20 20\"><path d=\"M15 8.5c0 1.434-.466 2.76-1.25 3.834l3.956 3.96a1.002 1.002 0 0 1-1.415 1.415l-3.957-3.959A6.499 6.499 0 0 1 2 8.5C2 4.91 4.91 2 8.5 2S15 4.91 15 8.5Zm-6.5-3a.748.748 0 0 0-.75.75v1.5h-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h1.5v1.5c0 .416.334.75.75.75s.75-.334.75-.75v-1.5h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5v-1.5a.748.748 0 0 0-.75-.75Z\"/></symbol>\n<symbol id=\"icon-search\" viewBox=\"0 0 20 20\"><path d=\"M15 8.5c0 1.434-.466 2.76-1.25 3.834l3.956 3.96a1.002 1.002 0 0 1-1.415 1.415l-3.957-3.959A6.499 6.499 0 0 1 2 8.5C2 4.91 4.91 2 8.5 2S15 4.91 15 8.5ZM8.5 13a4.501 4.501 0 1 0 0-9.002A4.501 4.501 0 0 0 8.5 13Z\"/></symbol>\n<symbol id=\"icon-shield-alert\" viewBox=\"0 0 20 20\"><path d=\"M10.003 2c.144 0 .288.031.416.09l5.887 2.498c.688.29 1.2.968 1.197 1.787-.015 3.1-1.29 8.772-6.678 11.35-.522.25-1.128.25-1.647 0-5.387-2.578-6.66-8.247-6.675-11.35A1.94 1.94 0 0 1 3.7 4.588L9.584 2.09a.998.998 0 0 1 .42-.091Zm0 9.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-6a.985.985 0 0 0-.981 1.053l.231 3.25a.748.748 0 0 0 1.494 0l.231-3.25A.983.983 0 0 0 9.997 5.5h.006Z\"/></symbol>\n<symbol id=\"icon-square-plus\" viewBox=\"0 0 20 20\"><path d=\"M5 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5Zm4.25 9.75v-2h-2A.748.748 0 0 1 6.5 10c0-.416.334-.75.75-.75h2v-2c0-.416.334-.75.75-.75s.75.334.75.75v2h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2v2c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75Z\"/></symbol>\n<symbol id=\"icon-thumbtack-full\" viewBox=\"0 0 20 20\"><path d=\"M11.31 2.294c.39-.39 1.024-.39 1.415 0l5 5a1.001 1.001 0 0 1-1.416 1.415l-.328-.328-3.069 3.582a5.264 5.264 0 0 1-.334 3.85l-.044.087a1.002 1.002 0 0 1-1.603.26L3.86 9.083a1.005 1.005 0 0 1-.28-.868.995.995 0 0 1 .54-.735l.087-.043a5.23 5.23 0 0 1 3.85-.335l3.582-3.069-.329-.328a1.002 1.002 0 0 1 0-1.415v.003Zm-9 14 3.315-3.319 1.416 1.416-3.32 3.315a1.002 1.002 0 0 1-1.415-1.415l.003.003Z\"/></symbol>\n<symbol id=\"icon-thumbtack-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-5.829-5.827 3.013-3.516.328.328a1.002 1.002 0 0 0 1.415-1.415l-5-5a1.002 1.002 0 0 0-1.415 1.415l.33.325-3.515 3.013-5.825-5.825Zm1.956 6.197-.043.022-.088.043a.999.999 0 0 0-.262 1.604l7.072 7.068c.228.228.55.332.868.282a.995.995 0 0 0 .735-.541l.043-.088.022-.043-8.347-8.347Zm-1.943 8.875a1.002 1.002 0 0 0 1.415 1.415l3.32-3.318-1.417-1.416-3.318 3.319Z\"/></symbol>\n<symbol id=\"icon-thumbtack\" viewBox=\"0 0 20 20\"><path d=\"M11.472 2.216a.747.747 0 0 1 1.06 0l4.393 4.393.863.86a.75.75 0 0 1-1.06 1.06l-.287-.288-2.875 3.337a5.745 5.745 0 0 1-.875 3.966l-.1.153c-.628-.41-.628-.41 0 0a1.25 1.25 0 0 1-1.932.2L4.106 9.344a1.251 1.251 0 0 1 .2-1.932l.15-.1a5.746 5.746 0 0 1 3.966-.875l3.337-2.875-.287-.287a.747.747 0 0 1 0-1.06Zm1.35 2.412L9.134 7.81a.747.747 0 0 1-.646.166 4.249 4.249 0 0 0-3.104.528L11.5 14.62c.581-.953.75-2.063.528-3.103a.75.75 0 0 1 .166-.647l3.181-3.69-2.55-2.55h-.003ZM5.79 13.153l1.059 1.06-3.566 3.568a.75.75 0 0 1-1.06-1.06l3.567-3.568Z\"/></symbol>\n<symbol id=\"icon-wrench\" viewBox=\"0 0 20 20\"><path d=\"M16.935 5.034c.234-.234.625-.175.742.132a4.922 4.922 0 0 1-4.6 6.68 4.936 4.936 0 0 1-1.545-.245l-5.751 5.75a2.216 2.216 0 0 1-3.133-3.132L8.4 8.468a4.922 4.922 0 0 1-.247-1.545 4.922 4.922 0 0 1 6.68-4.6c.308.117.364.508.133.742l-2.73 2.729a.494.494 0 0 0-.144.348v1.274c0 .27.222.492.492.492h1.274c.13 0 .256-.052.348-.145l2.73-2.729Z\"/></symbol>\n<symbol id=\"icon-ada\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2C5.58 2 2.002 5.49 2 9.798v7.698a.51.51 0 0 0 .518.504h2.647a.511.511 0 0 0 .517-.504v-1.514c0-.278.232-.504.518-.504h7.6c.286 0 .518.226.518.504v1.514a.51.51 0 0 0 .517.504h2.647a.511.511 0 0 0 .518-.504V9.798C17.997 5.49 14.419 2 10 2ZM5.682 9.476c0 2.324 1.933 4.208 4.318 4.208 2.384 0 4.318-1.884 4.318-4.208 0-2.323-1.934-4.207-4.318-4.207-2.385 0-4.318 1.884-4.318 4.207Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-agillic\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M11.259 6.33c0-.182.144-.33.32-.33.177 0 .32.148.32.33v4.922c0 .181-.144.33-.32.33a.326.326 0 0 1-.32-.33V6.33Zm-.961 1.18c.21 0 .382-.176.382-.394a.388.388 0 0 0-.382-.393.388.388 0 0 0-.382.393c0 .218.171.394.382.394Zm0 .596c.176 0 .32.148.32.33v2.816c0 .181-.144.33-.32.33a.326.326 0 0 1-.32-.33V8.436c0-.182.144-.33.32-.33Zm-5.555 3.153v-.056a1.652 1.652 0 0 1-2.249-.126A1.752 1.752 0 0 1 2 9.85c0-.464.175-.9.493-1.228a1.651 1.651 0 0 1 2.25-.125v-.054c0-.181.144-.33.32-.33.178 0 .32.147.32.33v2.816c0 .182-.144.33-.32.33a.326.326 0 0 1-.32-.33Zm-1.058-.33c-.578 0-1.047-.484-1.047-1.08 0-.594.47-1.077 1.047-1.077.578 0 1.047.483 1.047 1.078 0 .595-.47 1.078-1.047 1.078Zm10.838-3.813c0 .218-.171.394-.382.394a.388.388 0 0 1-.382-.394c0-.217.17-.393.382-.393.21 0 .382.176.382.393Zm-.382.99a.326.326 0 0 0-.32.33v2.816c0 .181.144.33.32.33.176 0 .32-.149.32-.33V8.436a.325.325 0 0 0-.32-.33ZM12.86 6a.326.326 0 0 0-.32.33v4.922c0 .181.144.33.32.33.176 0 .32-.149.32-.33V6.33a.325.325 0 0 0-.32-.33Zm2.165 3.85c0-.961.759-1.743 1.693-1.743.447 0 .858.175 1.19.508a.326.326 0 0 1 .09.232.34.34 0 0 1-.08.233.291.291 0 0 1-.215.095.404.404 0 0 1-.243-.092l-.017-.013c-.155-.121-.387-.303-.726-.303-.58 0-1.051.486-1.051 1.083 0 .598.471 1.084 1.052 1.084.307 0 .543-.172.683-.275l.015-.01.042-.03a.428.428 0 0 1 .241-.086.28.28 0 0 1 .218.102.338.338 0 0 1-.022.466c-.339.317-.758.492-1.177.492-.934 0-1.693-.781-1.693-1.743ZM7.634 8.107c-.45 0-.873.18-1.193.509a1.753 1.753 0 0 0-.493 1.228c0 .463.174.9.493 1.228a1.652 1.652 0 0 0 2.256.12v.097c0 .57-.48 1.053-1.046 1.053h-.016a1.086 1.086 0 0 1-.72-.312.354.354 0 0 0-.24-.106.321.321 0 0 0-.232.107c-.105.114-.093.333.028.47.293.33.691.499 1.181.499.452 0 .877-.181 1.196-.512.318-.33.493-.768.49-1.234V8.436a.326.326 0 0 0-.321-.33.326.326 0 0 0-.32.33v.06a1.64 1.64 0 0 0-1.063-.389Zm0 2.814c-.578 0-1.047-.484-1.047-1.079 0-.594.47-1.078 1.047-1.078s1.047.484 1.047 1.078c0 .595-.47 1.079-1.047 1.079Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-assembled\" viewBox=\"0 0 20 20\"><path d=\"M18.004 2v15.64H13.32V6.683H4.755V2h13.249Z\"/><path d=\"M7.093 7.816a5.093 5.093 0 1 0 5.093 5.093H7.093V7.816Z\"/></symbol>\n<symbol id=\"icon-braze\" viewBox=\"0 0 20 20\"><path d=\"M18 9.919a8 8 0 1 1-16.001-.001A8 8 0 0 1 18 9.919Zm-7.489 4.1c1.154-.13 1.855-1.201 2.152-1.755a4.94 4.94 0 0 0 .525-1.731c.022-.157.035-.316.04-.474.011-.462-.058-.856-.214-1.208-.335-.761-.926-1.161-1.756-1.186a2.44 2.44 0 0 0-1.178.263c.09-.355.344-1.415.484-2.455a.548.548 0 0 0-.12-.431.533.533 0 0 0-.397-.193.555.555 0 0 0-.578.49c-.21 1.641-.712 3.761-1.247 5.276a3.617 3.617 0 0 1-1.518 1.884 1.05 1.05 0 0 1-.107.058.578.578 0 0 0-.282.715.57.57 0 0 0 .786.317c.441-.216.839-.51 1.176-.867.415.904 1.107 1.422 2.233 1.296h.001v.001Zm-.916-1.411c-.199-.194-.317-.454-.352-.77-.096-.877.161-1.686.763-2.403.15-.178.33-.329.532-.441.174-.095.36-.142.538-.142a.9.9 0 0 1 .775.411c.136.214.209.468.225.778.007.12.003.242 0 .34l-.002.098c-.118.822-.419 1.444-.947 1.957-.192.187-.39.31-.606.375-.369.112-.672.045-.926-.203ZM15.5 9.875c0 3.05-2.452 5.524-5.478 5.524-3.025 0-5.477-2.474-5.477-5.524s2.452-5.521 5.477-5.521c3.026 0 5.478 2.472 5.478 5.521Zm-5.478 6.645c3.64 0 6.59-2.975 6.59-6.645 0-3.67-2.95-6.645-6.59-6.645-3.64 0-6.59 2.976-6.59 6.645 0 3.67 2.95 6.645 6.59 6.645Z\"/></symbol>\n<symbol id=\"icon-busylight\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"m7.332 4.052-.746-1.505a.374.374 0 0 1 .167-.504.363.363 0 0 1 .5.165L8 3.713a.376.376 0 0 1-.166.505.338.338 0 0 1-.166.037.375.375 0 0 1-.335-.203Zm-.111 13.085s-2.13-.81-2.292-1.731a1.93 1.93 0 0 1-.027-.418 69.73 69.73 0 0 1 .274-3.94c.151-1.487.373-2.962.665-4.426.102-.514.45-.933.916-1.102.846-.309 1.914-.463 3.204-.463 1.301 0 2.376.157 3.225.47.458.17.802.58.908 1.084.26 1.23.478 2.714.654 4.451a69.09 69.09 0 0 1 .287 3.928c.041.917-2.331 2.154-2.331 2.154s-.52.242-.866.267c-.268.02-.481.01-1.036-.033-.397-.03-.598-.042-.837-.042-.237 0-.435.01-.829.04-.566.042-.785.05-1.058.029-.34-.028-.857-.268-.857-.268Zm1.845-.846c-.545.041-1.04.052-1.98-.28-.938-.331-1.165-.533-1.165-.972 0-.438.154-2.749.269-3.873.147-1.45.364-2.89.648-4.318a.398.398 0 0 1 .249-.3c.728-.265 1.688-.404 2.874-.404 1.196 0 2.161.141 2.892.41a.398.398 0 0 1 .246.295c.25 1.187.462 2.631.635 4.33.127 1.239.277 3.385.277 3.732 0 .347-.433.739-.912.939-.479.2-1.69.486-2.222.444-.44-.034-.653-.045-.912-.045-.256 0-.465.01-.9.043ZM8.06 17.744a2.115 2.115 0 0 1-.771-.196.7.7 0 0 0 .675.452h4.012a.678.678 0 0 0 .115-.01c.296-.05.493-.189.567-.446-.236.12-.5.184-.806.207-.282.02-.502.011-1.067-.033a9.86 9.86 0 0 0-.821-.042c-.23 0-.425.011-.813.04-.577.043-.803.052-1.09.028Zm1.384-4.796.191 2.62s-.471.012-.561.019c-.42.032-.646.007-.847-.016a4.497 4.497 0 0 0-.191-.02c-.346-.025-.398.231-.017.26.068.004.133.011.2.019.21.023.441.049.872.015.393-.03.59-.041.823-.041.231 0 .426.01.816.04.444.032.681.005.898-.02.066-.008.13-.015.197-.02.389-.031.334-.287-.018-.259-.065.005-.126.012-.19.02-.207.024-.437.051-.87.02-.032-.003-.15-.005-.263-.007a8.709 8.709 0 0 1-.22-.005l.222-2.625c0-.374-.187-.677-.537-.677-.35 0-.505.303-.505.677Zm-5.42-5.07c.224 0 .404.188.404.407 0 .229-.18.407-.404.407h-1.62A.403.403 0 0 1 2 8.285a.41.41 0 0 1 .405-.406h1.62ZM18 8.286c0-.22-.18-.406-.405-.406h-1.62a.41.41 0 0 0-.405.406c0 .229.182.407.405.407h1.62A.403.403 0 0 0 18 8.285Zm-6.145-4.067c.053.03.11.037.166.037a.375.375 0 0 0 .334-.203l.746-1.505a.374.374 0 0 0-.166-.504.364.364 0 0 0-.5.165l-.747 1.505a.376.376 0 0 0 .167.505Zm-6.747.584c.2.095.281.333.18.532a.409.409 0 0 1-.361.215.372.372 0 0 1-.18-.039l-1.62-.797a.392.392 0 0 1-.182-.532.4.4 0 0 1 .544-.175l1.62.796ZM16.7 4.713a.391.391 0 0 0 .181-.532.399.399 0 0 0-.543-.175l-1.62.796a.392.392 0 0 0-.18.532c.07.136.213.215.362.215.06 0 .122-.008.18-.039l1.62-.797Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-digitalgenius\" viewBox=\"0 0 20 20\"><path d=\"M2 6.194h2.939c.595 0 1.114.06 1.559.182.452.122.84.287 1.166.495.333.2.606.434.82.699.223.265.397.538.524.817A3.995 3.995 0 0 1 9.365 10c0 .488-.1.96-.297 1.42a3.631 3.631 0 0 1-.88 1.214c-.39.352-.873.635-1.452.85-.572.215-1.234.322-1.987.322H2V6.194Zm1.142 6.645h1.44c.484 0 .94-.058 1.368-.172a3.542 3.542 0 0 0 1.142-.538c.326-.236.583-.53.774-.882.19-.358.285-.774.285-1.247a3.31 3.31 0 0 0-.13-.85 2.418 2.418 0 0 0-.5-.935c-.238-.294-.571-.541-1-.742-.428-.208-.983-.312-1.665-.312H3.142v5.678ZM18 9.548v3.753c-.206.115-.44.215-.702.301a7.115 7.115 0 0 1-.821.215 6.639 6.639 0 0 1-.857.14 8.11 8.11 0 0 1-.809.043c-.714 0-1.352-.107-1.915-.323a4.313 4.313 0 0 1-1.416-.87 3.848 3.848 0 0 1-.88-1.27A4.04 4.04 0 0 1 10.301 10c0-.566.107-1.093.321-1.58.222-.488.524-.911.904-1.27a4.174 4.174 0 0 1 1.392-.838A4.89 4.89 0 0 1 14.692 6c.778 0 1.412.09 1.904.269.492.172.904.412 1.238.72l-.81.785a2.989 2.989 0 0 0-1.106-.623 4.072 4.072 0 0 0-1.226-.183c-.484 0-.92.082-1.309.247a3.04 3.04 0 0 0-.999.645 2.82 2.82 0 0 0-.643.968c-.15.366-.226.756-.226 1.172 0 .43.084.832.25 1.204.167.366.397.685.69.957.294.273.639.488 1.036.646.396.15.828.225 1.296.225.405 0 .786-.032 1.143-.097.364-.071.674-.172.928-.3v-2.119H14.99v-.968H18Z\"/></symbol>\n<symbol id=\"icon-elevio\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M7.66 13.47a5.776 5.776 0 0 1-1.89-1.248 5.986 5.986 0 0 1-1.274-1.89c-.315-.727-.473-1.525-.473-2.395 0-.854.158-1.645.473-2.372a5.998 5.998 0 0 1 1.275-1.89 5.641 5.641 0 0 1 1.89-1.237A6.198 6.198 0 0 1 10 2c.835 0 1.615.146 2.34.438a5.768 5.768 0 0 1 3.186 3.127c.315.727.473 1.518.473 2.372 0 .87-.158 1.668-.473 2.396a5.908 5.908 0 0 1-1.285 1.889 5.908 5.908 0 0 1-1.901 1.248c-.725.3-1.505.45-2.34.45a6.07 6.07 0 0 1-2.34-.45ZM6.485 6.318a4.181 4.181 0 0 0-.308 1.62c0 .599.102 1.15.308 1.652.205.503.48.934.824 1.294s.747.64 1.208.843c.462.202.956.303 1.484.303.527 0 1.022-.1 1.483-.303a3.864 3.864 0 0 0 1.22-.843c.351-.36.626-.791.824-1.294a4.479 4.479 0 0 0 .296-1.653c0-.584-.099-1.124-.296-1.619a3.864 3.864 0 0 0-.824-1.282 3.85 3.85 0 0 0-1.22-.843 3.65 3.65 0 0 0-1.483-.304 3.65 3.65 0 0 0-1.484.304 3.716 3.716 0 0 0-1.208.843 4.1 4.1 0 0 0-.824 1.282ZM4 16.147v.298C4 17.436 6.735 18 10 18c3.264 0 6-.564 6-1.555v-.298c0-.515-.36-.834-.76-.772-.063.01-.164.03-.3.057-.752.15-2.58.515-4.94.515-2.36 0-4.19-.365-4.94-.515a8.411 8.411 0 0 0-.3-.057c-.401-.062-.76.257-.76.772Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-github\" viewBox=\"0 0 20 20\"><path d=\"M7.434 14.419c0 .062-.072.112-.162.112-.103.01-.175-.04-.175-.112 0-.063.072-.113.162-.113.094-.01.175.04.175.113Zm-.971-.14c-.022.062.04.133.134.152.081.032.175 0 .194-.062.018-.063-.041-.135-.135-.163-.081-.022-.172.01-.193.072Zm1.38-.054c-.09.022-.152.081-.143.153.01.063.09.103.184.081.091-.021.153-.08.144-.143-.01-.06-.094-.1-.184-.091ZM9.9 2.25c-4.334 0-7.65 3.29-7.65 7.625 0 3.466 2.181 6.431 5.297 7.475.4.072.54-.175.54-.378 0-.194-.009-1.263-.009-1.919 0 0-2.187.469-2.647-.931 0 0-.356-.91-.869-1.144 0 0-.715-.49.05-.481 0 0 .779.062 1.207.806.684 1.206 1.831.86 2.278.653.072-.5.275-.847.5-1.053-1.747-.194-3.51-.447-3.51-3.453 0-.86.238-1.29.738-1.84-.081-.204-.347-1.041.081-2.123.653-.203 2.157.844 2.157.844a7.342 7.342 0 0 1 1.962-.265c.666 0 1.338.09 1.963.265 0 0 1.503-1.05 2.156-.844.428 1.085.162 1.92.081 2.122.5.553.806.985.806 1.841 0 3.016-1.84 3.256-3.587 3.453.287.247.531.716.531 1.45 0 1.053-.01 2.356-.01 2.613 0 .203.144.45.541.378 3.125-1.038 5.244-4.003 5.244-7.469 0-4.334-3.516-7.625-7.85-7.625ZM5.287 13.028c-.04.031-.03.103.022.163.05.05.122.071.163.03.04-.03.031-.102-.022-.162-.05-.05-.122-.071-.163-.03Zm-.337-.253c-.022.04.01.09.072.122.05.031.112.022.134-.022.022-.04-.01-.09-.072-.122-.062-.019-.112-.01-.134.022Zm1.013 1.112c-.05.041-.032.135.04.194.072.072.163.082.203.032.04-.041.022-.135-.04-.194-.07-.072-.163-.082-.204-.032Zm-.357-.459c-.05.031-.05.113 0 .184.05.072.135.104.175.072.05-.04.05-.121 0-.193-.043-.072-.125-.104-.175-.063Z\"/></symbol>\n<symbol id=\"icon-ingrid\" viewBox=\"0 0 20 20\"><path d=\"M5.796 8.527c-.35 0-.676.14-.894.382l-.057.064V8.59h-.727v3.057h.77V9.881c0-.39.298-.685.692-.685.162 0 .32.061.436.168a.683.683 0 0 1 .205.517v1.766h.77V9.704c.001-.682-.502-1.177-1.195-1.177ZM11.977 9.06l-.063.122V8.59h-.726v3.058h.77v-1.412c0-.64.319-.964.946-.964h.074V8.59h-.144c-.398 0-.703.167-.857.47ZM14.113 8.59h-.77v3.058h.77V8.59ZM17.09 7.457v1.542l-.056-.06a1.338 1.338 0 0 0-.983-.408c-.866 0-1.545.7-1.545 1.595 0 .891.679 1.589 1.545 1.589.39 0 .75-.15 1.015-.421l.056-.058v.415h.74V7.458h-.771Zm-.894 3.615c-.512 0-.913-.415-.913-.945 0-.534.4-.952.913-.952.516 0 .92.419.92.952 0 .53-.404.945-.92.945ZM13.995 7.1a.528.528 0 0 0-.4-.065h-.003a.53.53 0 0 0-.39.636.526.526 0 0 0 .636.392.527.527 0 0 0 .157-.963Z\"/><path d=\"M14.113 8.59h-.77v3.058h.77V8.59ZM13.995 7.1a.528.528 0 0 0-.4-.065h-.003a.53.53 0 0 0-.39.636.526.526 0 0 0 .636.392.527.527 0 0 0 .157-.963ZM3.191 7.054a.525.525 0 0 0-.514.649.525.525 0 0 0 .635.393.53.53 0 0 0-.12-1.042ZM9.929 8.938l-.056-.056a1.313 1.313 0 0 0-.953-.377c-.23 0-.447.05-.644.148-.558.258-.903.82-.903 1.466 0 .868.649 1.524 1.51 1.524.447 0 .75-.096.951-.303l.055-.056.003.15c0 .54-.327.888-.831.888-.315 0-.59-.139-.742-.373h-.826c.128.485.602 1.03 1.548 1.03.505 0 .922-.154 1.207-.446.267-.274.408-.654.408-1.098V8.59H9.93v.348h-.001Zm-.873 2.094a.894.894 0 0 1-.91-.917c0-.528.4-.941.91-.941.515 0 .917.413.917.941a.896.896 0 0 1-.917.917ZM3.526 8.59H2.85a.584.584 0 0 1-.584.584H2v.674h.267c.216 0 .414-.048.587-.133v1.932h.73V8.59h-.058Z\"/></symbol>\n<symbol id=\"icon-jira\" viewBox=\"0 0 20 20\"><path d=\"M9 8a4.95 4.95 0 0 1-1.45-3.5v-.05L2 10l8 8a3.535 3.535 0 0 0 0-5l-3-3 2-2ZM11 12a4.949 4.949 0 0 1 1.45 3.5v.05L18 10l-8-8a3.535 3.535 0 0 0 0 5l3 3-2 2Z\"/></symbol>\n<symbol id=\"icon-kindly\" viewBox=\"0 0 20 20\"><path d=\"M5.082 11.042v.406H4.29L2.998 9.692l-.509.515v1.24H2V7.725h.489v1.98h.02l.584-.645 1.232-1.335h.597L3.34 9.394V9.4l1.258 1.647.484-.005ZM6.288 8.694v2.754h-.47V9.089h-.406v-.395h.876Zm.051-1.193v.551h-.571V7.5l.571.001ZM7.28 11.448V8.694h2.353v2.754h-.471V9.089H7.75v2.359h-.47ZM12.527 11.002h-.025a.846.846 0 0 1-.352.384.968.968 0 0 1-.53.126c-.75 0-1.226-.563-1.226-1.431 0-.869.475-1.444 1.226-1.444a.947.947 0 0 1 .534.125c.159.093.281.23.348.39h.025V7.5h.464v3.948h-.464v-.446Zm0-.435v-1.02c0-.308-.349-.533-.784-.533-.523 0-.851.335-.851.822v.47c0 .493.33.823.85.823.441 0 .785-.203.785-.562ZM13.994 11.448V7.5h.47v3.565h.445v.382h-.915ZM15.904 12.11h1.633v-1.12h-.026a.773.773 0 0 1-.327.387.893.893 0 0 1-.518.124c-.622 0-1.015-.383-1.015-1.048V8.685h.462v1.691c0 .493.242.742.693.742.369 0 .731-.168.731-.527V8.682H18V12.5h-2.092l-.004-.39Z\"/></symbol>\n<symbol id=\"icon-klaviyo\" viewBox=\"0 0 20 20\"><path d=\"M18 15.353H2V4.647h16L14.642 10 18 15.353Z\"/></symbol>\n<symbol id=\"icon-linear\" viewBox=\"0 0 20 20\"><path d=\"M2.196 11.844c-.036-.152.145-.248.255-.137l5.842 5.841c.11.11.015.292-.137.256a8.02 8.02 0 0 1-5.96-5.96ZM2 9.502a.158.158 0 0 0 .047.122l8.329 8.33c.032.031.076.049.122.046a8 8 0 0 0 1.114-.148.155.155 0 0 0 .076-.264L2.412 8.312a.156.156 0 0 0-.264.076A8.012 8.012 0 0 0 2 9.502Zm.674-2.75a.158.158 0 0 0 .033.177l10.364 10.364c.046.046.116.06.176.033.286-.127.563-.27.83-.43a.157.157 0 0 0 .03-.246L3.35 5.894a.157.157 0 0 0-.247.03 7.985 7.985 0 0 0-.43.829Zm1.351-1.86a.158.158 0 0 1-.007-.217 8.008 8.008 0 1 1 11.306 11.307.158.158 0 0 1-.216-.007L4.025 4.892Z\"/></symbol>\n<symbol id=\"icon-loyaltylion\" viewBox=\"0 0 20 20\"><path d=\"M15.827 14.707s-.412.895-1.204 1.055c1.17.799 1.101 1.727 1.067 2.11 0-.415-.241-1.662-2.993-2.046-3.302-.479-3.577-4.284-3.577-4.476 0 0 .138.928.894 1.855.895-1.215 2.064-1.44 2.064-1.44.654-.127 1.17-.031 1.273 0 .069 0 .103.033.103.097s-.034.128-.103.128c-.035 0-.035 0-.069-.032 0 0-.447-.16-1.135 0-1.066.224-1.789.895-2.133 1.279a5.089 5.089 0 0 0 1.961 1.47c.344-.639 1.066-1.854 2.236-2.397h.034c.034-.032.07-.032.103-.032.069 0 .138.063.138.159 0 .064-.035.096-.103.128-.31.256-1.376.48-2.339 2.174.24.096.447.192.722.256.447.096.79.256 1.101.384.309.032 1.341.255 1.96-.672Zm-7.085-1.406c-.895-2.014-3.474-2.942-3.474-2.942C1.931 9.272 2 5.884 2 5.884c0-1.695 1.169-3.26 2.064-3.645 0 0-.516.48-.998 1.631-.516 1.31-.344 3.868 1.686 4.635 1.685.608 2.717 1.918 2.717 1.918s.516.576.86 1.375c.516 1.247.653 2.046.413 1.503Zm2.82-6.778c.138.416 0 .767 0 .767.93.288 1.582.99 1.582.99-.103 0-.137-.031-.48-.126 0 0-.552-.192-.895-.16h-.172a.905.905 0 0 1-.62.223c-.619 0-1.066-.32-1.066-.32l.103-.031c.103-.032.413-.256.723-.512.55-.415.86-.83.825-.83Zm6.398 2.781c.034.128.07.416 0 1.151-.069.512-.206.832-.826 2.814 0 .032-.034.064-.034.096-.034.031-.138.127-.482.287-.24.096-1.135.416-1.926.352-1.066-.064-1.307.064-1.307.064s.07-.831 1.376-.512c.447.096 1.17.128 1.582.064.688-.128.791-.287.791-.287.104-.384.62-2.334.07-2.654-.138-.096-.206-.16-.345-.096 0 0-.447.096-.721-.575-.172-.288.102-.352.102-.352s.275-.192.62 0c0 0 .206-.448.894-.416 0 0 .104 0 .137.032-.413-1.055-4.299-2.46-4.299-2.46-1.445-.513-1.858-1.408-2.855-2.24-.757-.606-1.858-.99-2.408-1.118 1.513.384 2.545.799 2.545.799 1.067.384 2.098 1.918 3.062 2.366.653.288 3.714 1.535 4.024 2.685ZM8.054 3.358c.103.032.206.032.275.064-.172-.064-.275-.064-.275-.064ZM6.471 8.537c-2.304-.511-2.476-2.142-2.476-2.142.894 1.119 1.341 1.119 1.857 1.183-.48-.384-.86-.99-.447-1.886.275-.608.688-1.215.619-1.726-.069-.576-.48-.992-.309-.8.137.16.688.83.894 1.343.241.607.172.895-.069 1.63-.344 1.055.482 1.95.482 1.95.963.832 1.17 2.111 1.17 2.111-.138-.384-.517-1.375-1.72-1.663Zm.482-4.955C5.92 2.175 5.096 2.015 4.545 2.015c0 0 2.339-.287 3.096 1.631.344.927-.275 2.11-.275 2.11s.344-1.151-.413-2.174Zm-1.307 8.152c.516-.224 2.958 1.407 3.44 4.284-.104-.607-.516-1.886-1.927-2.558-1.788-.863-1.651-1.534-1.651-1.534s0-.128.138-.192Zm3.474 4.604s0-.064-.034-.192a.389.389 0 0 1 .034.192Z\"/></symbol>\n<symbol id=\"icon-magento\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M17 13.998V5.996L10.006 2 3 6.002v7.996l1.999 1.143-.013-7.995 5.008-2.862 5.004 2.862v7.992L17 13.998Zm-7 1.715.998-.575V7.143L13 8.286v7.999L9.997 18 7 16.285l-.003-7.996 1.999-1.143v7.998l1.004.569Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-miuros\" viewBox=\"0 0 20 20\"><path d=\"M2 12.698V2h2.615l.024.546a4.761 4.761 0 0 1 2.914-.436 4.754 4.754 0 0 1 2.423 1.174 4.754 4.754 0 0 1 4.039-1.219A4.772 4.772 0 0 1 18 6.774v5.88h-3.077v-5.88c0-1.123-.569-1.603-1.385-1.739a2.066 2.066 0 0 0-.615 0c-.816.136-1.385.616-1.385 1.694v5.97H8.462v-5.88c0-1.123-.57-1.603-1.385-1.74a2.066 2.066 0 0 0-.615 0c-.816.137-1.385.617-1.385 1.695v5.924H2ZM6.392 16.693a.927.927 0 0 1 .341-1.27l.846-.486a.935.935 0 0 1 1.274.34l.489.843A.927.927 0 0 1 9 17.389l-.846.486a.934.934 0 0 1-1.274-.34l-.488-.842ZM2 16.406c0-.88.716-1.593 1.6-1.593.884 0 1.6.713 1.6 1.593S4.484 18 3.6 18c-.884 0-1.6-.714-1.6-1.594ZM13.207 15.099a.388.388 0 0 0-.474-.273l-1.913.51a.386.386 0 0 0-.273.473l.512 1.905a.388.388 0 0 0 .475.273l1.912-.51a.386.386 0 0 0 .274-.473l-.513-1.905ZM14.8 15.012c0-.11.09-.2.2-.2h2.8c.11 0 .2.09.2.2V17.8a.2.2 0 0 1-.2.199H15a.2.2 0 0 1-.2-.2v-2.788Z\"/></symbol>\n<symbol id=\"icon-podio\" viewBox=\"0 0 20 20\"><path d=\"M15.019 3.993c-2.735-2.647-7.18-2.657-9.929-.031l-.032.031a6.667 6.667 0 0 0 .002 9.636l4.24 4.103a.96.96 0 0 0 .67.268c.243 0 .486-.09.671-.268a.897.897 0 0 0 0-1.298L6.4 12.332a4.872 4.872 0 0 1-.019-7.025l.02-.018c2.006-1.94 5.271-1.94 7.277 0 1.647 1.594 1.883 4.321.549 6.345a.9.9 0 0 0 .289 1.266.966.966 0 0 0 1.309-.279c1.831-2.777 1.492-6.405-.806-8.628Zm-1.697 9.846c.37.359.37.94 0 1.297a.958.958 0 0 1-.67.27.964.964 0 0 1-.671-.27l-4.24-4.101a3.078 3.078 0 0 1 0-4.448 3.286 3.286 0 0 1 2.297-.92h.001c.868 0 1.684.327 2.298.921a3.072 3.072 0 0 1 .815 3.125.954.954 0 0 1-1.18.617.913.913 0 0 1-.637-1.142 1.28 1.28 0 0 0-.34-1.303 1.367 1.367 0 0 0-.956-.384c-.363 0-.702.136-.958.383a1.282 1.282 0 0 0 0 1.853l4.24 4.102Z\"/></symbol>\n<symbol id=\"icon-recharge\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM7.509 9.063a.076.076 0 0 0-.02.037l-.774 3.97a.084.084 0 0 0 0 .036c.004.012.01.024.018.034.008.009.019.016.03.021a.082.082 0 0 0 .035.008h3.966a.085.085 0 0 0 .065-.048.085.085 0 0 0 .008-.04.085.085 0 0 0-.012-.041L7.624 9.07a.077.077 0 0 0-.034-.026.077.077 0 0 0-.043-.003.079.079 0 0 0-.038.021Zm-.827-1.88a.075.075 0 0 0-.032.032.075.075 0 0 0 .013.084l3.205 3.983a.079.079 0 0 0 .137-.031l.768-3.978a.085.085 0 0 0-.002-.037.084.084 0 0 0-.045-.054.085.085 0 0 0-.037-.007H6.726a.074.074 0 0 0-.043.009Zm4.488-.008a.083.083 0 0 0-.049.016.083.083 0 0 0-.028.043A2.37 2.37 0 0 0 13.415 9.9h.083a.073.073 0 0 0 .05-.015.072.072 0 0 0 .025-.045l.533-2.58a.083.083 0 0 0-.05-.083.085.085 0 0 0-.033-.008l-2.853.007Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-rivoloyalty\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M6.38 8.354a.903.903 0 0 1-.917-.922c0-.516.38-.932.917-.932.536 0 .926.416.926.932 0 .506-.39.922-.926.922Zm9.017 5.146c-1.619 0-2.613-1.06-2.613-2.518 0-1.458.994-2.519 2.613-2.519 1.609 0 2.603 1.061 2.603 2.519 0 1.457-.994 2.518-2.603 2.518Zm0-1.279c.702 0 1.121-.516 1.121-1.24 0-.723-.42-1.239-1.121-1.239-.712 0-1.122.516-1.122 1.24 0 .723.41 1.239 1.122 1.239Zm-4.446 1.15H9.605L7.577 8.592h1.648l1.053 3.004 1.053-3.004h1.657l-2.037 4.78Zm-5.312 0H7.12V8.592L5.639 9.593v3.778Zm-2.147 0H2V8.592h1.492v1.001c.166-.713.721-1.08 1.297-1.08.175 0 .273.01.39.04V9.96a3.297 3.297 0 0 0-.449-.03c-.81 0-1.238.536-1.238 1.597v1.844Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-salesforce\" viewBox=\"0 0 20 20\"><path d=\"M8.614 5.62A3.143 3.143 0 0 0 6.2 4.5C4.47 4.5 3.07 5.876 3.07 7.573c0 .447.097.871.272 1.255A2.556 2.556 0 0 0 2 11.069c0 1.416 1.168 2.564 2.61 2.564.213 0 .42-.025.619-.073a2.777 2.777 0 0 0 2.663 1.94 2.783 2.783 0 0 0 2.57-1.685c.317.123.662.191 1.024.191.999 0 1.875-.517 2.366-1.294.229.047.466.072.71.072 1.899 0 3.438-1.513 3.438-3.378 0-1.866-1.54-3.378-3.438-3.378-.468 0-.913.091-1.32.257a3.086 3.086 0 0 0-2.603-1.412c-.775 0-1.484.282-2.025.748Z\"/></symbol>\n<symbol id=\"icon-shopify\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"m15.123 4.986-1.281-.096-.944-.942c-.093-.094-.275-.066-.346-.044-.007.001-.086.026-.224.069l-.252.078c-.284-.821-.785-1.576-1.666-1.576l-.074.003C10.085 2.145 9.774 2 9.506 2 7.453 2 6.472 4.58 6.164 5.89l-1.437.449c-.445.14-.46.154-.518.575C4.166 7.235 3 16.291 3 16.291L12.08 18 17 16.93 15.262 5.116a.154.154 0 0 0-.14-.13Zm-5.079-.372-1.538.494c.296-1.185.851-1.758 1.337-1.974.122.318.202.775.202 1.39v.09Zm-2.147.689c.288-1.565.972-2.349 1.61-2.66a.44.44 0 0 0-.256-.09c-1.43 0-2.232 1.946-2.57 3.14l1.216-.39Zm.55 3.943c-.925 0-.972.603-.972.754 0 .328.325.575.719.875.602.458 1.363 1.038 1.363 2.211 0 1.526-.933 2.509-2.192 2.509-1.511 0-2.284-.975-2.284-.975l.405-1.385s.794.707 1.464.707c.438 0 .616-.358.616-.619 0-.473-.328-.749-.697-1.058-.472-.397-1.011-.85-1.011-1.847 0-1.493 1.034-2.94 3.122-2.94.804 0 1.202.24 1.202.24L9.594 9.53s-.515-.285-1.146-.285Zm1.942-6.213c.11.325.178.736.178 1.246V4.446l.744-.239c-.189-.598-.482-1.117-.922-1.174Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-solvemate\" viewBox=\"0 0 20 20\"><path d=\"M5.533 10.66a1.428 1.428 0 0 1 0-1.982 1.29 1.29 0 0 1 1.9 0l2.4 2.505 6.634-6.922C15.5 2.904 13.933 2 12.167 2H7.833C4.9 2 2.5 4.504 2.5 7.565V18h9.667c2.933 0 5.333-2.504 5.333-5.565v-4.87c0-.139 0-.278-.033-.452L9.8 15.148 5.533 10.66Z\"/></symbol>\n<symbol id=\"icon-trustpilot-outlined\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M11.152 9.115 10.003 5.39l-1.15 3.724-3.89-.003 3.146 2.402-1.17 3.793 8.105-6.192h-3.892Zm6.848-1L5.06 18l1.888-6.115L2 8.11l6.116.006L10.003 2l1.887 6.115H18Z\" clip-rule=\"evenodd\"/><path d=\"m13.488 13.274-3.485.95L14.95 18l-1.463-4.726Z\"/></symbol>\n<symbol id=\"icon-trustpilot-star\" viewBox=\"0 0 20 20\"><path d=\"M11.89 8.114H18l-7.997 6.109 3.485-.949L14.951 18l-4.948-3.777L5.06 18l1.887-6.114L2 8.108l6.116.006L10.003 2l1.888 6.114Z\"/></symbol>\n<symbol id=\"icon-voyado\" viewBox=\"0 0 20 20\"><path d=\"M11.63 11.91a6.46 6.46 0 0 1-2.31-2.348 6.629 6.629 0 0 1-.874-3.303C8.446 4.463 7.026 3 5.262 3c-1.516.009-2.783 1.095-3.108 2.54-.54 2.077.411 5.223 1.678 7.343.137.246.291.482.445.719 1.13 1.752 2.62 3.478 4.614 4.179.163.061.326.114.488.149h.009c.214.044.428.07.642.07a3.176 3.176 0 0 0 2.757-1.63c.89-1.568.368-3.557-1.156-4.46ZM14.815 9.527c1.76 0 3.185-1.459 3.185-3.259 0-1.8-1.426-3.26-3.185-3.26-1.758 0-3.184 1.46-3.184 3.26 0 1.8 1.426 3.26 3.184 3.26Z\"/></symbol>\n<symbol id=\"icon-web-form\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1a2 2 0 1 0-1.723-.984l-3.261 3.26a2 2 0 1 0 0 3.446l3.26 3.262a2 2 0 1 0 .707-.707l-3.26-3.261c.094-.16.167-.332.214-.516h8.126a2 2 0 1 0 0-1H5.937a1.988 1.988 0 0 0-.214-.516l3.261-3.26A1.99 1.99 0 0 0 10 6Zm-6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-webhooks\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M12.295 6.356a.498.498 0 0 1-.31-.634 1.99 1.99 0 0 0 .06-1.09 2.083 2.083 0 0 0-.53-.983 2.122 2.122 0 0 0-.967-.576 2.062 2.062 0 0 0-1.11.002A1.946 1.946 0 0 0 8.04 4.618c-.064.364-.025.742.115 1.093.127.319.331.603.596.826a.497.497 0 0 1 .143.122.498.498 0 0 1-.01.692l-3.09 7.04a1 1 0 1 1-.925-.382l3.029-6.9a3.092 3.092 0 0 1-.674-1.029 3.01 3.01 0 0 1-.17-1.633 2.944 2.944 0 0 1 .717-1.469c.374-.412.856-.71 1.394-.863a3.066 3.066 0 0 1 1.65-.004 3.122 3.122 0 0 1 1.423.847c.389.406.66.908.783 1.453a2.984 2.984 0 0 1-.089 1.636c-.09.26-.376.4-.637.31ZM11.002 5a.995.995 0 0 1-.186.58l2.923 6.66a3.107 3.107 0 0 1 1.034-.263 3.039 3.039 0 0 1 1.616.32 2.956 2.956 0 0 1 1.61 2.7 3.04 3.04 0 0 1-.484 1.573 3.116 3.116 0 0 1-2.856 1.42 3.01 3.01 0 0 1-1.542-.568.499.499 0 1 1 .591-.805c.297.217.653.349 1.028.378a2.118 2.118 0 0 0 1.936-.965c.206-.319.318-.685.326-1.056a1.952 1.952 0 0 0-1.065-1.787 2.034 2.034 0 0 0-1.081-.215 2.112 2.112 0 0 0-.99.336.5.5 0 0 1-.813-.151L9.906 5.995a1 1 0 1 1 1.096-.996Zm4 11a1 1 0 1 0-.838-1.547h-6.66v.048a.5.5 0 0 0-.5.5c0 .383-.104.695-.299 1.02a2.026 2.026 0 0 1-.799.758 1.95 1.95 0 0 1-2.076-.168 2.054 2.054 0 0 1-.675-.88 2.12 2.12 0 0 1 .33-2.137c.24-.289.553-.502.902-.619a.5.5 0 1 0-.316-.949 2.999 2.999 0 0 0-1.356.928 3.12 3.12 0 0 0-.488 3.152c.21.52.558.973 1.006 1.307a2.952 2.952 0 0 0 3.137.252c.493-.258.907-.65 1.194-1.131a2.98 2.98 0 0 0 .406-1.084h6.137a1 1 0 0 0 .895.55Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-yotpo\" viewBox=\"0 0 20 20\"><path d=\"M10 2c4.418 0 8 3.505 8 7.83a7.707 7.707 0 0 1-2.052 5.233c.07.325.282 1.33.358 1.942.09.737.141.775-.014.904-.155.13-.199.062-.9-.2-.651-.244-1.735-.767-1.888-.84a8.11 8.11 0 0 1-3.504.79c-4.418 0-8-3.506-8-7.83S5.582 2 10 2Zm-.733 9.643s-.075.561-.402.742c-.322.177-.889-.015-.907-.02L7.68 13.7s.994.406 1.722.098c.729-.308 1.192-1.331 1.192-1.331l2.462-6.146h-1.701l-1.261 3.451-1.34-3.45H6.972l2.295 5.32Z\"/></symbol>\n<symbol id=\"icon-away-toggle\" viewBox=\"0 0 20 20\"><path d=\"M10 6.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z\"/><path fill-rule=\"evenodd\" d=\"M15 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Zm-5 2.1a4.9 4.9 0 1 0 0 9.801A4.9 4.9 0 0 0 10 5.1Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-circle-empty\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10.021 2c4.43 0 8.022 3.582 8.022 8s-3.591 8-8.021 8C5.591 18 2 14.418 2 10s3.591-8 8.021-8Zm0 4a4.006 4.006 0 0 0-4.01 4c0 2.21 1.795 4 4.01 4 2.216 0 4.011-1.79 4.011-4 0-2.209-1.796-4-4.01-4Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-circle-simultaneous\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm2.5 8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-5-5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-circle-z\" viewBox=\"0 0 20 20\"><path d=\"M9.404 5.798h2.345l-1.228 1.296a3.713 3.713 0 0 0-1.117-.171 3.698 3.698 0 0 0-3.702 3.692 3.698 3.698 0 0 0 3.702 3.693c1.5 0 2.792-.89 3.373-2.17h3.874A7.403 7.403 0 0 1 9.404 18C5.315 18 2 14.694 2 10.615 2 6.537 5.315 3.231 9.404 3.23v2.568Z\"/><path d=\"m17.999 4.067-3.888 4.291H18v2.068h-6.86V8.358l3.87-4.29h-3.87V2H18v2.067Z\"/></symbol>\n<symbol id=\"icon-media-chat\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15 3a2 2 0 0 1 2 2v7.375a2 2 0 0 1-2 2H7.167a2 2 0 0 0-1.2.4L3 17V5a2 2 0 0 1 2-2h10ZM7.156 9.563a.656.656 0 0 0 0 1.312h3.063a.656.656 0 0 0 0-1.313H7.156Zm0-3.063a.656.656 0 1 0 0 1.313h5.688a.656.656 0 0 0 0-1.313H7.156Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-media-email\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10Zm.738 1.18a.75.75 0 0 0-1.057.082l-3.732 4.353a1.25 1.25 0 0 1-1.898 0L5.319 4.262a.75.75 0 0 0-1.138.976l3.731 4.354a2.75 2.75 0 0 0 4.176 0l3.731-4.354a.75.75 0 0 0-.08-1.057Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-media-messaging\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15 3a2 2 0 0 1 2 2v7.375a2 2 0 0 1-2 2H7.167a2 2 0 0 0-1.2.4L3 17V5a2 2 0 0 1 2-2h10Zm-3.237 1.588a.75.75 0 0 0-1.05.15l-2.625 3.5a.75.75 0 0 0 .6 1.2h1.124l-1.724 2.3a.75.75 0 0 0 1.2.9l2.624-3.5a.75.75 0 0 0-.6-1.2h-1.124l1.724-2.3a.75.75 0 0 0-.15-1.05Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-media-voice\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M15 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10ZM7.627 5.648l-1.506.41a.678.678 0 0 0-.496.651 7.654 7.654 0 0 0 7.666 7.666.678.678 0 0 0 .65-.496l.41-1.506c.086-.325-.068-.685-.393-.805l-1.643-.683a.66.66 0 0 0-.787.187l-.7.84a5.75 5.75 0 0 1-2.74-2.74l.84-.7a.66.66 0 0 0 .187-.787l-.683-1.643c-.12-.325-.48-.48-.805-.394Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-phone-filled\" viewBox=\"0 0 20 20\"><path d=\"M7.004 2.782A1.27 1.27 0 0 0 5.5 2.044l-.172.047c-2.019.55-3.744 2.506-3.24 4.888a14.214 14.214 0 0 0 10.93 10.93c2.385.507 4.338-1.221 4.888-3.24l.047-.172a1.265 1.265 0 0 0-.735-1.503l-3.04-1.265a1.268 1.268 0 0 0-1.469.368l-1.206 1.475a10.703 10.703 0 0 1-4.981-5.156l1.38-1.125a1.27 1.27 0 0 0 .37-1.469l-1.27-3.04Z\"/></symbol>\n<symbol id=\"icon-smile\" viewBox=\"0 0 20 20\"><path d=\"M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18Zm-2.831-5.94A3.495 3.495 0 0 0 10 13.5a3.495 3.495 0 0 0 2.831-1.44.75.75 0 0 1 1.213.88A4.996 4.996 0 0 1 10 15a4.996 4.996 0 0 1-4.044-2.06.75.75 0 0 1 1.213-.88ZM6.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z\"/></symbol>\n<symbol id=\"icon-star-full\" viewBox=\"0 0 20 20\"><path d=\"M10.716 2.522a.752.752 0 0 0-1.432 0L7.704 7.5H2.75a.747.747 0 0 0-.46 1.34l4.088 3.182-1.594 5a.752.752 0 0 0 1.175.822L10 14.7l4.04 3.14c.26.204.62.213.891.023a.747.747 0 0 0 .285-.844l-1.594-4.997 4.087-3.181A.75.75 0 0 0 17.25 7.5h-4.953l-1.585-4.978h.004Z\"/></symbol>\n<symbol id=\"icon-star-half-full\" viewBox=\"0 0 20 20\"><path d=\"M9.284 2.522c.1-.31.391-.522.716-.522.325 0 .616.212.716.522l.162.506.04.125.004.01L12.303 7.5h4.953a.747.747 0 0 1 .46 1.34l-.46.36-.062.047-.003.003-3.563 2.772 1.388 4.36.003.012c.012.034.078.244.2.631a.752.752 0 0 1-1.175.822c-.319-.25-.494-.385-.522-.406l-.01-.01-3.506-2.728-4.04 3.14a.746.746 0 0 1-.891.023.747.747 0 0 1-.284-.844l1.587-5L2.291 8.84A.75.75 0 0 1 2.75 7.5h4.953l1.584-4.978h-.003ZM10 12.95c.378 0 .76.122 1.075.369l1.497 1.162-.616-1.931c-.222-.7.016-1.463.594-1.913l1.787-1.39H12.3a1.752 1.752 0 0 1-1.669-1.219L10 6.047v6.903Z\"/></symbol>\n<symbol id=\"icon-star\" viewBox=\"0 0 20 20\"><path d=\"M10 2c.328 0 .615.212.715.521h-.003L12.296 7.5h4.953a.748.748 0 0 1 .46 1.34l-4.088 3.181 1.594 4.997a.747.747 0 0 1-.284.844.745.745 0 0 1-.89-.021L9.998 14.7l-4.04 3.143-.101.067a.757.757 0 0 1-.685.017l-.104-.062a.75.75 0 0 1-.312-.725l.028-.119 1.593-5-4.087-3.18A.748.748 0 0 1 2.75 7.5h4.953l1.582-4.98A.752.752 0 0 1 9.999 2Zm-.39 6.105A2 2 0 0 1 7.702 9.5H6.394l1.212.943a2 2 0 0 1 .677 2.186l-.37 1.159.859-.667a2 2 0 0 1 2.455 0l.858.667-.369-1.158a2 2 0 0 1 .677-2.186l1.213-.944h-1.31a2 2 0 0 1-1.905-1.394l-.392-1.23-.39 1.229Z\"/></symbol>\n<symbol id=\"icon-thumbs-down\" viewBox=\"0 0 20 20\"><path d=\"M14 3a1.5 1.5 0 0 1 1.394 2.053 1.497 1.497 0 0 1 .887 2.225 1.5 1.5 0 0 1 .316 2.847A1.5 1.5 0 0 1 16 13h-5l.881 2.2c.078.197.119.41.119.622v.131a1.543 1.543 0 0 1-2.925.69l-1.76-3.509A2.978 2.978 0 0 1 7 11.794V5.962c0-.606.278-1.18.75-1.562l.381-.303A5 5 0 0 1 11.253 3H14ZM4.5 5c.553 0 1 .447 1 1v8c0 .553-.447 1-1 1H3c-.553 0-1-.447-1-1V6c0-.553.447-1 1-1h1.5Z\"/></symbol>\n<symbol id=\"icon-thumbs-up\" viewBox=\"0 0 20 20\"><path d=\"M4.5 7c.553 0 1 .447 1 1v8c0 .553-.447 1-1 1H3c-.553 0-1-.447-1-1V8c0-.553.447-1 1-1h1.5Zm5.956-4.5C11.31 2.5 12 3.19 12 4.044v.131c0 .213-.04.425-.119.622L11 7h5a1.5 1.5 0 0 1 .597 2.875 1.5 1.5 0 0 1-.316 2.847 1.497 1.497 0 0 1-.887 2.225A1.5 1.5 0 0 1 14 17h-2.747a4.993 4.993 0 0 1-3.122-1.097L7.75 15.6A1.994 1.994 0 0 1 7 14.037v-5.83c0-.466.11-.926.316-1.341l1.756-3.513a1.549 1.549 0 0 1 1.384-.853Z\"/></symbol>\n<symbol id=\"icon-archive\" viewBox=\"0 0 20 20\"><path d=\"M2 4c0-.553.447-1 1-1h14c.553 0 1 .447 1 1v1c0 .553-.447 1-1 1H3c-.553 0-1-.447-1-1V4Zm1 3.5h14V15c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2V7.5Zm4.75 2a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4.5Z\"/></symbol>\n<symbol id=\"icon-autocomplete\" viewBox=\"0 0 20 20\"><path d=\"M17 6v8H3V6h14ZM3 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2H3Zm1.5 5v3.25c0 .416.334.75.75.75s.75-.334.75-.75v-.75h1v.75c0 .416.334.75.75.75s.75-.334.75-.75V9c0-1.103-.897-2-2-2s-2 .897-2 2ZM7 10H6V9c0-.275.225-.5.5-.5s.5.225.5.5v1Zm3-2.25v4.5c0 .416.334.75.75.75h1.625a1.876 1.876 0 0 0 1.36-3.166A1.876 1.876 0 0 0 12.124 7H10.75a.748.748 0 0 0-.75.75Zm2.5 1.125a.376.376 0 0 1-.375.375H11.5V8.5h.625c.206 0 .375.169.375.375Zm-1 2.625v-.75h.875c.206 0 .375.169.375.375a.376.376 0 0 1-.375.375H11.5Z\"/></symbol>\n<symbol id=\"icon-branch\" viewBox=\"0 0 20 20\"><path d=\"M5.5 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8 4.5a2.495 2.495 0 0 1-1.5 2.29v.71A1.5 1.5 0 0 0 8 9h4a1.5 1.5 0 0 0 1.5-1.5v-.71a2.5 2.5 0 1 1 2 0v.71c0 1.934-1.566 3.5-3.5 3.5h-1v2.21a2.5 2.5 0 1 1-3.5 2.29c0-1.025.616-1.906 1.5-2.29V11H8a3.498 3.498 0 0 1-3.5-3.5v-.71A2.5 2.5 0 1 1 8 4.5Zm6.5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.75 15.5a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z\"/></symbol>\n<symbol id=\"icon-building\" viewBox=\"0 0 20 20\"><path d=\"M6 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H6Zm3.5 11h1c.553 0 1 .447 1 1v2.5h-3V14c0-.553.447-1 1-1ZM7 5.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm4.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5ZM7 9.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm4.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5Z\"/></symbol>\n<symbol id=\"icon-channels\" viewBox=\"0 0 20 20\"><path d=\"M5.5 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8 4.5a2.495 2.495 0 0 1-1.5 2.29V9H12a1.5 1.5 0 0 0 1.5-1.5v-.71a2.5 2.5 0 1 1 2 0v.71c0 1.934-1.566 3.5-3.5 3.5H6.5v2.21a2.5 2.5 0 1 1-2 0V6.793A2.503 2.503 0 0 1 5.5 2 2.5 2.5 0 0 1 8 4.5Zm7.25 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM5.5 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z\"/></symbol>\n<symbol id=\"icon-cloud-check\" viewBox=\"0 0 20 20\"><path d=\"M5.5 17a4.501 4.501 0 0 1-1.44-8.766 4.501 4.501 0 0 1 8.428-2.825 3 3 0 0 1 4.184 3.956A4 4 0 0 1 15 17H5.5Zm7.137-7.353a.75.75 0 0 0-1.272-.797l-1.918 3.072-.844-1.125a.749.749 0 1 0-1.2.9l1.5 2c.147.197.384.31.631.3a.74.74 0 0 0 .603-.353l2.5-4v.003Z\"/></symbol>\n<symbol id=\"icon-cloud-download\" viewBox=\"0 0 20 20\"><path d=\"M5.5 17a4.501 4.501 0 0 1-1.44-8.766 4.501 4.501 0 0 1 8.428-2.825 3 3 0 0 1 4.184 3.956A4 4 0 0 1 15 17H5.5Zm7.281-5.219a.75.75 0 0 0-1.06-1.06l-.968.97V8.5a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v3.19l-.969-.968a.75.75 0 0 0-1.06 1.06l2.251 2.25a.747.747 0 0 0 1.06 0l2.25-2.25h-.004Z\"/></symbol>\n<symbol id=\"icon-cloud-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.219a.756.756 0 0 0-1.062 0 .754.754 0 0 0 0 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-1.46-1.459a4 4 0 0 0-.647-6.893 3 3 0 0 0-4.184-3.956A4.504 4.504 0 0 0 5.35 4.29L2.281 1.219ZM4 7.5c0 .25.022.497.06.734A4.501 4.501 0 0 0 5.5 17h8.319L4.013 7.194a5.01 5.01 0 0 0-.01.306H4Z\"/></symbol>\n<symbol id=\"icon-cloud-syncing\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M8.5 3c1.731 0 3.234.978 3.987 2.41a3 3 0 0 1 4.185 3.956A4 4 0 0 1 15 17H5.5a4.501 4.501 0 0 1-1.44-8.767A4.501 4.501 0 0 1 8.5 3Zm4.187 7.756a.627.627 0 0 0-.707.53 2.001 2.001 0 0 1-2.973 1.447A.623.623 0 0 0 9 11.512l-.127-.013-1.498.001a.624.624 0 0 0-.624.63H6.75l.012 1.49A.624.624 0 0 0 8 13.732l.012-.126-.001-.042c.55.427 1.238.685 1.988.685a3.25 3.25 0 0 0 3.217-2.787.625.625 0 0 0-.53-.707Zm-.062-3.006a.625.625 0 0 0-.625.625v.066a3.25 3.25 0 0 0-5.217 2.096.624.624 0 1 0 1.237.178v-.002a2 2 0 0 1 2.971-1.448.625.625 0 0 0 .134 1.235h1.5c.345 0 .625-.28.625-.625v-1.5a.625.625 0 0 0-.625-.625Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-cloud-upload\" viewBox=\"0 0 20 20\"><path d=\"M5.5 17a4.501 4.501 0 0 1-1.44-8.766 4.501 4.501 0 0 1 8.428-2.825 3 3 0 0 1 4.184 3.956A4 4 0 0 1 15 17H5.5Zm5.031-9.031a.747.747 0 0 0-1.06 0l-2.25 2.25a.75.75 0 0 0 1.06 1.06l.969-.97V13.5c0 .416.334.75.75.75s.75-.334.75-.75v-3.19l.969.968a.75.75 0 0 0 1.06-1.06l-2.25-2.25h.002Z\"/></symbol>\n<symbol id=\"icon-cloud\" viewBox=\"0 0 20 20\"><path d=\"M1 12.5C1 14.984 3.016 17 5.5 17H15a4 4 0 0 0 1.672-7.634 3 3 0 0 0-4.184-3.956A4.501 4.501 0 0 0 4.06 8.234 4.504 4.504 0 0 0 1 12.5Z\"/></symbol>\n<symbol id=\"icon-code\" viewBox=\"0 0 20 20\"><path d=\"M12.275 2.038a1.001 1.001 0 0 0-1.238.687l-4 14a1.001 1.001 0 1 0 1.926.55l4-14a1.001 1.001 0 0 0-.688-1.237Zm2.019 4.253c-.39.39-.39 1.025 0 1.415L16.587 10l-2.293 2.294a1.001 1.001 0 0 0 1.415 1.415l3-3c.391-.39.391-1.025 0-1.415l-3-3a1.001 1.001 0 0 0-1.415 0V6.29Zm-8.585 0a1.002 1.002 0 0 0-1.415 0l-3 3c-.39.39-.39 1.025 0 1.415l3 3a1.001 1.001 0 0 0 1.415-1.415L3.416 10l2.29-2.294c.39-.39.39-1.025 0-1.415h.003Z\"/></symbol>\n<symbol id=\"icon-cog\" viewBox=\"0 0 20 20\"><path d=\"M8.097 2.297a.998.998 0 0 1 .978-.797h1.869c.475 0 .884.334.978.797l.453 2.187c.44.188.853.428 1.228.713l2.119-.703a.998.998 0 0 1 1.181.45l.934 1.619a.997.997 0 0 1-.203 1.246L15.97 9.291c.028.23.04.468.04.709 0 .24-.015.478-.04.71l1.668 1.484c.357.315.438.837.204 1.247l-.935 1.618c-.237.41-.731.6-1.181.45l-2.119-.703c-.378.285-.79.522-1.228.713l-.45 2.184a1 1 0 0 1-.978.797H9.081a.998.998 0 0 1-.978-.797l-.45-2.184a5.856 5.856 0 0 1-1.228-.713l-2.128.703a.999.999 0 0 1-1.181-.45l-.935-1.618a.997.997 0 0 1 .203-1.247l1.67-1.485A5.888 5.888 0 0 1 4.011 10c0-.24.016-.478.041-.71L2.384 7.807a1.002 1.002 0 0 1-.203-1.247l.935-1.618a.999.999 0 0 1 1.18-.45l2.12.703c.378-.285.79-.522 1.228-.713l.453-2.184ZM10.009 12.5a2.5 2.5 0 1 0-.018-4.998 2.5 2.5 0 0 0 .018 4.998Z\"/></symbol>\n<symbol id=\"icon-combine\" viewBox=\"0 0 20 20\"><path d=\"M3 4a.999.999 0 1 0 0 2h3.037c.304 0 .591.138.782.375L9.719 10l-2.9 3.625c-.19.238-.478.375-.782.375H3a.999.999 0 1 0 0 2h3.037a3.01 3.01 0 0 0 2.344-1.125l3.1-3.875H14v1a1.004 1.004 0 0 0 1.71.71l2-2a.998.998 0 0 0 0-1.413l-2-2a.996.996 0 0 0-1.091-.216A.995.995 0 0 0 14 8v1h-2.519l-3.1-3.875A2.996 2.996 0 0 0 6.037 4H3Z\"/></symbol>\n<symbol id=\"icon-credit-card\" viewBox=\"0 0 20 20\"><path d=\"M2 6v1h16V6c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2Zm0 2.5V14c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8.5H2Zm2 4.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75Zm4.5 0c0-.416.334-.75.75-.75h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2a.748.748 0 0 1-.75-.75Z\"/></symbol>\n<symbol id=\"icon-dots-h\" viewBox=\"0 0 20 20\"><path d=\"M3 10a1.75 1.75 0 1 1 3.5 0A1.75 1.75 0 0 1 3 10Zm5.25 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm7-1.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z\"/></symbol>\n<symbol id=\"icon-dots-v\" viewBox=\"0 0 20 20\"><path d=\"M10 6.5A1.75 1.75 0 1 1 10 3a1.75 1.75 0 0 1 0 3.5Zm0 7a1.751 1.751 0 0 1 0 3.5 1.751 1.751 0 0 1 0-3.5Zm1.75-3.5a1.751 1.751 0 0 1-3.5 0 1.751 1.751 0 0 1 3.5 0Z\"/></symbol>\n<symbol id=\"icon-drag-h\" viewBox=\"0 0 20 20\"><path d=\"M4 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm6-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-6 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-6-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z\"/></symbol>\n<symbol id=\"icon-drag\" viewBox=\"0 0 20 20\"><path d=\"M9 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm0 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-4 6c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2ZM15 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-4 6a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm4 6c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2Z\"/></symbol>\n<symbol id=\"icon-dropdown-list\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M13.75 8.25a4.5 4.5 0 1 1 0 8.999 4.5 4.5 0 0 1 0-8.999Zm0 2c-.275 0-.5.225-.5.5v1.5h-1.5c-.275 0-.5.225-.5.5s.225.5.5.5h1.5v1.5c0 .275.225.5.5.5s.5-.225.5-.5v-1.5h1.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1.5v-1.5c0-.275-.225-.5-.5-.5Z\" clip-rule=\"evenodd\"/><path d=\"M7.882 14c.153.723.437 1.399.825 2H4a.999.999 0 1 1 0-2h3.882ZM9.068 9a5.982 5.982 0 0 0-1.058 2H4a.999.999 0 1 1 0-2h5.068ZM16 4a.999.999 0 1 1 0 2H4a.999.999 0 1 1 0-2h12Z\"/></symbol>\n<symbol id=\"icon-eye-closed\" viewBox=\"0 0 20 20\"><path d=\"M1.4 9.2a1.001 1.001 0 0 1 1.4.198c.006.006.7.912 1.912 1.793 1.266.92 3.063 1.81 5.288 1.81s4.021-.888 5.287-1.81c1.219-.884 1.913-1.793 1.913-1.793a1 1 0 0 1 1.6 1.203 12.622 12.622 0 0 1-1.65 1.668l1.253 2.172a.75.75 0 0 1-1.3.75l-1.166-2.022c-.537.35-1.147.691-1.828.982l.616 2.297a.751.751 0 0 1-1.45.387l-.588-2.194c-.606.163-1.253.278-1.937.329v2.28c0 .413-.338.75-.75.75a.748.748 0 0 1-.75-.75v-2.28a10.402 10.402 0 0 1-1.938-.329l-.587 2.194a.751.751 0 0 1-1.45-.387l.615-2.297a11.89 11.89 0 0 1-1.825-.978L2.9 15.19a.75.75 0 0 1-1.3-.75l1.25-2.168A13.04 13.04 0 0 1 1.2 10.6a1 1 0 0 1 .2-1.4Z\"/></symbol>\n<symbol id=\"icon-eye-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-3.013-3.011.25-.225c1.462-1.36 2.44-2.982 2.906-4.097a.994.994 0 0 0 0-.77c-.466-1.115-1.444-2.74-2.906-4.096-1.472-1.366-3.494-2.519-6.02-2.519-1.774 0-3.3.569-4.562 1.381L2.281 1.222Zm5.11 5.112a4.501 4.501 0 0 1 6.275 6.275l-1.085-1.084a3.002 3.002 0 0 0-4.11-4.113L7.389 6.328l.003.006Zm3.775 8.013a4.501 4.501 0 0 1-5.512-5.513L3.168 6.35C2.15 7.5 1.45 8.719 1.079 9.616a.994.994 0 0 0 0 .768c.465 1.116 1.443 2.741 2.905 4.097C5.456 15.847 7.478 17 10.004 17a8.147 8.147 0 0 0 3.171-.644l-2.006-2.006-.003-.003Z\"/></symbol>\n<symbol id=\"icon-eye\" viewBox=\"0 0 20 20\"><path d=\"M10 3C7.475 3 5.453 4.15 3.981 5.519 2.52 6.879 1.541 8.5 1.075 9.616a.994.994 0 0 0 0 .768c.466 1.116 1.444 2.741 2.906 4.097C5.453 15.847 7.475 17 10 17s4.547-1.15 6.019-2.519c1.462-1.36 2.44-2.981 2.906-4.097a.994.994 0 0 0 0-.768c-.466-1.116-1.444-2.741-2.906-4.097C14.547 4.153 12.525 3 10 3Zm-4.5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM10 8a2.002 2.002 0 0 1-2.99 1.738 3.002 3.002 0 1 0 5.888-.516 3.001 3.001 0 0 0-3.16-2.213C9.903 7.3 10 7.637 10 8Z\"/></symbol>\n<symbol id=\"icon-filter\" viewBox=\"0 0 20 20\"><path d=\"M3 4c-.403 0-.769.244-.925.619a.99.99 0 0 0 .219 1.087L8 11.416V15c0 .266.106.519.294.706l2 2a.996.996 0 0 0 1.09.216A.997.997 0 0 0 12 17v-5.584l5.706-5.707a.996.996 0 0 0 .216-1.09A1 1 0 0 0 17 4H3Z\"/></symbol>\n<symbol id=\"icon-flow\" viewBox=\"0 0 20 20\"><path d=\"M4.5 3a1.5 1.5 0 0 0 0 3h4.75v1.25l-1.5 1.5H5.5A2.249 2.249 0 0 0 3.25 11v2H3c-.553 0-1 .447-1 1v2c0 .553.447 1 1 1h2c.553 0 1-.447 1-1v-2c0-.553-.447-1-1-1h-.25v-2c0-.416.334-.75.75-.75h2.25l1.5 1.5V13H9c-.553 0-1 .447-1 1v2c0 .553.447 1 1 1h2c.553 0 1-.447 1-1v-2c0-.553-.447-1-1-1h-.25v-1.25l1.5-1.5h2.25c.416 0 .75.334.75.75v2H15c-.553 0-1 .447-1 1v2c0 .553.447 1 1 1h2c.553 0 1-.447 1-1v-2c0-.553-.447-1-1-1h-.25v-2a2.249 2.249 0 0 0-2.25-2.25h-2.25l-1.5-1.5V6h4.75a1.5 1.5 0 0 0 0-3h-11Z\"/></symbol>\n<symbol id=\"icon-hide-strategy\" viewBox=\"0 0 20 20\"><path d=\"M4 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2H4Zm3.25 5.25h5.5c.416 0 .75.334.75.75s-.334.75-.75.75h-5.5A.748.748 0 0 1 6.5 10c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-input\" viewBox=\"0 0 20 20\"><path d=\"M3 6v8h14V6H3ZM1 6c0-1.103.897-2 2-2h14c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V6Zm5 1.75v4.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-4.5c0-.416.334-.75.75-.75s.75.334.75.75Z\"/></symbol>\n<symbol id=\"icon-key\" viewBox=\"0 0 20 20\"><path d=\"M12.5 13A5.5 5.5 0 1 0 7 7.5c0 .584.09 1.15.26 1.678l-5.041 5.04A.75.75 0 0 0 2 14.75v2.5c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75V16h1.25c.416 0 .75-.334.75-.75V14h1.25c.2 0 .39-.078.531-.219l1.04-1.04A5.51 5.51 0 0 0 12.5 13Zm1.25-8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z\"/></symbol>\n<symbol id=\"icon-lightbulb\" viewBox=\"0 0 20 20\"><path d=\"M13.153 14c.228-.697.684-1.328 1.2-1.872A6.002 6.002 0 0 0 10 2a6.002 6.002 0 0 0-4.353 10.128c.515.544.975 1.175 1.2 1.872h6.306ZM13 15.5H7v.5a2.5 2.5 0 0 0 2.5 2.5h1A2.5 2.5 0 0 0 13 16v-.5Zm-3.25-10A2.249 2.249 0 0 0 7.5 7.75c0 .416-.334.75-.75.75A.748.748 0 0 1 6 7.75 3.749 3.749 0 0 1 9.75 4c.416 0 .75.334.75.75s-.334.75-.75.75Z\"/></symbol>\n<symbol id=\"icon-lock\" viewBox=\"0 0 20 20\"><path d=\"M10 3c1.103 0 2 .897 2 2v2H8V5c0-1.103.897-2 2-2ZM6 5v2c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2V5a4 4 0 1 0-8 0Zm4.75 6.25v2.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-2.5c0-.416.334-.75.75-.75s.75.334.75.75Z\"/></symbol>\n<symbol id=\"icon-merge\" viewBox=\"0 0 20 20\"><path d=\"M5.5 3.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm1.013 3.037A2.501 2.501 0 1 0 3 4.5c0 1.025.616 1.906 1.5 2.29v6.416A2.503 2.503 0 0 0 5.5 18a2.5 2.5 0 0 0 1-4.79v-2.707c.834.628 1.875 1 3 1h2.71a2.5 2.5 0 1 0 0-2L9.5 9.5a3.001 3.001 0 0 1-2.987-2.713ZM5.5 14.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm8.25-4.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z\"/></symbol>\n<symbol id=\"icon-pen-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-6.095-6.099 2.191-2.19-4.31-4.31-2.19 2.19-6.094-6.093Zm3.972 8.212-2.412 2.413a2.774 2.774 0 0 0-.707 1.21L2.028 17.05c-.072.26 0 .54.194.731.194.19.472.266.731.194l3.994-1.11a2.761 2.761 0 0 0 1.21-.706l2.412-2.412-4.31-4.31-.006-.003Zm6.775-6.772-1.403 1.404 4.31 4.309 1.402-1.403c.425-.422.663-.997.663-1.597s-.238-1.175-.663-1.597l-1.115-1.116A2.249 2.249 0 0 0 14.625 2c-.6 0-1.175.237-1.597.662Z\"/></symbol>\n<symbol id=\"icon-pen\" viewBox=\"0 0 20 20\"><path d=\"m13.028 2.663-1.403 1.403 4.31 4.309 1.402-1.403c.425-.422.663-.997.663-1.597s-.238-1.175-.663-1.597l-1.115-1.115A2.248 2.248 0 0 0 14.625 2c-.6 0-1.175.237-1.597.663Zm-2.462 2.462L3.84 11.847a2.774 2.774 0 0 0-.707 1.21L2.028 17.05c-.072.26 0 .54.194.731.194.19.472.266.731.194l3.994-1.11a2.761 2.761 0 0 0 1.21-.706l6.718-6.725-4.31-4.309Z\"/></symbol>\n<symbol id=\"icon-plug\" viewBox=\"0 0 20 20\"><path d=\"M7 1c.553 0 1 .447 1 1v3h4V2a.999.999 0 1 1 2 0v3h2a.999.999 0 1 1 0 2v2a6 6 0 0 1-5 5.916V17a.999.999 0 1 1-2 0v-2.084A6 6 0 0 1 4 9V7a.999.999 0 1 1 0-2h2V2c0-.553.447-1 1-1Z\"/></symbol>\n<symbol id=\"icon-preferences\" viewBox=\"0 0 20 20\"><path d=\"M3 4a.999.999 0 1 0 0 2h2.71A2.495 2.495 0 0 0 8 7.5 2.495 2.495 0 0 0 10.29 6H17a.999.999 0 1 0 0-2h-6.71A2.495 2.495 0 0 0 8 2.5 2.495 2.495 0 0 0 5.71 4H3Zm0 5a.999.999 0 1 0 0 2h7.71A2.495 2.495 0 0 0 13 12.5a2.495 2.495 0 0 0 2.29-1.5H17a.999.999 0 1 0 0-2h-1.71A2.495 2.495 0 0 0 13 7.5 2.495 2.495 0 0 0 10.71 9H3Zm0 5a.999.999 0 1 0 0 2h1.71A2.495 2.495 0 0 0 7 17.5 2.495 2.495 0 0 0 9.29 16H17a.999.999 0 1 0 0-2H9.29A2.495 2.495 0 0 0 7 12.5 2.495 2.495 0 0 0 4.71 14H3Z\"/></symbol>\n<symbol id=\"icon-route\" viewBox=\"0 0 20 20\"><path d=\"M1.887 6.944H3V13a4 4 0 1 0 8 0V7c0-1.103.897-2 2-2s2 .897 2 2v6h-1.113a.887.887 0 0 0-.628 1.516l2.21 2.209a.747.747 0 0 0 1.06 0l2.209-2.21A.887.887 0 0 0 18.11 13h-1.113V7.001a4 4 0 0 0-4-4A3.997 3.997 0 0 0 9 7v6c0 1.103-.897 2-2 2s-2-.897-2-2V6.944h1.112a.887.887 0 0 0 .629-1.516l-2.21-2.21a.747.747 0 0 0-1.06 0L1.26 5.429a.887.887 0 0 0 .628 1.516Z\"/></symbol>\n<symbol id=\"icon-trash\" viewBox=\"0 0 20 20\"><path d=\"M7.272 2.184 7 3H4a.999.999 0 1 0 0 2h12a.999.999 0 1 0 0-2h-3l-.272-.816a1.001 1.001 0 0 0-.95-.684H8.222c-.431 0-.813.275-.95.684ZM16 6.5H4l.66 10.097c.05.79.706 1.403 1.496 1.403h7.688c.79 0 1.447-.613 1.497-1.403L16 6.5Z\"/></symbol>\n<symbol id=\"icon-url-trigger\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M12.75 9.003a3.75 3.75 0 0 1 3.128 5.82l1.903 1.899a.75.75 0 0 1-1.06 1.06l-1.899-1.904a3.727 3.727 0 0 1-2.07.622l-.002.003A3.749 3.749 0 0 1 9 12.753a3.75 3.75 0 0 1 3.75-3.75Zm0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M15.125 2C16.159 2 17 2.84 17 3.875v5.793A5.25 5.25 0 1 0 9.669 17H3.875A1.877 1.877 0 0 1 2 15.125V3.875C2 2.841 2.84 2 3.875 2h11.25ZM4.812 3.875a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876Zm2.813 0a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876Zm2.813 0a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-world-slash\" viewBox=\"0 0 20 20\"><path d=\"M1.22 1.22a.75.75 0 0 1 1.06 0l2.624 2.624a7.977 7.977 0 0 1 2.434-1.385c-.456.737-.845 1.648-1.147 2.672l1.227 1.226c.202-.873.469-1.667.782-2.338.356-.763.74-1.307 1.097-1.638.35-.328.59-.38.716-.38.125 0 .366.052.716.38.356.331.74.875 1.096 1.638.635 1.359 1.082 3.215 1.17 5.231H10.31l1.5 1.5H13a16.57 16.57 0 0 1-.089 1.102l1.318 1.318c.14-.775.233-1.588.267-2.42h3.482a7.958 7.958 0 0 1-1.812 4.357l2.613 2.613a.75.75 0 1 1-1.06 1.06L1.22 2.28a.75.75 0 0 1 0-1.06ZM12.114 15.295c-.09.24-.185.47-.286.687-.356.762-.74 1.306-1.096 1.637-.35.328-.591.381-.716.381s-.366-.053-.716-.38c-.356-.332-.74-.873-1.097-1.639-.634-1.359-1.081-3.215-1.172-5.23h.538l4.545 4.544ZM5.528 10.75c.11 2.675.8 5.16 1.81 6.791a8.005 8.005 0 0 1-5.291-6.79h3.481ZM13.842 17.023a7.978 7.978 0 0 1-1.154.518c.205-.332.396-.702.573-1.1l.58.582ZM5.557 8.737c-.012.17-.022.341-.029.513H2.047a7.955 7.955 0 0 1 .941-3.081l2.569 2.568Z\"/><path d=\"M12.688 2.459a8.005 8.005 0 0 1 5.29 6.791h-3.48c-.11-2.675-.801-5.16-1.81-6.791Z\"/></symbol>\n<symbol id=\"icon-world\" viewBox=\"0 0 20 20\"><path d=\"M12.997 10.75H7.03c.09 2.016.538 3.872 1.172 5.231.356.766.74 1.307 1.097 1.638.35.328.59.381.716.381.125 0 .365-.053.715-.381.357-.331.74-.875 1.097-1.638.635-1.36 1.081-3.215 1.172-5.231h-.003Zm-5.969-1.5h5.966c-.088-2.016-.535-3.872-1.169-5.231-.356-.763-.74-1.307-1.097-1.638-.35-.328-.59-.381-.716-.381-.125 0-.365.053-.715.381-.356.332-.74.875-1.097 1.638-.634 1.36-1.081 3.215-1.172 5.231Zm-1.5 0c.11-2.675.8-5.16 1.81-6.79a8.004 8.004 0 0 0-5.291 6.79h3.481Zm-3.481 1.5a8.004 8.004 0 0 0 5.29 6.79c-1.009-1.63-1.7-4.115-1.809-6.79H2.047Zm12.45 0c-.11 2.675-.8 5.16-1.81 6.79a8.008 8.008 0 0 0 5.291-6.79h-3.481Zm3.481-1.5a8.004 8.004 0 0 0-5.29-6.79c1.009 1.63 1.7 4.115 1.809 6.79h3.481Z\"/></symbol>\n<symbol id=\"icon-address-book\" viewBox=\"0 0 20 20\"><path d=\"M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5Zm3.5 9h2a2.5 2.5 0 0 1 2.5 2.5c0 .275-.225.5-.5.5h-6a.501.501 0 0 1-.5-.5A2.5 2.5 0 0 1 8.5 11Zm-.75-3a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM18 4.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v2c0 .275.225.5.5.5s.5-.225.5-.5v-2Zm0 4c0-.275-.225-.5-.5-.5s-.5.225-.5.5v2c0 .275.225.5.5.5s.5-.225.5-.5v-2Zm-.5 3.5c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5s.5-.225.5-.5v-2c0-.275-.225-.5-.5-.5Z\"/></symbol>\n<symbol id=\"icon-ban\" viewBox=\"0 0 20 20\"><path d=\"M13.475 14.89 5.109 6.526a6.002 6.002 0 0 0 8.366 8.366Zm1.416-1.415a6.002 6.002 0 0 0-8.366-8.366l8.366 8.366ZM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z\"/></symbol>\n<symbol id=\"icon-id-card\" viewBox=\"0 0 20 20\"><path d=\"M3 3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H3Zm2.5 8h2a2.5 2.5 0 0 1 2.5 2.5c0 .275-.225.5-.5.5h-6a.501.501 0 0 1-.5-.5A2.5 2.5 0 0 1 5.5 11Zm-.75-3a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm7.5-1.5h3.5c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Zm0 3h3.5c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-role-custom\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10.667 8.5a1.5 1.5 0 0 0 1.5 1.5h2.5v6.19c0 1.018-.82 1.81-1.81 1.81H3.81A1.787 1.787 0 0 1 2 16.19V7.144c0-.99.792-1.81 1.81-1.81h6.857V8.5ZM7.4 13.477c-1.583 0-2.912 1.187-3.11 2.713h8.059c-.198-1.526-1.528-2.713-3.139-2.713H7.4Zm.933-5.43c-.735.001-1.414.397-1.781 1.018-.368.65-.368 1.415 0 2.037.367.65 1.046 1.017 1.781 1.017.707 0 1.385-.367 1.753-1.017.367-.622.367-1.386 0-2.037a2.067 2.067 0 0 0-1.753-1.017Z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M17.048 2c.52 0 .952.475.952 1.048v5.238c0 .59-.431 1.047-.952 1.047h-4.762c-.535 0-.953-.458-.953-1.047V3.048c0-.573.417-1.048.953-1.048h4.762Zm-3.571 1.048c-.268 0-.477.245-.477.523v.525h-.238c-.268 0-.476.245-.476.523 0 .295.208.523.476.524H13v2.619c0 .294.209.524.477.524.252 0 .475-.23.475-.524v-2.62h.238c.253 0 .477-.228.477-.523 0-.278-.224-.523-.477-.523h-.238V3.57c0-.278-.223-.523-.475-.523Zm2.38 0c-.267 0-.476.245-.476.523v2.62h-.238c-.268 0-.476.245-.476.523 0 .294.208.524.476.524h.238v.524c0 .294.209.524.476.524.253 0 .476-.23.476-.524v-.524h.238c.253 0 .477-.23.477-.524 0-.278-.224-.524-.477-.524h-.238V3.571c0-.278-.223-.523-.476-.523Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-role-system\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M10.667 8.5a1.5 1.5 0 0 0 1.5 1.5h2.5v6.19c0 1.018-.82 1.81-1.81 1.81H3.81A1.787 1.787 0 0 1 2 16.19V7.144c0-.99.792-1.81 1.81-1.81h6.857V8.5ZM7.4 13.477c-1.583 0-2.912 1.187-3.11 2.713h8.059c-.198-1.526-1.528-2.713-3.139-2.713H7.4Zm.933-5.43c-.735.001-1.414.397-1.781 1.018-.368.65-.368 1.415 0 2.037.367.65 1.046 1.017 1.781 1.017.707 0 1.385-.367 1.753-1.017.367-.622.367-1.386 0-2.037a2.067 2.067 0 0 0-1.753-1.017Z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M14.667 2c1.175 0 2.143.931 2.143 2.063v.687h.238c.52 0 .952.416.952.917v2.75c0 .515-.431.916-.952.916h-4.762c-.535 0-.953-.4-.953-.916v-2.75c0-.501.417-.917.953-.917h.237v-.688c0-1.131.954-2.062 2.144-2.062Zm0 .917c-.67 0-1.19.515-1.19 1.146v.687h2.38v-.688c0-.63-.535-1.145-1.19-1.145Z\" clip-rule=\"evenodd\"/></symbol>\n<symbol id=\"icon-team\" viewBox=\"0 0 20 20\"><path d=\"M10 2.5A3.25 3.25 0 1 1 10 9a3.25 3.25 0 0 1 0-6.5ZM3 4.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5ZM0 15a4 4 0 0 1 5.153-3.831A6.479 6.479 0 0 0 3.5 15.5v.5c0 .356.075.694.21 1H1c-.553 0-1-.447-1-1v-1Zm16.29 2a2.48 2.48 0 0 0 .21-1v-.5a6.479 6.479 0 0 0-1.653-4.331A4 4 0 0 1 20 15v1c0 .553-.447 1-1 1h-2.71ZM14.75 7a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM5 15.5c0-2.762 2.237-5 5-5 2.762 0 5 2.238 5 5v.5c0 .553-.447 1-1 1H6c-.553 0-1-.447-1-1v-.5Z\"/></symbol>\n<symbol id=\"icon-user-agent\" viewBox=\"0 0 20 20\"><path d=\"M5.5 7a4.501 4.501 0 0 1 9 0v3.5H12A1.5 1.5 0 0 0 10.5 9h-1a1.5 1.5 0 0 0 0 3h5.75c.416 0 .75-.334.75-.75V7c0-3.313-2.688-6-6-6-3.313 0-6 2.688-6 6 0 .416.334.75.75.75s.75-.334.75-.75Zm8 0c0-1.934-1.566-3.5-3.5-3.5a3.498 3.498 0 0 0-2.838 5.55A2.745 2.745 0 0 1 9.5 7.75h1c.966 0 1.816.497 2.306 1.25h.069a3.47 3.47 0 0 0 .628-2H13.5Zm-5.716 6A4.285 4.285 0 0 0 3.5 17.284c0 .397.319.716.716.716h11.572a.715.715 0 0 0 .715-.716A4.285 4.285 0 0 0 12.22 13H7.784Z\"/></symbol>\n<symbol id=\"icon-user-minus\" viewBox=\"0 0 20 20\"><path d=\"M4.25 6a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM1.5 17.072A5.57 5.57 0 0 1 7.072 11.5h1.856a5.57 5.57 0 0 1 5.572 5.572.928.928 0 0 1-.928.928H2.428a.928.928 0 0 1-.928-.928ZM14.75 7.25h4.5c.416 0 .75.334.75.75s-.334.75-.75.75h-4.5A.748.748 0 0 1 14 8c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-user-plus\" viewBox=\"0 0 20 20\"><path d=\"M4.25 6a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM1.5 17.072A5.57 5.57 0 0 1 7.072 11.5h1.856a5.57 5.57 0 0 1 5.572 5.572.928.928 0 0 1-.928.928H2.428a.928.928 0 0 1-.928-.928ZM17 5c.416 0 .75.334.75.75v1.5h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v1.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-1.5h-1.5A.748.748 0 0 1 14 8c0-.416.334-.75.75-.75h1.5v-1.5c0-.416.334-.75.75-.75Z\"/></symbol>\n<symbol id=\"icon-user-secret\" viewBox=\"0 0 20 20\"><path d=\"M5.25 6H6v.5a4 4 0 1 0 8 0V6h.75c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-.96c-.324-1.678-.996-3.5-2.134-3.5-.3 0-.594.122-.86.256-.255.128-.574.244-.796.244-.222 0-.54-.116-.797-.244-.265-.134-.56-.256-.86-.256C7.207 1 6.538 2.822 6.21 4.5H5.25a.748.748 0 0 0-.75.75c0 .416.334.75.75.75ZM10 6h2.5v.5a2.5 2.5 0 1 1-5 0V6H10Zm-.953 5.5a.545.545 0 0 0-.416.903l.857 1L8.518 17H8.5l-1.081-4.328c-.069-.272-.347-.438-.61-.338A5.145 5.145 0 0 0 3.5 17.141c0 .472.384.856.856.856h11.285a.858.858 0 0 0 .856-.856 5.145 5.145 0 0 0-3.31-4.807c-.262-.1-.54.066-.609.338L11.497 17h-.019l-.969-3.597.857-1a.545.545 0 0 0-.416-.903H9.044h.003Z\"/></symbol>\n<symbol id=\"icon-user-slash\" viewBox=\"0 0 20 20\"><path d=\"M2.281 1.222a.747.747 0 0 0-1.06 0 .756.756 0 0 0-.002 1.062l16.5 16.5a.75.75 0 0 0 1.06-1.06l-8.045-8.046A3.752 3.752 0 0 0 13.75 6 3.749 3.749 0 0 0 10 2.25a3.752 3.752 0 0 0-3.678 3.016l-4.04-4.044Zm6.081 10.322A5.576 5.576 0 0 0 3.5 17.072c0 .512.416.928.928.928h10.39l-6.456-6.456Z\"/></symbol>\n<symbol id=\"icon-user-status\" viewBox=\"0 0 20 20\"><path d=\"M15.25 8.5A6 6 0 0 0 9.794 12H7.75a4 4 0 0 0-3.469 2.006 5.986 5.986 0 0 0 5.147 1.957c.172.684.463 1.325.847 1.893A8.162 8.162 0 0 1 8.75 18a8 8 0 0 1-8-8 8 8 0 0 1 15.887-1.338A5.98 5.98 0 0 0 15.25 8.5Zm-6.5 2a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm6.5-.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-3.172 4.5a3.11 3.11 0 0 0 5.572 1.9.259.259 0 0 0-.222-.419 2.491 2.491 0 0 1-2.022-4.16.26.26 0 0 0 .047-.277.264.264 0 0 0-.234-.157h-.028a3.11 3.11 0 0 0-3.11 3.11l-.003.003Z\"/></symbol>\n<symbol id=\"icon-user\" viewBox=\"0 0 20 20\"><path d=\"M10 9.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm-.928 1.75A5.57 5.57 0 0 0 3.5 17.072c0 .512.416.928.928.928h11.144a.928.928 0 0 0 .928-.928 5.57 5.57 0 0 0-5.572-5.572H9.072Z\"/></symbol>\n<symbol id=\"icon-users\" viewBox=\"0 0 20 20\"><path d=\"M3 6a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM1 16.5a5.5 5.5 0 0 1 11 0v.188c0 .725-.588 1.312-1.313 1.312H2.313A1.312 1.312 0 0 1 1 16.687V16.5ZM14.5 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 7.5c2.484 0 4.5 2.016 4.5 4.5v.7c0 .719-.581 1.3-1.3 1.3h-4.525c.206-.39.325-.837.325-1.313V16.5a6.98 6.98 0 0 0-1.453-4.272A4.488 4.488 0 0 1 14.5 11.5Z\"/></symbol></svg>" };
//#endregion
//#region src/components/icon/scripts/addSVGIconsToDocument.ts
function M(e) {
	if (process.env.NODE_ENV === "test") return;
	let t = "dixa-icons-svg-lib";
	if (e.getElementById(t)) return;
	let n = e.createElement("span");
	n.id = t, n.style.display = "none", n.innerHTML = ae.svg, e.body.appendChild(n);
}
//#endregion
//#region src/components/icon/icon.tsx
M(document);
function N({ className: e, name: n, size: i = 16, color: a, style: o, ...s }) {
	let c = t(ie.root, e), l = { ...o }, u = {
		height: i,
		width: i
	};
	return a && (l.color = O(a)), /* @__PURE__ */ r("svg", {
		...s,
		className: c,
		style: l,
		...u,
		children: /* @__PURE__ */ r("use", { href: `#icon-${n}` })
	});
}
//#endregion
//#region src/components/box/box.types.ts
var oe = "div", se = [
	"display",
	"align",
	"wrap",
	"clamp",
	"background",
	"color",
	"fontSize",
	"boxShadow",
	"padding",
	"margin",
	"width",
	"minWidth",
	"maxWidth",
	"height",
	"minHeight",
	"maxHeight",
	"borderRadius",
	"borderColor",
	"borderWidth",
	"flex",
	"justifySelf",
	"alignSelf",
	"style",
	"boxSizing"
];
function ce(e) {
	let t = { ...e };
	return se.forEach((e) => {
		delete t[e];
	}), t;
}
function le(e) {
	let { display: t, align: n, wrap: r, clamp: i, background: a, color: o, fontSize: s, boxShadow: c, padding: l, margin: u, width: d, minWidth: f, maxWidth: p, height: m, minHeight: h, maxHeight: g, borderRadius: _, borderColor: v, borderWidth: y, flex: b, justifySelf: x, alignSelf: S, style: C, boxSizing: w } = e, T = {};
	return [
		{
			value: t,
			name: "display"
		},
		{
			value: s,
			name: "fontSize"
		},
		{
			value: d,
			name: "width"
		},
		{
			value: m,
			name: "height"
		},
		{
			value: f,
			name: "minWidth"
		},
		{
			value: p,
			name: "maxWidth"
		},
		{
			value: h,
			name: "minHeight"
		},
		{
			value: g,
			name: "maxHeight"
		},
		{
			value: b,
			name: "flex"
		},
		{
			value: x,
			name: "justifySelf"
		},
		{
			value: S,
			name: "alignSelf"
		},
		{
			value: n,
			name: "textAlign"
		},
		{
			value: r,
			name: "whiteSpace"
		},
		{
			value: w,
			name: "boxSizing"
		}
	].forEach((e) => {
		e.value && (T[e.name] = e.value);
	}), c && (T.boxShadow = k(c)), a && (T.backgroundColor = O(a)), o && (T.color = O(o)), l && (T.padding = j(l)), u && (T.margin = j(u)), l && (T.padding = j(l)), _ && (T.borderRadius = te(typeof _ == "boolean" ? "100" : _)), v && (T.borderColor = O(v), T.borderWidth = ne(), T.borderStyle = "solid"), y && (T.borderWidth = ne(y)), s && (T.fontSize = re(s)), i && (T.display = "-webkit-box", T.overflow = "hidden", T.WebkitBoxOrient = "vertical", T.WebkitLineClamp = i), T = {
		...T,
		...C
	}, T;
}
//#endregion
//#region src/components/box/box.tsx
var P = c(function(e, t) {
	let { as: n, children: i, ...a } = ce(e), o = n ?? "div", s = le(e);
	return /* @__PURE__ */ r(o, {
		...a,
		ref: t,
		style: s,
		children: i
	});
}), F = { text: "h-text--sharedStyles__text" }, I = {
	"heading-1": "h-text-heading--heading__heading-1",
	"heading-2": "h-text-heading--heading__heading-2",
	"heading-3": "h-text-heading--heading__heading-3",
	"heading-4": "h-text-heading--heading__heading-4",
	withMarginBottom: "h-text-heading--heading__withMarginBottom"
}, ue = {
	"heading-1": I["heading-1"],
	"heading-2": I["heading-2"],
	"heading-3": I["heading-3"],
	"heading-4": I["heading-4"]
}, de = class e extends a {
	static defaultProps = {
		variant: "heading-2",
		withMarginBottom: !1,
		as: "h2"
	};
	render() {
		let { children: n, variant: i = e.defaultProps.variant, className: a, withMarginBottom: o = e.defaultProps.withMarginBottom, ...s } = this.props, c = t(F.text, ue[i], { [I.withMarginBottom]: o }, a);
		return /* @__PURE__ */ r(P, {
			...s,
			className: c,
			children: n
		});
	}
}, L = {
	error: "h-text-input--input__error",
	warning: "h-text-input--input__warning",
	success: "h-text-input--input__success",
	title: "h-text-input--input__title"
}, fe = {
	title: L.title,
	success: L.success,
	warning: L.warning,
	error: L.error
}, pe = class extends a {
	static defaultProps = {
		variant: "title",
		as: "div"
	};
	render() {
		let { children: e, variant: n, className: i, ...a } = this.props, o = t(F.text, fe[n], i);
		return /* @__PURE__ */ r(P, {
			...a,
			role: "alert",
			className: o,
			children: e
		});
	}
}, me = { linkText: "h-text-link--externalLink__linkText" }, he = class extends a {
	static defaultProps = { as: "a" };
	render() {
		let { children: e, className: n, ...i } = this.props, a = t(me.linkText, F.text, n);
		return /* @__PURE__ */ r(P, {
			...i,
			className: a,
			children: e
		});
	}
}, R = {
	"variant-1": "h-text-paragraph--paragraph__variant-1",
	"variant-1-subdued": "h-text-paragraph--paragraph__variant-1-subdued",
	"variant-2": "h-text-paragraph--paragraph__variant-2",
	"variant-2-subdued": "h-text-paragraph--paragraph__variant-2-subdued",
	"variant-3": "h-text-paragraph--paragraph__variant-3",
	"variant-3-subdued": "h-text-paragraph--paragraph__variant-3-subdued",
	"variant-4": "h-text-paragraph--paragraph__variant-4",
	"variant-4-subdued": "h-text-paragraph--paragraph__variant-4-subdued",
	"variant-5": "h-text-paragraph--paragraph__variant-5",
	withMarginBottom: "h-text-paragraph--paragraph__withMarginBottom"
}, ge = {
	1: R["variant-1"],
	2: R["variant-2"],
	3: R["variant-3"],
	4: R["variant-4"],
	5: R["variant-5"]
}, _e = {
	1: R["variant-1-subdued"],
	2: R["variant-2-subdued"],
	3: R["variant-3-subdued"],
	4: R["variant-4-subdued"],
	5: ""
};
function ve(e, n, r, i) {
	let a = ge[e], o = _e[e];
	return t([
		F.text,
		a,
		i,
		{
			[o]: n,
			[R.withMarginBottom]: r
		}
	]);
}
function ye({ as: e = "p", variant: t = "2", subdued: n = !1, withMarginBottom: i = !1, className: a, children: o, ...s }) {
	return /* @__PURE__ */ r(P, {
		as: e,
		...s,
		className: ve(t, n, i, a),
		children: o
	});
}
//#endregion
//#region src/components/text/text.tsx
var z = class extends a {
	static Heading = de;
	static Paragraph = ye;
	static ExternalLink = he;
	static Input = pe;
	render() {
		return console.error("Using <Text> component directly is not allowed, use one of the sub-components instead: <Text.Paragraph>"), null;
	}
}, B = {
	root: "h-button--button__root",
	normal: "h-button--button__normal",
	large: "h-button--button__large",
	primary: "h-button--button__primary",
	active: "h-button--button__active",
	label: "h-button--button__label",
	secondary: "h-button--button__secondary",
	tertiary: "h-button--button__tertiary",
	danger: "h-button--button__danger",
	disabled: "h-button--button__disabled",
	loading: "h-button--button__loading",
	withLabel: "h-button--button__withLabel",
	slot: "h-button--button__slot",
	content: "h-button--button__content"
}, V = l(c(function({ children: e, className: a, type: o = "button", variant: s = "primary", size: c = "normal", icon: l, slotStart: u, slotEnd: d, active: f = !1, isLoading: p = !1, loadingIndicator: m = /* @__PURE__ */ r(z.Paragraph, {
	as: "span",
	variant: "3",
	wrap: "nowrap",
	color: "inherit",
	children: "Loading..."
}), label: h, styleText: g = !0, disabled: _ = !1, onClick: v, ...y }, b) {
	let x = t({
		[B.root]: !0,
		[B[s]]: !0,
		[B[c]]: !0,
		[B.active]: f,
		[B.disabled]: _,
		[B.loading]: p,
		[B.withLabel]: !d && !!h
	}, a);
	return /* @__PURE__ */ r("button", {
		...y,
		type: o,
		className: x,
		onClick: _ ? void 0 : v,
		disabled: _,
		ref: b,
		children: p ? m : /* @__PURE__ */ i(n, { children: [
			(u || l) && /* @__PURE__ */ r("span", {
				className: B.slot,
				children: l ? /* @__PURE__ */ r(N, { name: l }) : u
			}),
			(g || e) && /* @__PURE__ */ r("span", {
				className: B.content,
				children: g ? /* @__PURE__ */ r(z.Paragraph, {
					as: "span",
					variant: "3",
					wrap: "nowrap",
					color: "inherit",
					children: e
				}) : e
			}),
			h && /* @__PURE__ */ r(z.Paragraph, {
				as: "span",
				variant: "4",
				wrap: "nowrap",
				color: "inherit",
				className: B.label,
				children: h
			}),
			d && /* @__PURE__ */ r("span", {
				className: B.slot,
				children: d
			})
		] })
	});
})), be = { root: "h-button-navigationButton--navigationButton__root" }, xe = ({ className: e, navigate: n, onClick: i, ...a }) => {
	let o = (e) => {
		i?.(e), n();
	};
	return /* @__PURE__ */ r(V, {
		...a,
		variant: a.variant ?? "tertiary",
		onClick: o,
		className: t(e, be.root)
	});
}, Se = {
	root: "h-spinner--spinner__root",
	spin: "h-spinner--spinner__spin"
}, Ce = class extends a {
	render() {
		let { className: e, size: n, color: i, trackColor: a, bgColor: o, ...s } = this.props, c = t({ [Se.root]: !0 }, e), l = typeof n == "number" ? n : 32, u = typeof n == "number" ? `${l}px` : "32px", d = {
			height: u,
			width: u,
			borderWidth: `${Math.max(Math.floor(l / 8), 1)}px`
		};
		return a && a.length && (d.borderColor = a), i && i.length && (d.borderTopColor = i), o && o.length && (d.backgroundColor = o), /* @__PURE__ */ r("div", {
			...s,
			style: d,
			className: c
		});
	}
}, we = { root: "h-iconButton--iconButton__root" }, Te = l(c(function({ children: e, className: n, icon: i, iconProps: a, iconSize: o, variant: s = "primary", ...c }, l) {
	return /* @__PURE__ */ r(V, {
		ref: l,
		"aria-label": i,
		...c,
		variant: s,
		className: t(we.root, n),
		loadingIndicator: /* @__PURE__ */ r(Ce, { size: 16 }),
		styleText: !1,
		slotStart: /* @__PURE__ */ r(N, {
			size: o || 16,
			name: i,
			...a
		})
	});
})), H = {
	root: "h-inputWrapper--inputWrapper__root",
	rootDisabled: "h-inputWrapper--inputWrapper__rootDisabled",
	rootActive: "h-inputWrapper--inputWrapper__rootActive",
	rootHasError: "h-inputWrapper--inputWrapper__rootHasError",
	rootHasWarning: "h-inputWrapper--inputWrapper__rootHasWarning",
	rootHasSuccess: "h-inputWrapper--inputWrapper__rootHasSuccess",
	inputWrapper: "h-inputWrapper--inputWrapper__inputWrapper",
	rootWithPrefix: "h-inputWrapper--inputWrapper__rootWithPrefix",
	rootWithSuffix: "h-inputWrapper--inputWrapper__rootWithSuffix",
	suffixesContainer: "h-inputWrapper--inputWrapper__suffixesContainer",
	prefix: "h-inputWrapper--inputWrapper__prefix",
	suffix: "h-inputWrapper--inputWrapper__suffix",
	prefixDropdownButton: "h-inputWrapper--inputWrapper__prefixDropdownButton",
	suffixDropdownButton: "h-inputWrapper--inputWrapper__suffixDropdownButton",
	prefixButton: "h-inputWrapper--inputWrapper__prefixButton",
	suffixButton: "h-inputWrapper--inputWrapper__suffixButton",
	icon: "h-inputWrapper--inputWrapper__icon"
}, U = o({
	position: null,
	disabled: !1,
	active: !1,
	status: "success"
}), Ee = "inputWrapper", De = class extends a {
	renderIcon() {
		let { icon: e } = this.props;
		return e ? /* @__PURE__ */ r(N, {
			className: H.icon,
			name: e
		}) : null;
	}
	isButtonAddon(e) {
		return !!e && "type" in e && e.type === "button";
	}
	isCustomAddon(e) {
		return !!e && "type" in e && (!e.type || e.type === "custom");
	}
	renderAddon(e) {
		let n = this.props[e], { disabled: i } = this.props;
		if (!n) return null;
		let a;
		if (typeof n != "object" || !("type" in n)) a = /* @__PURE__ */ r("div", {
			className: t(H[e]),
			children: n
		});
		else if (this.isCustomAddon(n)) a = n.noWrap ? n.value : /* @__PURE__ */ r("div", {
			className: H[e],
			children: n.value
		});
		else if (this.isButtonAddon(n)) {
			let { className: o, disabled: s, ...c } = n.button;
			a = /* @__PURE__ */ r(Te, {
				className: t({
					[H[e]]: !n.noStyle,
					[H[`${e}Button`]]: !n.noStyle
				}, o),
				disabled: i || s,
				...c
			});
		}
		return a;
	}
	getContextValue(e) {
		let { disabled: t, active: n, status: r } = this.props;
		return {
			position: e,
			disabled: !!t,
			active: !!n,
			status: r || "success"
		};
	}
	render() {
		let { className: e, disabled: n, active: a, status: o, prefix: s, suffix: c, icon: l, children: u, innerRef: d, ...f } = this.props;
		return /* @__PURE__ */ i("div", {
			"data-testid": Ee,
			className: t(H.root, {
				[H.rootActive]: a,
				[H.rootDisabled]: n,
				[H.rootHasError]: o === "error",
				[H.rootHasWarning]: o === "warning",
				[H.rootHasSuccess]: o === "success",
				[H.rootWithPrefix]: !!s,
				[H.rootWithSuffix]: !!c
			}, e),
			ref: d,
			...f,
			children: [
				/* @__PURE__ */ r(U.Provider, {
					value: this.getContextValue("prefix"),
					children: this.renderAddon("prefix")
				}),
				/* @__PURE__ */ r("div", {
					className: H.inputWrapper,
					children: u
				}),
				/* @__PURE__ */ i("span", {
					className: H.suffixesContainer,
					children: [this.renderIcon(), /* @__PURE__ */ r(U.Provider, {
						value: this.getContextValue("suffix"),
						children: this.renderAddon("suffix")
					})]
				})
			]
		});
	}
}, Oe = c(function(e, t) {
	return /* @__PURE__ */ r(De, {
		innerRef: t,
		...e,
		children: e.children
	});
}), W = (e, t = 0) => {
	if (!e) return t;
	if (typeof e == "number") return e;
	let n = parseFloat(e);
	return isNaN(n) ? t : n;
}, G = {
	root: "h-inputText-inputNumberArrows--inputNumberArrows__root",
	button: "h-inputText-inputNumberArrows--inputNumberArrows__button",
	buttonUp: "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp",
	buttonDown: "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown",
	spacer: "h-inputText-inputNumberArrows--inputNumberArrows__spacer"
}, ke = 50, Ae = 300, je = "inputNumberArrowsTestId", Me = class extends a {
	intervalId;
	timeoutId;
	constructor(e) {
		super(e), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
	}
	componentDidMount() {
		window.addEventListener("mouseup", this.stopChangeValue);
	}
	componentWillUnmount() {
		window.removeEventListener("mouseup", this.stopChangeValue);
	}
	getNewValue(e) {
		let { step: t, min: n, max: r, inputRef: { current: i } } = this.props;
		if (!i) return 0;
		let a = W(i.value), o = W(t, 1), s = W(n, -(2 ** 53 - 1)), c = W(r, 2 ** 53 - 1);
		return e == "decrease" ? Math.max(a - o, s) : Math.min(a + o, c);
	}
	startIncreaseValue() {
		this.timeoutId = setTimeout(() => this.startChangeValue("increase"), Ae);
	}
	startDecreaseValue() {
		this.timeoutId = setTimeout(() => this.startChangeValue("decrease"), Ae);
	}
	startChangeValue(e) {
		this.intervalId ||= setInterval(() => this.triggerInputChange(e), ke);
	}
	stopChangeValue() {
		this.timeoutId &&= (clearTimeout(this.timeoutId), null), this.intervalId &&= (clearInterval(this.intervalId), null);
	}
	increaseValue(e) {
		e.preventDefault(), this.triggerInputChange("increase");
	}
	decreaseValue(e) {
		e.preventDefault(), this.triggerInputChange("decrease");
	}
	triggerInputChange(e) {
		let { inputRef: { current: t }, readOnly: n } = this.props;
		if (!t || n) return;
		let r = this.getNewValue(e), i = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(t);
		(Object.getOwnPropertyDescriptor(a, "value")?.set)?.call(t, r), t.dispatchEvent(i), t.focus();
	}
	render() {
		return /* @__PURE__ */ i("div", {
			className: G.root,
			"data-testid": je,
			children: [
				/* @__PURE__ */ r("button", {
					className: t(G.button, G.buttonUp),
					tabIndex: -1,
					onClick: this.increaseValue,
					onMouseDown: this.startIncreaseValue,
					children: /* @__PURE__ */ r(N, { name: "angle-up" })
				}),
				/* @__PURE__ */ r("span", { className: G.spacer }),
				/* @__PURE__ */ r("button", {
					className: t(G.button, G.buttonDown),
					tabIndex: -1,
					onClick: this.decreaseValue,
					onMouseDown: this.startDecreaseValue,
					children: /* @__PURE__ */ r(N, { name: "angle-down" })
				})
			]
		});
	}
}, K = {
	rootReadOnly: "h-inputText--inputText__rootReadOnly",
	container: "h-inputText--inputText__container",
	rootHasIcon: "h-inputText--inputText__rootHasIcon",
	rootTypeNumber: "h-inputText--inputText__rootTypeNumber",
	input: "h-inputText--inputText__input"
}, Ne = "inputText", Pe = c(function(e, n) {
	let a = m(null);
	f(n, () => a.current);
	let { className: o, disabled: s, readOnly: c, type: l = "text", name: u, prefix: d, suffix: p, icon: h, status: g, min: _, max: v, step: y, hideNumberArrows: b = !1, active: x = !1, ...S } = e;
	return /* @__PURE__ */ r(Oe, {
		className: t(o, {
			[K.rootTypeNumber]: l === "number",
			[K.rootHasIcon]: !!h,
			[K.rootReadOnly]: c
		}),
		status: g,
		disabled: s,
		active: x,
		prefix: d,
		suffix: p,
		icon: h,
		children: /* @__PURE__ */ i("div", {
			className: K.container,
			children: [/* @__PURE__ */ r("input", {
				"data-testid": Ne,
				dir: "auto",
				id: u,
				name: u,
				ref: a,
				...S,
				min: _,
				max: v,
				step: y,
				type: l,
				disabled: s,
				readOnly: c,
				className: K.input
			}), l === "number" && !b && /* @__PURE__ */ r(Me, {
				min: _,
				max: v,
				step: y,
				inputRef: a,
				readOnly: c
			})]
		})
	});
}), Fe = g, Ie = _, q = {
	root: "h-emojiPicker--emojiCategory__root",
	rootActive: "h-emojiPicker--emojiCategory__rootActive"
}, Le = ({ category: e, active: n, gotoCategory: i }) => /* @__PURE__ */ r("button", {
	type: "button",
	className: t({
		[q.root]: !0,
		[q.rootActive]: n
	}),
	title: e.name,
	onClick: () => i(e.key),
	children: /* @__PURE__ */ r(N, { name: e.icon })
}, e.key);
Le.displayName = "EmojiCategory";
var Re = { root: "h-emojiPicker--emojiButton__root" }, ze = ({ emoji: e, onSelect: t }) => {
	let { emoji: n } = e;
	return /* @__PURE__ */ r("button", {
		type: "button",
		onClick: () => t(n),
		className: Re.root,
		children: n
	});
};
ze.displayName = "Emoji";
var Be = { sectionHeader: "h-emojiPicker--emojiSection__sectionHeader" }, J = ({ emojis: e, category: t, onSelect: n, sectionRef: a }) => /* @__PURE__ */ i("div", { children: [/* @__PURE__ */ r("div", {
	ref: a,
	"data-ref": t.key,
	className: "tracker"
}), !!e.length && /* @__PURE__ */ i("div", { children: [/* @__PURE__ */ r(z.Paragraph, {
	as: "div",
	variant: "4",
	subdued: !0,
	className: Be.sectionHeader,
	children: t.name
}), e.map((e) => /* @__PURE__ */ r(ze, {
	emoji: e,
	onSelect: n
}, e.emoji))] })] }, t.key);
J.displayName = "EmojiSection";
var Y = {
	root: "h-emojiPicker--emojiPicker__root",
	search: "h-emojiPicker--emojiPicker__search",
	categories: "h-emojiPicker--emojiPicker__categories",
	container: "h-emojiPicker--emojiPicker__container",
	grid: "h-emojiPicker--emojiPicker__grid",
	empty: "h-emojiPicker--emojiPicker__empty"
}, X = {
	categories: [
		{
			key: 0,
			name: "Frequently used",
			icon: "clock"
		},
		{
			key: 1,
			name: "Smileys & People",
			icon: "smile"
		},
		{
			key: 2,
			name: "Animals & Nature",
			icon: "sun"
		},
		{
			key: 3,
			name: "Food & Drink",
			icon: "hamburger"
		},
		{
			key: 4,
			name: "Activities",
			icon: "american-football"
		},
		{
			key: 5,
			name: "Travel & Places",
			icon: "plane"
		},
		{
			key: 6,
			name: "Objects",
			icon: "lightbulb"
		},
		{
			key: 7,
			name: "Symbols",
			icon: "info"
		},
		{
			key: 8,
			name: "Flags",
			icon: "flag"
		}
	],
	emojis: [
		[],
		[
			{
				emoji: "😀",
				name: "GRINNING FACE",
				added_in: "6.1",
				shortName: "grinning",
				shortNames: ["grinning"],
				category: 1
			},
			{
				emoji: "😁",
				name: "GRINNING FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "grin",
				shortNames: ["grin"],
				category: 1
			},
			{
				emoji: "😂",
				name: "FACE WITH TEARS OF JOY",
				added_in: "6.0",
				shortName: "joy",
				shortNames: ["joy"],
				category: 1
			},
			{
				emoji: "😃",
				name: "SMILING FACE WITH OPEN MOUTH",
				added_in: "6.0",
				shortName: "smiley",
				shortNames: ["smiley"],
				category: 1
			},
			{
				emoji: "😄",
				name: "SMILING FACE WITH OPEN MOUTH AND SMILING EYES",
				added_in: "6.0",
				shortName: "smile",
				shortNames: ["smile"],
				category: 1
			},
			{
				emoji: "😅",
				name: "SMILING FACE WITH OPEN MOUTH AND COLD SWEAT",
				added_in: "6.0",
				shortName: "sweat_smile",
				shortNames: ["sweat_smile"],
				category: 1
			},
			{
				emoji: "😆",
				name: "SMILING FACE WITH OPEN MOUTH AND TIGHTLY-CLOSED EYES",
				added_in: "6.0",
				shortName: "laughing",
				shortNames: ["laughing", "satisfied"],
				category: 1
			},
			{
				emoji: "😇",
				name: "SMILING FACE WITH HALO",
				added_in: "6.0",
				shortName: "innocent",
				shortNames: ["innocent"],
				category: 1
			},
			{
				emoji: "😉",
				name: "WINKING FACE",
				added_in: "6.0",
				shortName: "wink",
				shortNames: ["wink"],
				category: 1
			},
			{
				emoji: "😊",
				name: "SMILING FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "blush",
				shortNames: ["blush"],
				category: 1
			},
			{
				emoji: "😋",
				name: "FACE SAVOURING DELICIOUS FOOD",
				added_in: "6.0",
				shortName: "yum",
				shortNames: ["yum"],
				category: 1
			},
			{
				emoji: "😌",
				name: "RELIEVED FACE",
				added_in: "6.0",
				shortName: "relieved",
				shortNames: ["relieved"],
				category: 1
			},
			{
				emoji: "😍",
				name: "SMILING FACE WITH HEART-SHAPED EYES",
				added_in: "6.0",
				shortName: "heart_eyes",
				shortNames: ["heart_eyes"],
				category: 1
			},
			{
				emoji: "😎",
				name: "SMILING FACE WITH SUNGLASSES",
				added_in: "6.0",
				shortName: "sunglasses",
				shortNames: ["sunglasses"],
				category: 1
			},
			{
				emoji: "😏",
				name: "SMIRKING FACE",
				added_in: "6.0",
				shortName: "smirk",
				shortNames: ["smirk"],
				category: 1
			},
			{
				emoji: "😐",
				name: "NEUTRAL FACE",
				added_in: "6.0",
				shortName: "neutral_face",
				shortNames: ["neutral_face"],
				category: 1
			},
			{
				emoji: "😑",
				name: "EXPRESSIONLESS FACE",
				added_in: "6.1",
				shortName: "expressionless",
				shortNames: ["expressionless"],
				category: 1
			},
			{
				emoji: "😒",
				name: "UNAMUSED FACE",
				added_in: "6.0",
				shortName: "unamused",
				shortNames: ["unamused"],
				category: 1
			},
			{
				emoji: "😓",
				name: "FACE WITH COLD SWEAT",
				added_in: "6.0",
				shortName: "sweat",
				shortNames: ["sweat"],
				category: 1
			},
			{
				emoji: "😔",
				name: "PENSIVE FACE",
				added_in: "6.0",
				shortName: "pensive",
				shortNames: ["pensive"],
				category: 1
			},
			{
				emoji: "😕",
				name: "CONFUSED FACE",
				added_in: "6.1",
				shortName: "confused",
				shortNames: ["confused"],
				category: 1
			},
			{
				emoji: "😖",
				name: "CONFOUNDED FACE",
				added_in: "6.0",
				shortName: "confounded",
				shortNames: ["confounded"],
				category: 1
			},
			{
				emoji: "😗",
				name: "KISSING FACE",
				added_in: "6.1",
				shortName: "kissing",
				shortNames: ["kissing"],
				category: 1
			},
			{
				emoji: "😘",
				name: "FACE THROWING A KISS",
				added_in: "6.0",
				shortName: "kissing_heart",
				shortNames: ["kissing_heart"],
				category: 1
			},
			{
				emoji: "😙",
				name: "KISSING FACE WITH SMILING EYES",
				added_in: "6.1",
				shortName: "kissing_smiling_eyes",
				shortNames: ["kissing_smiling_eyes"],
				category: 1
			},
			{
				emoji: "😚",
				name: "KISSING FACE WITH CLOSED EYES",
				added_in: "6.0",
				shortName: "kissing_closed_eyes",
				shortNames: ["kissing_closed_eyes"],
				category: 1
			},
			{
				emoji: "😛",
				name: "FACE WITH STUCK-OUT TONGUE",
				added_in: "6.1",
				shortName: "stuck_out_tongue",
				shortNames: ["stuck_out_tongue"],
				category: 1
			},
			{
				emoji: "😜",
				name: "FACE WITH STUCK-OUT TONGUE AND WINKING EYE",
				added_in: "6.0",
				shortName: "stuck_out_tongue_winking_eye",
				shortNames: ["stuck_out_tongue_winking_eye"],
				category: 1
			},
			{
				emoji: "😝",
				name: "FACE WITH STUCK-OUT TONGUE AND TIGHTLY-CLOSED EYES",
				added_in: "6.0",
				shortName: "stuck_out_tongue_closed_eyes",
				shortNames: ["stuck_out_tongue_closed_eyes"],
				category: 1
			},
			{
				emoji: "😞",
				name: "DISAPPOINTED FACE",
				added_in: "6.0",
				shortName: "disappointed",
				shortNames: ["disappointed"],
				category: 1
			},
			{
				emoji: "😟",
				name: "WORRIED FACE",
				added_in: "6.1",
				shortName: "worried",
				shortNames: ["worried"],
				category: 1
			},
			{
				emoji: "😠",
				name: "ANGRY FACE",
				added_in: "6.0",
				shortName: "angry",
				shortNames: ["angry"],
				category: 1
			},
			{
				emoji: "😡",
				name: "POUTING FACE",
				added_in: "6.0",
				shortName: "rage",
				shortNames: ["rage"],
				category: 1
			},
			{
				emoji: "😢",
				name: "CRYING FACE",
				added_in: "6.0",
				shortName: "cry",
				shortNames: ["cry"],
				category: 1
			},
			{
				emoji: "😣",
				name: "PERSEVERING FACE",
				added_in: "6.0",
				shortName: "persevere",
				shortNames: ["persevere"],
				category: 1
			},
			{
				emoji: "😤",
				name: "FACE WITH LOOK OF TRIUMPH",
				added_in: "6.0",
				shortName: "triumph",
				shortNames: ["triumph"],
				category: 1
			},
			{
				emoji: "😥",
				name: "DISAPPOINTED BUT RELIEVED FACE",
				added_in: "6.0",
				shortName: "disappointed_relieved",
				shortNames: ["disappointed_relieved"],
				category: 1
			},
			{
				emoji: "😦",
				name: "FROWNING FACE WITH OPEN MOUTH",
				added_in: "6.1",
				shortName: "frowning",
				shortNames: ["frowning"],
				category: 1
			},
			{
				emoji: "😧",
				name: "ANGUISHED FACE",
				added_in: "6.1",
				shortName: "anguished",
				shortNames: ["anguished"],
				category: 1
			},
			{
				emoji: "😨",
				name: "FEARFUL FACE",
				added_in: "6.0",
				shortName: "fearful",
				shortNames: ["fearful"],
				category: 1
			},
			{
				emoji: "😩",
				name: "WEARY FACE",
				added_in: "6.0",
				shortName: "weary",
				shortNames: ["weary"],
				category: 1
			},
			{
				emoji: "😪",
				name: "SLEEPY FACE",
				added_in: "6.0",
				shortName: "sleepy",
				shortNames: ["sleepy"],
				category: 1
			},
			{
				emoji: "😫",
				name: "TIRED FACE",
				added_in: "6.0",
				shortName: "tired_face",
				shortNames: ["tired_face"],
				category: 1
			},
			{
				emoji: "😬",
				name: "GRIMACING FACE",
				added_in: "6.1",
				shortName: "grimacing",
				shortNames: ["grimacing"],
				category: 1
			},
			{
				emoji: "😭",
				name: "LOUDLY CRYING FACE",
				added_in: "6.0",
				shortName: "sob",
				shortNames: ["sob"],
				category: 1
			},
			{
				emoji: "😮",
				name: "FACE WITH OPEN MOUTH",
				added_in: "6.1",
				shortName: "open_mouth",
				shortNames: ["open_mouth"],
				category: 1
			},
			{
				emoji: "😯",
				name: "HUSHED FACE",
				added_in: "6.1",
				shortName: "hushed",
				shortNames: ["hushed"],
				category: 1
			},
			{
				emoji: "😰",
				name: "FACE WITH OPEN MOUTH AND COLD SWEAT",
				added_in: "6.0",
				shortName: "cold_sweat",
				shortNames: ["cold_sweat"],
				category: 1
			},
			{
				emoji: "😱",
				name: "FACE SCREAMING IN FEAR",
				added_in: "6.0",
				shortName: "scream",
				shortNames: ["scream"],
				category: 1
			},
			{
				emoji: "😲",
				name: "ASTONISHED FACE",
				added_in: "6.0",
				shortName: "astonished",
				shortNames: ["astonished"],
				category: 1
			},
			{
				emoji: "😳",
				name: "FLUSHED FACE",
				added_in: "6.0",
				shortName: "flushed",
				shortNames: ["flushed"],
				category: 1
			},
			{
				emoji: "😴",
				name: "SLEEPING FACE",
				added_in: "6.1",
				shortName: "sleeping",
				shortNames: ["sleeping"],
				category: 1
			},
			{
				emoji: "😵",
				name: "DIZZY FACE",
				added_in: "6.0",
				shortName: "dizzy_face",
				shortNames: ["dizzy_face"],
				category: 1
			},
			{
				emoji: "😶",
				name: "FACE WITHOUT MOUTH",
				added_in: "6.0",
				shortName: "no_mouth",
				shortNames: ["no_mouth"],
				category: 1
			},
			{
				emoji: "😷",
				name: "FACE WITH MEDICAL MASK",
				added_in: "6.0",
				shortName: "mask",
				shortNames: ["mask"],
				category: 1
			},
			{
				emoji: "🙂",
				name: "SLIGHTLY SMILING FACE",
				added_in: "7.0",
				shortName: "slightly_smiling_face",
				shortNames: ["slightly_smiling_face"],
				category: 1
			},
			{
				emoji: "👿",
				name: "IMP",
				added_in: "6.0",
				shortName: "imp",
				shortNames: ["imp"],
				category: 1
			},
			{
				emoji: "😈",
				name: "SMILING FACE WITH HORNS",
				added_in: "6.0",
				shortName: "smiling_imp",
				shortNames: ["smiling_imp"],
				category: 1
			},
			{
				emoji: "👆",
				name: "WHITE UP POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_up_2",
				shortNames: ["point_up_2"],
				category: 1
			},
			{
				emoji: "👇",
				name: "WHITE DOWN POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_down",
				shortNames: ["point_down"],
				category: 1
			},
			{
				emoji: "👈",
				name: "WHITE LEFT POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_left",
				shortNames: ["point_left"],
				category: 1
			},
			{
				emoji: "👉",
				name: "WHITE RIGHT POINTING BACKHAND INDEX",
				added_in: "6.0",
				shortName: "point_right",
				shortNames: ["point_right"],
				category: 1
			},
			{
				emoji: "👊",
				name: "FISTED HAND SIGN",
				added_in: "6.0",
				shortName: "facepunch",
				shortNames: ["facepunch", "punch"],
				category: 1
			},
			{
				emoji: "👋",
				name: "WAVING HAND SIGN",
				added_in: "6.0",
				shortName: "wave",
				shortNames: ["wave"],
				category: 1
			},
			{
				emoji: "👌",
				name: "OK HAND SIGN",
				added_in: "6.0",
				shortName: "ok_hand",
				shortNames: ["ok_hand"],
				category: 1
			},
			{
				emoji: "👍",
				name: "THUMBS UP SIGN",
				added_in: "6.0",
				shortName: "+1",
				shortNames: ["+1", "thumbsup"],
				category: 1
			},
			{
				emoji: "👎",
				name: "THUMBS DOWN SIGN",
				added_in: "6.0",
				shortName: "-1",
				shortNames: ["-1", "thumbsdown"],
				category: 1
			},
			{
				emoji: "👏",
				name: "CLAPPING HANDS SIGN",
				added_in: "6.0",
				shortName: "clap",
				shortNames: ["clap"],
				category: 1
			},
			{
				emoji: "👐",
				name: "OPEN HANDS SIGN",
				added_in: "6.0",
				shortName: "open_hands",
				shortNames: ["open_hands"],
				category: 1
			},
			{
				emoji: "🙌",
				name: "PERSON RAISING BOTH HANDS IN CELEBRATION",
				added_in: "6.0",
				shortName: "raised_hands",
				shortNames: ["raised_hands"],
				category: 1
			},
			{
				emoji: "🙏",
				name: "PERSON WITH FOLDED HANDS",
				added_in: "6.0",
				shortName: "pray",
				shortNames: ["pray"],
				category: 1
			},
			{
				emoji: "☝️",
				name: "WHITE UP POINTING INDEX",
				added_in: "1.1",
				shortName: "point_up",
				shortNames: ["point_up"],
				category: 1
			},
			{
				emoji: "✊",
				name: "RAISED FIST",
				added_in: "6.0",
				shortName: "fist",
				shortNames: ["fist"],
				category: 1
			},
			{
				emoji: "✋",
				name: "RAISED HAND",
				added_in: "6.0",
				shortName: "hand",
				shortNames: ["hand", "raised_hand"],
				category: 1
			},
			{
				emoji: "✌️",
				name: "VICTORY HAND",
				added_in: "1.1",
				shortName: "v",
				shortNames: ["v"],
				category: 1
			},
			{
				emoji: "😸",
				name: "GRINNING CAT FACE WITH SMILING EYES",
				added_in: "6.0",
				shortName: "smile_cat",
				shortNames: ["smile_cat"],
				category: 1
			},
			{
				emoji: "😹",
				name: "CAT FACE WITH TEARS OF JOY",
				added_in: "6.0",
				shortName: "joy_cat",
				shortNames: ["joy_cat"],
				category: 1
			},
			{
				emoji: "😺",
				name: "SMILING CAT FACE WITH OPEN MOUTH",
				added_in: "6.0",
				shortName: "smiley_cat",
				shortNames: ["smiley_cat"],
				category: 1
			},
			{
				emoji: "😻",
				name: "SMILING CAT FACE WITH HEART-SHAPED EYES",
				added_in: "6.0",
				shortName: "heart_eyes_cat",
				shortNames: ["heart_eyes_cat"],
				category: 1
			},
			{
				emoji: "😼",
				name: "CAT FACE WITH WRY SMILE",
				added_in: "6.0",
				shortName: "smirk_cat",
				shortNames: ["smirk_cat"],
				category: 1
			},
			{
				emoji: "😽",
				name: "KISSING CAT FACE WITH CLOSED EYES",
				added_in: "6.0",
				shortName: "kissing_cat",
				shortNames: ["kissing_cat"],
				category: 1
			},
			{
				emoji: "😾",
				name: "POUTING CAT FACE",
				added_in: "6.0",
				shortName: "pouting_cat",
				shortNames: ["pouting_cat"],
				category: 1
			},
			{
				emoji: "😿",
				name: "CRYING CAT FACE",
				added_in: "6.0",
				shortName: "crying_cat_face",
				shortNames: ["crying_cat_face"],
				category: 1
			},
			{
				emoji: "🙀",
				name: "WEARY CAT FACE",
				added_in: "6.0",
				shortName: "scream_cat",
				shortNames: ["scream_cat"],
				category: 1
			},
			{
				emoji: "🙈",
				name: "SEE-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "see_no_evil",
				shortNames: ["see_no_evil"],
				category: 1
			},
			{
				emoji: "🙉",
				name: "HEAR-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "hear_no_evil",
				shortNames: ["hear_no_evil"],
				category: 1
			},
			{
				emoji: "🙊",
				name: "SPEAK-NO-EVIL MONKEY",
				added_in: "6.0",
				shortName: "speak_no_evil",
				shortNames: ["speak_no_evil"],
				category: 1
			},
			{
				emoji: "🎅",
				name: "FATHER CHRISTMAS",
				added_in: "6.0",
				shortName: "santa",
				shortNames: ["santa"],
				category: 1
			},
			{
				emoji: "👦",
				name: "BOY",
				added_in: "6.0",
				shortName: "boy",
				shortNames: ["boy"],
				category: 1
			},
			{
				emoji: "👧",
				name: "GIRL",
				added_in: "6.0",
				shortName: "girl",
				shortNames: ["girl"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-boy",
				shortNames: ["man-man-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-boy-boy",
				shortNames: ["man-man-boy-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl",
				shortNames: ["man-man-girl"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl-boy",
				shortNames: ["man-man-girl-boy"],
				category: 1
			},
			{
				emoji: "👨‍👨‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-man-girl-girl",
				shortNames: ["man-man-girl-girl"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-boy",
				shortNames: ["man-woman-boy", "family"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-boy-boy",
				shortNames: ["man-woman-boy-boy"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl",
				shortNames: ["man-woman-girl"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl-boy",
				shortNames: ["man-woman-girl-boy"],
				category: 1
			},
			{
				emoji: "👨‍👩‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "man-woman-girl-girl",
				shortNames: ["man-woman-girl-girl"],
				category: 1
			},
			{
				emoji: "👨‍❤️‍👨",
				name: null,
				added_in: "6.0",
				shortName: "man-heart-man",
				shortNames: ["man-heart-man"],
				category: 1
			},
			{
				emoji: "👨‍❤️‍💋‍👨",
				name: null,
				added_in: "6.0",
				shortName: "man-kiss-man",
				shortNames: ["man-kiss-man"],
				category: 1
			},
			{
				emoji: "👨",
				name: "MAN",
				added_in: "6.0",
				shortName: "man",
				shortNames: ["man"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-boy",
				shortNames: ["woman-woman-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👦‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-boy-boy",
				shortNames: ["woman-woman-boy-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl",
				shortNames: ["woman-woman-girl"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧‍👦",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl-boy",
				shortNames: ["woman-woman-girl-boy"],
				category: 1
			},
			{
				emoji: "👩‍👩‍👧‍👧",
				name: null,
				added_in: "6.0",
				shortName: "woman-woman-girl-girl",
				shortNames: ["woman-woman-girl-girl"],
				category: 1
			},
			{
				emoji: "👩‍❤️‍👩",
				name: null,
				added_in: "6.0",
				shortName: "woman-heart-woman",
				shortNames: ["woman-heart-woman"],
				category: 1
			},
			{
				emoji: "👩‍❤️‍💋‍👩",
				name: null,
				added_in: "6.0",
				shortName: "woman-kiss-woman",
				shortNames: ["woman-kiss-woman"],
				category: 1
			},
			{
				emoji: "👩",
				name: "WOMAN",
				added_in: "6.0",
				shortName: "woman",
				shortNames: ["woman"],
				category: 1
			},
			{
				emoji: "👫",
				name: "MAN AND WOMAN HOLDING HANDS",
				added_in: "6.0",
				shortName: "couple",
				shortNames: ["couple", "man_and_woman_holding_hands"],
				category: 1
			},
			{
				emoji: "👬",
				name: "TWO MEN HOLDING HANDS",
				added_in: "6.0",
				shortName: "two_men_holding_hands",
				shortNames: ["two_men_holding_hands"],
				category: 1
			},
			{
				emoji: "👭",
				name: "TWO WOMEN HOLDING HANDS",
				added_in: "6.0",
				shortName: "two_women_holding_hands",
				shortNames: ["two_women_holding_hands"],
				category: 1
			},
			{
				emoji: "👲",
				name: "MAN WITH GUA PI MAO",
				added_in: "6.0",
				shortName: "man_with_gua_pi_mao",
				shortNames: ["man_with_gua_pi_mao"],
				category: 1
			},
			{
				emoji: "👴",
				name: "OLDER MAN",
				added_in: "6.0",
				shortName: "older_man",
				shortNames: ["older_man"],
				category: 1
			},
			{
				emoji: "👵",
				name: "OLDER WOMAN",
				added_in: "6.0",
				shortName: "older_woman",
				shortNames: ["older_woman"],
				category: 1
			},
			{
				emoji: "👰",
				name: "BRIDE WITH VEIL",
				added_in: "6.0",
				shortName: "bride_with_veil",
				shortNames: ["bride_with_veil"],
				category: 1
			},
			{
				emoji: "👶",
				name: "BABY",
				added_in: "6.0",
				shortName: "baby",
				shortNames: ["baby"],
				category: 1
			},
			{
				emoji: "👸",
				name: "PRINCESS",
				added_in: "6.0",
				shortName: "princess",
				shortNames: ["princess"],
				category: 1
			},
			{
				emoji: "👼",
				name: "BABY ANGEL",
				added_in: "6.0",
				shortName: "angel",
				shortNames: ["angel"],
				category: 1
			},
			{
				emoji: "🎩",
				name: "TOP HAT",
				added_in: "6.0",
				shortName: "tophat",
				shortNames: ["tophat"],
				category: 1
			},
			{
				emoji: "👒",
				name: "WOMANS HAT",
				added_in: "6.0",
				shortName: "womans_hat",
				shortNames: ["womans_hat"],
				category: 1
			},
			{
				emoji: "👕",
				name: "T-SHIRT",
				added_in: "6.0",
				shortName: "shirt",
				shortNames: ["shirt", "tshirt"],
				category: 1
			},
			{
				emoji: "👚",
				name: "WOMANS CLOTHES",
				added_in: "6.0",
				shortName: "womans_clothes",
				shortNames: ["womans_clothes"],
				category: 1
			},
			{
				emoji: "👜",
				name: "HANDBAG",
				added_in: "6.0",
				shortName: "handbag",
				shortNames: ["handbag"],
				category: 1
			},
			{
				emoji: "👞",
				name: "MANS SHOE",
				added_in: "6.0",
				shortName: "mans_shoe",
				shortNames: ["mans_shoe", "shoe"],
				category: 1
			},
			{
				emoji: "👟",
				name: "ATHLETIC SHOE",
				added_in: "6.0",
				shortName: "athletic_shoe",
				shortNames: ["athletic_shoe"],
				category: 1
			},
			{
				emoji: "👠",
				name: "HIGH-HEELED SHOE",
				added_in: "6.0",
				shortName: "high_heel",
				shortNames: ["high_heel"],
				category: 1
			},
			{
				emoji: "👡",
				name: "WOMANS SANDAL",
				added_in: "6.0",
				shortName: "sandal",
				shortNames: ["sandal"],
				category: 1
			},
			{
				emoji: "👢",
				name: "WOMANS BOOTS",
				added_in: "6.0",
				shortName: "boot",
				shortNames: ["boot"],
				category: 1
			},
			{
				emoji: "🎒",
				name: "SCHOOL SATCHEL",
				added_in: "6.0",
				shortName: "school_satchel",
				shortNames: ["school_satchel"],
				category: 1
			},
			{
				emoji: "🎓",
				name: "GRADUATION CAP",
				added_in: "6.0",
				shortName: "mortar_board",
				shortNames: ["mortar_board"],
				category: 1
			},
			{
				emoji: "🏂",
				name: "SNOWBOARDER",
				added_in: "6.0",
				shortName: "snowboarder",
				shortNames: ["snowboarder"],
				category: 1
			},
			{
				emoji: "🏇",
				name: "HORSE RACING",
				added_in: "6.0",
				shortName: "horse_racing",
				shortNames: ["horse_racing"],
				category: 1
			},
			{
				emoji: "👀",
				name: "EYES",
				added_in: "6.0",
				shortName: "eyes",
				shortNames: ["eyes"],
				category: 1
			},
			{
				emoji: "👂",
				name: "EAR",
				added_in: "6.0",
				shortName: "ear",
				shortNames: ["ear"],
				category: 1
			},
			{
				emoji: "👃",
				name: "NOSE",
				added_in: "6.0",
				shortName: "nose",
				shortNames: ["nose"],
				category: 1
			},
			{
				emoji: "👄",
				name: "MOUTH",
				added_in: "6.0",
				shortName: "lips",
				shortNames: ["lips"],
				category: 1
			},
			{
				emoji: "👅",
				name: "TONGUE",
				added_in: "6.0",
				shortName: "tongue",
				shortNames: ["tongue"],
				category: 1
			},
			{
				emoji: "👑",
				name: "CROWN",
				added_in: "6.0",
				shortName: "crown",
				shortNames: ["crown"],
				category: 1
			},
			{
				emoji: "👓",
				name: "EYEGLASSES",
				added_in: "6.0",
				shortName: "eyeglasses",
				shortNames: ["eyeglasses"],
				category: 1
			},
			{
				emoji: "👔",
				name: "NECKTIE",
				added_in: "6.0",
				shortName: "necktie",
				shortNames: ["necktie"],
				category: 1
			},
			{
				emoji: "👖",
				name: "JEANS",
				added_in: "6.0",
				shortName: "jeans",
				shortNames: ["jeans"],
				category: 1
			},
			{
				emoji: "👗",
				name: "DRESS",
				added_in: "6.0",
				shortName: "dress",
				shortNames: ["dress"],
				category: 1
			},
			{
				emoji: "👘",
				name: "KIMONO",
				added_in: "6.0",
				shortName: "kimono",
				shortNames: ["kimono"],
				category: 1
			},
			{
				emoji: "👙",
				name: "BIKINI",
				added_in: "6.0",
				shortName: "bikini",
				shortNames: ["bikini"],
				category: 1
			},
			{
				emoji: "👛",
				name: "PURSE",
				added_in: "6.0",
				shortName: "purse",
				shortNames: ["purse"],
				category: 1
			},
			{
				emoji: "👝",
				name: "POUCH",
				added_in: "6.0",
				shortName: "pouch",
				shortNames: ["pouch"],
				category: 1
			},
			{
				emoji: "👣",
				name: "FOOTPRINTS",
				added_in: "6.0",
				shortName: "footprints",
				shortNames: ["footprints"],
				category: 1
			},
			{
				emoji: "👤",
				name: "BUST IN SILHOUETTE",
				added_in: "6.0",
				shortName: "bust_in_silhouette",
				shortNames: ["bust_in_silhouette"],
				category: 1
			},
			{
				emoji: "👥",
				name: "BUSTS IN SILHOUETTE",
				added_in: "6.0",
				shortName: "busts_in_silhouette",
				shortNames: ["busts_in_silhouette"],
				category: 1
			},
			{
				emoji: "👹",
				name: "JAPANESE OGRE",
				added_in: "6.0",
				shortName: "japanese_ogre",
				shortNames: ["japanese_ogre"],
				category: 1
			},
			{
				emoji: "👺",
				name: "JAPANESE GOBLIN",
				added_in: "6.0",
				shortName: "japanese_goblin",
				shortNames: ["japanese_goblin"],
				category: 1
			},
			{
				emoji: "👻",
				name: "GHOST",
				added_in: "6.0",
				shortName: "ghost",
				shortNames: ["ghost"],
				category: 1
			},
			{
				emoji: "👽",
				name: "EXTRATERRESTRIAL ALIEN",
				added_in: "6.0",
				shortName: "alien",
				shortNames: ["alien"],
				category: 1
			},
			{
				emoji: "👾",
				name: "ALIEN MONSTER",
				added_in: "6.0",
				shortName: "space_invader",
				shortNames: ["space_invader"],
				category: 1
			},
			{
				emoji: "💀",
				name: "SKULL",
				added_in: "6.0",
				shortName: "skull",
				shortNames: ["skull"],
				category: 1
			},
			{
				emoji: "💃",
				name: "DANCER",
				added_in: "6.0",
				shortName: "dancer",
				shortNames: ["dancer"],
				category: 1
			},
			{
				emoji: "💄",
				name: "LIPSTICK",
				added_in: "6.0",
				shortName: "lipstick",
				shortNames: ["lipstick"],
				category: 1
			},
			{
				emoji: "💅",
				name: "NAIL POLISH",
				added_in: "6.0",
				shortName: "nail_care",
				shortNames: ["nail_care"],
				category: 1
			},
			{
				emoji: "💋",
				name: "KISS MARK",
				added_in: "6.0",
				shortName: "kiss",
				shortNames: ["kiss"],
				category: 1
			},
			{
				emoji: "💌",
				name: "LOVE LETTER",
				added_in: "6.0",
				shortName: "love_letter",
				shortNames: ["love_letter"],
				category: 1
			},
			{
				emoji: "💍",
				name: "RING",
				added_in: "6.0",
				shortName: "ring",
				shortNames: ["ring"],
				category: 1
			},
			{
				emoji: "💎",
				name: "GEM STONE",
				added_in: "6.0",
				shortName: "gem",
				shortNames: ["gem"],
				category: 1
			},
			{
				emoji: "💓",
				name: "BEATING HEART",
				added_in: "6.0",
				shortName: "heartbeat",
				shortNames: ["heartbeat"],
				category: 1
			},
			{
				emoji: "💔",
				name: "BROKEN HEART",
				added_in: "6.0",
				shortName: "broken_heart",
				shortNames: ["broken_heart"],
				category: 1
			},
			{
				emoji: "💕",
				name: "TWO HEARTS",
				added_in: "6.0",
				shortName: "two_hearts",
				shortNames: ["two_hearts"],
				category: 1
			},
			{
				emoji: "💖",
				name: "SPARKLING HEART",
				added_in: "6.0",
				shortName: "sparkling_heart",
				shortNames: ["sparkling_heart"],
				category: 1
			},
			{
				emoji: "💗",
				name: "GROWING HEART",
				added_in: "6.0",
				shortName: "heartpulse",
				shortNames: ["heartpulse"],
				category: 1
			},
			{
				emoji: "💘",
				name: "HEART WITH ARROW",
				added_in: "6.0",
				shortName: "cupid",
				shortNames: ["cupid"],
				category: 1
			},
			{
				emoji: "💙",
				name: "BLUE HEART",
				added_in: "6.0",
				shortName: "blue_heart",
				shortNames: ["blue_heart"],
				category: 1
			},
			{
				emoji: "💚",
				name: "GREEN HEART",
				added_in: "6.0",
				shortName: "green_heart",
				shortNames: ["green_heart"],
				category: 1
			},
			{
				emoji: "💛",
				name: "YELLOW HEART",
				added_in: "6.0",
				shortName: "yellow_heart",
				shortNames: ["yellow_heart"],
				category: 1
			},
			{
				emoji: "💜",
				name: "PURPLE HEART",
				added_in: "6.0",
				shortName: "purple_heart",
				shortNames: ["purple_heart"],
				category: 1
			},
			{
				emoji: "💝",
				name: "HEART WITH RIBBON",
				added_in: "6.0",
				shortName: "gift_heart",
				shortNames: ["gift_heart"],
				category: 1
			},
			{
				emoji: "💞",
				name: "REVOLVING HEARTS",
				added_in: "6.0",
				shortName: "revolving_hearts",
				shortNames: ["revolving_hearts"],
				category: 1
			},
			{
				emoji: "💟",
				name: "HEART DECORATION",
				added_in: "6.0",
				shortName: "heart_decoration",
				shortNames: ["heart_decoration"],
				category: 1
			},
			{
				emoji: "💢",
				name: "ANGER SYMBOL",
				added_in: "6.0",
				shortName: "anger",
				shortNames: ["anger"],
				category: 1
			},
			{
				emoji: "💣",
				name: "BOMB",
				added_in: "6.0",
				shortName: "bomb",
				shortNames: ["bomb"],
				category: 1
			},
			{
				emoji: "💤",
				name: "SLEEPING SYMBOL",
				added_in: "6.0",
				shortName: "zzz",
				shortNames: ["zzz"],
				category: 1
			},
			{
				emoji: "💥",
				name: "COLLISION SYMBOL",
				added_in: "6.0",
				shortName: "boom",
				shortNames: ["boom", "collision"],
				category: 1
			},
			{
				emoji: "💦",
				name: "SPLASHING SWEAT SYMBOL",
				added_in: "6.0",
				shortName: "sweat_drops",
				shortNames: ["sweat_drops"],
				category: 1
			},
			{
				emoji: "💨",
				name: "DASH SYMBOL",
				added_in: "6.0",
				shortName: "dash",
				shortNames: ["dash"],
				category: 1
			},
			{
				emoji: "💩",
				name: "PILE OF POO",
				added_in: "6.0",
				shortName: "hankey",
				shortNames: [
					"hankey",
					"poop",
					"shit"
				],
				category: 1
			},
			{
				emoji: "💪",
				name: "FLEXED BICEPS",
				added_in: "6.0",
				shortName: "muscle",
				shortNames: ["muscle"],
				category: 1
			},
			{
				emoji: "💫",
				name: "DIZZY SYMBOL",
				added_in: "6.0",
				shortName: "dizzy",
				shortNames: ["dizzy"],
				category: 1
			},
			{
				emoji: "💬",
				name: "SPEECH BALLOON",
				added_in: "6.0",
				shortName: "speech_balloon",
				shortNames: ["speech_balloon"],
				category: 1
			},
			{
				emoji: "💭",
				name: "THOUGHT BALLOON",
				added_in: "6.0",
				shortName: "thought_balloon",
				shortNames: ["thought_balloon"],
				category: 1
			},
			{
				emoji: "🛀",
				name: "BATH",
				added_in: "6.0",
				shortName: "bath",
				shortNames: ["bath"],
				category: 1
			},
			{
				emoji: "❤️",
				name: "HEAVY BLACK HEART",
				added_in: "1.1",
				shortName: "heart",
				shortNames: ["heart"],
				category: 1
			}
		],
		[
			{
				emoji: "🐭",
				name: "MOUSE FACE",
				added_in: "6.0",
				shortName: "mouse",
				shortNames: ["mouse"],
				category: 2
			},
			{
				emoji: "🐮",
				name: "COW FACE",
				added_in: "6.0",
				shortName: "cow",
				shortNames: ["cow"],
				category: 2
			},
			{
				emoji: "🐯",
				name: "TIGER FACE",
				added_in: "6.0",
				shortName: "tiger",
				shortNames: ["tiger"],
				category: 2
			},
			{
				emoji: "🐰",
				name: "RABBIT FACE",
				added_in: "6.0",
				shortName: "rabbit",
				shortNames: ["rabbit"],
				category: 2
			},
			{
				emoji: "🐲",
				name: "DRAGON FACE",
				added_in: "6.0",
				shortName: "dragon_face",
				shortNames: ["dragon_face"],
				category: 2
			},
			{
				emoji: "🐴",
				name: "HORSE FACE",
				added_in: "6.0",
				shortName: "horse",
				shortNames: ["horse"],
				category: 2
			},
			{
				emoji: "🐵",
				name: "MONKEY FACE",
				added_in: "6.0",
				shortName: "monkey_face",
				shortNames: ["monkey_face"],
				category: 2
			},
			{
				emoji: "🐶",
				name: "DOG FACE",
				added_in: "6.0",
				shortName: "dog",
				shortNames: ["dog"],
				category: 2
			},
			{
				emoji: "🐷",
				name: "PIG FACE",
				added_in: "6.0",
				shortName: "pig",
				shortNames: ["pig"],
				category: 2
			},
			{
				emoji: "🐸",
				name: "FROG FACE",
				added_in: "6.0",
				shortName: "frog",
				shortNames: ["frog"],
				category: 2
			},
			{
				emoji: "🐹",
				name: "HAMSTER FACE",
				added_in: "6.0",
				shortName: "hamster",
				shortNames: ["hamster"],
				category: 2
			},
			{
				emoji: "🐺",
				name: "WOLF FACE",
				added_in: "6.0",
				shortName: "wolf",
				shortNames: ["wolf"],
				category: 2
			},
			{
				emoji: "🐻",
				name: "BEAR FACE",
				added_in: "6.0",
				shortName: "bear",
				shortNames: ["bear"],
				category: 2
			},
			{
				emoji: "🐼",
				name: "PANDA FACE",
				added_in: "6.0",
				shortName: "panda_face",
				shortNames: ["panda_face"],
				category: 2
			},
			{
				emoji: "🐱",
				name: "CAT FACE",
				added_in: "6.0",
				shortName: "cat",
				shortNames: ["cat"],
				category: 2
			},
			{
				emoji: "🐒",
				name: "MONKEY",
				added_in: "6.0",
				shortName: "monkey",
				shortNames: ["monkey"],
				category: 2
			},
			{
				emoji: "🐤",
				name: "BABY CHICK",
				added_in: "6.0",
				shortName: "baby_chick",
				shortNames: ["baby_chick"],
				category: 2
			},
			{
				emoji: "🐥",
				name: "FRONT-FACING BABY CHICK",
				added_in: "6.0",
				shortName: "hatched_chick",
				shortNames: ["hatched_chick"],
				category: 2
			},
			{
				emoji: "🐣",
				name: "HATCHING CHICK",
				added_in: "6.0",
				shortName: "hatching_chick",
				shortNames: ["hatching_chick"],
				category: 2
			},
			{
				emoji: "🌱",
				name: "SEEDLING",
				added_in: "6.0",
				shortName: "seedling",
				shortNames: ["seedling"],
				category: 2
			},
			{
				emoji: "🌲",
				name: "EVERGREEN TREE",
				added_in: "6.0",
				shortName: "evergreen_tree",
				shortNames: ["evergreen_tree"],
				category: 2
			},
			{
				emoji: "🌳",
				name: "DECIDUOUS TREE",
				added_in: "6.0",
				shortName: "deciduous_tree",
				shortNames: ["deciduous_tree"],
				category: 2
			},
			{
				emoji: "🌴",
				name: "PALM TREE",
				added_in: "6.0",
				shortName: "palm_tree",
				shortNames: ["palm_tree"],
				category: 2
			},
			{
				emoji: "🌵",
				name: "CACTUS",
				added_in: "6.0",
				shortName: "cactus",
				shortNames: ["cactus"],
				category: 2
			},
			{
				emoji: "🌷",
				name: "TULIP",
				added_in: "6.0",
				shortName: "tulip",
				shortNames: ["tulip"],
				category: 2
			},
			{
				emoji: "🌸",
				name: "CHERRY BLOSSOM",
				added_in: "6.0",
				shortName: "cherry_blossom",
				shortNames: ["cherry_blossom"],
				category: 2
			},
			{
				emoji: "🌹",
				name: "ROSE",
				added_in: "6.0",
				shortName: "rose",
				shortNames: ["rose"],
				category: 2
			},
			{
				emoji: "🌺",
				name: "HIBISCUS",
				added_in: "6.0",
				shortName: "hibiscus",
				shortNames: ["hibiscus"],
				category: 2
			},
			{
				emoji: "🌻",
				name: "SUNFLOWER",
				added_in: "6.0",
				shortName: "sunflower",
				shortNames: ["sunflower"],
				category: 2
			},
			{
				emoji: "🌼",
				name: "BLOSSOM",
				added_in: "6.0",
				shortName: "blossom",
				shortNames: ["blossom"],
				category: 2
			},
			{
				emoji: "🌾",
				name: "EAR OF RICE",
				added_in: "6.0",
				shortName: "ear_of_rice",
				shortNames: ["ear_of_rice"],
				category: 2
			},
			{
				emoji: "🌿",
				name: "HERB",
				added_in: "6.0",
				shortName: "herb",
				shortNames: ["herb"],
				category: 2
			},
			{
				emoji: "🍀",
				name: "FOUR LEAF CLOVER",
				added_in: "6.0",
				shortName: "four_leaf_clover",
				shortNames: ["four_leaf_clover"],
				category: 2
			},
			{
				emoji: "🍁",
				name: "MAPLE LEAF",
				added_in: "6.0",
				shortName: "maple_leaf",
				shortNames: ["maple_leaf"],
				category: 2
			},
			{
				emoji: "🍂",
				name: "FALLEN LEAF",
				added_in: "6.0",
				shortName: "fallen_leaf",
				shortNames: ["fallen_leaf"],
				category: 2
			},
			{
				emoji: "🍃",
				name: "LEAF FLUTTERING IN WIND",
				added_in: "6.0",
				shortName: "leaves",
				shortNames: ["leaves"],
				category: 2
			},
			{
				emoji: "🐀",
				name: "RAT",
				added_in: "6.0",
				shortName: "rat",
				shortNames: ["rat"],
				category: 2
			},
			{
				emoji: "🐁",
				name: "MOUSE",
				added_in: "6.0",
				shortName: "mouse2",
				shortNames: ["mouse2"],
				category: 2
			},
			{
				emoji: "🐂",
				name: "OX",
				added_in: "6.0",
				shortName: "ox",
				shortNames: ["ox"],
				category: 2
			},
			{
				emoji: "🐃",
				name: "WATER BUFFALO",
				added_in: "6.0",
				shortName: "water_buffalo",
				shortNames: ["water_buffalo"],
				category: 2
			},
			{
				emoji: "🐄",
				name: "COW",
				added_in: "6.0",
				shortName: "cow2",
				shortNames: ["cow2"],
				category: 2
			},
			{
				emoji: "🐅",
				name: "TIGER",
				added_in: "6.0",
				shortName: "tiger2",
				shortNames: ["tiger2"],
				category: 2
			},
			{
				emoji: "🐆",
				name: "LEOPARD",
				added_in: "6.0",
				shortName: "leopard",
				shortNames: ["leopard"],
				category: 2
			},
			{
				emoji: "🐇",
				name: "RABBIT",
				added_in: "6.0",
				shortName: "rabbit2",
				shortNames: ["rabbit2"],
				category: 2
			},
			{
				emoji: "🐈",
				name: "CAT",
				added_in: "6.0",
				shortName: "cat2",
				shortNames: ["cat2"],
				category: 2
			},
			{
				emoji: "🐉",
				name: "DRAGON",
				added_in: "6.0",
				shortName: "dragon",
				shortNames: ["dragon"],
				category: 2
			},
			{
				emoji: "🐊",
				name: "CROCODILE",
				added_in: "6.0",
				shortName: "crocodile",
				shortNames: ["crocodile"],
				category: 2
			},
			{
				emoji: "🐋",
				name: "WHALE",
				added_in: "6.0",
				shortName: "whale2",
				shortNames: ["whale2"],
				category: 2
			},
			{
				emoji: "🐌",
				name: "SNAIL",
				added_in: "6.0",
				shortName: "snail",
				shortNames: ["snail"],
				category: 2
			},
			{
				emoji: "🐍",
				name: "SNAKE",
				added_in: "6.0",
				shortName: "snake",
				shortNames: ["snake"],
				category: 2
			},
			{
				emoji: "🐎",
				name: "HORSE",
				added_in: "6.0",
				shortName: "racehorse",
				shortNames: ["racehorse"],
				category: 2
			},
			{
				emoji: "🐏",
				name: "RAM",
				added_in: "6.0",
				shortName: "ram",
				shortNames: ["ram"],
				category: 2
			},
			{
				emoji: "🐐",
				name: "GOAT",
				added_in: "6.0",
				shortName: "goat",
				shortNames: ["goat"],
				category: 2
			},
			{
				emoji: "🐑",
				name: "SHEEP",
				added_in: "6.0",
				shortName: "sheep",
				shortNames: ["sheep"],
				category: 2
			},
			{
				emoji: "🐓",
				name: "ROOSTER",
				added_in: "6.0",
				shortName: "rooster",
				shortNames: ["rooster"],
				category: 2
			},
			{
				emoji: "🐔",
				name: "CHICKEN",
				added_in: "6.0",
				shortName: "chicken",
				shortNames: ["chicken"],
				category: 2
			},
			{
				emoji: "🐕",
				name: "DOG",
				added_in: "6.0",
				shortName: "dog2",
				shortNames: ["dog2"],
				category: 2
			},
			{
				emoji: "🐖",
				name: "PIG",
				added_in: "6.0",
				shortName: "pig2",
				shortNames: ["pig2"],
				category: 2
			},
			{
				emoji: "🐗",
				name: "BOAR",
				added_in: "6.0",
				shortName: "boar",
				shortNames: ["boar"],
				category: 2
			},
			{
				emoji: "🐘",
				name: "ELEPHANT",
				added_in: "6.0",
				shortName: "elephant",
				shortNames: ["elephant"],
				category: 2
			},
			{
				emoji: "🐙",
				name: "OCTOPUS",
				added_in: "6.0",
				shortName: "octopus",
				shortNames: ["octopus"],
				category: 2
			},
			{
				emoji: "🐚",
				name: "SPIRAL SHELL",
				added_in: "6.0",
				shortName: "shell",
				shortNames: ["shell"],
				category: 2
			},
			{
				emoji: "🐛",
				name: "BUG",
				added_in: "6.0",
				shortName: "bug",
				shortNames: ["bug"],
				category: 2
			},
			{
				emoji: "🐜",
				name: "ANT",
				added_in: "6.0",
				shortName: "ant",
				shortNames: ["ant"],
				category: 2
			},
			{
				emoji: "🐝",
				name: "HONEYBEE",
				added_in: "6.0",
				shortName: "bee",
				shortNames: ["bee", "honeybee"],
				category: 2
			},
			{
				emoji: "🐞",
				name: "LADY BEETLE",
				added_in: "6.0",
				shortName: "beetle",
				shortNames: ["beetle"],
				category: 2
			},
			{
				emoji: "🐟",
				name: "FISH",
				added_in: "6.0",
				shortName: "fish",
				shortNames: ["fish"],
				category: 2
			},
			{
				emoji: "🐠",
				name: "TROPICAL FISH",
				added_in: "6.0",
				shortName: "tropical_fish",
				shortNames: ["tropical_fish"],
				category: 2
			},
			{
				emoji: "🐡",
				name: "BLOWFISH",
				added_in: "6.0",
				shortName: "blowfish",
				shortNames: ["blowfish"],
				category: 2
			},
			{
				emoji: "🐢",
				name: "TURTLE",
				added_in: "6.0",
				shortName: "turtle",
				shortNames: ["turtle"],
				category: 2
			},
			{
				emoji: "🐦",
				name: "BIRD",
				added_in: "6.0",
				shortName: "bird",
				shortNames: ["bird"],
				category: 2
			},
			{
				emoji: "🐧",
				name: "PENGUIN",
				added_in: "6.0",
				shortName: "penguin",
				shortNames: ["penguin"],
				category: 2
			},
			{
				emoji: "🐨",
				name: "KOALA",
				added_in: "6.0",
				shortName: "koala",
				shortNames: ["koala"],
				category: 2
			},
			{
				emoji: "🐩",
				name: "POODLE",
				added_in: "6.0",
				shortName: "poodle",
				shortNames: ["poodle"],
				category: 2
			},
			{
				emoji: "🐪",
				name: "DROMEDARY CAMEL",
				added_in: "6.0",
				shortName: "dromedary_camel",
				shortNames: ["dromedary_camel"],
				category: 2
			},
			{
				emoji: "🐫",
				name: "BACTRIAN CAMEL",
				added_in: "6.0",
				shortName: "camel",
				shortNames: ["camel"],
				category: 2
			},
			{
				emoji: "🐬",
				name: "DOLPHIN",
				added_in: "6.0",
				shortName: "dolphin",
				shortNames: ["dolphin", "flipper"],
				category: 2
			},
			{
				emoji: "🐳",
				name: "SPOUTING WHALE",
				added_in: "6.0",
				shortName: "whale",
				shortNames: ["whale"],
				category: 2
			},
			{
				emoji: "🐽",
				name: "PIG NOSE",
				added_in: "6.0",
				shortName: "pig_nose",
				shortNames: ["pig_nose"],
				category: 2
			},
			{
				emoji: "🐾",
				name: "PAW PRINTS",
				added_in: "6.0",
				shortName: "feet",
				shortNames: ["feet", "paw_prints"],
				category: 2
			},
			{
				emoji: "💐",
				name: "BOUQUET",
				added_in: "6.0",
				shortName: "bouquet",
				shortNames: ["bouquet"],
				category: 2
			},
			{
				emoji: "💮",
				name: "WHITE FLOWER",
				added_in: "6.0",
				shortName: "white_flower",
				shortNames: ["white_flower"],
				category: 2
			}
		],
		[
			{
				emoji: "🍤",
				name: "FRIED SHRIMP",
				added_in: "6.0",
				shortName: "fried_shrimp",
				shortNames: ["fried_shrimp"],
				category: 3
			},
			{
				emoji: "🍗",
				name: "POULTRY LEG",
				added_in: "6.0",
				shortName: "poultry_leg",
				shortNames: ["poultry_leg"],
				category: 3
			},
			{
				emoji: "🍵",
				name: "TEACUP WITHOUT HANDLE",
				added_in: "6.0",
				shortName: "tea",
				shortNames: ["tea"],
				category: 3
			},
			{
				emoji: "🍼",
				name: "BABY BOTTLE",
				added_in: "6.0",
				shortName: "baby_bottle",
				shortNames: ["baby_bottle"],
				category: 3
			},
			{
				emoji: "🌰",
				name: "CHESTNUT",
				added_in: "6.0",
				shortName: "chestnut",
				shortNames: ["chestnut"],
				category: 3
			},
			{
				emoji: "🌽",
				name: "EAR OF MAIZE",
				added_in: "6.0",
				shortName: "corn",
				shortNames: ["corn"],
				category: 3
			},
			{
				emoji: "🍄",
				name: "MUSHROOM",
				added_in: "6.0",
				shortName: "mushroom",
				shortNames: ["mushroom"],
				category: 3
			},
			{
				emoji: "🍅",
				name: "TOMATO",
				added_in: "6.0",
				shortName: "tomato",
				shortNames: ["tomato"],
				category: 3
			},
			{
				emoji: "🍆",
				name: "AUBERGINE",
				added_in: "6.0",
				shortName: "eggplant",
				shortNames: ["eggplant"],
				category: 3
			},
			{
				emoji: "🍇",
				name: "GRAPES",
				added_in: "6.0",
				shortName: "grapes",
				shortNames: ["grapes"],
				category: 3
			},
			{
				emoji: "🍈",
				name: "MELON",
				added_in: "6.0",
				shortName: "melon",
				shortNames: ["melon"],
				category: 3
			},
			{
				emoji: "🍉",
				name: "WATERMELON",
				added_in: "6.0",
				shortName: "watermelon",
				shortNames: ["watermelon"],
				category: 3
			},
			{
				emoji: "🍊",
				name: "TANGERINE",
				added_in: "6.0",
				shortName: "tangerine",
				shortNames: ["tangerine"],
				category: 3
			},
			{
				emoji: "🍋",
				name: "LEMON",
				added_in: "6.0",
				shortName: "lemon",
				shortNames: ["lemon"],
				category: 3
			},
			{
				emoji: "🍌",
				name: "BANANA",
				added_in: "6.0",
				shortName: "banana",
				shortNames: ["banana"],
				category: 3
			},
			{
				emoji: "🍍",
				name: "PINEAPPLE",
				added_in: "6.0",
				shortName: "pineapple",
				shortNames: ["pineapple"],
				category: 3
			},
			{
				emoji: "🍎",
				name: "RED APPLE",
				added_in: "6.0",
				shortName: "apple",
				shortNames: ["apple"],
				category: 3
			},
			{
				emoji: "🍏",
				name: "GREEN APPLE",
				added_in: "6.0",
				shortName: "green_apple",
				shortNames: ["green_apple"],
				category: 3
			},
			{
				emoji: "🍐",
				name: "PEAR",
				added_in: "6.0",
				shortName: "pear",
				shortNames: ["pear"],
				category: 3
			},
			{
				emoji: "🍑",
				name: "PEACH",
				added_in: "6.0",
				shortName: "peach",
				shortNames: ["peach"],
				category: 3
			},
			{
				emoji: "🍒",
				name: "CHERRIES",
				added_in: "6.0",
				shortName: "cherries",
				shortNames: ["cherries"],
				category: 3
			},
			{
				emoji: "🍓",
				name: "STRAWBERRY",
				added_in: "6.0",
				shortName: "strawberry",
				shortNames: ["strawberry"],
				category: 3
			},
			{
				emoji: "🍔",
				name: "HAMBURGER",
				added_in: "6.0",
				shortName: "hamburger",
				shortNames: ["hamburger"],
				category: 3
			},
			{
				emoji: "🍕",
				name: "SLICE OF PIZZA",
				added_in: "6.0",
				shortName: "pizza",
				shortNames: ["pizza"],
				category: 3
			},
			{
				emoji: "🍖",
				name: "MEAT ON BONE",
				added_in: "6.0",
				shortName: "meat_on_bone",
				shortNames: ["meat_on_bone"],
				category: 3
			},
			{
				emoji: "🍘",
				name: "RICE CRACKER",
				added_in: "6.0",
				shortName: "rice_cracker",
				shortNames: ["rice_cracker"],
				category: 3
			},
			{
				emoji: "🍙",
				name: "RICE BALL",
				added_in: "6.0",
				shortName: "rice_ball",
				shortNames: ["rice_ball"],
				category: 3
			},
			{
				emoji: "🍚",
				name: "COOKED RICE",
				added_in: "6.0",
				shortName: "rice",
				shortNames: ["rice"],
				category: 3
			},
			{
				emoji: "🍛",
				name: "CURRY AND RICE",
				added_in: "6.0",
				shortName: "curry",
				shortNames: ["curry"],
				category: 3
			},
			{
				emoji: "🍜",
				name: "STEAMING BOWL",
				added_in: "6.0",
				shortName: "ramen",
				shortNames: ["ramen"],
				category: 3
			},
			{
				emoji: "🍝",
				name: "SPAGHETTI",
				added_in: "6.0",
				shortName: "spaghetti",
				shortNames: ["spaghetti"],
				category: 3
			},
			{
				emoji: "🍞",
				name: "BREAD",
				added_in: "6.0",
				shortName: "bread",
				shortNames: ["bread"],
				category: 3
			},
			{
				emoji: "🍟",
				name: "FRENCH FRIES",
				added_in: "6.0",
				shortName: "fries",
				shortNames: ["fries"],
				category: 3
			},
			{
				emoji: "🍠",
				name: "ROASTED SWEET POTATO",
				added_in: "6.0",
				shortName: "sweet_potato",
				shortNames: ["sweet_potato"],
				category: 3
			},
			{
				emoji: "🍡",
				name: "DANGO",
				added_in: "6.0",
				shortName: "dango",
				shortNames: ["dango"],
				category: 3
			},
			{
				emoji: "🍢",
				name: "ODEN",
				added_in: "6.0",
				shortName: "oden",
				shortNames: ["oden"],
				category: 3
			},
			{
				emoji: "🍣",
				name: "SUSHI",
				added_in: "6.0",
				shortName: "sushi",
				shortNames: ["sushi"],
				category: 3
			},
			{
				emoji: "🍥",
				name: "FISH CAKE WITH SWIRL DESIGN",
				added_in: "6.0",
				shortName: "fish_cake",
				shortNames: ["fish_cake"],
				category: 3
			},
			{
				emoji: "🍦",
				name: "SOFT ICE CREAM",
				added_in: "6.0",
				shortName: "icecream",
				shortNames: ["icecream"],
				category: 3
			},
			{
				emoji: "🍧",
				name: "SHAVED ICE",
				added_in: "6.0",
				shortName: "shaved_ice",
				shortNames: ["shaved_ice"],
				category: 3
			},
			{
				emoji: "🍨",
				name: "ICE CREAM",
				added_in: "6.0",
				shortName: "ice_cream",
				shortNames: ["ice_cream"],
				category: 3
			},
			{
				emoji: "🍩",
				name: "DOUGHNUT",
				added_in: "6.0",
				shortName: "doughnut",
				shortNames: ["doughnut"],
				category: 3
			},
			{
				emoji: "🍪",
				name: "COOKIE",
				added_in: "6.0",
				shortName: "cookie",
				shortNames: ["cookie"],
				category: 3
			},
			{
				emoji: "🍫",
				name: "CHOCOLATE BAR",
				added_in: "6.0",
				shortName: "chocolate_bar",
				shortNames: ["chocolate_bar"],
				category: 3
			},
			{
				emoji: "🍬",
				name: "CANDY",
				added_in: "6.0",
				shortName: "candy",
				shortNames: ["candy"],
				category: 3
			},
			{
				emoji: "🍭",
				name: "LOLLIPOP",
				added_in: "6.0",
				shortName: "lollipop",
				shortNames: ["lollipop"],
				category: 3
			},
			{
				emoji: "🍮",
				name: "CUSTARD",
				added_in: "6.0",
				shortName: "custard",
				shortNames: ["custard"],
				category: 3
			},
			{
				emoji: "🍯",
				name: "HONEY POT",
				added_in: "6.0",
				shortName: "honey_pot",
				shortNames: ["honey_pot"],
				category: 3
			},
			{
				emoji: "🍰",
				name: "SHORTCAKE",
				added_in: "6.0",
				shortName: "cake",
				shortNames: ["cake"],
				category: 3
			},
			{
				emoji: "🍱",
				name: "BENTO BOX",
				added_in: "6.0",
				shortName: "bento",
				shortNames: ["bento"],
				category: 3
			},
			{
				emoji: "🍲",
				name: "POT OF FOOD",
				added_in: "6.0",
				shortName: "stew",
				shortNames: ["stew"],
				category: 3
			},
			{
				emoji: "🍳",
				name: "COOKING",
				added_in: "6.0",
				shortName: "fried_egg",
				shortNames: ["fried_egg", "cooking"],
				category: 3
			},
			{
				emoji: "🍴",
				name: "FORK AND KNIFE",
				added_in: "6.0",
				shortName: "fork_and_knife",
				shortNames: ["fork_and_knife"],
				category: 3
			},
			{
				emoji: "🍶",
				name: "SAKE BOTTLE AND CUP",
				added_in: "6.0",
				shortName: "sake",
				shortNames: ["sake"],
				category: 3
			},
			{
				emoji: "🍷",
				name: "WINE GLASS",
				added_in: "6.0",
				shortName: "wine_glass",
				shortNames: ["wine_glass"],
				category: 3
			},
			{
				emoji: "🍸",
				name: "COCKTAIL GLASS",
				added_in: "6.0",
				shortName: "cocktail",
				shortNames: ["cocktail"],
				category: 3
			},
			{
				emoji: "🍹",
				name: "TROPICAL DRINK",
				added_in: "6.0",
				shortName: "tropical_drink",
				shortNames: ["tropical_drink"],
				category: 3
			},
			{
				emoji: "🍺",
				name: "BEER MUG",
				added_in: "6.0",
				shortName: "beer",
				shortNames: ["beer"],
				category: 3
			},
			{
				emoji: "🍻",
				name: "CLINKING BEER MUGS",
				added_in: "6.0",
				shortName: "beers",
				shortNames: ["beers"],
				category: 3
			},
			{
				emoji: "🎂",
				name: "BIRTHDAY CAKE",
				added_in: "6.0",
				shortName: "birthday",
				shortNames: ["birthday"],
				category: 3
			},
			{
				emoji: "🔪",
				name: "HOCHO",
				added_in: "6.0",
				shortName: "hocho",
				shortNames: ["hocho", "knife"],
				category: 3
			},
			{
				emoji: "☕",
				name: "HOT BEVERAGE",
				added_in: "4.0",
				shortName: "coffee",
				shortNames: ["coffee"],
				category: 3
			}
		],
		[
			{
				emoji: "🎽",
				name: "RUNNING SHIRT WITH SASH",
				added_in: "6.0",
				shortName: "running_shirt_with_sash",
				shortNames: ["running_shirt_with_sash"],
				category: 4
			},
			{
				emoji: "🀄",
				name: "MAHJONG TILE RED DRAGON",
				added_in: "5.1",
				shortName: "mahjong",
				shortNames: ["mahjong"],
				category: 4
			},
			{
				emoji: "🃏",
				name: "PLAYING CARD BLACK JOKER",
				added_in: "6.0",
				shortName: "black_joker",
				shortNames: ["black_joker"],
				category: 4
			},
			{
				emoji: "🎀",
				name: "RIBBON",
				added_in: "6.0",
				shortName: "ribbon",
				shortNames: ["ribbon"],
				category: 4
			},
			{
				emoji: "🎁",
				name: "WRAPPED PRESENT",
				added_in: "6.0",
				shortName: "gift",
				shortNames: ["gift"],
				category: 4
			},
			{
				emoji: "🎃",
				name: "JACK-O-LANTERN",
				added_in: "6.0",
				shortName: "jack_o_lantern",
				shortNames: ["jack_o_lantern"],
				category: 4
			},
			{
				emoji: "🎄",
				name: "CHRISTMAS TREE",
				added_in: "6.0",
				shortName: "christmas_tree",
				shortNames: ["christmas_tree"],
				category: 4
			},
			{
				emoji: "🎆",
				name: "FIREWORKS",
				added_in: "6.0",
				shortName: "fireworks",
				shortNames: ["fireworks"],
				category: 4
			},
			{
				emoji: "🎇",
				name: "FIREWORK SPARKLER",
				added_in: "6.0",
				shortName: "sparkler",
				shortNames: ["sparkler"],
				category: 4
			},
			{
				emoji: "🎈",
				name: "BALLOON",
				added_in: "6.0",
				shortName: "balloon",
				shortNames: ["balloon"],
				category: 4
			},
			{
				emoji: "🎉",
				name: "PARTY POPPER",
				added_in: "6.0",
				shortName: "tada",
				shortNames: ["tada"],
				category: 4
			},
			{
				emoji: "🎊",
				name: "CONFETTI BALL",
				added_in: "6.0",
				shortName: "confetti_ball",
				shortNames: ["confetti_ball"],
				category: 4
			},
			{
				emoji: "🎋",
				name: "TANABATA TREE",
				added_in: "6.0",
				shortName: "tanabata_tree",
				shortNames: ["tanabata_tree"],
				category: 4
			},
			{
				emoji: "🎍",
				name: "PINE DECORATION",
				added_in: "6.0",
				shortName: "bamboo",
				shortNames: ["bamboo"],
				category: 4
			},
			{
				emoji: "🎎",
				name: "JAPANESE DOLLS",
				added_in: "6.0",
				shortName: "dolls",
				shortNames: ["dolls"],
				category: 4
			},
			{
				emoji: "🎏",
				name: "CARP STREAMER",
				added_in: "6.0",
				shortName: "flags",
				shortNames: ["flags"],
				category: 4
			},
			{
				emoji: "🎐",
				name: "WIND CHIME",
				added_in: "6.0",
				shortName: "wind_chime",
				shortNames: ["wind_chime"],
				category: 4
			},
			{
				emoji: "🎑",
				name: "MOON VIEWING CEREMONY",
				added_in: "6.0",
				shortName: "rice_scene",
				shortNames: ["rice_scene"],
				category: 4
			},
			{
				emoji: "🎣",
				name: "FISHING POLE AND FISH",
				added_in: "6.0",
				shortName: "fishing_pole_and_fish",
				shortNames: ["fishing_pole_and_fish"],
				category: 4
			},
			{
				emoji: "🎫",
				name: "TICKET",
				added_in: "6.0",
				shortName: "ticket",
				shortNames: ["ticket"],
				category: 4
			},
			{
				emoji: "🎮",
				name: "VIDEO GAME",
				added_in: "6.0",
				shortName: "video_game",
				shortNames: ["video_game"],
				category: 4
			},
			{
				emoji: "🎯",
				name: "DIRECT HIT",
				added_in: "6.0",
				shortName: "dart",
				shortNames: ["dart"],
				category: 4
			},
			{
				emoji: "🎱",
				name: "BILLIARDS",
				added_in: "6.0",
				shortName: "8ball",
				shortNames: ["8ball"],
				category: 4
			},
			{
				emoji: "🎲",
				name: "GAME DIE",
				added_in: "6.0",
				shortName: "game_die",
				shortNames: ["game_die"],
				category: 4
			},
			{
				emoji: "🎳",
				name: "BOWLING",
				added_in: "6.0",
				shortName: "bowling",
				shortNames: ["bowling"],
				category: 4
			},
			{
				emoji: "🎴",
				name: "FLOWER PLAYING CARDS",
				added_in: "6.0",
				shortName: "flower_playing_cards",
				shortNames: ["flower_playing_cards"],
				category: 4
			},
			{
				emoji: "🎾",
				name: "TENNIS RACQUET AND BALL",
				added_in: "6.0",
				shortName: "tennis",
				shortNames: ["tennis"],
				category: 4
			},
			{
				emoji: "🎿",
				name: "SKI AND SKI BOOT",
				added_in: "6.0",
				shortName: "ski",
				shortNames: ["ski"],
				category: 4
			},
			{
				emoji: "🏀",
				name: "BASKETBALL AND HOOP",
				added_in: "6.0",
				shortName: "basketball",
				shortNames: ["basketball"],
				category: 4
			},
			{
				emoji: "🏆",
				name: "TROPHY",
				added_in: "6.0",
				shortName: "trophy",
				shortNames: ["trophy"],
				category: 4
			},
			{
				emoji: "🏈",
				name: "AMERICAN FOOTBALL",
				added_in: "6.0",
				shortName: "football",
				shortNames: ["football"],
				category: 4
			},
			{
				emoji: "🏉",
				name: "RUGBY FOOTBALL",
				added_in: "6.0",
				shortName: "rugby_football",
				shortNames: ["rugby_football"],
				category: 4
			},
			{
				emoji: "♠️",
				name: "BLACK SPADE SUIT",
				added_in: "1.1",
				shortName: "spades",
				shortNames: ["spades"],
				category: 4
			},
			{
				emoji: "♣️",
				name: "BLACK CLUB SUIT",
				added_in: "1.1",
				shortName: "clubs",
				shortNames: ["clubs"],
				category: 4
			},
			{
				emoji: "♥️",
				name: "BLACK HEART SUIT",
				added_in: "1.1",
				shortName: "hearts",
				shortNames: ["hearts"],
				category: 4
			},
			{
				emoji: "♦️",
				name: "BLACK DIAMOND SUIT",
				added_in: "1.1",
				shortName: "diamonds",
				shortNames: ["diamonds"],
				category: 4
			},
			{
				emoji: "⚽",
				name: "SOCCER BALL",
				added_in: "5.2",
				shortName: "soccer",
				shortNames: ["soccer"],
				category: 4
			},
			{
				emoji: "⚾",
				name: "BASEBALL",
				added_in: "5.2",
				shortName: "baseball",
				shortNames: ["baseball"],
				category: 4
			},
			{
				emoji: "⛳",
				name: "FLAG IN HOLE",
				added_in: "5.2",
				shortName: "golf",
				shortNames: ["golf"],
				category: 4
			},
			{
				emoji: "✨",
				name: "SPARKLES",
				added_in: "6.0",
				shortName: "sparkles",
				shortNames: ["sparkles"],
				category: 4
			}
		],
		[
			{
				emoji: "🌚",
				name: "NEW MOON WITH FACE",
				added_in: "6.0",
				shortName: "new_moon_with_face",
				shortNames: ["new_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌛",
				name: "FIRST QUARTER MOON WITH FACE",
				added_in: "6.0",
				shortName: "first_quarter_moon_with_face",
				shortNames: ["first_quarter_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌜",
				name: "LAST QUARTER MOON WITH FACE",
				added_in: "6.0",
				shortName: "last_quarter_moon_with_face",
				shortNames: ["last_quarter_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌝",
				name: "FULL MOON WITH FACE",
				added_in: "6.0",
				shortName: "full_moon_with_face",
				shortNames: ["full_moon_with_face"],
				category: 5
			},
			{
				emoji: "🌞",
				name: "SUN WITH FACE",
				added_in: "6.0",
				shortName: "sun_with_face",
				shortNames: ["sun_with_face"],
				category: 5
			},
			{
				emoji: "🕐",
				name: "CLOCK FACE ONE OCLOCK",
				added_in: "6.0",
				shortName: "clock1",
				shortNames: ["clock1"],
				category: 5
			},
			{
				emoji: "🕑",
				name: "CLOCK FACE TWO OCLOCK",
				added_in: "6.0",
				shortName: "clock2",
				shortNames: ["clock2"],
				category: 5
			},
			{
				emoji: "🕒",
				name: "CLOCK FACE THREE OCLOCK",
				added_in: "6.0",
				shortName: "clock3",
				shortNames: ["clock3"],
				category: 5
			},
			{
				emoji: "🕓",
				name: "CLOCK FACE FOUR OCLOCK",
				added_in: "6.0",
				shortName: "clock4",
				shortNames: ["clock4"],
				category: 5
			},
			{
				emoji: "🕔",
				name: "CLOCK FACE FIVE OCLOCK",
				added_in: "6.0",
				shortName: "clock5",
				shortNames: ["clock5"],
				category: 5
			},
			{
				emoji: "🕕",
				name: "CLOCK FACE SIX OCLOCK",
				added_in: "6.0",
				shortName: "clock6",
				shortNames: ["clock6"],
				category: 5
			},
			{
				emoji: "🕖",
				name: "CLOCK FACE SEVEN OCLOCK",
				added_in: "6.0",
				shortName: "clock7",
				shortNames: ["clock7"],
				category: 5
			},
			{
				emoji: "🕗",
				name: "CLOCK FACE EIGHT OCLOCK",
				added_in: "6.0",
				shortName: "clock8",
				shortNames: ["clock8"],
				category: 5
			},
			{
				emoji: "🕘",
				name: "CLOCK FACE NINE OCLOCK",
				added_in: "6.0",
				shortName: "clock9",
				shortNames: ["clock9"],
				category: 5
			},
			{
				emoji: "🕙",
				name: "CLOCK FACE TEN OCLOCK",
				added_in: "6.0",
				shortName: "clock10",
				shortNames: ["clock10"],
				category: 5
			},
			{
				emoji: "🕚",
				name: "CLOCK FACE ELEVEN OCLOCK",
				added_in: "6.0",
				shortName: "clock11",
				shortNames: ["clock11"],
				category: 5
			},
			{
				emoji: "🕛",
				name: "CLOCK FACE TWELVE OCLOCK",
				added_in: "6.0",
				shortName: "clock12",
				shortNames: ["clock12"],
				category: 5
			},
			{
				emoji: "🕜",
				name: "CLOCK FACE ONE-THIRTY",
				added_in: "6.0",
				shortName: "clock130",
				shortNames: ["clock130"],
				category: 5
			},
			{
				emoji: "🕝",
				name: "CLOCK FACE TWO-THIRTY",
				added_in: "6.0",
				shortName: "clock230",
				shortNames: ["clock230"],
				category: 5
			},
			{
				emoji: "🕞",
				name: "CLOCK FACE THREE-THIRTY",
				added_in: "6.0",
				shortName: "clock330",
				shortNames: ["clock330"],
				category: 5
			},
			{
				emoji: "🕟",
				name: "CLOCK FACE FOUR-THIRTY",
				added_in: "6.0",
				shortName: "clock430",
				shortNames: ["clock430"],
				category: 5
			},
			{
				emoji: "🕠",
				name: "CLOCK FACE FIVE-THIRTY",
				added_in: "6.0",
				shortName: "clock530",
				shortNames: ["clock530"],
				category: 5
			},
			{
				emoji: "🕡",
				name: "CLOCK FACE SIX-THIRTY",
				added_in: "6.0",
				shortName: "clock630",
				shortNames: ["clock630"],
				category: 5
			},
			{
				emoji: "🕢",
				name: "CLOCK FACE SEVEN-THIRTY",
				added_in: "6.0",
				shortName: "clock730",
				shortNames: ["clock730"],
				category: 5
			},
			{
				emoji: "🕣",
				name: "CLOCK FACE EIGHT-THIRTY",
				added_in: "6.0",
				shortName: "clock830",
				shortNames: ["clock830"],
				category: 5
			},
			{
				emoji: "🕤",
				name: "CLOCK FACE NINE-THIRTY",
				added_in: "6.0",
				shortName: "clock930",
				shortNames: ["clock930"],
				category: 5
			},
			{
				emoji: "🕥",
				name: "CLOCK FACE TEN-THIRTY",
				added_in: "6.0",
				shortName: "clock1030",
				shortNames: ["clock1030"],
				category: 5
			},
			{
				emoji: "🕦",
				name: "CLOCK FACE ELEVEN-THIRTY",
				added_in: "6.0",
				shortName: "clock1130",
				shortNames: ["clock1130"],
				category: 5
			},
			{
				emoji: "🕧",
				name: "CLOCK FACE TWELVE-THIRTY",
				added_in: "6.0",
				shortName: "clock1230",
				shortNames: ["clock1230"],
				category: 5
			},
			{
				emoji: "⛄",
				name: "SNOWMAN WITHOUT SNOW",
				added_in: "5.2",
				shortName: "snowman_without_snow",
				shortNames: ["snowman_without_snow"],
				category: 5
			},
			{
				emoji: "🌀",
				name: "CYCLONE",
				added_in: "6.0",
				shortName: "cyclone",
				shortNames: ["cyclone"],
				category: 5
			},
			{
				emoji: "🌁",
				name: "FOGGY",
				added_in: "6.0",
				shortName: "foggy",
				shortNames: ["foggy"],
				category: 5
			},
			{
				emoji: "🌂",
				name: "CLOSED UMBRELLA",
				added_in: "6.0",
				shortName: "closed_umbrella",
				shortNames: ["closed_umbrella"],
				category: 5
			},
			{
				emoji: "🌃",
				name: "NIGHT WITH STARS",
				added_in: "6.0",
				shortName: "night_with_stars",
				shortNames: ["night_with_stars"],
				category: 5
			},
			{
				emoji: "🌄",
				name: "SUNRISE OVER MOUNTAINS",
				added_in: "6.0",
				shortName: "sunrise_over_mountains",
				shortNames: ["sunrise_over_mountains"],
				category: 5
			},
			{
				emoji: "🌅",
				name: "SUNRISE",
				added_in: "6.0",
				shortName: "sunrise",
				shortNames: ["sunrise"],
				category: 5
			},
			{
				emoji: "🌆",
				name: "CITYSCAPE AT DUSK",
				added_in: "6.0",
				shortName: "city_sunset",
				shortNames: ["city_sunset"],
				category: 5
			},
			{
				emoji: "🌇",
				name: "SUNSET OVER BUILDINGS",
				added_in: "6.0",
				shortName: "city_sunrise",
				shortNames: ["city_sunrise"],
				category: 5
			},
			{
				emoji: "🌈",
				name: "RAINBOW",
				added_in: "6.0",
				shortName: "rainbow",
				shortNames: ["rainbow"],
				category: 5
			},
			{
				emoji: "🌉",
				name: "BRIDGE AT NIGHT",
				added_in: "6.0",
				shortName: "bridge_at_night",
				shortNames: ["bridge_at_night"],
				category: 5
			},
			{
				emoji: "🌊",
				name: "WATER WAVE",
				added_in: "6.0",
				shortName: "ocean",
				shortNames: ["ocean"],
				category: 5
			},
			{
				emoji: "🌋",
				name: "VOLCANO",
				added_in: "6.0",
				shortName: "volcano",
				shortNames: ["volcano"],
				category: 5
			},
			{
				emoji: "🌌",
				name: "MILKY WAY",
				added_in: "6.0",
				shortName: "milky_way",
				shortNames: ["milky_way"],
				category: 5
			},
			{
				emoji: "🌍",
				name: "EARTH GLOBE EUROPE-AFRICA",
				added_in: "6.0",
				shortName: "earth_africa",
				shortNames: ["earth_africa"],
				category: 5
			},
			{
				emoji: "🌎",
				name: "EARTH GLOBE AMERICAS",
				added_in: "6.0",
				shortName: "earth_americas",
				shortNames: ["earth_americas"],
				category: 5
			},
			{
				emoji: "🌏",
				name: "EARTH GLOBE ASIA-AUSTRALIA",
				added_in: "6.0",
				shortName: "earth_asia",
				shortNames: ["earth_asia"],
				category: 5
			},
			{
				emoji: "🌐",
				name: "GLOBE WITH MERIDIANS",
				added_in: "6.0",
				shortName: "globe_with_meridians",
				shortNames: ["globe_with_meridians"],
				category: 5
			},
			{
				emoji: "🌑",
				name: "NEW MOON SYMBOL",
				added_in: "6.0",
				shortName: "new_moon",
				shortNames: ["new_moon"],
				category: 5
			},
			{
				emoji: "🌒",
				name: "WAXING CRESCENT MOON SYMBOL",
				added_in: "6.0",
				shortName: "waxing_crescent_moon",
				shortNames: ["waxing_crescent_moon"],
				category: 5
			},
			{
				emoji: "🌓",
				name: "FIRST QUARTER MOON SYMBOL",
				added_in: "6.0",
				shortName: "first_quarter_moon",
				shortNames: ["first_quarter_moon"],
				category: 5
			},
			{
				emoji: "🌔",
				name: "WAXING GIBBOUS MOON SYMBOL",
				added_in: "6.0",
				shortName: "moon",
				shortNames: ["moon", "waxing_gibbous_moon"],
				category: 5
			},
			{
				emoji: "🌕",
				name: "FULL MOON SYMBOL",
				added_in: "6.0",
				shortName: "full_moon",
				shortNames: ["full_moon"],
				category: 5
			},
			{
				emoji: "🌖",
				name: "WANING GIBBOUS MOON SYMBOL",
				added_in: "6.0",
				shortName: "waning_gibbous_moon",
				shortNames: ["waning_gibbous_moon"],
				category: 5
			},
			{
				emoji: "🌗",
				name: "LAST QUARTER MOON SYMBOL",
				added_in: "6.0",
				shortName: "last_quarter_moon",
				shortNames: ["last_quarter_moon"],
				category: 5
			},
			{
				emoji: "🌘",
				name: "WANING CRESCENT MOON SYMBOL",
				added_in: "6.0",
				shortName: "waning_crescent_moon",
				shortNames: ["waning_crescent_moon"],
				category: 5
			},
			{
				emoji: "🌙",
				name: "CRESCENT MOON",
				added_in: "6.0",
				shortName: "crescent_moon",
				shortNames: ["crescent_moon"],
				category: 5
			},
			{
				emoji: "🌟",
				name: "GLOWING STAR",
				added_in: "6.0",
				shortName: "star2",
				shortNames: ["star2"],
				category: 5
			},
			{
				emoji: "🌠",
				name: "SHOOTING STAR",
				added_in: "6.0",
				shortName: "stars",
				shortNames: ["stars"],
				category: 5
			},
			{
				emoji: "🎠",
				name: "CAROUSEL HORSE",
				added_in: "6.0",
				shortName: "carousel_horse",
				shortNames: ["carousel_horse"],
				category: 5
			},
			{
				emoji: "🎡",
				name: "FERRIS WHEEL",
				added_in: "6.0",
				shortName: "ferris_wheel",
				shortNames: ["ferris_wheel"],
				category: 5
			},
			{
				emoji: "🎢",
				name: "ROLLER COASTER",
				added_in: "6.0",
				shortName: "roller_coaster",
				shortNames: ["roller_coaster"],
				category: 5
			},
			{
				emoji: "🎨",
				name: "ARTIST PALETTE",
				added_in: "6.0",
				shortName: "art",
				shortNames: ["art"],
				category: 5
			},
			{
				emoji: "🎪",
				name: "CIRCUS TENT",
				added_in: "6.0",
				shortName: "circus_tent",
				shortNames: ["circus_tent"],
				category: 5
			},
			{
				emoji: "🎭",
				name: "PERFORMING ARTS",
				added_in: "6.0",
				shortName: "performing_arts",
				shortNames: ["performing_arts"],
				category: 5
			},
			{
				emoji: "🎰",
				name: "SLOT MACHINE",
				added_in: "6.0",
				shortName: "slot_machine",
				shortNames: ["slot_machine"],
				category: 5
			},
			{
				emoji: "🏠",
				name: "HOUSE BUILDING",
				added_in: "6.0",
				shortName: "house",
				shortNames: ["house"],
				category: 5
			},
			{
				emoji: "🏡",
				name: "HOUSE WITH GARDEN",
				added_in: "6.0",
				shortName: "house_with_garden",
				shortNames: ["house_with_garden"],
				category: 5
			},
			{
				emoji: "🏢",
				name: "OFFICE BUILDING",
				added_in: "6.0",
				shortName: "office",
				shortNames: ["office"],
				category: 5
			},
			{
				emoji: "🏣",
				name: "JAPANESE POST OFFICE",
				added_in: "6.0",
				shortName: "post_office",
				shortNames: ["post_office"],
				category: 5
			},
			{
				emoji: "🏤",
				name: "EUROPEAN POST OFFICE",
				added_in: "6.0",
				shortName: "european_post_office",
				shortNames: ["european_post_office"],
				category: 5
			},
			{
				emoji: "🏥",
				name: "HOSPITAL",
				added_in: "6.0",
				shortName: "hospital",
				shortNames: ["hospital"],
				category: 5
			},
			{
				emoji: "🏦",
				name: "BANK",
				added_in: "6.0",
				shortName: "bank",
				shortNames: ["bank"],
				category: 5
			},
			{
				emoji: "🏨",
				name: "HOTEL",
				added_in: "6.0",
				shortName: "hotel",
				shortNames: ["hotel"],
				category: 5
			},
			{
				emoji: "🏩",
				name: "LOVE HOTEL",
				added_in: "6.0",
				shortName: "love_hotel",
				shortNames: ["love_hotel"],
				category: 5
			},
			{
				emoji: "🏪",
				name: "CONVENIENCE STORE",
				added_in: "6.0",
				shortName: "convenience_store",
				shortNames: ["convenience_store"],
				category: 5
			},
			{
				emoji: "🏫",
				name: "SCHOOL",
				added_in: "6.0",
				shortName: "school",
				shortNames: ["school"],
				category: 5
			},
			{
				emoji: "🏬",
				name: "DEPARTMENT STORE",
				added_in: "6.0",
				shortName: "department_store",
				shortNames: ["department_store"],
				category: 5
			},
			{
				emoji: "🏭",
				name: "FACTORY",
				added_in: "6.0",
				shortName: "factory",
				shortNames: ["factory"],
				category: 5
			},
			{
				emoji: "🏯",
				name: "JAPANESE CASTLE",
				added_in: "6.0",
				shortName: "japanese_castle",
				shortNames: ["japanese_castle"],
				category: 5
			},
			{
				emoji: "🏰",
				name: "EUROPEAN CASTLE",
				added_in: "6.0",
				shortName: "european_castle",
				shortNames: ["european_castle"],
				category: 5
			},
			{
				emoji: "💈",
				name: "BARBER POLE",
				added_in: "6.0",
				shortName: "barber",
				shortNames: ["barber"],
				category: 5
			},
			{
				emoji: "💒",
				name: "WEDDING",
				added_in: "6.0",
				shortName: "wedding",
				shortNames: ["wedding"],
				category: 5
			},
			{
				emoji: "💧",
				name: "DROPLET",
				added_in: "6.0",
				shortName: "droplet",
				shortNames: ["droplet"],
				category: 5
			},
			{
				emoji: "💺",
				name: "SEAT",
				added_in: "6.0",
				shortName: "seat",
				shortNames: ["seat"],
				category: 5
			},
			{
				emoji: "🔥",
				name: "FIRE",
				added_in: "6.0",
				shortName: "fire",
				shortNames: ["fire"],
				category: 5
			},
			{
				emoji: "🗻",
				name: "MOUNT FUJI",
				added_in: "6.0",
				shortName: "mount_fuji",
				shortNames: ["mount_fuji"],
				category: 5
			},
			{
				emoji: "🗼",
				name: "TOKYO TOWER",
				added_in: "6.0",
				shortName: "tokyo_tower",
				shortNames: ["tokyo_tower"],
				category: 5
			},
			{
				emoji: "🗽",
				name: "STATUE OF LIBERTY",
				added_in: "6.0",
				shortName: "statue_of_liberty",
				shortNames: ["statue_of_liberty"],
				category: 5
			},
			{
				emoji: "🗾",
				name: "SILHOUETTE OF JAPAN",
				added_in: "6.0",
				shortName: "japan",
				shortNames: ["japan"],
				category: 5
			},
			{
				emoji: "🚀",
				name: "ROCKET",
				added_in: "6.0",
				shortName: "rocket",
				shortNames: ["rocket"],
				category: 5
			},
			{
				emoji: "🚁",
				name: "HELICOPTER",
				added_in: "6.0",
				shortName: "helicopter",
				shortNames: ["helicopter"],
				category: 5
			},
			{
				emoji: "🚂",
				name: "STEAM LOCOMOTIVE",
				added_in: "6.0",
				shortName: "steam_locomotive",
				shortNames: ["steam_locomotive"],
				category: 5
			},
			{
				emoji: "🚃",
				name: "RAILWAY CAR",
				added_in: "6.0",
				shortName: "railway_car",
				shortNames: ["railway_car"],
				category: 5
			},
			{
				emoji: "🚄",
				name: "HIGH-SPEED TRAIN",
				added_in: "6.0",
				shortName: "bullettrain_side",
				shortNames: ["bullettrain_side"],
				category: 5
			},
			{
				emoji: "🚅",
				name: "HIGH-SPEED TRAIN WITH BULLET NOSE",
				added_in: "6.0",
				shortName: "bullettrain_front",
				shortNames: ["bullettrain_front"],
				category: 5
			},
			{
				emoji: "🚆",
				name: "TRAIN",
				added_in: "6.0",
				shortName: "train2",
				shortNames: ["train2"],
				category: 5
			},
			{
				emoji: "🚇",
				name: "METRO",
				added_in: "6.0",
				shortName: "metro",
				shortNames: ["metro"],
				category: 5
			},
			{
				emoji: "🚈",
				name: "LIGHT RAIL",
				added_in: "6.0",
				shortName: "light_rail",
				shortNames: ["light_rail"],
				category: 5
			},
			{
				emoji: "🚉",
				name: "STATION",
				added_in: "6.0",
				shortName: "station",
				shortNames: ["station"],
				category: 5
			},
			{
				emoji: "🚊",
				name: "TRAM",
				added_in: "6.0",
				shortName: "tram",
				shortNames: ["tram"],
				category: 5
			},
			{
				emoji: "🚋",
				name: "TRAM CAR",
				added_in: "6.0",
				shortName: "train",
				shortNames: ["train"],
				category: 5
			},
			{
				emoji: "🚌",
				name: "BUS",
				added_in: "6.0",
				shortName: "bus",
				shortNames: ["bus"],
				category: 5
			},
			{
				emoji: "🚍",
				name: "ONCOMING BUS",
				added_in: "6.0",
				shortName: "oncoming_bus",
				shortNames: ["oncoming_bus"],
				category: 5
			},
			{
				emoji: "🚎",
				name: "TROLLEYBUS",
				added_in: "6.0",
				shortName: "trolleybus",
				shortNames: ["trolleybus"],
				category: 5
			},
			{
				emoji: "🚏",
				name: "BUS STOP",
				added_in: "6.0",
				shortName: "busstop",
				shortNames: ["busstop"],
				category: 5
			},
			{
				emoji: "🚐",
				name: "MINIBUS",
				added_in: "6.0",
				shortName: "minibus",
				shortNames: ["minibus"],
				category: 5
			},
			{
				emoji: "🚑",
				name: "AMBULANCE",
				added_in: "6.0",
				shortName: "ambulance",
				shortNames: ["ambulance"],
				category: 5
			},
			{
				emoji: "🚒",
				name: "FIRE ENGINE",
				added_in: "6.0",
				shortName: "fire_engine",
				shortNames: ["fire_engine"],
				category: 5
			},
			{
				emoji: "🚓",
				name: "POLICE CAR",
				added_in: "6.0",
				shortName: "police_car",
				shortNames: ["police_car"],
				category: 5
			},
			{
				emoji: "🚔",
				name: "ONCOMING POLICE CAR",
				added_in: "6.0",
				shortName: "oncoming_police_car",
				shortNames: ["oncoming_police_car"],
				category: 5
			},
			{
				emoji: "🚕",
				name: "TAXI",
				added_in: "6.0",
				shortName: "taxi",
				shortNames: ["taxi"],
				category: 5
			},
			{
				emoji: "🚖",
				name: "ONCOMING TAXI",
				added_in: "6.0",
				shortName: "oncoming_taxi",
				shortNames: ["oncoming_taxi"],
				category: 5
			},
			{
				emoji: "🚗",
				name: "AUTOMOBILE",
				added_in: "6.0",
				shortName: "car",
				shortNames: ["car", "red_car"],
				category: 5
			},
			{
				emoji: "🚘",
				name: "ONCOMING AUTOMOBILE",
				added_in: "6.0",
				shortName: "oncoming_automobile",
				shortNames: ["oncoming_automobile"],
				category: 5
			},
			{
				emoji: "🚙",
				name: "RECREATIONAL VEHICLE",
				added_in: "6.0",
				shortName: "blue_car",
				shortNames: ["blue_car"],
				category: 5
			},
			{
				emoji: "🚚",
				name: "DELIVERY TRUCK",
				added_in: "6.0",
				shortName: "truck",
				shortNames: ["truck"],
				category: 5
			},
			{
				emoji: "🚛",
				name: "ARTICULATED LORRY",
				added_in: "6.0",
				shortName: "articulated_lorry",
				shortNames: ["articulated_lorry"],
				category: 5
			},
			{
				emoji: "🚜",
				name: "TRACTOR",
				added_in: "6.0",
				shortName: "tractor",
				shortNames: ["tractor"],
				category: 5
			},
			{
				emoji: "🚝",
				name: "MONORAIL",
				added_in: "6.0",
				shortName: "monorail",
				shortNames: ["monorail"],
				category: 5
			},
			{
				emoji: "🚞",
				name: "MOUNTAIN RAILWAY",
				added_in: "6.0",
				shortName: "mountain_railway",
				shortNames: ["mountain_railway"],
				category: 5
			},
			{
				emoji: "🚟",
				name: "SUSPENSION RAILWAY",
				added_in: "6.0",
				shortName: "suspension_railway",
				shortNames: ["suspension_railway"],
				category: 5
			},
			{
				emoji: "🚠",
				name: "MOUNTAIN CABLEWAY",
				added_in: "6.0",
				shortName: "mountain_cableway",
				shortNames: ["mountain_cableway"],
				category: 5
			},
			{
				emoji: "🚡",
				name: "AERIAL TRAMWAY",
				added_in: "6.0",
				shortName: "aerial_tramway",
				shortNames: ["aerial_tramway"],
				category: 5
			},
			{
				emoji: "🚢",
				name: "SHIP",
				added_in: "6.0",
				shortName: "ship",
				shortNames: ["ship"],
				category: 5
			},
			{
				emoji: "🚤",
				name: "SPEEDBOAT",
				added_in: "6.0",
				shortName: "speedboat",
				shortNames: ["speedboat"],
				category: 5
			},
			{
				emoji: "🚥",
				name: "HORIZONTAL TRAFFIC LIGHT",
				added_in: "6.0",
				shortName: "traffic_light",
				shortNames: ["traffic_light"],
				category: 5
			},
			{
				emoji: "🚦",
				name: "VERTICAL TRAFFIC LIGHT",
				added_in: "6.0",
				shortName: "vertical_traffic_light",
				shortNames: ["vertical_traffic_light"],
				category: 5
			},
			{
				emoji: "🚧",
				name: "CONSTRUCTION SIGN",
				added_in: "6.0",
				shortName: "construction",
				shortNames: ["construction"],
				category: 5
			},
			{
				emoji: "🚨",
				name: "POLICE CARS REVOLVING LIGHT",
				added_in: "6.0",
				shortName: "rotating_light",
				shortNames: ["rotating_light"],
				category: 5
			},
			{
				emoji: "🚪",
				name: "DOOR",
				added_in: "6.0",
				shortName: "door",
				shortNames: ["door"],
				category: 5
			},
			{
				emoji: "🚲",
				name: "BICYCLE",
				added_in: "6.0",
				shortName: "bike",
				shortNames: ["bike"],
				category: 5
			},
			{
				emoji: "🚽",
				name: "TOILET",
				added_in: "6.0",
				shortName: "toilet",
				shortNames: ["toilet"],
				category: 5
			},
			{
				emoji: "🚿",
				name: "SHOWER",
				added_in: "6.0",
				shortName: "shower",
				shortNames: ["shower"],
				category: 5
			},
			{
				emoji: "🛁",
				name: "BATHTUB",
				added_in: "6.0",
				shortName: "bathtub",
				shortNames: ["bathtub"],
				category: 5
			},
			{
				emoji: "⌚",
				name: "WATCH",
				added_in: "1.1",
				shortName: "watch",
				shortNames: ["watch"],
				category: 5
			},
			{
				emoji: "⌛",
				name: "HOURGLASS",
				added_in: "1.1",
				shortName: "hourglass",
				shortNames: ["hourglass"],
				category: 5
			},
			{
				emoji: "⏰",
				name: "ALARM CLOCK",
				added_in: "6.0",
				shortName: "alarm_clock",
				shortNames: ["alarm_clock"],
				category: 5
			},
			{
				emoji: "⏳",
				name: "HOURGLASS WITH FLOWING SAND",
				added_in: "6.0",
				shortName: "hourglass_flowing_sand",
				shortNames: ["hourglass_flowing_sand"],
				category: 5
			},
			{
				emoji: "☀️",
				name: "BLACK SUN WITH RAYS",
				added_in: "1.1",
				shortName: "sunny",
				shortNames: ["sunny"],
				category: 5
			},
			{
				emoji: "☁️",
				name: "CLOUD",
				added_in: "1.1",
				shortName: "cloud",
				shortNames: ["cloud"],
				category: 5
			},
			{
				emoji: "☔",
				name: "UMBRELLA WITH RAIN DROPS",
				added_in: "4.0",
				shortName: "umbrella_with_rain_drops",
				shortNames: ["umbrella_with_rain_drops"],
				category: 5
			},
			{
				emoji: "♨️",
				name: "HOT SPRINGS",
				added_in: "1.1",
				shortName: "hotsprings",
				shortNames: ["hotsprings"],
				category: 5
			},
			{
				emoji: "⚓",
				name: "ANCHOR",
				added_in: "4.1",
				shortName: "anchor",
				shortNames: ["anchor"],
				category: 5
			},
			{
				emoji: "⚡",
				name: "HIGH VOLTAGE SIGN",
				added_in: "4.0",
				shortName: "zap",
				shortNames: ["zap"],
				category: 5
			},
			{
				emoji: "⛅",
				name: "SUN BEHIND CLOUD",
				added_in: "5.2",
				shortName: "partly_sunny",
				shortNames: ["partly_sunny"],
				category: 5
			},
			{
				emoji: "⛪",
				name: "CHURCH",
				added_in: "5.2",
				shortName: "church",
				shortNames: ["church"],
				category: 5
			},
			{
				emoji: "⛲",
				name: "FOUNTAIN",
				added_in: "5.2",
				shortName: "fountain",
				shortNames: ["fountain"],
				category: 5
			},
			{
				emoji: "⛵",
				name: "SAILBOAT",
				added_in: "5.2",
				shortName: "boat",
				shortNames: ["boat", "sailboat"],
				category: 5
			},
			{
				emoji: "⛺",
				name: "TENT",
				added_in: "5.2",
				shortName: "tent",
				shortNames: ["tent"],
				category: 5
			},
			{
				emoji: "⛽",
				name: "FUEL PUMP",
				added_in: "5.2",
				shortName: "fuelpump",
				shortNames: ["fuelpump"],
				category: 5
			},
			{
				emoji: "✈️",
				name: "AIRPLANE",
				added_in: "1.1",
				shortName: "airplane",
				shortNames: ["airplane"],
				category: 5
			},
			{
				emoji: "❄️",
				name: "SNOWFLAKE",
				added_in: "1.1",
				shortName: "snowflake",
				shortNames: ["snowflake"],
				category: 5
			},
			{
				emoji: "⭐",
				name: "WHITE MEDIUM STAR",
				added_in: "5.1",
				shortName: "star",
				shortNames: ["star"],
				category: 5
			}
		],
		[
			{
				emoji: "📇",
				name: "CARD INDEX",
				added_in: "6.0",
				shortName: "card_index",
				shortNames: ["card_index"],
				category: 6
			},
			{
				emoji: "🎤",
				name: "MICROPHONE",
				added_in: "6.0",
				shortName: "microphone",
				shortNames: ["microphone"],
				category: 6
			},
			{
				emoji: "🎥",
				name: "MOVIE CAMERA",
				added_in: "6.0",
				shortName: "movie_camera",
				shortNames: ["movie_camera"],
				category: 6
			},
			{
				emoji: "🎧",
				name: "HEADPHONE",
				added_in: "6.0",
				shortName: "headphones",
				shortNames: ["headphones"],
				category: 6
			},
			{
				emoji: "🎬",
				name: "CLAPPER BOARD",
				added_in: "6.0",
				shortName: "clapper",
				shortNames: ["clapper"],
				category: 6
			},
			{
				emoji: "🎵",
				name: "MUSICAL NOTE",
				added_in: "6.0",
				shortName: "musical_note",
				shortNames: ["musical_note"],
				category: 6
			},
			{
				emoji: "🎶",
				name: "MULTIPLE MUSICAL NOTES",
				added_in: "6.0",
				shortName: "notes",
				shortNames: ["notes"],
				category: 6
			},
			{
				emoji: "🎷",
				name: "SAXOPHONE",
				added_in: "6.0",
				shortName: "saxophone",
				shortNames: ["saxophone"],
				category: 6
			},
			{
				emoji: "🎸",
				name: "GUITAR",
				added_in: "6.0",
				shortName: "guitar",
				shortNames: ["guitar"],
				category: 6
			},
			{
				emoji: "🎹",
				name: "MUSICAL KEYBOARD",
				added_in: "6.0",
				shortName: "musical_keyboard",
				shortNames: ["musical_keyboard"],
				category: 6
			},
			{
				emoji: "🎺",
				name: "TRUMPET",
				added_in: "6.0",
				shortName: "trumpet",
				shortNames: ["trumpet"],
				category: 6
			},
			{
				emoji: "🎻",
				name: "VIOLIN",
				added_in: "6.0",
				shortName: "violin",
				shortNames: ["violin"],
				category: 6
			},
			{
				emoji: "🎼",
				name: "MUSICAL SCORE",
				added_in: "6.0",
				shortName: "musical_score",
				shortNames: ["musical_score"],
				category: 6
			},
			{
				emoji: "🏮",
				name: "IZAKAYA LANTERN",
				added_in: "6.0",
				shortName: "izakaya_lantern",
				shortNames: ["izakaya_lantern", "lantern"],
				category: 6
			},
			{
				emoji: "💉",
				name: "SYRINGE",
				added_in: "6.0",
				shortName: "syringe",
				shortNames: ["syringe"],
				category: 6
			},
			{
				emoji: "💊",
				name: "PILL",
				added_in: "6.0",
				shortName: "pill",
				shortNames: ["pill"],
				category: 6
			},
			{
				emoji: "💡",
				name: "ELECTRIC LIGHT BULB",
				added_in: "6.0",
				shortName: "bulb",
				shortNames: ["bulb"],
				category: 6
			},
			{
				emoji: "💰",
				name: "MONEY BAG",
				added_in: "6.0",
				shortName: "moneybag",
				shortNames: ["moneybag"],
				category: 6
			},
			{
				emoji: "💱",
				name: "CURRENCY EXCHANGE",
				added_in: "6.0",
				shortName: "currency_exchange",
				shortNames: ["currency_exchange"],
				category: 6
			},
			{
				emoji: "💲",
				name: "HEAVY DOLLAR SIGN",
				added_in: "6.0",
				shortName: "heavy_dollar_sign",
				shortNames: ["heavy_dollar_sign"],
				category: 6
			},
			{
				emoji: "💳",
				name: "CREDIT CARD",
				added_in: "6.0",
				shortName: "credit_card",
				shortNames: ["credit_card"],
				category: 6
			},
			{
				emoji: "💴",
				name: "BANKNOTE WITH YEN SIGN",
				added_in: "6.0",
				shortName: "yen",
				shortNames: ["yen"],
				category: 6
			},
			{
				emoji: "💵",
				name: "BANKNOTE WITH DOLLAR SIGN",
				added_in: "6.0",
				shortName: "dollar",
				shortNames: ["dollar"],
				category: 6
			},
			{
				emoji: "💶",
				name: "BANKNOTE WITH EURO SIGN",
				added_in: "6.0",
				shortName: "euro",
				shortNames: ["euro"],
				category: 6
			},
			{
				emoji: "💷",
				name: "BANKNOTE WITH POUND SIGN",
				added_in: "6.0",
				shortName: "pound",
				shortNames: ["pound"],
				category: 6
			},
			{
				emoji: "💸",
				name: "MONEY WITH WINGS",
				added_in: "6.0",
				shortName: "money_with_wings",
				shortNames: ["money_with_wings"],
				category: 6
			},
			{
				emoji: "💹",
				name: "CHART WITH UPWARDS TREND AND YEN SIGN",
				added_in: "6.0",
				shortName: "chart",
				shortNames: ["chart"],
				category: 6
			},
			{
				emoji: "💻",
				name: "PERSONAL COMPUTER",
				added_in: "6.0",
				shortName: "computer",
				shortNames: ["computer"],
				category: 6
			},
			{
				emoji: "💼",
				name: "BRIEFCASE",
				added_in: "6.0",
				shortName: "briefcase",
				shortNames: ["briefcase"],
				category: 6
			},
			{
				emoji: "💽",
				name: "MINIDISC",
				added_in: "6.0",
				shortName: "minidisc",
				shortNames: ["minidisc"],
				category: 6
			},
			{
				emoji: "💾",
				name: "FLOPPY DISK",
				added_in: "6.0",
				shortName: "floppy_disk",
				shortNames: ["floppy_disk"],
				category: 6
			},
			{
				emoji: "💿",
				name: "OPTICAL DISC",
				added_in: "6.0",
				shortName: "cd",
				shortNames: ["cd"],
				category: 6
			},
			{
				emoji: "📀",
				name: "DVD",
				added_in: "6.0",
				shortName: "dvd",
				shortNames: ["dvd"],
				category: 6
			},
			{
				emoji: "📁",
				name: "FILE FOLDER",
				added_in: "6.0",
				shortName: "file_folder",
				shortNames: ["file_folder"],
				category: 6
			},
			{
				emoji: "📂",
				name: "OPEN FILE FOLDER",
				added_in: "6.0",
				shortName: "open_file_folder",
				shortNames: ["open_file_folder"],
				category: 6
			},
			{
				emoji: "📃",
				name: "PAGE WITH CURL",
				added_in: "6.0",
				shortName: "page_with_curl",
				shortNames: ["page_with_curl"],
				category: 6
			},
			{
				emoji: "📄",
				name: "PAGE FACING UP",
				added_in: "6.0",
				shortName: "page_facing_up",
				shortNames: ["page_facing_up"],
				category: 6
			},
			{
				emoji: "📅",
				name: "CALENDAR",
				added_in: "6.0",
				shortName: "date",
				shortNames: ["date"],
				category: 6
			},
			{
				emoji: "📆",
				name: "TEAR-OFF CALENDAR",
				added_in: "6.0",
				shortName: "calendar",
				shortNames: ["calendar"],
				category: 6
			},
			{
				emoji: "📈",
				name: "CHART WITH UPWARDS TREND",
				added_in: "6.0",
				shortName: "chart_with_upwards_trend",
				shortNames: ["chart_with_upwards_trend"],
				category: 6
			},
			{
				emoji: "📉",
				name: "CHART WITH DOWNWARDS TREND",
				added_in: "6.0",
				shortName: "chart_with_downwards_trend",
				shortNames: ["chart_with_downwards_trend"],
				category: 6
			},
			{
				emoji: "📊",
				name: "BAR CHART",
				added_in: "6.0",
				shortName: "bar_chart",
				shortNames: ["bar_chart"],
				category: 6
			},
			{
				emoji: "📋",
				name: "CLIPBOARD",
				added_in: "6.0",
				shortName: "clipboard",
				shortNames: ["clipboard"],
				category: 6
			},
			{
				emoji: "📌",
				name: "PUSHPIN",
				added_in: "6.0",
				shortName: "pushpin",
				shortNames: ["pushpin"],
				category: 6
			},
			{
				emoji: "📍",
				name: "ROUND PUSHPIN",
				added_in: "6.0",
				shortName: "round_pushpin",
				shortNames: ["round_pushpin"],
				category: 6
			},
			{
				emoji: "📎",
				name: "PAPERCLIP",
				added_in: "6.0",
				shortName: "paperclip",
				shortNames: ["paperclip"],
				category: 6
			},
			{
				emoji: "📏",
				name: "STRAIGHT RULER",
				added_in: "6.0",
				shortName: "straight_ruler",
				shortNames: ["straight_ruler"],
				category: 6
			},
			{
				emoji: "📐",
				name: "TRIANGULAR RULER",
				added_in: "6.0",
				shortName: "triangular_ruler",
				shortNames: ["triangular_ruler"],
				category: 6
			},
			{
				emoji: "📑",
				name: "BOOKMARK TABS",
				added_in: "6.0",
				shortName: "bookmark_tabs",
				shortNames: ["bookmark_tabs"],
				category: 6
			},
			{
				emoji: "📒",
				name: "LEDGER",
				added_in: "6.0",
				shortName: "ledger",
				shortNames: ["ledger"],
				category: 6
			},
			{
				emoji: "📓",
				name: "NOTEBOOK",
				added_in: "6.0",
				shortName: "notebook",
				shortNames: ["notebook"],
				category: 6
			},
			{
				emoji: "📔",
				name: "NOTEBOOK WITH DECORATIVE COVER",
				added_in: "6.0",
				shortName: "notebook_with_decorative_cover",
				shortNames: ["notebook_with_decorative_cover"],
				category: 6
			},
			{
				emoji: "📕",
				name: "CLOSED BOOK",
				added_in: "6.0",
				shortName: "closed_book",
				shortNames: ["closed_book"],
				category: 6
			},
			{
				emoji: "📖",
				name: "OPEN BOOK",
				added_in: "6.0",
				shortName: "book",
				shortNames: ["book", "open_book"],
				category: 6
			},
			{
				emoji: "📗",
				name: "GREEN BOOK",
				added_in: "6.0",
				shortName: "green_book",
				shortNames: ["green_book"],
				category: 6
			},
			{
				emoji: "📘",
				name: "BLUE BOOK",
				added_in: "6.0",
				shortName: "blue_book",
				shortNames: ["blue_book"],
				category: 6
			},
			{
				emoji: "📙",
				name: "ORANGE BOOK",
				added_in: "6.0",
				shortName: "orange_book",
				shortNames: ["orange_book"],
				category: 6
			},
			{
				emoji: "📚",
				name: "BOOKS",
				added_in: "6.0",
				shortName: "books",
				shortNames: ["books"],
				category: 6
			},
			{
				emoji: "📜",
				name: "SCROLL",
				added_in: "6.0",
				shortName: "scroll",
				shortNames: ["scroll"],
				category: 6
			},
			{
				emoji: "📝",
				name: "MEMO",
				added_in: "6.0",
				shortName: "memo",
				shortNames: ["memo", "pencil"],
				category: 6
			},
			{
				emoji: "📞",
				name: "TELEPHONE RECEIVER",
				added_in: "6.0",
				shortName: "telephone_receiver",
				shortNames: ["telephone_receiver"],
				category: 6
			},
			{
				emoji: "📟",
				name: "PAGER",
				added_in: "6.0",
				shortName: "pager",
				shortNames: ["pager"],
				category: 6
			},
			{
				emoji: "📠",
				name: "FAX MACHINE",
				added_in: "6.0",
				shortName: "fax",
				shortNames: ["fax"],
				category: 6
			},
			{
				emoji: "📡",
				name: "SATELLITE ANTENNA",
				added_in: "6.0",
				shortName: "satellite_antenna",
				shortNames: ["satellite_antenna"],
				category: 6
			},
			{
				emoji: "📢",
				name: "PUBLIC ADDRESS LOUDSPEAKER",
				added_in: "6.0",
				shortName: "loudspeaker",
				shortNames: ["loudspeaker"],
				category: 6
			},
			{
				emoji: "📣",
				name: "CHEERING MEGAPHONE",
				added_in: "6.0",
				shortName: "mega",
				shortNames: ["mega"],
				category: 6
			},
			{
				emoji: "📤",
				name: "OUTBOX TRAY",
				added_in: "6.0",
				shortName: "outbox_tray",
				shortNames: ["outbox_tray"],
				category: 6
			},
			{
				emoji: "📥",
				name: "INBOX TRAY",
				added_in: "6.0",
				shortName: "inbox_tray",
				shortNames: ["inbox_tray"],
				category: 6
			},
			{
				emoji: "📦",
				name: "PACKAGE",
				added_in: "6.0",
				shortName: "package",
				shortNames: ["package"],
				category: 6
			},
			{
				emoji: "📧",
				name: "E-MAIL SYMBOL",
				added_in: "6.0",
				shortName: "e-mail",
				shortNames: ["e-mail"],
				category: 6
			},
			{
				emoji: "📨",
				name: "INCOMING ENVELOPE",
				added_in: "6.0",
				shortName: "incoming_envelope",
				shortNames: ["incoming_envelope"],
				category: 6
			},
			{
				emoji: "📩",
				name: "ENVELOPE WITH DOWNWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "envelope_with_arrow",
				shortNames: ["envelope_with_arrow"],
				category: 6
			},
			{
				emoji: "📪",
				name: "CLOSED MAILBOX WITH LOWERED FLAG",
				added_in: "6.0",
				shortName: "mailbox_closed",
				shortNames: ["mailbox_closed"],
				category: 6
			},
			{
				emoji: "📫",
				name: "CLOSED MAILBOX WITH RAISED FLAG",
				added_in: "6.0",
				shortName: "mailbox",
				shortNames: ["mailbox"],
				category: 6
			},
			{
				emoji: "📬",
				name: "OPEN MAILBOX WITH RAISED FLAG",
				added_in: "6.0",
				shortName: "mailbox_with_mail",
				shortNames: ["mailbox_with_mail"],
				category: 6
			},
			{
				emoji: "📭",
				name: "OPEN MAILBOX WITH LOWERED FLAG",
				added_in: "6.0",
				shortName: "mailbox_with_no_mail",
				shortNames: ["mailbox_with_no_mail"],
				category: 6
			},
			{
				emoji: "📮",
				name: "POSTBOX",
				added_in: "6.0",
				shortName: "postbox",
				shortNames: ["postbox"],
				category: 6
			},
			{
				emoji: "📯",
				name: "POSTAL HORN",
				added_in: "6.0",
				shortName: "postal_horn",
				shortNames: ["postal_horn"],
				category: 6
			},
			{
				emoji: "📰",
				name: "NEWSPAPER",
				added_in: "6.0",
				shortName: "newspaper",
				shortNames: ["newspaper"],
				category: 6
			},
			{
				emoji: "📱",
				name: "MOBILE PHONE",
				added_in: "6.0",
				shortName: "iphone",
				shortNames: ["iphone"],
				category: 6
			},
			{
				emoji: "📲",
				name: "MOBILE PHONE WITH RIGHTWARDS ARROW AT LEFT",
				added_in: "6.0",
				shortName: "calling",
				shortNames: ["calling"],
				category: 6
			},
			{
				emoji: "📷",
				name: "CAMERA",
				added_in: "6.0",
				shortName: "camera",
				shortNames: ["camera"],
				category: 6
			},
			{
				emoji: "📹",
				name: "VIDEO CAMERA",
				added_in: "6.0",
				shortName: "video_camera",
				shortNames: ["video_camera"],
				category: 6
			},
			{
				emoji: "📺",
				name: "TELEVISION",
				added_in: "6.0",
				shortName: "tv",
				shortNames: ["tv"],
				category: 6
			},
			{
				emoji: "📻",
				name: "RADIO",
				added_in: "6.0",
				shortName: "radio",
				shortNames: ["radio"],
				category: 6
			},
			{
				emoji: "📼",
				name: "VIDEOCASSETTE",
				added_in: "6.0",
				shortName: "vhs",
				shortNames: ["vhs"],
				category: 6
			},
			{
				emoji: "🔇",
				name: "SPEAKER WITH CANCELLATION STROKE",
				added_in: "6.0",
				shortName: "mute",
				shortNames: ["mute"],
				category: 6
			},
			{
				emoji: "🔈",
				name: "SPEAKER",
				added_in: "6.0",
				shortName: "speaker",
				shortNames: ["speaker"],
				category: 6
			},
			{
				emoji: "🔉",
				name: "SPEAKER WITH ONE SOUND WAVE",
				added_in: "6.0",
				shortName: "sound",
				shortNames: ["sound"],
				category: 6
			},
			{
				emoji: "🔊",
				name: "SPEAKER WITH THREE SOUND WAVES",
				added_in: "6.0",
				shortName: "loud_sound",
				shortNames: ["loud_sound"],
				category: 6
			},
			{
				emoji: "🔋",
				name: "BATTERY",
				added_in: "6.0",
				shortName: "battery",
				shortNames: ["battery"],
				category: 6
			},
			{
				emoji: "🔌",
				name: "ELECTRIC PLUG",
				added_in: "6.0",
				shortName: "electric_plug",
				shortNames: ["electric_plug"],
				category: 6
			},
			{
				emoji: "🔍",
				name: "LEFT-POINTING MAGNIFYING GLASS",
				added_in: "6.0",
				shortName: "mag",
				shortNames: ["mag"],
				category: 6
			},
			{
				emoji: "🔎",
				name: "RIGHT-POINTING MAGNIFYING GLASS",
				added_in: "6.0",
				shortName: "mag_right",
				shortNames: ["mag_right"],
				category: 6
			},
			{
				emoji: "🔏",
				name: "LOCK WITH INK PEN",
				added_in: "6.0",
				shortName: "lock_with_ink_pen",
				shortNames: ["lock_with_ink_pen"],
				category: 6
			},
			{
				emoji: "🔐",
				name: "CLOSED LOCK WITH KEY",
				added_in: "6.0",
				shortName: "closed_lock_with_key",
				shortNames: ["closed_lock_with_key"],
				category: 6
			},
			{
				emoji: "🔑",
				name: "KEY",
				added_in: "6.0",
				shortName: "key",
				shortNames: ["key"],
				category: 6
			},
			{
				emoji: "🔒",
				name: "LOCK",
				added_in: "6.0",
				shortName: "lock",
				shortNames: ["lock"],
				category: 6
			},
			{
				emoji: "🔓",
				name: "OPEN LOCK",
				added_in: "6.0",
				shortName: "unlock",
				shortNames: ["unlock"],
				category: 6
			},
			{
				emoji: "🔔",
				name: "BELL",
				added_in: "6.0",
				shortName: "bell",
				shortNames: ["bell"],
				category: 6
			},
			{
				emoji: "🔕",
				name: "BELL WITH CANCELLATION STROKE",
				added_in: "6.0",
				shortName: "no_bell",
				shortNames: ["no_bell"],
				category: 6
			},
			{
				emoji: "🔖",
				name: "BOOKMARK",
				added_in: "6.0",
				shortName: "bookmark",
				shortNames: ["bookmark"],
				category: 6
			},
			{
				emoji: "🔗",
				name: "LINK SYMBOL",
				added_in: "6.0",
				shortName: "link",
				shortNames: ["link"],
				category: 6
			},
			{
				emoji: "🔦",
				name: "ELECTRIC TORCH",
				added_in: "6.0",
				shortName: "flashlight",
				shortNames: ["flashlight"],
				category: 6
			},
			{
				emoji: "🔧",
				name: "WRENCH",
				added_in: "6.0",
				shortName: "wrench",
				shortNames: ["wrench"],
				category: 6
			},
			{
				emoji: "🔨",
				name: "HAMMER",
				added_in: "6.0",
				shortName: "hammer",
				shortNames: ["hammer"],
				category: 6
			},
			{
				emoji: "🔩",
				name: "NUT AND BOLT",
				added_in: "6.0",
				shortName: "nut_and_bolt",
				shortNames: ["nut_and_bolt"],
				category: 6
			},
			{
				emoji: "🔫",
				name: "PISTOL",
				added_in: "6.0",
				shortName: "gun",
				shortNames: ["gun"],
				category: 6
			},
			{
				emoji: "🔬",
				name: "MICROSCOPE",
				added_in: "6.0",
				shortName: "microscope",
				shortNames: ["microscope"],
				category: 6
			},
			{
				emoji: "🔭",
				name: "TELESCOPE",
				added_in: "6.0",
				shortName: "telescope",
				shortNames: ["telescope"],
				category: 6
			},
			{
				emoji: "🔮",
				name: "CRYSTAL BALL",
				added_in: "6.0",
				shortName: "crystal_ball",
				shortNames: ["crystal_ball"],
				category: 6
			},
			{
				emoji: "🗿",
				name: "MOYAI",
				added_in: "6.0",
				shortName: "moyai",
				shortNames: ["moyai"],
				category: 6
			},
			{
				emoji: "🚬",
				name: "SMOKING SYMBOL",
				added_in: "6.0",
				shortName: "smoking",
				shortNames: ["smoking"],
				category: 6
			},
			{
				emoji: "☎️",
				name: "BLACK TELEPHONE",
				added_in: "1.1",
				shortName: "phone",
				shortNames: ["phone", "telephone"],
				category: 6
			},
			{
				emoji: "✂️",
				name: "BLACK SCISSORS",
				added_in: "1.1",
				shortName: "scissors",
				shortNames: ["scissors"],
				category: 6
			},
			{
				emoji: "✉️",
				name: "ENVELOPE",
				added_in: "1.1",
				shortName: "email",
				shortNames: ["email", "envelope"],
				category: 6
			},
			{
				emoji: "✏️",
				name: "PENCIL",
				added_in: "1.1",
				shortName: "pencil2",
				shortNames: ["pencil2"],
				category: 6
			},
			{
				emoji: "✒️",
				name: "BLACK NIB",
				added_in: "1.1",
				shortName: "black_nib",
				shortNames: ["black_nib"],
				category: 6
			}
		],
		[
			{
				emoji: "🚼",
				name: "BABY SYMBOL",
				added_in: "6.0",
				shortName: "baby_symbol",
				shortNames: ["baby_symbol"],
				category: 7
			},
			{
				emoji: "🅰️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER A",
				added_in: "6.0",
				shortName: "a",
				shortNames: ["a"],
				category: 7
			},
			{
				emoji: "🅱️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER B",
				added_in: "6.0",
				shortName: "b",
				shortNames: ["b"],
				category: 7
			},
			{
				emoji: "🅾️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER O",
				added_in: "6.0",
				shortName: "o2",
				shortNames: ["o2"],
				category: 7
			},
			{
				emoji: "🅿️",
				name: "NEGATIVE SQUARED LATIN CAPITAL LETTER P",
				added_in: "5.2",
				shortName: "parking",
				shortNames: ["parking"],
				category: 7
			},
			{
				emoji: "🆎",
				name: "NEGATIVE SQUARED AB",
				added_in: "6.0",
				shortName: "ab",
				shortNames: ["ab"],
				category: 7
			},
			{
				emoji: "🆑",
				name: "SQUARED CL",
				added_in: "6.0",
				shortName: "cl",
				shortNames: ["cl"],
				category: 7
			},
			{
				emoji: "🆒",
				name: "SQUARED COOL",
				added_in: "6.0",
				shortName: "cool",
				shortNames: ["cool"],
				category: 7
			},
			{
				emoji: "🆓",
				name: "SQUARED FREE",
				added_in: "6.0",
				shortName: "free",
				shortNames: ["free"],
				category: 7
			},
			{
				emoji: "🆔",
				name: "SQUARED ID",
				added_in: "6.0",
				shortName: "id",
				shortNames: ["id"],
				category: 7
			},
			{
				emoji: "🆕",
				name: "SQUARED NEW",
				added_in: "6.0",
				shortName: "new",
				shortNames: ["new"],
				category: 7
			},
			{
				emoji: "🆖",
				name: "SQUARED NG",
				added_in: "6.0",
				shortName: "ng",
				shortNames: ["ng"],
				category: 7
			},
			{
				emoji: "🆗",
				name: "SQUARED OK",
				added_in: "6.0",
				shortName: "ok",
				shortNames: ["ok"],
				category: 7
			},
			{
				emoji: "🆘",
				name: "SQUARED SOS",
				added_in: "6.0",
				shortName: "sos",
				shortNames: ["sos"],
				category: 7
			},
			{
				emoji: "🆙",
				name: "SQUARED UP WITH EXCLAMATION MARK",
				added_in: "6.0",
				shortName: "up",
				shortNames: ["up"],
				category: 7
			},
			{
				emoji: "🆚",
				name: "SQUARED VS",
				added_in: "6.0",
				shortName: "vs",
				shortNames: ["vs"],
				category: 7
			},
			{
				emoji: "🈁",
				name: "SQUARED KATAKANA KOKO",
				added_in: "6.0",
				shortName: "koko",
				shortNames: ["koko"],
				category: 7
			},
			{
				emoji: "🈂️",
				name: "SQUARED KATAKANA SA",
				added_in: "6.0",
				shortName: "sa",
				shortNames: ["sa"],
				category: 7
			},
			{
				emoji: "🈚",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7121",
				added_in: "5.2",
				shortName: "u7121",
				shortNames: ["u7121"],
				category: 7
			},
			{
				emoji: "🈯",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6307",
				added_in: "5.2",
				shortName: "u6307",
				shortNames: ["u6307"],
				category: 7
			},
			{
				emoji: "🈲",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7981",
				added_in: "6.0",
				shortName: "u7981",
				shortNames: ["u7981"],
				category: 7
			},
			{
				emoji: "🈳",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7A7A",
				added_in: "6.0",
				shortName: "u7a7a",
				shortNames: ["u7a7a"],
				category: 7
			},
			{
				emoji: "🈴",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-5408",
				added_in: "6.0",
				shortName: "u5408",
				shortNames: ["u5408"],
				category: 7
			},
			{
				emoji: "🈵",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6E80",
				added_in: "6.0",
				shortName: "u6e80",
				shortNames: ["u6e80"],
				category: 7
			},
			{
				emoji: "🈶",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6709",
				added_in: "6.0",
				shortName: "u6709",
				shortNames: ["u6709"],
				category: 7
			},
			{
				emoji: "🈷️",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-6708",
				added_in: "6.0",
				shortName: "u6708",
				shortNames: ["u6708"],
				category: 7
			},
			{
				emoji: "🈸",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-7533",
				added_in: "6.0",
				shortName: "u7533",
				shortNames: ["u7533"],
				category: 7
			},
			{
				emoji: "🈹",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-5272",
				added_in: "6.0",
				shortName: "u5272",
				shortNames: ["u5272"],
				category: 7
			},
			{
				emoji: "🈺",
				name: "SQUARED CJK UNIFIED IDEOGRAPH-55B6",
				added_in: "6.0",
				shortName: "u55b6",
				shortNames: ["u55b6"],
				category: 7
			},
			{
				emoji: "🉐",
				name: "CIRCLED IDEOGRAPH ADVANTAGE",
				added_in: "6.0",
				shortName: "ideograph_advantage",
				shortNames: ["ideograph_advantage"],
				category: 7
			},
			{
				emoji: "🉑",
				name: "CIRCLED IDEOGRAPH ACCEPT",
				added_in: "6.0",
				shortName: "accept",
				shortNames: ["accept"],
				category: 7
			},
			{
				emoji: "🎦",
				name: "CINEMA",
				added_in: "6.0",
				shortName: "cinema",
				shortNames: ["cinema"],
				category: 7
			},
			{
				emoji: "🏧",
				name: "AUTOMATED TELLER MACHINE",
				added_in: "6.0",
				shortName: "atm",
				shortNames: ["atm"],
				category: 7
			},
			{
				emoji: "💠",
				name: "DIAMOND SHAPE WITH A DOT INSIDE",
				added_in: "6.0",
				shortName: "diamond_shape_with_a_dot_inside",
				shortNames: ["diamond_shape_with_a_dot_inside"],
				category: 7
			},
			{
				emoji: "💯",
				name: "HUNDRED POINTS SYMBOL",
				added_in: "6.0",
				shortName: "100",
				shortNames: ["100"],
				category: 7
			},
			{
				emoji: "📛",
				name: "NAME BADGE",
				added_in: "6.0",
				shortName: "name_badge",
				shortNames: ["name_badge"],
				category: 7
			},
			{
				emoji: "📳",
				name: "VIBRATION MODE",
				added_in: "6.0",
				shortName: "vibration_mode",
				shortNames: ["vibration_mode"],
				category: 7
			},
			{
				emoji: "📴",
				name: "MOBILE PHONE OFF",
				added_in: "6.0",
				shortName: "mobile_phone_off",
				shortNames: ["mobile_phone_off"],
				category: 7
			},
			{
				emoji: "📵",
				name: "NO MOBILE PHONES",
				added_in: "6.0",
				shortName: "no_mobile_phones",
				shortNames: ["no_mobile_phones"],
				category: 7
			},
			{
				emoji: "📶",
				name: "ANTENNA WITH BARS",
				added_in: "6.0",
				shortName: "signal_strength",
				shortNames: ["signal_strength"],
				category: 7
			},
			{
				emoji: "🔀",
				name: "TWISTED RIGHTWARDS ARROWS",
				added_in: "6.0",
				shortName: "twisted_rightwards_arrows",
				shortNames: ["twisted_rightwards_arrows"],
				category: 7
			},
			{
				emoji: "🔁",
				name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "repeat",
				shortNames: ["repeat"],
				category: 7
			},
			{
				emoji: "🔂",
				name: "CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS WITH CIRCLED ONE OVERLAY",
				added_in: "6.0",
				shortName: "repeat_one",
				shortNames: ["repeat_one"],
				category: 7
			},
			{
				emoji: "🔃",
				name: "CLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "arrows_clockwise",
				shortNames: ["arrows_clockwise"],
				category: 7
			},
			{
				emoji: "🔄",
				name: "ANTICLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS",
				added_in: "6.0",
				shortName: "arrows_counterclockwise",
				shortNames: ["arrows_counterclockwise"],
				category: 7
			},
			{
				emoji: "🔅",
				name: "LOW BRIGHTNESS SYMBOL",
				added_in: "6.0",
				shortName: "low_brightness",
				shortNames: ["low_brightness"],
				category: 7
			},
			{
				emoji: "🔆",
				name: "HIGH BRIGHTNESS SYMBOL",
				added_in: "6.0",
				shortName: "high_brightness",
				shortNames: ["high_brightness"],
				category: 7
			},
			{
				emoji: "🔘",
				name: "RADIO BUTTON",
				added_in: "6.0",
				shortName: "radio_button",
				shortNames: ["radio_button"],
				category: 7
			},
			{
				emoji: "🔙",
				name: "BACK WITH LEFTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "back",
				shortNames: ["back"],
				category: 7
			},
			{
				emoji: "🔚",
				name: "END WITH LEFTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "end",
				shortNames: ["end"],
				category: 7
			},
			{
				emoji: "🔛",
				name: "ON WITH EXCLAMATION MARK WITH LEFT RIGHT ARROW ABOVE",
				added_in: "6.0",
				shortName: "on",
				shortNames: ["on"],
				category: 7
			},
			{
				emoji: "🔜",
				name: "SOON WITH RIGHTWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "soon",
				shortNames: ["soon"],
				category: 7
			},
			{
				emoji: "🔝",
				name: "TOP WITH UPWARDS ARROW ABOVE",
				added_in: "6.0",
				shortName: "top",
				shortNames: ["top"],
				category: 7
			},
			{
				emoji: "🔞",
				name: "NO ONE UNDER EIGHTEEN SYMBOL",
				added_in: "6.0",
				shortName: "underage",
				shortNames: ["underage"],
				category: 7
			},
			{
				emoji: "🔟",
				name: "KEYCAP TEN",
				added_in: "6.0",
				shortName: "keycap_ten",
				shortNames: ["keycap_ten"],
				category: 7
			},
			{
				emoji: "🔠",
				name: "INPUT SYMBOL FOR LATIN CAPITAL LETTERS",
				added_in: "6.0",
				shortName: "capital_abcd",
				shortNames: ["capital_abcd"],
				category: 7
			},
			{
				emoji: "🔡",
				name: "INPUT SYMBOL FOR LATIN SMALL LETTERS",
				added_in: "6.0",
				shortName: "abcd",
				shortNames: ["abcd"],
				category: 7
			},
			{
				emoji: "🔢",
				name: "INPUT SYMBOL FOR NUMBERS",
				added_in: "6.0",
				shortName: "1234",
				shortNames: ["1234"],
				category: 7
			},
			{
				emoji: "🔣",
				name: "INPUT SYMBOL FOR SYMBOLS",
				added_in: "6.0",
				shortName: "symbols",
				shortNames: ["symbols"],
				category: 7
			},
			{
				emoji: "🔤",
				name: "INPUT SYMBOL FOR LATIN LETTERS",
				added_in: "6.0",
				shortName: "abc",
				shortNames: ["abc"],
				category: 7
			},
			{
				emoji: "🔯",
				name: "SIX POINTED STAR WITH MIDDLE DOT",
				added_in: "6.0",
				shortName: "six_pointed_star",
				shortNames: ["six_pointed_star"],
				category: 7
			},
			{
				emoji: "🔰",
				name: "JAPANESE SYMBOL FOR BEGINNER",
				added_in: "6.0",
				shortName: "beginner",
				shortNames: ["beginner"],
				category: 7
			},
			{
				emoji: "🔱",
				name: "TRIDENT EMBLEM",
				added_in: "6.0",
				shortName: "trident",
				shortNames: ["trident"],
				category: 7
			},
			{
				emoji: "🔲",
				name: "BLACK SQUARE BUTTON",
				added_in: "6.0",
				shortName: "black_square_button",
				shortNames: ["black_square_button"],
				category: 7
			},
			{
				emoji: "🔳",
				name: "WHITE SQUARE BUTTON",
				added_in: "6.0",
				shortName: "white_square_button",
				shortNames: ["white_square_button"],
				category: 7
			},
			{
				emoji: "🔴",
				name: "LARGE RED CIRCLE",
				added_in: "6.0",
				shortName: "red_circle",
				shortNames: ["red_circle"],
				category: 7
			},
			{
				emoji: "🔵",
				name: "LARGE BLUE CIRCLE",
				added_in: "6.0",
				shortName: "large_blue_circle",
				shortNames: ["large_blue_circle"],
				category: 7
			},
			{
				emoji: "🔶",
				name: "LARGE ORANGE DIAMOND",
				added_in: "6.0",
				shortName: "large_orange_diamond",
				shortNames: ["large_orange_diamond"],
				category: 7
			},
			{
				emoji: "🔷",
				name: "LARGE BLUE DIAMOND",
				added_in: "6.0",
				shortName: "large_blue_diamond",
				shortNames: ["large_blue_diamond"],
				category: 7
			},
			{
				emoji: "🔸",
				name: "SMALL ORANGE DIAMOND",
				added_in: "6.0",
				shortName: "small_orange_diamond",
				shortNames: ["small_orange_diamond"],
				category: 7
			},
			{
				emoji: "🔹",
				name: "SMALL BLUE DIAMOND",
				added_in: "6.0",
				shortName: "small_blue_diamond",
				shortNames: ["small_blue_diamond"],
				category: 7
			},
			{
				emoji: "🔺",
				name: "UP-POINTING RED TRIANGLE",
				added_in: "6.0",
				shortName: "small_red_triangle",
				shortNames: ["small_red_triangle"],
				category: 7
			},
			{
				emoji: "🔻",
				name: "DOWN-POINTING RED TRIANGLE",
				added_in: "6.0",
				shortName: "small_red_triangle_down",
				shortNames: ["small_red_triangle_down"],
				category: 7
			},
			{
				emoji: "🔼",
				name: "UP-POINTING SMALL RED TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_up_small",
				shortNames: ["arrow_up_small"],
				category: 7
			},
			{
				emoji: "🔽",
				name: "DOWN-POINTING SMALL RED TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_down_small",
				shortNames: ["arrow_down_small"],
				category: 7
			},
			{
				emoji: "🚫",
				name: "NO ENTRY SIGN",
				added_in: "6.0",
				shortName: "no_entry_sign",
				shortNames: ["no_entry_sign"],
				category: 7
			},
			{
				emoji: "🚭",
				name: "NO SMOKING SYMBOL",
				added_in: "6.0",
				shortName: "no_smoking",
				shortNames: ["no_smoking"],
				category: 7
			},
			{
				emoji: "🚮",
				name: "PUT LITTER IN ITS PLACE SYMBOL",
				added_in: "6.0",
				shortName: "put_litter_in_its_place",
				shortNames: ["put_litter_in_its_place"],
				category: 7
			},
			{
				emoji: "🚯",
				name: "DO NOT LITTER SYMBOL",
				added_in: "6.0",
				shortName: "do_not_litter",
				shortNames: ["do_not_litter"],
				category: 7
			},
			{
				emoji: "🚰",
				name: "POTABLE WATER SYMBOL",
				added_in: "6.0",
				shortName: "potable_water",
				shortNames: ["potable_water"],
				category: 7
			},
			{
				emoji: "🚱",
				name: "NON-POTABLE WATER SYMBOL",
				added_in: "6.0",
				shortName: "non-potable_water",
				shortNames: ["non-potable_water"],
				category: 7
			},
			{
				emoji: "🚳",
				name: "NO BICYCLES",
				added_in: "6.0",
				shortName: "no_bicycles",
				shortNames: ["no_bicycles"],
				category: 7
			},
			{
				emoji: "🚷",
				name: "NO PEDESTRIANS",
				added_in: "6.0",
				shortName: "no_pedestrians",
				shortNames: ["no_pedestrians"],
				category: 7
			},
			{
				emoji: "🚸",
				name: "CHILDREN CROSSING",
				added_in: "6.0",
				shortName: "children_crossing",
				shortNames: ["children_crossing"],
				category: 7
			},
			{
				emoji: "🚹",
				name: "MENS SYMBOL",
				added_in: "6.0",
				shortName: "mens",
				shortNames: ["mens"],
				category: 7
			},
			{
				emoji: "🚺",
				name: "WOMENS SYMBOL",
				added_in: "6.0",
				shortName: "womens",
				shortNames: ["womens"],
				category: 7
			},
			{
				emoji: "🚻",
				name: "RESTROOM",
				added_in: "6.0",
				shortName: "restroom",
				shortNames: ["restroom"],
				category: 7
			},
			{
				emoji: "🚾",
				name: "WATER CLOSET",
				added_in: "6.0",
				shortName: "wc",
				shortNames: ["wc"],
				category: 7
			},
			{
				emoji: "🛂",
				name: "PASSPORT CONTROL",
				added_in: "6.0",
				shortName: "passport_control",
				shortNames: ["passport_control"],
				category: 7
			},
			{
				emoji: "🛃",
				name: "CUSTOMS",
				added_in: "6.0",
				shortName: "customs",
				shortNames: ["customs"],
				category: 7
			},
			{
				emoji: "🛄",
				name: "BAGGAGE CLAIM",
				added_in: "6.0",
				shortName: "baggage_claim",
				shortNames: ["baggage_claim"],
				category: 7
			},
			{
				emoji: "🛅",
				name: "LEFT LUGGAGE",
				added_in: "6.0",
				shortName: "left_luggage",
				shortNames: ["left_luggage"],
				category: 7
			},
			{
				emoji: "‼️",
				name: "DOUBLE EXCLAMATION MARK",
				added_in: "1.1",
				shortName: "bangbang",
				shortNames: ["bangbang"],
				category: 7
			},
			{
				emoji: "⁉️",
				name: "EXCLAMATION QUESTION MARK",
				added_in: "3.0",
				shortName: "interrobang",
				shortNames: ["interrobang"],
				category: 7
			},
			{
				emoji: "™️",
				name: "TRADE MARK SIGN",
				added_in: "1.1",
				shortName: "tm",
				shortNames: ["tm"],
				category: 7
			},
			{
				emoji: "ℹ️",
				name: "INFORMATION SOURCE",
				added_in: "3.0",
				shortName: "information_source",
				shortNames: ["information_source"],
				category: 7
			},
			{
				emoji: "↔️",
				name: "LEFT RIGHT ARROW",
				added_in: "1.1",
				shortName: "left_right_arrow",
				shortNames: ["left_right_arrow"],
				category: 7
			},
			{
				emoji: "↕️",
				name: "UP DOWN ARROW",
				added_in: "1.1",
				shortName: "arrow_up_down",
				shortNames: ["arrow_up_down"],
				category: 7
			},
			{
				emoji: "↖️",
				name: "NORTH WEST ARROW",
				added_in: "1.1",
				shortName: "arrow_upper_left",
				shortNames: ["arrow_upper_left"],
				category: 7
			},
			{
				emoji: "↗️",
				name: "NORTH EAST ARROW",
				added_in: "1.1",
				shortName: "arrow_upper_right",
				shortNames: ["arrow_upper_right"],
				category: 7
			},
			{
				emoji: "↘️",
				name: "SOUTH EAST ARROW",
				added_in: "1.1",
				shortName: "arrow_lower_right",
				shortNames: ["arrow_lower_right"],
				category: 7
			},
			{
				emoji: "↙️",
				name: "SOUTH WEST ARROW",
				added_in: "1.1",
				shortName: "arrow_lower_left",
				shortNames: ["arrow_lower_left"],
				category: 7
			},
			{
				emoji: "↩️",
				name: "LEFTWARDS ARROW WITH HOOK",
				added_in: "1.1",
				shortName: "leftwards_arrow_with_hook",
				shortNames: ["leftwards_arrow_with_hook"],
				category: 7
			},
			{
				emoji: "↪️",
				name: "RIGHTWARDS ARROW WITH HOOK",
				added_in: "1.1",
				shortName: "arrow_right_hook",
				shortNames: ["arrow_right_hook"],
				category: 7
			},
			{
				emoji: "⏩",
				name: "BLACK RIGHT-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "fast_forward",
				shortNames: ["fast_forward"],
				category: 7
			},
			{
				emoji: "⏪",
				name: "BLACK LEFT-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "rewind",
				shortNames: ["rewind"],
				category: 7
			},
			{
				emoji: "⏫",
				name: "BLACK UP-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_double_up",
				shortNames: ["arrow_double_up"],
				category: 7
			},
			{
				emoji: "⏬",
				name: "BLACK DOWN-POINTING DOUBLE TRIANGLE",
				added_in: "6.0",
				shortName: "arrow_double_down",
				shortNames: ["arrow_double_down"],
				category: 7
			},
			{
				emoji: "Ⓜ️",
				name: "CIRCLED LATIN CAPITAL LETTER M",
				added_in: "1.1",
				shortName: "m",
				shortNames: ["m"],
				category: 7
			},
			{
				emoji: "▪️",
				name: "BLACK SMALL SQUARE",
				added_in: "1.1",
				shortName: "black_small_square",
				shortNames: ["black_small_square"],
				category: 7
			},
			{
				emoji: "▫️",
				name: "WHITE SMALL SQUARE",
				added_in: "1.1",
				shortName: "white_small_square",
				shortNames: ["white_small_square"],
				category: 7
			},
			{
				emoji: "▶️",
				name: "BLACK RIGHT-POINTING TRIANGLE",
				added_in: "1.1",
				shortName: "arrow_forward",
				shortNames: ["arrow_forward"],
				category: 7
			},
			{
				emoji: "◀️",
				name: "BLACK LEFT-POINTING TRIANGLE",
				added_in: "1.1",
				shortName: "arrow_backward",
				shortNames: ["arrow_backward"],
				category: 7
			},
			{
				emoji: "◻️",
				name: "WHITE MEDIUM SQUARE",
				added_in: "3.2",
				shortName: "white_medium_square",
				shortNames: ["white_medium_square"],
				category: 7
			},
			{
				emoji: "◼️",
				name: "BLACK MEDIUM SQUARE",
				added_in: "3.2",
				shortName: "black_medium_square",
				shortNames: ["black_medium_square"],
				category: 7
			},
			{
				emoji: "◽",
				name: "WHITE MEDIUM SMALL SQUARE",
				added_in: "3.2",
				shortName: "white_medium_small_square",
				shortNames: ["white_medium_small_square"],
				category: 7
			},
			{
				emoji: "◾",
				name: "BLACK MEDIUM SMALL SQUARE",
				added_in: "3.2",
				shortName: "black_medium_small_square",
				shortNames: ["black_medium_small_square"],
				category: 7
			},
			{
				emoji: "☑️",
				name: "BALLOT BOX WITH CHECK",
				added_in: "1.1",
				shortName: "ballot_box_with_check",
				shortNames: ["ballot_box_with_check"],
				category: 7
			},
			{
				emoji: "♈",
				name: "ARIES",
				added_in: "1.1",
				shortName: "aries",
				shortNames: ["aries"],
				category: 7
			},
			{
				emoji: "♉",
				name: "TAURUS",
				added_in: "1.1",
				shortName: "taurus",
				shortNames: ["taurus"],
				category: 7
			},
			{
				emoji: "♊",
				name: "GEMINI",
				added_in: "1.1",
				shortName: "gemini",
				shortNames: ["gemini"],
				category: 7
			},
			{
				emoji: "♋",
				name: "CANCER",
				added_in: "1.1",
				shortName: "cancer",
				shortNames: ["cancer"],
				category: 7
			},
			{
				emoji: "♌",
				name: "LEO",
				added_in: "1.1",
				shortName: "leo",
				shortNames: ["leo"],
				category: 7
			},
			{
				emoji: "♍",
				name: "VIRGO",
				added_in: "1.1",
				shortName: "virgo",
				shortNames: ["virgo"],
				category: 7
			},
			{
				emoji: "♎",
				name: "LIBRA",
				added_in: "1.1",
				shortName: "libra",
				shortNames: ["libra"],
				category: 7
			},
			{
				emoji: "♏",
				name: "SCORPIUS",
				added_in: "1.1",
				shortName: "scorpius",
				shortNames: ["scorpius"],
				category: 7
			},
			{
				emoji: "♐",
				name: "SAGITTARIUS",
				added_in: "1.1",
				shortName: "sagittarius",
				shortNames: ["sagittarius"],
				category: 7
			},
			{
				emoji: "♑",
				name: "CAPRICORN",
				added_in: "1.1",
				shortName: "capricorn",
				shortNames: ["capricorn"],
				category: 7
			},
			{
				emoji: "♒",
				name: "AQUARIUS",
				added_in: "1.1",
				shortName: "aquarius",
				shortNames: ["aquarius"],
				category: 7
			},
			{
				emoji: "♓",
				name: "PISCES",
				added_in: "1.1",
				shortName: "pisces",
				shortNames: ["pisces"],
				category: 7
			},
			{
				emoji: "♻️",
				name: "BLACK UNIVERSAL RECYCLING SYMBOL",
				added_in: "3.2",
				shortName: "recycle",
				shortNames: ["recycle"],
				category: 7
			},
			{
				emoji: "♿",
				name: "WHEELCHAIR SYMBOL",
				added_in: "4.1",
				shortName: "wheelchair",
				shortNames: ["wheelchair"],
				category: 7
			},
			{
				emoji: "⚠️",
				name: "WARNING SIGN",
				added_in: "4.0",
				shortName: "warning",
				shortNames: ["warning"],
				category: 7
			},
			{
				emoji: "⚪",
				name: "MEDIUM WHITE CIRCLE",
				added_in: "4.1",
				shortName: "white_circle",
				shortNames: ["white_circle"],
				category: 7
			},
			{
				emoji: "⚫",
				name: "MEDIUM BLACK CIRCLE",
				added_in: "4.1",
				shortName: "black_circle",
				shortNames: ["black_circle"],
				category: 7
			},
			{
				emoji: "⛎",
				name: "OPHIUCHUS",
				added_in: "6.0",
				shortName: "ophiuchus",
				shortNames: ["ophiuchus"],
				category: 7
			},
			{
				emoji: "⛔",
				name: "NO ENTRY",
				added_in: "5.2",
				shortName: "no_entry",
				shortNames: ["no_entry"],
				category: 7
			},
			{
				emoji: "✅",
				name: "WHITE HEAVY CHECK MARK",
				added_in: "6.0",
				shortName: "white_check_mark",
				shortNames: ["white_check_mark"],
				category: 7
			},
			{
				emoji: "✔️",
				name: "HEAVY CHECK MARK",
				added_in: "1.1",
				shortName: "heavy_check_mark",
				shortNames: ["heavy_check_mark"],
				category: 7
			},
			{
				emoji: "✖️",
				name: "HEAVY MULTIPLICATION X",
				added_in: "1.1",
				shortName: "heavy_multiplication_x",
				shortNames: ["heavy_multiplication_x"],
				category: 7
			},
			{
				emoji: "✳️",
				name: "EIGHT SPOKED ASTERISK",
				added_in: "1.1",
				shortName: "eight_spoked_asterisk",
				shortNames: ["eight_spoked_asterisk"],
				category: 7
			},
			{
				emoji: "✴️",
				name: "EIGHT POINTED BLACK STAR",
				added_in: "1.1",
				shortName: "eight_pointed_black_star",
				shortNames: ["eight_pointed_black_star"],
				category: 7
			},
			{
				emoji: "❇️",
				name: "SPARKLE",
				added_in: "1.1",
				shortName: "sparkle",
				shortNames: ["sparkle"],
				category: 7
			},
			{
				emoji: "❌",
				name: "CROSS MARK",
				added_in: "6.0",
				shortName: "x",
				shortNames: ["x"],
				category: 7
			},
			{
				emoji: "❎",
				name: "NEGATIVE SQUARED CROSS MARK",
				added_in: "6.0",
				shortName: "negative_squared_cross_mark",
				shortNames: ["negative_squared_cross_mark"],
				category: 7
			},
			{
				emoji: "❓",
				name: "BLACK QUESTION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "question",
				shortNames: ["question"],
				category: 7
			},
			{
				emoji: "❔",
				name: "WHITE QUESTION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "grey_question",
				shortNames: ["grey_question"],
				category: 7
			},
			{
				emoji: "❕",
				name: "WHITE EXCLAMATION MARK ORNAMENT",
				added_in: "6.0",
				shortName: "grey_exclamation",
				shortNames: ["grey_exclamation"],
				category: 7
			},
			{
				emoji: "❗",
				name: "HEAVY EXCLAMATION MARK SYMBOL",
				added_in: "5.2",
				shortName: "exclamation",
				shortNames: ["exclamation", "heavy_exclamation_mark"],
				category: 7
			},
			{
				emoji: "➕",
				name: "HEAVY PLUS SIGN",
				added_in: "6.0",
				shortName: "heavy_plus_sign",
				shortNames: ["heavy_plus_sign"],
				category: 7
			},
			{
				emoji: "➖",
				name: "HEAVY MINUS SIGN",
				added_in: "6.0",
				shortName: "heavy_minus_sign",
				shortNames: ["heavy_minus_sign"],
				category: 7
			},
			{
				emoji: "➗",
				name: "HEAVY DIVISION SIGN",
				added_in: "6.0",
				shortName: "heavy_division_sign",
				shortNames: ["heavy_division_sign"],
				category: 7
			},
			{
				emoji: "➡️",
				name: "BLACK RIGHTWARDS ARROW",
				added_in: "1.1",
				shortName: "arrow_right",
				shortNames: ["arrow_right"],
				category: 7
			},
			{
				emoji: "➰",
				name: "CURLY LOOP",
				added_in: "6.0",
				shortName: "curly_loop",
				shortNames: ["curly_loop"],
				category: 7
			},
			{
				emoji: "➿",
				name: "DOUBLE CURLY LOOP",
				added_in: "6.0",
				shortName: "loop",
				shortNames: ["loop"],
				category: 7
			},
			{
				emoji: "⤴️",
				name: "ARROW POINTING RIGHTWARDS THEN CURVING UPWARDS",
				added_in: "3.2",
				shortName: "arrow_heading_up",
				shortNames: ["arrow_heading_up"],
				category: 7
			},
			{
				emoji: "⤵️",
				name: "ARROW POINTING RIGHTWARDS THEN CURVING DOWNWARDS",
				added_in: "3.2",
				shortName: "arrow_heading_down",
				shortNames: ["arrow_heading_down"],
				category: 7
			},
			{
				emoji: "⬅️",
				name: "LEFTWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_left",
				shortNames: ["arrow_left"],
				category: 7
			},
			{
				emoji: "⬆️",
				name: "UPWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_up",
				shortNames: ["arrow_up"],
				category: 7
			},
			{
				emoji: "⬇️",
				name: "DOWNWARDS BLACK ARROW",
				added_in: "4.0",
				shortName: "arrow_down",
				shortNames: ["arrow_down"],
				category: 7
			},
			{
				emoji: "⬛",
				name: "BLACK LARGE SQUARE",
				added_in: "5.1",
				shortName: "black_large_square",
				shortNames: ["black_large_square"],
				category: 7
			},
			{
				emoji: "⬜",
				name: "WHITE LARGE SQUARE",
				added_in: "5.1",
				shortName: "white_large_square",
				shortNames: ["white_large_square"],
				category: 7
			},
			{
				emoji: "⭕",
				name: "HEAVY LARGE CIRCLE",
				added_in: "5.2",
				shortName: "o",
				shortNames: ["o"],
				category: 7
			},
			{
				emoji: "〰️",
				name: "WAVY DASH",
				added_in: "1.1",
				shortName: "wavy_dash",
				shortNames: ["wavy_dash"],
				category: 7
			},
			{
				emoji: "〽️",
				name: "PART ALTERNATION MARK",
				added_in: "3.2",
				shortName: "part_alternation_mark",
				shortNames: ["part_alternation_mark"],
				category: 7
			},
			{
				emoji: "㊗️",
				name: "CIRCLED IDEOGRAPH CONGRATULATION",
				added_in: "1.1",
				shortName: "congratulations",
				shortNames: ["congratulations"],
				category: 7
			},
			{
				emoji: "㊙️",
				name: "CIRCLED IDEOGRAPH SECRET",
				added_in: "1.1",
				shortName: "secret",
				shortNames: ["secret"],
				category: 7
			}
		],
		[
			{
				emoji: "🇩🇪",
				name: "Germany Flag",
				added_in: "6.0",
				shortName: "de",
				shortNames: ["de", "flag-de"],
				category: 8
			},
			{
				emoji: "🇮🇲",
				name: "Isle of Man Flag",
				added_in: "6.0",
				shortName: "flag-im",
				shortNames: ["flag-im"],
				category: 8
			},
			{
				emoji: "🇰🇾",
				name: "Cayman Islands Flag",
				added_in: "6.0",
				shortName: "flag-ky",
				shortNames: ["flag-ky"],
				category: 8
			},
			{
				emoji: "🇴🇲",
				name: "Oman Flag",
				added_in: "6.0",
				shortName: "flag-om",
				shortNames: ["flag-om"],
				category: 8
			},
			{
				emoji: "🇷🇴",
				name: "Romania Flag",
				added_in: "6.0",
				shortName: "flag-ro",
				shortNames: ["flag-ro"],
				category: 8
			},
			{
				emoji: "🇦🇨",
				name: "Ascension Island Flag",
				added_in: "6.0",
				shortName: "flag-ac",
				shortNames: ["flag-ac"],
				category: 8
			},
			{
				emoji: "🇦🇩",
				name: "Andorra Flag",
				added_in: "6.0",
				shortName: "flag-ad",
				shortNames: ["flag-ad"],
				category: 8
			},
			{
				emoji: "🇦🇪",
				name: "United Arab Emirates Flag",
				added_in: "6.0",
				shortName: "flag-ae",
				shortNames: ["flag-ae"],
				category: 8
			},
			{
				emoji: "🇦🇫",
				name: "Afghanistan Flag",
				added_in: "6.0",
				shortName: "flag-af",
				shortNames: ["flag-af"],
				category: 8
			},
			{
				emoji: "🇦🇬",
				name: "Antigua & Barbuda Flag",
				added_in: "6.0",
				shortName: "flag-ag",
				shortNames: ["flag-ag"],
				category: 8
			},
			{
				emoji: "🇦🇮",
				name: "Anguilla Flag",
				added_in: "6.0",
				shortName: "flag-ai",
				shortNames: ["flag-ai"],
				category: 8
			},
			{
				emoji: "🇦🇱",
				name: "Albania Flag",
				added_in: "6.0",
				shortName: "flag-al",
				shortNames: ["flag-al"],
				category: 8
			},
			{
				emoji: "🇦🇲",
				name: "Armenia Flag",
				added_in: "6.0",
				shortName: "flag-am",
				shortNames: ["flag-am"],
				category: 8
			},
			{
				emoji: "🇦🇴",
				name: "Angola Flag",
				added_in: "6.0",
				shortName: "flag-ao",
				shortNames: ["flag-ao"],
				category: 8
			},
			{
				emoji: "🇦🇶",
				name: "Antarctica Flag",
				added_in: "6.0",
				shortName: "flag-aq",
				shortNames: ["flag-aq"],
				category: 8
			},
			{
				emoji: "🇦🇷",
				name: "Argentina Flag",
				added_in: "6.0",
				shortName: "flag-ar",
				shortNames: ["flag-ar"],
				category: 8
			},
			{
				emoji: "🇦🇸",
				name: "American Samoa Flag",
				added_in: "6.0",
				shortName: "flag-as",
				shortNames: ["flag-as"],
				category: 8
			},
			{
				emoji: "🇦🇹",
				name: "Austria Flag",
				added_in: "6.0",
				shortName: "flag-at",
				shortNames: ["flag-at"],
				category: 8
			},
			{
				emoji: "🇦🇺",
				name: "Australia Flag",
				added_in: "6.0",
				shortName: "flag-au",
				shortNames: ["flag-au"],
				category: 8
			},
			{
				emoji: "🇦🇼",
				name: "Aruba Flag",
				added_in: "6.0",
				shortName: "flag-aw",
				shortNames: ["flag-aw"],
				category: 8
			},
			{
				emoji: "🇦🇽",
				name: "Åland Islands Flag",
				added_in: "6.0",
				shortName: "flag-ax",
				shortNames: ["flag-ax"],
				category: 8
			},
			{
				emoji: "🇦🇿",
				name: "Azerbaijan Flag",
				added_in: "6.0",
				shortName: "flag-az",
				shortNames: ["flag-az"],
				category: 8
			},
			{
				emoji: "🇧🇧",
				name: "Barbados Flag",
				added_in: "6.0",
				shortName: "flag-bb",
				shortNames: ["flag-bb"],
				category: 8
			},
			{
				emoji: "🇧🇩",
				name: "Bangladesh Flag",
				added_in: "6.0",
				shortName: "flag-bd",
				shortNames: ["flag-bd"],
				category: 8
			},
			{
				emoji: "🇧🇪",
				name: "Belgium Flag",
				added_in: "6.0",
				shortName: "flag-be",
				shortNames: ["flag-be"],
				category: 8
			},
			{
				emoji: "🇧🇫",
				name: "Burkina Faso Flag",
				added_in: "6.0",
				shortName: "flag-bf",
				shortNames: ["flag-bf"],
				category: 8
			},
			{
				emoji: "🇧🇬",
				name: "Bulgaria Flag",
				added_in: "6.0",
				shortName: "flag-bg",
				shortNames: ["flag-bg"],
				category: 8
			},
			{
				emoji: "🇧🇭",
				name: "Bahrain Flag",
				added_in: "6.0",
				shortName: "flag-bh",
				shortNames: ["flag-bh"],
				category: 8
			},
			{
				emoji: "🇧🇮",
				name: "Burundi Flag",
				added_in: "6.0",
				shortName: "flag-bi",
				shortNames: ["flag-bi"],
				category: 8
			},
			{
				emoji: "🇧🇯",
				name: "Benin Flag",
				added_in: "6.0",
				shortName: "flag-bj",
				shortNames: ["flag-bj"],
				category: 8
			},
			{
				emoji: "🇧🇲",
				name: "Bermuda Flag",
				added_in: "6.0",
				shortName: "flag-bm",
				shortNames: ["flag-bm"],
				category: 8
			},
			{
				emoji: "🇧🇴",
				name: "Bolivia Flag",
				added_in: "6.0",
				shortName: "flag-bo",
				shortNames: ["flag-bo"],
				category: 8
			},
			{
				emoji: "🇧🇷",
				name: "Brazil Flag",
				added_in: "6.0",
				shortName: "flag-br",
				shortNames: ["flag-br"],
				category: 8
			},
			{
				emoji: "🇧🇸",
				name: "Bahamas Flag",
				added_in: "6.0",
				shortName: "flag-bs",
				shortNames: ["flag-bs"],
				category: 8
			},
			{
				emoji: "🇧🇹",
				name: "Bhutan Flag",
				added_in: "6.0",
				shortName: "flag-bt",
				shortNames: ["flag-bt"],
				category: 8
			},
			{
				emoji: "🇧🇻",
				name: "Bouvet Island Flag",
				added_in: "6.0",
				shortName: "flag-bv",
				shortNames: ["flag-bv"],
				category: 8
			},
			{
				emoji: "🇧🇼",
				name: "Botswana Flag",
				added_in: "6.0",
				shortName: "flag-bw",
				shortNames: ["flag-bw"],
				category: 8
			},
			{
				emoji: "🇧🇾",
				name: "Belarus Flag",
				added_in: "6.0",
				shortName: "flag-by",
				shortNames: ["flag-by"],
				category: 8
			},
			{
				emoji: "🇧🇿",
				name: "Belize Flag",
				added_in: "6.0",
				shortName: "flag-bz",
				shortNames: ["flag-bz"],
				category: 8
			},
			{
				emoji: "🇨🇦",
				name: "Canada Flag",
				added_in: "6.0",
				shortName: "flag-ca",
				shortNames: ["flag-ca"],
				category: 8
			},
			{
				emoji: "🇨🇨",
				name: "Cocos (Keeling) Islands Flag",
				added_in: "6.0",
				shortName: "flag-cc",
				shortNames: ["flag-cc"],
				category: 8
			},
			{
				emoji: "🇨🇩",
				name: "Congo - Kinshasa Flag",
				added_in: "6.0",
				shortName: "flag-cd",
				shortNames: ["flag-cd"],
				category: 8
			},
			{
				emoji: "🇨🇫",
				name: "Central African Republic Flag",
				added_in: "6.0",
				shortName: "flag-cf",
				shortNames: ["flag-cf"],
				category: 8
			},
			{
				emoji: "🇨🇬",
				name: "Congo - Brazzaville Flag",
				added_in: "6.0",
				shortName: "flag-cg",
				shortNames: ["flag-cg"],
				category: 8
			},
			{
				emoji: "🇨🇭",
				name: "Switzerland Flag",
				added_in: "6.0",
				shortName: "flag-ch",
				shortNames: ["flag-ch"],
				category: 8
			},
			{
				emoji: "🇨🇮",
				name: "Côte d’Ivoire Flag",
				added_in: "6.0",
				shortName: "flag-ci",
				shortNames: ["flag-ci"],
				category: 8
			},
			{
				emoji: "🇨🇰",
				name: "Cook Islands Flag",
				added_in: "6.0",
				shortName: "flag-ck",
				shortNames: ["flag-ck"],
				category: 8
			},
			{
				emoji: "🇨🇱",
				name: "Chile Flag",
				added_in: "6.0",
				shortName: "flag-cl",
				shortNames: ["flag-cl"],
				category: 8
			},
			{
				emoji: "🇨🇲",
				name: "Cameroon Flag",
				added_in: "6.0",
				shortName: "flag-cm",
				shortNames: ["flag-cm"],
				category: 8
			},
			{
				emoji: "🇨🇳",
				name: "China Flag",
				added_in: "6.0",
				shortName: "cn",
				shortNames: ["cn", "flag-cn"],
				category: 8
			},
			{
				emoji: "🇨🇴",
				name: "Colombia Flag",
				added_in: "6.0",
				shortName: "flag-co",
				shortNames: ["flag-co"],
				category: 8
			},
			{
				emoji: "🇨🇷",
				name: "Costa Rica Flag",
				added_in: "6.0",
				shortName: "flag-cr",
				shortNames: ["flag-cr"],
				category: 8
			},
			{
				emoji: "🇨🇺",
				name: "Cuba Flag",
				added_in: "6.0",
				shortName: "flag-cu",
				shortNames: ["flag-cu"],
				category: 8
			},
			{
				emoji: "🇨🇻",
				name: "Cape Verde Flag",
				added_in: "6.0",
				shortName: "flag-cv",
				shortNames: ["flag-cv"],
				category: 8
			},
			{
				emoji: "🇨🇼",
				name: "Curaçao Flag",
				added_in: "6.0",
				shortName: "flag-cw",
				shortNames: ["flag-cw"],
				category: 8
			},
			{
				emoji: "🇨🇽",
				name: "Christmas Island Flag",
				added_in: "6.0",
				shortName: "flag-cx",
				shortNames: ["flag-cx"],
				category: 8
			},
			{
				emoji: "🇨🇾",
				name: "Cyprus Flag",
				added_in: "6.0",
				shortName: "flag-cy",
				shortNames: ["flag-cy"],
				category: 8
			},
			{
				emoji: "🇨🇿",
				name: "Czechia Flag",
				added_in: "6.0",
				shortName: "flag-cz",
				shortNames: ["flag-cz"],
				category: 8
			},
			{
				emoji: "🇩🇯",
				name: "Djibouti Flag",
				added_in: "6.0",
				shortName: "flag-dj",
				shortNames: ["flag-dj"],
				category: 8
			},
			{
				emoji: "🇩🇰",
				name: "Denmark Flag",
				added_in: "6.0",
				shortName: "flag-dk",
				shortNames: ["flag-dk"],
				category: 8
			},
			{
				emoji: "🇩🇲",
				name: "Dominica Flag",
				added_in: "6.0",
				shortName: "flag-dm",
				shortNames: ["flag-dm"],
				category: 8
			},
			{
				emoji: "🇩🇴",
				name: "Dominican Republic Flag",
				added_in: "6.0",
				shortName: "flag-do",
				shortNames: ["flag-do"],
				category: 8
			},
			{
				emoji: "🇩🇿",
				name: "Algeria Flag",
				added_in: "6.0",
				shortName: "flag-dz",
				shortNames: ["flag-dz"],
				category: 8
			},
			{
				emoji: "🇪🇨",
				name: "Ecuador Flag",
				added_in: "6.0",
				shortName: "flag-ec",
				shortNames: ["flag-ec"],
				category: 8
			},
			{
				emoji: "🇪🇪",
				name: "Estonia Flag",
				added_in: "6.0",
				shortName: "flag-ee",
				shortNames: ["flag-ee"],
				category: 8
			},
			{
				emoji: "🇪🇬",
				name: "Egypt Flag",
				added_in: "6.0",
				shortName: "flag-eg",
				shortNames: ["flag-eg"],
				category: 8
			},
			{
				emoji: "🇪🇷",
				name: "Eritrea Flag",
				added_in: "6.0",
				shortName: "flag-er",
				shortNames: ["flag-er"],
				category: 8
			},
			{
				emoji: "🇪🇸",
				name: "Spain Flag",
				added_in: "6.0",
				shortName: "es",
				shortNames: ["es", "flag-es"],
				category: 8
			},
			{
				emoji: "🇪🇹",
				name: "Ethiopia Flag",
				added_in: "6.0",
				shortName: "flag-et",
				shortNames: ["flag-et"],
				category: 8
			},
			{
				emoji: "🇪🇺",
				name: "European Union Flag",
				added_in: "6.0",
				shortName: "flag-eu",
				shortNames: ["flag-eu"],
				category: 8
			},
			{
				emoji: "🇫🇮",
				name: "Finland Flag",
				added_in: "6.0",
				shortName: "flag-fi",
				shortNames: ["flag-fi"],
				category: 8
			},
			{
				emoji: "🇫🇯",
				name: "Fiji Flag",
				added_in: "6.0",
				shortName: "flag-fj",
				shortNames: ["flag-fj"],
				category: 8
			},
			{
				emoji: "🇫🇲",
				name: "Micronesia Flag",
				added_in: "6.0",
				shortName: "flag-fm",
				shortNames: ["flag-fm"],
				category: 8
			},
			{
				emoji: "🇫🇴",
				name: "Faroe Islands Flag",
				added_in: "6.0",
				shortName: "flag-fo",
				shortNames: ["flag-fo"],
				category: 8
			},
			{
				emoji: "🇫🇷",
				name: "France Flag",
				added_in: "6.0",
				shortName: "fr",
				shortNames: ["fr", "flag-fr"],
				category: 8
			},
			{
				emoji: "🇬🇦",
				name: "Gabon Flag",
				added_in: "6.0",
				shortName: "flag-ga",
				shortNames: ["flag-ga"],
				category: 8
			},
			{
				emoji: "🇬🇧",
				name: "United Kingdom Flag",
				added_in: "6.0",
				shortName: "gb",
				shortNames: [
					"gb",
					"uk",
					"flag-gb"
				],
				category: 8
			},
			{
				emoji: "🇬🇩",
				name: "Grenada Flag",
				added_in: "6.0",
				shortName: "flag-gd",
				shortNames: ["flag-gd"],
				category: 8
			},
			{
				emoji: "🇬🇪",
				name: "Georgia Flag",
				added_in: "6.0",
				shortName: "flag-ge",
				shortNames: ["flag-ge"],
				category: 8
			},
			{
				emoji: "🇬🇬",
				name: "Guernsey Flag",
				added_in: "6.0",
				shortName: "flag-gg",
				shortNames: ["flag-gg"],
				category: 8
			},
			{
				emoji: "🇬🇭",
				name: "Ghana Flag",
				added_in: "6.0",
				shortName: "flag-gh",
				shortNames: ["flag-gh"],
				category: 8
			},
			{
				emoji: "🇬🇮",
				name: "Gibraltar Flag",
				added_in: "6.0",
				shortName: "flag-gi",
				shortNames: ["flag-gi"],
				category: 8
			},
			{
				emoji: "🇬🇱",
				name: "Greenland Flag",
				added_in: "6.0",
				shortName: "flag-gl",
				shortNames: ["flag-gl"],
				category: 8
			},
			{
				emoji: "🇬🇲",
				name: "Gambia Flag",
				added_in: "6.0",
				shortName: "flag-gm",
				shortNames: ["flag-gm"],
				category: 8
			},
			{
				emoji: "🇬🇳",
				name: "Guinea Flag",
				added_in: "6.0",
				shortName: "flag-gn",
				shortNames: ["flag-gn"],
				category: 8
			},
			{
				emoji: "🇬🇶",
				name: "Equatorial Guinea Flag",
				added_in: "6.0",
				shortName: "flag-gq",
				shortNames: ["flag-gq"],
				category: 8
			},
			{
				emoji: "🇬🇷",
				name: "Greece Flag",
				added_in: "6.0",
				shortName: "flag-gr",
				shortNames: ["flag-gr"],
				category: 8
			},
			{
				emoji: "🇬🇹",
				name: "Guatemala Flag",
				added_in: "6.0",
				shortName: "flag-gt",
				shortNames: ["flag-gt"],
				category: 8
			},
			{
				emoji: "🇬🇺",
				name: "Guam Flag",
				added_in: "6.0",
				shortName: "flag-gu",
				shortNames: ["flag-gu"],
				category: 8
			},
			{
				emoji: "🇬🇼",
				name: "Guinea-Bissau Flag",
				added_in: "6.0",
				shortName: "flag-gw",
				shortNames: ["flag-gw"],
				category: 8
			},
			{
				emoji: "🇬🇾",
				name: "Guyana Flag",
				added_in: "6.0",
				shortName: "flag-gy",
				shortNames: ["flag-gy"],
				category: 8
			},
			{
				emoji: "🇭🇰",
				name: "Hong Kong SAR China Flag",
				added_in: "6.0",
				shortName: "flag-hk",
				shortNames: ["flag-hk"],
				category: 8
			},
			{
				emoji: "🇭🇲",
				name: "Heard & McDonald Islands Flag",
				added_in: "6.0",
				shortName: "flag-hm",
				shortNames: ["flag-hm"],
				category: 8
			},
			{
				emoji: "🇭🇳",
				name: "Honduras Flag",
				added_in: "6.0",
				shortName: "flag-hn",
				shortNames: ["flag-hn"],
				category: 8
			},
			{
				emoji: "🇭🇷",
				name: "Croatia Flag",
				added_in: "6.0",
				shortName: "flag-hr",
				shortNames: ["flag-hr"],
				category: 8
			},
			{
				emoji: "🇭🇹",
				name: "Haiti Flag",
				added_in: "6.0",
				shortName: "flag-ht",
				shortNames: ["flag-ht"],
				category: 8
			},
			{
				emoji: "🇭🇺",
				name: "Hungary Flag",
				added_in: "6.0",
				shortName: "flag-hu",
				shortNames: ["flag-hu"],
				category: 8
			},
			{
				emoji: "🇮🇨",
				name: "Canary Islands Flag",
				added_in: "6.0",
				shortName: "flag-ic",
				shortNames: ["flag-ic"],
				category: 8
			},
			{
				emoji: "🇮🇩",
				name: "Indonesia Flag",
				added_in: "6.0",
				shortName: "flag-id",
				shortNames: ["flag-id"],
				category: 8
			},
			{
				emoji: "🇮🇪",
				name: "Ireland Flag",
				added_in: "6.0",
				shortName: "flag-ie",
				shortNames: ["flag-ie"],
				category: 8
			},
			{
				emoji: "🇮🇱",
				name: "Israel Flag",
				added_in: "6.0",
				shortName: "flag-il",
				shortNames: ["flag-il"],
				category: 8
			},
			{
				emoji: "🇮🇳",
				name: "India Flag",
				added_in: "6.0",
				shortName: "flag-in",
				shortNames: ["flag-in"],
				category: 8
			},
			{
				emoji: "🇮🇴",
				name: "British Indian Ocean Territory Flag",
				added_in: "6.0",
				shortName: "flag-io",
				shortNames: ["flag-io"],
				category: 8
			},
			{
				emoji: "🇮🇶",
				name: "Iraq Flag",
				added_in: "6.0",
				shortName: "flag-iq",
				shortNames: ["flag-iq"],
				category: 8
			},
			{
				emoji: "🇮🇷",
				name: "Iran Flag",
				added_in: "6.0",
				shortName: "flag-ir",
				shortNames: ["flag-ir"],
				category: 8
			},
			{
				emoji: "🇮🇸",
				name: "Iceland Flag",
				added_in: "6.0",
				shortName: "flag-is",
				shortNames: ["flag-is"],
				category: 8
			},
			{
				emoji: "🇮🇹",
				name: "Italy Flag",
				added_in: "6.0",
				shortName: "it",
				shortNames: ["it", "flag-it"],
				category: 8
			},
			{
				emoji: "🇯🇪",
				name: "Jersey Flag",
				added_in: "6.0",
				shortName: "flag-je",
				shortNames: ["flag-je"],
				category: 8
			},
			{
				emoji: "🇯🇲",
				name: "Jamaica Flag",
				added_in: "6.0",
				shortName: "flag-jm",
				shortNames: ["flag-jm"],
				category: 8
			},
			{
				emoji: "🇯🇴",
				name: "Jordan Flag",
				added_in: "6.0",
				shortName: "flag-jo",
				shortNames: ["flag-jo"],
				category: 8
			},
			{
				emoji: "🇯🇵",
				name: "Japan Flag",
				added_in: "6.0",
				shortName: "jp",
				shortNames: ["jp", "flag-jp"],
				category: 8
			},
			{
				emoji: "🇰🇪",
				name: "Kenya Flag",
				added_in: "6.0",
				shortName: "flag-ke",
				shortNames: ["flag-ke"],
				category: 8
			},
			{
				emoji: "🇰🇬",
				name: "Kyrgyzstan Flag",
				added_in: "6.0",
				shortName: "flag-kg",
				shortNames: ["flag-kg"],
				category: 8
			},
			{
				emoji: "🇰🇭",
				name: "Cambodia Flag",
				added_in: "6.0",
				shortName: "flag-kh",
				shortNames: ["flag-kh"],
				category: 8
			},
			{
				emoji: "🇰🇮",
				name: "Kiribati Flag",
				added_in: "6.0",
				shortName: "flag-ki",
				shortNames: ["flag-ki"],
				category: 8
			},
			{
				emoji: "🇰🇲",
				name: "Comoros Flag",
				added_in: "6.0",
				shortName: "flag-km",
				shortNames: ["flag-km"],
				category: 8
			},
			{
				emoji: "🇰🇳",
				name: "St. Kitts & Nevis Flag",
				added_in: "6.0",
				shortName: "flag-kn",
				shortNames: ["flag-kn"],
				category: 8
			},
			{
				emoji: "🇰🇵",
				name: "North Korea Flag",
				added_in: "6.0",
				shortName: "flag-kp",
				shortNames: ["flag-kp"],
				category: 8
			},
			{
				emoji: "🇰🇷",
				name: "South Korea Flag",
				added_in: "6.0",
				shortName: "kr",
				shortNames: ["kr", "flag-kr"],
				category: 8
			},
			{
				emoji: "🇰🇼",
				name: "Kuwait Flag",
				added_in: "6.0",
				shortName: "flag-kw",
				shortNames: ["flag-kw"],
				category: 8
			},
			{
				emoji: "🇰🇿",
				name: "Kazakhstan Flag",
				added_in: "6.0",
				shortName: "flag-kz",
				shortNames: ["flag-kz"],
				category: 8
			},
			{
				emoji: "🇱🇦",
				name: "Laos Flag",
				added_in: "6.0",
				shortName: "flag-la",
				shortNames: ["flag-la"],
				category: 8
			},
			{
				emoji: "🇱🇧",
				name: "Lebanon Flag",
				added_in: "6.0",
				shortName: "flag-lb",
				shortNames: ["flag-lb"],
				category: 8
			},
			{
				emoji: "🇱🇨",
				name: "St. Lucia Flag",
				added_in: "6.0",
				shortName: "flag-lc",
				shortNames: ["flag-lc"],
				category: 8
			},
			{
				emoji: "🇱🇮",
				name: "Liechtenstein Flag",
				added_in: "6.0",
				shortName: "flag-li",
				shortNames: ["flag-li"],
				category: 8
			},
			{
				emoji: "🇱🇰",
				name: "Sri Lanka Flag",
				added_in: "6.0",
				shortName: "flag-lk",
				shortNames: ["flag-lk"],
				category: 8
			},
			{
				emoji: "🇱🇷",
				name: "Liberia Flag",
				added_in: "6.0",
				shortName: "flag-lr",
				shortNames: ["flag-lr"],
				category: 8
			},
			{
				emoji: "🇱🇸",
				name: "Lesotho Flag",
				added_in: "6.0",
				shortName: "flag-ls",
				shortNames: ["flag-ls"],
				category: 8
			},
			{
				emoji: "🇱🇹",
				name: "Lithuania Flag",
				added_in: "6.0",
				shortName: "flag-lt",
				shortNames: ["flag-lt"],
				category: 8
			},
			{
				emoji: "🇱🇺",
				name: "Luxembourg Flag",
				added_in: "6.0",
				shortName: "flag-lu",
				shortNames: ["flag-lu"],
				category: 8
			},
			{
				emoji: "🇱🇻",
				name: "Latvia Flag",
				added_in: "6.0",
				shortName: "flag-lv",
				shortNames: ["flag-lv"],
				category: 8
			},
			{
				emoji: "🇱🇾",
				name: "Libya Flag",
				added_in: "6.0",
				shortName: "flag-ly",
				shortNames: ["flag-ly"],
				category: 8
			},
			{
				emoji: "🇲🇦",
				name: "Morocco Flag",
				added_in: "6.0",
				shortName: "flag-ma",
				shortNames: ["flag-ma"],
				category: 8
			},
			{
				emoji: "🇲🇨",
				name: "Monaco Flag",
				added_in: "6.0",
				shortName: "flag-mc",
				shortNames: ["flag-mc"],
				category: 8
			},
			{
				emoji: "🇲🇩",
				name: "Moldova Flag",
				added_in: "6.0",
				shortName: "flag-md",
				shortNames: ["flag-md"],
				category: 8
			},
			{
				emoji: "🇲🇪",
				name: "Montenegro Flag",
				added_in: "6.0",
				shortName: "flag-me",
				shortNames: ["flag-me"],
				category: 8
			},
			{
				emoji: "🇲🇬",
				name: "Madagascar Flag",
				added_in: "6.0",
				shortName: "flag-mg",
				shortNames: ["flag-mg"],
				category: 8
			},
			{
				emoji: "🇲🇭",
				name: "Marshall Islands Flag",
				added_in: "6.0",
				shortName: "flag-mh",
				shortNames: ["flag-mh"],
				category: 8
			},
			{
				emoji: "🇲🇰",
				name: "Macedonia Flag",
				added_in: "6.0",
				shortName: "flag-mk",
				shortNames: ["flag-mk"],
				category: 8
			},
			{
				emoji: "🇲🇱",
				name: "Mali Flag",
				added_in: "6.0",
				shortName: "flag-ml",
				shortNames: ["flag-ml"],
				category: 8
			},
			{
				emoji: "🇲🇲",
				name: "Myanmar (Burma) Flag",
				added_in: "6.0",
				shortName: "flag-mm",
				shortNames: ["flag-mm"],
				category: 8
			},
			{
				emoji: "🇲🇳",
				name: "Mongolia Flag",
				added_in: "6.0",
				shortName: "flag-mn",
				shortNames: ["flag-mn"],
				category: 8
			},
			{
				emoji: "🇲🇴",
				name: "Macau SAR China Flag",
				added_in: "6.0",
				shortName: "flag-mo",
				shortNames: ["flag-mo"],
				category: 8
			},
			{
				emoji: "🇲🇵",
				name: "Northern Mariana Islands Flag",
				added_in: "6.0",
				shortName: "flag-mp",
				shortNames: ["flag-mp"],
				category: 8
			},
			{
				emoji: "🇲🇷",
				name: "Mauritania Flag",
				added_in: "6.0",
				shortName: "flag-mr",
				shortNames: ["flag-mr"],
				category: 8
			},
			{
				emoji: "🇲🇸",
				name: "Montserrat Flag",
				added_in: "6.0",
				shortName: "flag-ms",
				shortNames: ["flag-ms"],
				category: 8
			},
			{
				emoji: "🇲🇹",
				name: "Malta Flag",
				added_in: "6.0",
				shortName: "flag-mt",
				shortNames: ["flag-mt"],
				category: 8
			},
			{
				emoji: "🇲🇺",
				name: "Mauritius Flag",
				added_in: "6.0",
				shortName: "flag-mu",
				shortNames: ["flag-mu"],
				category: 8
			},
			{
				emoji: "🇲🇻",
				name: "Maldives Flag",
				added_in: "6.0",
				shortName: "flag-mv",
				shortNames: ["flag-mv"],
				category: 8
			},
			{
				emoji: "🇲🇼",
				name: "Malawi Flag",
				added_in: "6.0",
				shortName: "flag-mw",
				shortNames: ["flag-mw"],
				category: 8
			},
			{
				emoji: "🇲🇽",
				name: "Mexico Flag",
				added_in: "6.0",
				shortName: "flag-mx",
				shortNames: ["flag-mx"],
				category: 8
			},
			{
				emoji: "🇲🇾",
				name: "Malaysia Flag",
				added_in: "6.0",
				shortName: "flag-my",
				shortNames: ["flag-my"],
				category: 8
			},
			{
				emoji: "🇲🇿",
				name: "Mozambique Flag",
				added_in: "6.0",
				shortName: "flag-mz",
				shortNames: ["flag-mz"],
				category: 8
			},
			{
				emoji: "🇳🇦",
				name: "Namibia Flag",
				added_in: "6.0",
				shortName: "flag-na",
				shortNames: ["flag-na"],
				category: 8
			},
			{
				emoji: "🇳🇪",
				name: "Niger Flag",
				added_in: "6.0",
				shortName: "flag-ne",
				shortNames: ["flag-ne"],
				category: 8
			},
			{
				emoji: "🇳🇫",
				name: "Norfolk Island Flag",
				added_in: "6.0",
				shortName: "flag-nf",
				shortNames: ["flag-nf"],
				category: 8
			},
			{
				emoji: "🇳🇬",
				name: "Nigeria Flag",
				added_in: "6.0",
				shortName: "flag-ng",
				shortNames: ["flag-ng"],
				category: 8
			},
			{
				emoji: "🇳🇮",
				name: "Nicaragua Flag",
				added_in: "6.0",
				shortName: "flag-ni",
				shortNames: ["flag-ni"],
				category: 8
			},
			{
				emoji: "🇳🇱",
				name: "Netherlands Flag",
				added_in: "6.0",
				shortName: "flag-nl",
				shortNames: ["flag-nl"],
				category: 8
			},
			{
				emoji: "🇳🇴",
				name: "Norway Flag",
				added_in: "6.0",
				shortName: "flag-no",
				shortNames: ["flag-no"],
				category: 8
			},
			{
				emoji: "🇳🇵",
				name: "Nepal Flag",
				added_in: "6.0",
				shortName: "flag-np",
				shortNames: ["flag-np"],
				category: 8
			},
			{
				emoji: "🇳🇷",
				name: "Nauru Flag",
				added_in: "6.0",
				shortName: "flag-nr",
				shortNames: ["flag-nr"],
				category: 8
			},
			{
				emoji: "🇳🇺",
				name: "Niue Flag",
				added_in: "6.0",
				shortName: "flag-nu",
				shortNames: ["flag-nu"],
				category: 8
			},
			{
				emoji: "🇳🇿",
				name: "New Zealand Flag",
				added_in: "6.0",
				shortName: "flag-nz",
				shortNames: ["flag-nz"],
				category: 8
			},
			{
				emoji: "🇵🇦",
				name: "Panama Flag",
				added_in: "6.0",
				shortName: "flag-pa",
				shortNames: ["flag-pa"],
				category: 8
			},
			{
				emoji: "🇵🇪",
				name: "Peru Flag",
				added_in: "6.0",
				shortName: "flag-pe",
				shortNames: ["flag-pe"],
				category: 8
			},
			{
				emoji: "🇵🇫",
				name: "French Polynesia Flag",
				added_in: "6.0",
				shortName: "flag-pf",
				shortNames: ["flag-pf"],
				category: 8
			},
			{
				emoji: "🇵🇬",
				name: "Papua New Guinea Flag",
				added_in: "6.0",
				shortName: "flag-pg",
				shortNames: ["flag-pg"],
				category: 8
			},
			{
				emoji: "🇵🇭",
				name: "Philippines Flag",
				added_in: "6.0",
				shortName: "flag-ph",
				shortNames: ["flag-ph"],
				category: 8
			},
			{
				emoji: "🇵🇰",
				name: "Pakistan Flag",
				added_in: "6.0",
				shortName: "flag-pk",
				shortNames: ["flag-pk"],
				category: 8
			},
			{
				emoji: "🇵🇱",
				name: "Poland Flag",
				added_in: "6.0",
				shortName: "flag-pl",
				shortNames: ["flag-pl"],
				category: 8
			},
			{
				emoji: "🇵🇳",
				name: "Pitcairn Islands Flag",
				added_in: "6.0",
				shortName: "flag-pn",
				shortNames: ["flag-pn"],
				category: 8
			},
			{
				emoji: "🇵🇷",
				name: "Puerto Rico Flag",
				added_in: "6.0",
				shortName: "flag-pr",
				shortNames: ["flag-pr"],
				category: 8
			},
			{
				emoji: "🇵🇸",
				name: "Palestinian Territories Flag",
				added_in: "6.0",
				shortName: "flag-ps",
				shortNames: ["flag-ps"],
				category: 8
			},
			{
				emoji: "🇵🇹",
				name: "Portugal Flag",
				added_in: "6.0",
				shortName: "flag-pt",
				shortNames: ["flag-pt"],
				category: 8
			},
			{
				emoji: "🇵🇼",
				name: "Palau Flag",
				added_in: "6.0",
				shortName: "flag-pw",
				shortNames: ["flag-pw"],
				category: 8
			},
			{
				emoji: "🇵🇾",
				name: "Paraguay Flag",
				added_in: "6.0",
				shortName: "flag-py",
				shortNames: ["flag-py"],
				category: 8
			},
			{
				emoji: "🇶🇦",
				name: "Qatar Flag",
				added_in: "6.0",
				shortName: "flag-qa",
				shortNames: ["flag-qa"],
				category: 8
			},
			{
				emoji: "🇷🇸",
				name: "Serbia Flag",
				added_in: "6.0",
				shortName: "flag-rs",
				shortNames: ["flag-rs"],
				category: 8
			},
			{
				emoji: "🇷🇺",
				name: "Russia Flag",
				added_in: "6.0",
				shortName: "ru",
				shortNames: ["ru", "flag-ru"],
				category: 8
			},
			{
				emoji: "🇷🇼",
				name: "Rwanda Flag",
				added_in: "6.0",
				shortName: "flag-rw",
				shortNames: ["flag-rw"],
				category: 8
			},
			{
				emoji: "🇸🇦",
				name: "Saudi Arabia Flag",
				added_in: "6.0",
				shortName: "flag-sa",
				shortNames: ["flag-sa"],
				category: 8
			},
			{
				emoji: "🇸🇧",
				name: "Solomon Islands Flag",
				added_in: "6.0",
				shortName: "flag-sb",
				shortNames: ["flag-sb"],
				category: 8
			},
			{
				emoji: "🇸🇨",
				name: "Seychelles Flag",
				added_in: "6.0",
				shortName: "flag-sc",
				shortNames: ["flag-sc"],
				category: 8
			},
			{
				emoji: "🇸🇩",
				name: "Sudan Flag",
				added_in: "6.0",
				shortName: "flag-sd",
				shortNames: ["flag-sd"],
				category: 8
			},
			{
				emoji: "🇸🇪",
				name: "Sweden Flag",
				added_in: "6.0",
				shortName: "flag-se",
				shortNames: ["flag-se"],
				category: 8
			},
			{
				emoji: "🇸🇬",
				name: "Singapore Flag",
				added_in: "6.0",
				shortName: "flag-sg",
				shortNames: ["flag-sg"],
				category: 8
			},
			{
				emoji: "🇸🇭",
				name: "St. Helena Flag",
				added_in: "6.0",
				shortName: "flag-sh",
				shortNames: ["flag-sh"],
				category: 8
			},
			{
				emoji: "🇸🇮",
				name: "Slovenia Flag",
				added_in: "6.0",
				shortName: "flag-si",
				shortNames: ["flag-si"],
				category: 8
			},
			{
				emoji: "🇸🇯",
				name: "Svalbard & Jan Mayen Flag",
				added_in: "6.0",
				shortName: "flag-sj",
				shortNames: ["flag-sj"],
				category: 8
			},
			{
				emoji: "🇸🇰",
				name: "Slovakia Flag",
				added_in: "6.0",
				shortName: "flag-sk",
				shortNames: ["flag-sk"],
				category: 8
			},
			{
				emoji: "🇸🇱",
				name: "Sierra Leone Flag",
				added_in: "6.0",
				shortName: "flag-sl",
				shortNames: ["flag-sl"],
				category: 8
			},
			{
				emoji: "🇸🇲",
				name: "San Marino Flag",
				added_in: "6.0",
				shortName: "flag-sm",
				shortNames: ["flag-sm"],
				category: 8
			},
			{
				emoji: "🇸🇳",
				name: "Senegal Flag",
				added_in: "6.0",
				shortName: "flag-sn",
				shortNames: ["flag-sn"],
				category: 8
			},
			{
				emoji: "🇸🇴",
				name: "Somalia Flag",
				added_in: "6.0",
				shortName: "flag-so",
				shortNames: ["flag-so"],
				category: 8
			},
			{
				emoji: "🇸🇷",
				name: "Suriname Flag",
				added_in: "6.0",
				shortName: "flag-sr",
				shortNames: ["flag-sr"],
				category: 8
			},
			{
				emoji: "🇸🇸",
				name: "South Sudan Flag",
				added_in: "6.0",
				shortName: "flag-ss",
				shortNames: ["flag-ss"],
				category: 8
			},
			{
				emoji: "🇸🇹",
				name: "São Tomé & Príncipe Flag",
				added_in: "6.0",
				shortName: "flag-st",
				shortNames: ["flag-st"],
				category: 8
			},
			{
				emoji: "🇸🇻",
				name: "El Salvador Flag",
				added_in: "6.0",
				shortName: "flag-sv",
				shortNames: ["flag-sv"],
				category: 8
			},
			{
				emoji: "🇸🇽",
				name: "Sint Maarten Flag",
				added_in: "6.0",
				shortName: "flag-sx",
				shortNames: ["flag-sx"],
				category: 8
			},
			{
				emoji: "🇸🇾",
				name: "Syria Flag",
				added_in: "6.0",
				shortName: "flag-sy",
				shortNames: ["flag-sy"],
				category: 8
			},
			{
				emoji: "🇸🇿",
				name: "Swaziland Flag",
				added_in: "6.0",
				shortName: "flag-sz",
				shortNames: ["flag-sz"],
				category: 8
			},
			{
				emoji: "🇹🇦",
				name: "Tristan da Cunha Flag",
				added_in: "6.0",
				shortName: "flag-ta",
				shortNames: ["flag-ta"],
				category: 8
			},
			{
				emoji: "🇹🇨",
				name: "Turks & Caicos Islands Flag",
				added_in: "6.0",
				shortName: "flag-tc",
				shortNames: ["flag-tc"],
				category: 8
			},
			{
				emoji: "🇹🇩",
				name: "Chad Flag",
				added_in: "6.0",
				shortName: "flag-td",
				shortNames: ["flag-td"],
				category: 8
			},
			{
				emoji: "🇹🇬",
				name: "Togo Flag",
				added_in: "6.0",
				shortName: "flag-tg",
				shortNames: ["flag-tg"],
				category: 8
			},
			{
				emoji: "🇹🇭",
				name: "Thailand Flag",
				added_in: "6.0",
				shortName: "flag-th",
				shortNames: ["flag-th"],
				category: 8
			},
			{
				emoji: "🇹🇯",
				name: "Tajikistan Flag",
				added_in: "6.0",
				shortName: "flag-tj",
				shortNames: ["flag-tj"],
				category: 8
			},
			{
				emoji: "🇹🇰",
				name: "Tokelau Flag",
				added_in: "6.0",
				shortName: "flag-tk",
				shortNames: ["flag-tk"],
				category: 8
			},
			{
				emoji: "🇹🇱",
				name: "Timor-Leste Flag",
				added_in: "6.0",
				shortName: "flag-tl",
				shortNames: ["flag-tl"],
				category: 8
			},
			{
				emoji: "🇹🇲",
				name: "Turkmenistan Flag",
				added_in: "6.0",
				shortName: "flag-tm",
				shortNames: ["flag-tm"],
				category: 8
			},
			{
				emoji: "🇹🇳",
				name: "Tunisia Flag",
				added_in: "6.0",
				shortName: "flag-tn",
				shortNames: ["flag-tn"],
				category: 8
			},
			{
				emoji: "🇹🇴",
				name: "Tonga Flag",
				added_in: "6.0",
				shortName: "flag-to",
				shortNames: ["flag-to"],
				category: 8
			},
			{
				emoji: "🇹🇷",
				name: "Turkey Flag",
				added_in: "6.0",
				shortName: "flag-tr",
				shortNames: ["flag-tr"],
				category: 8
			},
			{
				emoji: "🇹🇹",
				name: "Trinidad & Tobago Flag",
				added_in: "6.0",
				shortName: "flag-tt",
				shortNames: ["flag-tt"],
				category: 8
			},
			{
				emoji: "🇹🇻",
				name: "Tuvalu Flag",
				added_in: "6.0",
				shortName: "flag-tv",
				shortNames: ["flag-tv"],
				category: 8
			},
			{
				emoji: "🇹🇼",
				name: "Taiwan Flag",
				added_in: "6.0",
				shortName: "flag-tw",
				shortNames: ["flag-tw"],
				category: 8
			},
			{
				emoji: "🇹🇿",
				name: "Tanzania Flag",
				added_in: "6.0",
				shortName: "flag-tz",
				shortNames: ["flag-tz"],
				category: 8
			},
			{
				emoji: "🇺🇦",
				name: "Ukraine Flag",
				added_in: "6.0",
				shortName: "flag-ua",
				shortNames: ["flag-ua"],
				category: 8
			},
			{
				emoji: "🇺🇬",
				name: "Uganda Flag",
				added_in: "6.0",
				shortName: "flag-ug",
				shortNames: ["flag-ug"],
				category: 8
			},
			{
				emoji: "🇺🇲",
				name: "U.S. Outlying Islands Flag",
				added_in: "6.0",
				shortName: "flag-um",
				shortNames: ["flag-um"],
				category: 8
			},
			{
				emoji: "🇺🇸",
				name: "United States Flag",
				added_in: "6.0",
				shortName: "us",
				shortNames: ["us", "flag-us"],
				category: 8
			},
			{
				emoji: "🇺🇾",
				name: "Uruguay Flag",
				added_in: "6.0",
				shortName: "flag-uy",
				shortNames: ["flag-uy"],
				category: 8
			},
			{
				emoji: "🇺🇿",
				name: "Uzbekistan Flag",
				added_in: "6.0",
				shortName: "flag-uz",
				shortNames: ["flag-uz"],
				category: 8
			},
			{
				emoji: "🇻🇦",
				name: "Vatican City Flag",
				added_in: "6.0",
				shortName: "flag-va",
				shortNames: ["flag-va"],
				category: 8
			},
			{
				emoji: "🇻🇨",
				name: "St. Vincent & Grenadines Flag",
				added_in: "6.0",
				shortName: "flag-vc",
				shortNames: ["flag-vc"],
				category: 8
			},
			{
				emoji: "🇻🇪",
				name: "Venezuela Flag",
				added_in: "6.0",
				shortName: "flag-ve",
				shortNames: ["flag-ve"],
				category: 8
			},
			{
				emoji: "🇻🇬",
				name: "British Virgin Islands Flag",
				added_in: "6.0",
				shortName: "flag-vg",
				shortNames: ["flag-vg"],
				category: 8
			},
			{
				emoji: "🇻🇮",
				name: "U.S. Virgin Islands Flag",
				added_in: "6.0",
				shortName: "flag-vi",
				shortNames: ["flag-vi"],
				category: 8
			},
			{
				emoji: "🇻🇳",
				name: "Vietnam Flag",
				added_in: "6.0",
				shortName: "flag-vn",
				shortNames: ["flag-vn"],
				category: 8
			},
			{
				emoji: "🇻🇺",
				name: "Vanuatu Flag",
				added_in: "6.0",
				shortName: "flag-vu",
				shortNames: ["flag-vu"],
				category: 8
			},
			{
				emoji: "🇼🇸",
				name: "Samoa Flag",
				added_in: "6.0",
				shortName: "flag-ws",
				shortNames: ["flag-ws"],
				category: 8
			},
			{
				emoji: "🇾🇪",
				name: "Yemen Flag",
				added_in: "6.0",
				shortName: "flag-ye",
				shortNames: ["flag-ye"],
				category: 8
			},
			{
				emoji: "🇿🇦",
				name: "South Africa Flag",
				added_in: "6.0",
				shortName: "flag-za",
				shortNames: ["flag-za"],
				category: 8
			},
			{
				emoji: "🇿🇲",
				name: "Zambia Flag",
				added_in: "6.0",
				shortName: "flag-zm",
				shortNames: ["flag-zm"],
				category: 8
			},
			{
				emoji: "🇿🇼",
				name: "Zimbabwe Flag",
				added_in: "6.0",
				shortName: "flag-zw",
				shortNames: ["flag-zw"],
				category: 8
			},
			{
				emoji: "🎌",
				name: "CROSSED FLAGS",
				added_in: "6.0",
				shortName: "crossed_flags",
				shortNames: ["crossed_flags"],
				category: 8
			},
			{
				emoji: "🏁",
				name: "CHEQUERED FLAG",
				added_in: "6.0",
				shortName: "checkered_flag",
				shortNames: ["checkered_flag"],
				category: 8
			},
			{
				emoji: "🏳️‍🌈",
				name: null,
				added_in: "7.0",
				shortName: "rainbow-flag",
				shortNames: ["rainbow-flag"],
				category: 8
			},
			{
				emoji: "🚩",
				name: "TRIANGULAR FLAG ON POST",
				added_in: "6.0",
				shortName: "triangular_flag_on_post",
				shortNames: ["triangular_flag_on_post"],
				category: 8
			}
		]
	]
}, Z = X.categories, Ve = X.emojis, He = [].concat(...Ve), Q = "emoji.frequently";
function Ue(e) {
	let t = e.trim().toLowerCase();
	if (!t) return [];
	let n = [], r = [];
	return He.forEach((e) => {
		let i = [
			e.name,
			e.shortName,
			...e.shortNames
		].map((e) => (e || "").toLowerCase());
		i.some((e) => e.startsWith(t)) ? n.push(e) : i.some((e) => e.includes(t)) && r.push(e);
	}), [...n, ...r];
}
var $ = ({ className: e, onSelect: n, ...a }) => {
	let [o, c] = h(0), [l, f] = h(""), [g, _] = h(() => {
		try {
			return JSON.parse(localStorage.getItem(Q) || "");
		} catch {
			return {};
		}
	}), v = m(null), y = m(null), b = m(null), x = m(Z.map(() => s())), S = m([]), C = u(() => {
		let e = v.current;
		if (!e) return;
		let t = e.getBoundingClientRect();
		S.current = [], x.current.forEach((n) => {
			let r = n.current;
			if (r) {
				let n = r.getBoundingClientRect();
				S.current.push(n.top - t.top - 1 + e.scrollTop);
			}
		});
	}, []);
	d(() => {
		y.current?.focus();
	}, []), d(() => {
		C();
	});
	let w = u(() => {
		let e = v.current;
		if (!e) return;
		let { scrollTop: t } = e, n = 0;
		for (let e = 0; e < S.current.length; e += 1) {
			let r = S.current[e], i = S.current[e + 1];
			if (t >= n && (i && t < i || !i)) {
				o !== e && (C(), c(e));
				break;
			}
			n = r;
		}
	}, [o, C]), T = u((e) => {
		v.current && (v.current.scrollTop = S.current[e]);
	}, []), E = u((e) => {
		let t = { ...g };
		e && (t[e] = (t[e] || 0) + 1), localStorage.setItem(Q, JSON.stringify(t)), _(t), n(e);
	}, [g, n]), ee = u((e) => {
		f(e.target.value);
	}, []), D = p(() => Ie(Object.keys(g).map((e) => ({
		emoji: e,
		count: g[e] || 1
	})), ["count"]).reverse().splice(0, 22).map((e) => Fe(He, ["emoji", e.emoji])).filter((e) => !!e), [g]), O = l.trim().length > 0, k = p(() => O ? Ue(l) : [], [O, l]);
	return /* @__PURE__ */ i("div", {
		...a,
		className: t(Y.root, e),
		children: [
			/* @__PURE__ */ r("div", {
				className: Y.search,
				children: /* @__PURE__ */ r(Pe, {
					ref: y,
					type: "search",
					icon: "search",
					placeholder: "Search emoji…",
					"aria-label": "Search emoji",
					value: l,
					onChange: ee
				})
			}),
			!O && /* @__PURE__ */ r("div", {
				className: Y.categories,
				children: Z.map((e) => /* @__PURE__ */ r(Le, {
					category: e,
					active: e.key === o,
					gotoCategory: T
				}, e.key))
			}),
			/* @__PURE__ */ r("div", {
				className: Y.container,
				children: /* @__PURE__ */ r("div", {
					className: Y.grid,
					ref: v,
					onScroll: w,
					children: O ? k.length > 0 ? /* @__PURE__ */ r(J, {
						sectionRef: b,
						category: {
							key: "search",
							name: "Search results"
						},
						emojis: k,
						onSelect: E
					}, "search") : /* @__PURE__ */ r(z.Paragraph, {
						as: "div",
						variant: "4",
						subdued: !0,
						className: Y.empty,
						children: "No emojis found"
					}) : Z.map((e) => /* @__PURE__ */ r(J, {
						sectionRef: x.current[e.key],
						category: e,
						emojis: e.key === 0 ? D : Ve[e.key],
						onSelect: E
					}, e.key))
				})
			})
		]
	});
};
$.displayName = "EmojiPicker";
//#endregion
//#region src/components/emojiPicker/index.ts
var We = /* @__PURE__ */ e({
	EMOJIS: () => X,
	EmojiPicker: () => $
});
//#endregion
export { j as _, Oe as a, Ce as c, z as d, P as f, O as g, M as h, Pe as i, xe as l, N as m, $ as n, U as o, oe as p, X as r, Te as s, We as t, V as u, v };

//# sourceMappingURL=emoji-BruFqa5E.js.map